webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return AUTH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return AUTH_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return AUTH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return AUTH_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return AUTH_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return USER_REQUEST; });
/* unused harmony export INITIAL_USER_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return USER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ALL_PACKAGES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ALL_PACKAGES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ALL_TRAINERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ALL_TRAINERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ALL_WORKOUTS_TEMPLATES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ALL_WORKOUTS_TEMPLATES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return TRAINER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TRAINER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RUNNER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RUNNER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RUNNER_DATA_FILLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RUNNERS_TRAINER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RUNNERS_TRAINER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return TRAINERS_RUNNERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TRAINERS_RUNNERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADMIN_RUNNERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADMIN_RUNNERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADMIN_TRAINERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADMIN_TRAINERS_SUCCESS; });
var AUTH_REQUEST = 'AUTH_REQUEST';
var AUTH_TOKEN = 'AUTH_TOKEN';
var AUTH_SUCCESS = 'AUTH_SUCCESS';
var AUTH_ERROR = 'AUTH_ERROR';
var AUTH_LOGOUT = 'AUTH_LOGOUT';
var USER_REQUEST = 'USER_REQUEST';
var INITIAL_USER_REQUEST = 'INITIAL_USER_REQUEST';
var USER_SUCCESS = 'USER_SUCCESS';
var USER_ERROR = 'USER_ERROR';

var ALL_PACKAGES_REQUEST = 'ALL_PACKAGES_REQUEST';
var ALL_PACKAGES_SUCCESS = 'ALL_PACKAGES_SUCCESS';

var ALL_TRAINERS_REQUEST = 'ALL_TRAINERS_REQUEST';
var ALL_TRAINERS_SUCCESS = 'ALL_TRAINERS_SUCCESS';

var ALL_WORKOUTS_TEMPLATES_REQUEST = 'ALL_WORKOUTS_TEMPLATES_REQUEST';
var ALL_WORKOUTS_TEMPLATES_SUCCESS = 'ALL_WORKOUTS_TEMPLATES_SUCCESS';

var TRAINER_REQUEST = 'TRAINER_REQUEST';
var TRAINER_SUCCESS = 'TRAINER_SUCCESS';
var RUNNER_REQUEST = 'RUNNER_REQUEST';
var RUNNER_SUCCESS = 'RUNNER_SUCCESS';
var RUNNER_DATA_FILLED = 'RUNNER_DATA_FILLED';
var RUNNERS_TRAINER_REQUEST = 'RUNNERS_TRAINER_REQUEST';
var RUNNERS_TRAINER_SUCCESS = 'RUNNERS_TRAINER_SUCCESS';

var TRAINERS_RUNNERS_REQUEST = 'TRAINERS_RUNNERS_REQUEST';
var TRAINERS_RUNNERS_SUCCESS = 'TRAINERS_RUNNERS_SUCCESS';

var ADMIN_RUNNERS_REQUEST = 'ADMIN_RUNNERS_REQUEST';
var ADMIN_RUNNERS_SUCCESS = 'ADMIN_RUNNERS_SUCCESS';

var ADMIN_TRAINERS_REQUEST = 'ADMIN_TRAINERS_REQUEST';
var ADMIN_TRAINERS_SUCCESS = 'ADMIN_TRAINERS_SUCCESS';

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchRunners; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchSimpleAdminRunners; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getRunner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getRunnerDataTrainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getRunnerDataPackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getRunnerData1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getRunnerData2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return registerRunnerAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updateRunner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return updateRunnerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return updateRunnerDataPackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return updateRunnerDataTrainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return updateRunnerData1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return updateRunnerData2; });
/* unused harmony export patchRunner */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activateRunner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deactivateRunner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return sendMailRunner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchTrainerRunners; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchSimpleTrainerRunners; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return updateRunnerTrainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return patchRunnerTrainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(20);






var fetchRunners = function fetchRunners(params) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].get('/runners/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var fetchSimpleAdminRunners = function fetchSimpleAdminRunners(params) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].get('/runners/simple/', { params: params }).then(function (resp) {
    return resp.data;
  });
};

var getRunner = function getRunner(runnerId) {
  if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.isTrainer) {
    return _getTrainersRunner(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.authUser.id, runnerId);
  } else {
    return _getRunner(runnerId);
  }
};

var getRunnerDataTrainer = function getRunnerDataTrainer(id) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].get('/runners/' + id + '/application_trainer/').then(function (resp) {
    return resp.data;
  });
};
var getRunnerDataPackage = function getRunnerDataPackage(id) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].get('/runners/' + id + '/application_package/').then(function (resp) {
    return resp.data;
  });
};
var getRunnerData1 = function getRunnerData1(id) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].get('/runners/' + id + '/application1/').then(function (resp) {
    return resp.data;
  });
};
var getRunnerData2 = function getRunnerData2(id) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].get('/runners/' + id + '/application2/').then(function (resp) {
    return resp.data;
  });
};
var registerRunnerAdmin = function registerRunnerAdmin(obj) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].post('/users/registration/runner/', obj).then(function (resp) {
    return resp.data;
  });
};

var updateRunner = function updateRunner(obj) {
  var fd = new FormData();
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(obj)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

      var key = _ref2[0];
      var value = _ref2[1];

      if (key === 'avatar_thumbnail' && !(value instanceof File)) {
        continue;
      }
      if (value === null) {
        continue;
      }
      fd.append(key, value);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].put('/runners/' + obj.id + '/', fd).then(function (resp) {
    return resp.data;
  });
};

var updateRunnerData = function updateRunnerData(obj) {
  var fd = new FormData();
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(obj)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _ref3 = _step2.value;

      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

      var key = _ref4[0];
      var value = _ref4[1];

      if (key === 'avatar_thumbnail' && !(value instanceof File)) {
        continue;
      }
      if (value === null) {
        continue;
      }
      fd.append(key, value);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].put('/runners/' + obj.id + '/data/', fd).then(function (resp) {
    return resp.data;
  });
};

var updateRunnerDataPackage = function updateRunnerDataPackage(id, obj) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].put('/runners/' + id + '/application_package/', obj).then(function (resp) {
    return resp.data;
  });
};
var updateRunnerDataTrainer = function updateRunnerDataTrainer(id, obj) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].put('/runners/' + id + '/application_trainer/', obj).then(function (resp) {
    return resp.data;
  });
};
var updateRunnerData1 = function updateRunnerData1(id, obj) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].put('/runners/' + id + '/application1/', obj).then(function (resp) {
    return resp.data;
  });
};
var updateRunnerData2 = function updateRunnerData2(id, obj) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].put('/runners/' + id + '/application2/', obj).then(function (resp) {
    return resp.data;
  });
};

var patchRunner = function patchRunner(obj) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].patch('/runners/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var activateRunner = function activateRunner(obj) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].patch('/runners/' + obj.id + '/', { is_active: true }).then(function (resp) {
    return resp.data;
  });
};
var deactivateRunner = function deactivateRunner(obj) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].patch('/runners/' + obj.id + '/', { is_active: false }).then(function (resp) {
    return resp.data;
  });
};
var sendMailRunner = function sendMailRunner(obj) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].post('/runners/' + obj.id + '/resend_email/', {}).then(function (resp) {
    return resp.data;
  });
};

// zawodnicy trenera
var fetchTrainerRunners = function fetchTrainerRunners(trainerId, params) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].get('/trainers/' + trainerId + '/runners/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var fetchSimpleTrainerRunners = function fetchSimpleTrainerRunners(trainerId, params) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].get('/trainers/' + trainerId + '/runners/simple/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var updateRunnerTrainer = function updateRunnerTrainer(trainerId, obj) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].put('/trainers/' + trainerId + '/runners/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};
var patchRunnerTrainer = function patchRunnerTrainer(trainerId, obj) {
  if (!trainerId) {
    return patchRunner(obj);
  }
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].patch('/trainers/' + trainerId + '/runners/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};
var _getRunner = function _getRunner(id) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].get('/runners/' + id + '/').then(function (resp) {
    return resp.data;
  });
};
var _getTrainersRunner = function _getTrainersRunner(trainerId, runnerId) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].get('/trainers/' + trainerId + '/runners/' + runnerId + '/').then(function (resp) {
    return resp.data;
  });
};

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_izitoast__);






var myAxios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: '/api/v1'
});
myAxios.interceptors.response.use(function (response) {
  // intercept the global error
  return response;
}, function (error) {
  if (error.response.status === 401) {
    if (myAxios.defaults.headers.common['Authorization'] !== undefined) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["l" /* AUTH_LOGOUT */]);
    }
  }
  if (error.response.status === 404) {}
  if (error.response.status === 403) {
    __WEBPACK_IMPORTED_MODULE_4_izitoast___default.a.show({
      message: 'Brak uprawnień do wykonania czynności.',
      color: 'red'
    });
  }
  // Do something with response error
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (myAxios);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return fetchPlan; });
/* unused harmony export fetchWorkouts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createWorkout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return copyWorkoutsMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return copyWorkoutsWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return removeWorkoutsWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return updateWorkout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return doneWorkout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return undoneWorkout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return doneWorkoutsWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return undoneWorkoutsWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return deleteWorkout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return fetchRaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return fetchRacesSimple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createRace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return updateRace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return doneRace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return deleteRace; });
/* unused harmony export fetchActivities */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return updateActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return fetchRecords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return updateRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return updateComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return fetchComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return openDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeDay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(12);


var fetchPlan = function fetchPlan(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/runners/' + runner.id + '/plan/', { params: params }).then(function (resp) {
    return resp.data;
  });
};

var fetchWorkouts = function fetchWorkouts(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/runners/' + runner.id + '/workouts/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var createWorkout = function createWorkout(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/runners/' + runner.id + '/workouts/', obj).then(function (resp) {
    return resp.data;
  });
};

var copyWorkoutsMonth = function copyWorkoutsMonth(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/runners/' + runner.id + '/workouts/copy_month/', params).then(function (resp) {
    return resp.data;
  });
};

var copyWorkoutsWeek = function copyWorkoutsWeek(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/runners/' + runner.id + '/workouts/copy_week/', params).then(function (resp) {
    return resp.data;
  });
};
var removeWorkoutsWeek = function removeWorkoutsWeek(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/runners/' + runner.id + '/workouts/remove_week/', params).then(function (resp) {
    return resp.data;
  });
};

var updateWorkout = function updateWorkout(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/runners/' + runner.id + '/workouts/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var doneWorkout = function doneWorkout(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/runners/' + runner.id + '/workouts/' + obj.id + '/workout_done/', obj).then(function (resp) {
    return resp.data;
  });
};

var undoneWorkout = function undoneWorkout(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/runners/' + runner.id + '/workouts/' + obj.id + '/workout_undone/').then(function (resp) {
    return resp.data;
  });
};

var doneWorkoutsWeek = function doneWorkoutsWeek(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/runners/' + runner.id + '/workouts/done_week/', params).then(function (resp) {
    return resp.data;
  });
};

var undoneWorkoutsWeek = function undoneWorkoutsWeek(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/runners/' + runner.id + '/workouts/undone_week/', params).then(function (resp) {
    return resp.data;
  });
};

var deleteWorkout = function deleteWorkout(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].delete('/runners/' + runner.id + '/workouts/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var fetchRaces = function fetchRaces(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/runners/' + runner.id + '/races/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var fetchRacesSimple = function fetchRacesSimple(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/runners/' + runner.id + '/races/simple/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var createRace = function createRace(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/runners/' + runner.id + '/races/', obj).then(function (resp) {
    return resp.data;
  });
};

var updateRace = function updateRace(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/runners/' + runner.id + '/races/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var doneRace = function doneRace(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/runners/' + runner.id + '/races/' + obj.id + '/race_done/', obj).then(function (resp) {
    return resp.data;
  });
};

var deleteRace = function deleteRace(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].delete('/runners/' + runner.id + '/races/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var fetchActivities = function fetchActivities(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/runners/' + runner.id + '/activities/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var createActivity = function createActivity(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/runners/' + runner.id + '/activities/', obj).then(function (resp) {
    return resp.data;
  });
};

var updateActivity = function updateActivity(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/runners/' + runner.id + '/activities/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var deleteActivity = function deleteActivity(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].delete('/runners/' + runner.id + '/activities/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var fetchRecords = function fetchRecords(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/runners/' + runner.id + '/records/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var createRecord = function createRecord(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/runners/' + runner.id + '/records/', obj).then(function (resp) {
    return resp.data;
  });
};
var updateRecord = function updateRecord(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/runners/' + runner.id + '/records/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var createComment = function createComment(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/runners/' + runner.id + '/plan_comments/', obj).then(function (resp) {
    return resp.data;
  });
};

var updateComment = function updateComment(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/runners/' + runner.id + '/plan_comments/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var deleteComment = function deleteComment(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].delete('/runners/' + runner.id + '/plan_comments/' + obj.id + '/').then(function (resp) {
    return resp.data;
  });
};

var fetchComments = function fetchComments(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/runners/' + runner.id + '/plan_comments/', { params: params }).then(function (resp) {
    return resp.data;
  });
};

var openDay = function openDay(runner, date) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].delete('/runners/' + runner.id + '/days/' + date.format('YYYY-MM-DD') + '/').then(function (resp) {
    return resp.data;
  });
};
var closeDay = function closeDay(runner, date) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/runners/' + runner.id + '/days/', { date: date.format('YYYY-MM-DD') }).then(function (resp) {
    return resp.data;
  });
};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fields_vue__ = __webpack_require__(114);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45f42b76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fields_vue__ = __webpack_require__(529);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fields_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45f42b76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fields_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(6);





__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var state = {
  token: localStorage.getItem('user-token') || '',
  user: null,
  trainer: null,
  runner: null,
  runnersTrainer: null,
  trainerRunners: [],
  adminRunners: [],
  adminTrainers: [],
  initial: {
    allPackages: [],
    allTrainers: [],
    allWorkoutsTemplates: [],
    racePriorities: ['A', 'B', 'C'],
    raceTypesStrings: [{
      text: 'ulica',
      value: 'street'
    }, {
      text: 'bieżnia',
      value: 'track'
    }, {
      text: 'przełaj',
      value: 'cross'
    }, {
      text: 'góry',
      value: 'mountains'
    }, {
      text: 'bieg przeszkodowy',
      value: 'obstacle'
    }],
    recordsRaceTypesStrings: [{
      text: 'ulica',
      value: 'street'
    }, {
      text: 'bieżnia',
      value: 'track'
    }],
    raceDistanceStrings: [{
      text: '100m',
      value: '100m'
    }, {
      text: '200m',
      value: '200m'
    }, {
      text: '400m',
      value: '400m'
    }, {
      text: '800m',
      value: '800m'
    }, {
      text: '1000m',
      value: '1000m'
    }, {
      text: '1500m',
      value: '1500m'
    }, {
      text: '3000m',
      value: '3000m'
    }, {
      text: '3000m z p.',
      value: '3000m s.'
    }, {
      text: '5000m',
      value: '5000m'
    }, {
      text: '10 000m',
      value: '10000m'
    }, {
      text: '5km',
      value: '5km'
    }, {
      text: '10km',
      value: '10km'
    }, {
      text: '15km',
      value: '15km'
    }, {
      text: 'półmaraton',
      value: '21km'
    }, {
      text: 'maraton',
      value: '42km'
    }, {
      text: '100km',
      value: '100km'
    }, {
      text: 'ultra',
      value: 'ultra'
    }, {
      text: 'inne',
      value: 'other'
    }],
    raceDistanceTrackStrings: [{
      text: '100m',
      value: '100m'
    }, {
      text: '200m',
      value: '200m'
    }, {
      text: '400m',
      value: '400m'
    }, {
      text: '800m',
      value: '800m'
    }, {
      text: '1000m',
      value: '1000m'
    }, {
      text: '1500m',
      value: '1500m'
    }, {
      text: '3000m',
      value: '3000m'
    }, {
      text: '3000m z p.',
      value: '3000m s.'
    }, {
      text: '5000m',
      value: '5000m'
    }, {
      text: '10 000m',
      value: '10000m'
    }],
    raceDistanceStreetStrings: [{
      text: '5km',
      value: '5km'
    }, {
      text: '10km',
      value: '10km'
    }, {
      text: '15km',
      value: '15km'
    }, {
      text: 'półmaraton',
      value: '21km'
    }, {
      text: 'maraton',
      value: '42km'
    }, {
      text: '100km',
      value: '100km'
    }, {
      text: 'ultra',
      value: 'ultra'
    }, {
      text: 'inne',
      value: 'other'
    }],
    measurableRaceDistanceStreetStrings: [{
      text: '5km',
      value: '5km'
    }, {
      text: '10km',
      value: '10km'
    }, {
      text: '15km',
      value: '15km'
    }, {
      text: 'półmaraton',
      value: '21km'
    }, {
      text: 'maraton',
      value: '42km'
    }, {
      text: '100km',
      value: '100km'
    }],
    measurableRaceDistanceStrings: [{
      text: '100m',
      value: '100m'
    }, {
      text: '200m',
      value: '200m'
    }, {
      text: '400m',
      value: '400m'
    }, {
      text: '800m',
      value: '800m'
    }, {
      text: '1000m',
      value: '1000m'
    }, {
      text: '1500m',
      value: '1500m'
    }, {
      text: '3000m',
      value: '3000m'
    }, {
      text: '3000m z p.',
      value: '3000m s.'
    }, {
      text: '5000m',
      value: '5000m'
    }, {
      text: '10 000m',
      value: '10000m'
    }, {
      text: '5km',
      value: '5km'
    }, {
      text: '10km',
      value: '10km'
    }, {
      text: '15km',
      value: '15km'
    }, {
      text: 'półmaraton',
      value: '21km'
    }, {
      text: 'maraton',
      value: '42km'
    }, {
      text: '100km',
      value: '100km'
    }],
    raceFrequency: [{
      text: 'Raz do roku lub rzadziej',
      value: 1
    }, {
      text: '2-6 razy w roku',
      value: 2
    }, {
      text: '1-2 razy w miesiącu',
      value: 3
    }, {
      text: 'Raz na tydzień lub częściej',
      value: 4
    }],
    tshirtSize: [{
      text: 'Męska S',
      value: 1
    }, {
      text: 'Męska M',
      value: 2
    }, {
      text: 'Męska L',
      value: 3
    }, {
      text: 'Męska XL',
      value: 4
    }, {
      text: 'Męska XXL',
      value: 5
    }, {
      text: 'Damska S',
      value: 6
    }, {
      text: 'Damska M',
      value: 7
    }, {
      text: 'Damska L',
      value: 8
    }, {
      text: 'Damska XL',
      value: 9
    }]
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: state,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */]
}));

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListMixin; });
var enhanceData = function enhanceData(results) {
  return results.map(function (i) {
    i._showDetails = false;
    i.isDetails = false;
    i.isEdit = false;
    return i;
  });
};

var ListMixin = {
  data: function data() {
    return {
      searchQuery: null,
      currentPage: 1,
      rowsTotal: 0,
      context: { rowsPerPage: 10 },
      perPage: 10,
      perPageOptions: [5, 10, 25, 50]
    };
  },

  methods: {
    showDetails: function showDetails(item) {
      item.isDetails = true;
      item.isEdit = false;
      item._showDetails = true;
    },
    showEdit: function showEdit(item) {
      item.isDetails = false;
      item.isEdit = true;
      item._showDetails = true;
    },
    hideData: function hideData(item) {
      item.isDetails = false;
      item.isEdit = false;
      item._showDetails = false;
    },
    prepareParams: function prepareParams() {
      var params = {};
      var ctx = this.context;
      if (ctx.sortBy) {
        params['ordering'] = (ctx.descending ? '-' : '') + ctx.sortBy;
      }
      if (ctx.rowsPerPage) {
        params['page_size'] = ctx.rowsPerPage;
      }
      if (ctx.page) {
        params['page'] = ctx.page;
      }
      if (ctx.searchQuery) {
        params['search'] = ctx.searchQuery;
      }
      return params;
    },
    enhanceListData: function enhanceListData(data) {
      var items = enhanceData(data.results);
      this.rowsTotal = data.count;
      return items;
    }
  }
};

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_izitoast__);


/* harmony default export */ __webpack_exports__["a"] = ({
  validators: {},
  data: function data() {
    return {
      submitting: false,
      formErrors: {},
      formData: {}
    };
  },

  computed: {
    message: function message() {
      return 'Zapisano dane';
    }
  },
  methods: {
    prepareData: function prepareData() {
      return this.formData;
    },
    submit: function submit(data) {
      throw new Error('Function submit must be overroded');
    },
    onSuccess: function onSuccess(data) {
      this.$emit('success', data);
      __WEBPACK_IMPORTED_MODULE_0_izitoast___default.a.show({
        message: this.message,
        color: 'green'
      });
      return data;
    },
    onError: function onError(data) {
      if (data.response.status === 400) {
        this.formErrors = data.response.data;
        this.$validate();
      }
      return data;
    },
    onFinally: function onFinally() {
      this.submitting = false;
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.$validate().then(function (success) {
        if (success) {
          _this.submitting = true;
          var data = _this.prepareData();
          var promise = _this.submit(data);
          promise.then(_this.onSuccess, _this.onError).finally(_this.onFinally);
        }
      });
    }
  }
});

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return registerRunnerSelf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accountConfirmEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return accountRunnerAdminConfirmEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return accountTrainerAdminConfirmEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return passwordReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return passwordResetConfirm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return passwordChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return user; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(12);


var registerRunnerSelf = function registerRunnerSelf(obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/users/registration/runner_self/', obj).then(function (resp) {
    return resp.data;
  });
};

var accountConfirmEmail = function accountConfirmEmail(token) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/users/verify-email/runner_self/', { key: token }).then(function (resp) {
    return resp.data;
  });
};

var accountRunnerAdminConfirmEmail = function accountRunnerAdminConfirmEmail(data) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/users/verify-email/runner/', data).then(function (resp) {
    return resp.data;
  });
};

var accountTrainerAdminConfirmEmail = function accountTrainerAdminConfirmEmail(data) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/users/verify-email/trainer/', data).then(function (resp) {
    return resp.data;
  });
};

var passwordReset = function passwordReset(email) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/users/password/reset/', { email: email }).then(function (resp) {
    return resp.data;
  });
};

var passwordResetConfirm = function passwordResetConfirm(data) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/users/password/reset-confirm/', data).then(function (resp) {
    return resp.data;
  });
};

var passwordChange = function passwordChange(data) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/rest-auth/password/change/', data).then(function (resp) {
    return resp.data;
  });
};

var login = function login(user) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/rest-auth/login/', user);
};

var user = function user() {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/user/');
};

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serverValidation; });
/* unused harmony export serverFakeValidation */
var serverValidation = function serverValidation(formErrors, name) {
  return function () {
    if (formErrors[name] !== undefined && formErrors[name].length > 0) {
      var ret = formErrors[name][0];
      delete formErrors[name];
      return ret;
    }
  };
};

var serverFakeValidation = function serverFakeValidation(formErrors, name) {
  return function () {
    if (formErrors[name] !== undefined && formErrors[name].length > 0) {
      var ret = formErrors[name][0];
      return ret;
    }
  };
};

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/avatar.dda6fd6.png";

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchTrainers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchSimpleAdminTrainers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTrainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return registerTrainerAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateTrainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activateTrainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deactivateTrainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sendMailTrainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api__ = __webpack_require__(12);





var fetchTrainers = function fetchTrainers(params) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].get('/trainers/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var fetchSimpleAdminTrainers = function fetchSimpleAdminTrainers(params) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].get('/trainers/simple/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var getTrainer = function getTrainer(id) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].get('/trainers/' + id + '/').then(function (resp) {
    return resp.data;
  });
};
var registerTrainerAdmin = function registerTrainerAdmin(obj) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].post('/users/registration/trainer/', obj).then(function (resp) {
    return resp.data;
  });
};

var updateTrainer = function updateTrainer(obj) {
  var fd = new FormData();
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(obj)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

      var key = _ref2[0];
      var value = _ref2[1];

      if (key === 'avatar_thumbnail' && !(value instanceof File)) {
        continue;
      }
      if (value === null) {
        continue;
      }
      fd.append(key, value);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].put('/trainers/' + obj.id + '/', fd).then(function (resp) {
    return resp.data;
  });
};

var activateTrainer = function activateTrainer(obj) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].patch('/trainers/' + obj.id + '/', { is_active: true }).then(function (resp) {
    return resp.data;
  });
};
var deactivateTrainer = function deactivateTrainer(obj) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].patch('/trainers/' + obj.id + '/', { is_active: false }).then(function (resp) {
    return resp.data;
  });
};
var sendMailTrainer = function sendMailTrainer(obj) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].post('/trainers/' + obj.id + '/resend_email/', {}).then(function (resp) {
    return resp.data;
  });
};

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return boolFormatter; });

var boolFormatter = function boolFormatter(value, key, item) {
  return value ? 'Tak' : 'Nie';
};

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchPayments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchRunnerPayments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchRunnerPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return payRunnerPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updatePayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return patchPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deletePayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return paidPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return unpaidPayment; });
/* unused harmony export downalodPaymentDocument */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(12);


var fetchPayments = function fetchPayments(params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/payments/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var fetchRunnerPayments = function fetchRunnerPayments(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/runners/' + runner.id + '/payments/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var fetchRunnerPayment = function fetchRunnerPayment(runner, id) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/runners/' + runner.id + '/payments/' + id + '/').then(function (resp) {
    return resp.data;
  });
};
var payRunnerPayment = function payRunnerPayment(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/runners/' + runner.id + '/payments/' + obj.id + '/pay/').then(function (resp) {
    return resp.data;
  });
};
var createPayment = function createPayment(obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/payments/', obj).then(function (resp) {
    return resp.data;
  });
};

var updatePayment = function updatePayment(obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/payments/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var patchPayment = function patchPayment(obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].patch('/payments/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var deletePayment = function deletePayment(obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].delete('/payments/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var paidPayment = function paidPayment(id, type) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/payments/' + id + '/paid/', { 'payment_type': type }).then(function (resp) {
    return resp.data;
  });
};

var unpaidPayment = function unpaidPayment(id) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].delete('/payments/' + id + '/paid/').then(function (resp) {
    return resp.data;
  });
};

var downalodPaymentDocument = function downalodPaymentDocument(obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/payments/' + obj.id + '/download/').then(function (resp) {
    return resp.data;
  });
};

/***/ }),
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerDataField_vue__ = __webpack_require__(296);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_267d26a3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerDataField_vue__ = __webpack_require__(631);
function injectStyle (ssrContext) {
  __webpack_require__(630)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerDataField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_267d26a3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerDataField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextField_vue__ = __webpack_require__(319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aced21e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextField_vue__ = __webpack_require__(676);
function injectStyle (ssrContext) {
  __webpack_require__(675)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aced21e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDate_vue__ = __webpack_require__(131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f0d611_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputDate_vue__ = __webpack_require__(528);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f0d611_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_ConfirmDialog__ = __webpack_require__(405);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ConfirmDialog: __WEBPACK_IMPORTED_MODULE_0__utils_ConfirmDialog__["a" /* default */] },
  mounted: function mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open
 * }
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: 'primary',
        width: 400,
        confirmText: 'Ok',
        cancelText: 'Anuluj'
      }
    };
  },

  methods: {
    open: function open(title, message, options) {
      var _this = this;

      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.options, options);

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
      });
    },
    agree: function agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel: function cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NotFoundView__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__packages_Packages__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__payments_AdminPayments__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__payments_RunnerPayments__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__payments_RunnerPaymentPay__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__payments_RunnerPaymentReturn__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth_Login__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__auth_PasswordReset__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__auth_PasswordResetConfirm__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__auth_RunnerSelfRegister__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__auth_RegistrationCompleted__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__auth_AccountConfirmEmail__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__auth_AccountRunnerAdminConfirmEmail__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__auth_AccountTrainerAdminConfirmEmail__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__auth_ChangePassword__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__runners_AdminRunners__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__runners_TrainerRunners__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__runners_RunnerData__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__runners_RunnerApplicationDataPackage__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__runners_RunnerApplicationDataTrainer__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__runners_RunnerApplicationDataFirst__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__runners_RunnerApplicationDataSecond__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__plan_Plan__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__physical_tests_PhysicalTests__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__results_Results__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__notifications_Notifications__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__races_Races__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__videos_Videos__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Page__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__trainers_AdminTrainers__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__trainers_TrainerData__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__trainers_TrainerDataPresentation__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__layouts_UnauthenticatedLayout__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__layouts_AppLayout__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__layouts_TrainerPanelLayout__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__layouts_RunnerPanelLayout__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__layouts_AdminPanelLayout__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__layouts_Forum__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__store__ = __webpack_require__(20);

















































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/site-layout',
    name: 'unauthenticated',
    component: __WEBPACK_IMPORTED_MODULE_34__layouts_UnauthenticatedLayout__["a" /* default */],
    meta: { requiresAuth: false },
    children: [{
      path: '/accounts/login/',
      name: 'login',
      component: __WEBPACK_IMPORTED_MODULE_8__auth_Login__["a" /* default */]
    }, {
      path: '/accounts/password-reset/',
      name: 'password-reset',
      component: __WEBPACK_IMPORTED_MODULE_9__auth_PasswordReset__["a" /* default */]
    }, {
      path: '/accounts/password-reset-confirm/:uidb64/:token/',
      name: 'password-confirm-email',
      component: __WEBPACK_IMPORTED_MODULE_10__auth_PasswordResetConfirm__["a" /* default */]
    }, {
      path: '/accounts/register-self/',
      name: 'register-self',
      component: __WEBPACK_IMPORTED_MODULE_11__auth_RunnerSelfRegister__["a" /* default */]
    }, {
      path: '/accounts/registration-completed/',
      name: 'registration-completed',
      component: __WEBPACK_IMPORTED_MODULE_12__auth_RegistrationCompleted__["a" /* default */]
    }, {
      path: '/accounts/account-confirm-email/runner_self/:token/',
      name: 'account-confirm-email',
      component: __WEBPACK_IMPORTED_MODULE_13__auth_AccountConfirmEmail__["a" /* default */]
    }, {
      path: '/accounts/account-confirm-email/runner/:token/',
      name: 'account-runner-admin-confirm-email',
      component: __WEBPACK_IMPORTED_MODULE_14__auth_AccountRunnerAdminConfirmEmail__["a" /* default */]
    }, {
      path: '/accounts/account-confirm-email/trainer/:token/',
      name: 'account-trainer-admin-confirm-email',
      component: __WEBPACK_IMPORTED_MODULE_15__auth_AccountTrainerAdminConfirmEmail__["a" /* default */]
    }]
  }, {
    path: '/',
    name: 'app',
    redirect: function redirect(to) {
      if (!__WEBPACK_IMPORTED_MODULE_40__store__["a" /* default */].getters.isAuthenticated) {
        return { name: 'login' };
      }
      var authUser = __WEBPACK_IMPORTED_MODULE_40__store__["a" /* default */].getters.authUser;
      if (authUser) {
        if (authUser.role_id === 'ADMIN') {
          return { name: 'runners-admin' };
        } else if (authUser.role_id === 'TRAINER') {
          return { name: 'trainer-runners', params: { id: authUser.id } };
        } else if (authUser.role_id === 'RUNNER') {
          return { name: 'runner-plan', params: { id: authUser.id } };
        }
      }
      return { name: 'login' };
    }
  }, {
    path: '/my-profile',
    name: 'my-profile',
    redirect: function redirect(to) {
      if (!__WEBPACK_IMPORTED_MODULE_40__store__["a" /* default */].getters.isAuthenticated) {
        return { name: 'login' };
      }
      var authUser = __WEBPACK_IMPORTED_MODULE_40__store__["a" /* default */].getters.authUser;
      if (authUser) {
        if (authUser.role_id === 'ADMIN') {
          return { name: 'admin-change-password' };
        } else if (authUser.role_id === 'TRAINER') {
          return { name: 'trainer-data', params: { id: authUser.id } };
        } else if (authUser.role_id === 'RUNNER') {
          return { name: 'runner-data', params: { id: authUser.id } };
        }
      }
      return { name: 'login' };
    }
  }, {
    path: '/app-layout',
    name: 'app-layout',
    component: __WEBPACK_IMPORTED_MODULE_35__layouts_AppLayout__["a" /* default */],
    meta: { requiresAuth: true },
    children: [{
      path: '/admin/',
      name: 'admin-panel',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_38__layouts_AdminPanelLayout__["a" /* default */]
      },
      redirect: { name: 'runners-admin' },
      meta: { adminAuth: true },
      children: [{
        path: 'accounts/change-password/',
        name: 'admin-change-password',
        component: __WEBPACK_IMPORTED_MODULE_16__auth_ChangePassword__["a" /* default */]
      }, {
        path: 'runners/',
        name: 'runners-admin',
        component: __WEBPACK_IMPORTED_MODULE_17__runners_AdminRunners__["a" /* default */]
      }, {
        path: 'trainers/',
        name: 'trainers-admin',
        component: __WEBPACK_IMPORTED_MODULE_31__trainers_AdminTrainers__["a" /* default */]
      }, {
        path: 'packages/',
        name: 'packages',
        component: __WEBPACK_IMPORTED_MODULE_3__packages_Packages__["a" /* default */]
      }, {
        path: 'videos/',
        name: 'admin-videos',
        component: __WEBPACK_IMPORTED_MODULE_29__videos_Videos__["a" /* default */]
      }, {
        path: 'payments/',
        name: 'payments-admin',
        component: __WEBPACK_IMPORTED_MODULE_4__payments_AdminPayments__["a" /* default */]
      }, {
        path: 'forum/',
        name: 'forum-admin',
        component: __WEBPACK_IMPORTED_MODULE_39__layouts_Forum__["a" /* default */]
      }, {
        path: 'pages/:slug/',
        name: 'pages-admin',
        component: __WEBPACK_IMPORTED_MODULE_30__pages_Page__["a" /* default */]
      }]
    }, {
      path: '/trainers/:id/',
      name: 'trainer-panel',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_36__layouts_TrainerPanelLayout__["a" /* default */]
      },
      meta: { trainerAuth: true },
      children: [{
        path: 'accounts/change-password/',
        name: 'trainer-change-password',
        component: __WEBPACK_IMPORTED_MODULE_16__auth_ChangePassword__["a" /* default */]
      }, {
        path: 'profile/',
        name: 'trainer-data',
        component: __WEBPACK_IMPORTED_MODULE_32__trainers_TrainerData__["a" /* default */]
      }, {
        path: 'runners/',
        name: 'trainer-runners',
        component: __WEBPACK_IMPORTED_MODULE_18__runners_TrainerRunners__["a" /* default */]
      }, {
        path: 'pages/:slug/',
        name: 'trainer-pages',
        component: __WEBPACK_IMPORTED_MODULE_30__pages_Page__["a" /* default */]
      }, {
        path: 'notifications/',
        name: 'trainer-notifications',
        component: __WEBPACK_IMPORTED_MODULE_27__notifications_Notifications__["a" /* default */]
      }, {
        path: 'forum/',
        name: 'trainer-forum',
        component: __WEBPACK_IMPORTED_MODULE_39__layouts_Forum__["a" /* default */]
      }, {
        path: 'videos/',
        name: 'trainer-videos',
        component: __WEBPACK_IMPORTED_MODULE_29__videos_Videos__["a" /* default */]
      }]
    }, {
      path: '/runners/:id/',
      name: 'runner-panel-fluid',
      component: __WEBPACK_IMPORTED_MODULE_37__layouts_RunnerPanelLayout__["a" /* default */],
      props: { fluid: true },
      children: [{
        path: 'plan/',
        name: 'runner-plan',
        component: __WEBPACK_IMPORTED_MODULE_24__plan_Plan__["a" /* default */]
      }]
    }, {
      path: '/runners/:id/',
      name: 'runner-panel',
      component: __WEBPACK_IMPORTED_MODULE_37__layouts_RunnerPanelLayout__["a" /* default */],
      children: [{
        path: 'accounts/change-password/',
        name: 'runner-change-password',
        component: __WEBPACK_IMPORTED_MODULE_16__auth_ChangePassword__["a" /* default */]
      }, {
        path: 'profile/',
        name: 'runner-data',
        component: __WEBPACK_IMPORTED_MODULE_19__runners_RunnerData__["a" /* default */]
      }, {
        path: 'application-package-step/',
        name: 'runner-application-data-package',
        component: __WEBPACK_IMPORTED_MODULE_20__runners_RunnerApplicationDataPackage__["a" /* default */]
      }, {
        path: 'application-trainer-step/',
        name: 'runner-application-data-trainer',
        component: __WEBPACK_IMPORTED_MODULE_21__runners_RunnerApplicationDataTrainer__["a" /* default */]
      }, {
        path: 'application-first-step/',
        name: 'runner-application-data-first',
        component: __WEBPACK_IMPORTED_MODULE_22__runners_RunnerApplicationDataFirst__["a" /* default */]
      }, {
        path: 'application-second-step/',
        name: 'runner-application-data-second',
        component: __WEBPACK_IMPORTED_MODULE_23__runners_RunnerApplicationDataSecond__["a" /* default */]
      }, {
        path: 'trainer/',
        name: 'runner-trainer-data',
        component: __WEBPACK_IMPORTED_MODULE_33__trainers_TrainerDataPresentation__["a" /* default */]
      }, {
        path: 'hrmax/',
        name: 'runner-hrmax',
        component: __WEBPACK_IMPORTED_MODULE_25__physical_tests_PhysicalTests__["a" /* default */]
      }, {
        path: 'pages/:slug/',
        name: 'runner-pages',
        meta: { runnerAuth: true },
        component: __WEBPACK_IMPORTED_MODULE_30__pages_Page__["a" /* default */]
      }, {
        path: 'progression/',
        name: 'runner-progression',
        component: __WEBPACK_IMPORTED_MODULE_26__results_Results__["a" /* default */]
      }, {
        path: 'races/',
        name: 'runner-races',
        component: __WEBPACK_IMPORTED_MODULE_28__races_Races__["a" /* default */]
      }, {
        path: 'payments/',
        name: 'runner-payments',
        component: __WEBPACK_IMPORTED_MODULE_5__payments_RunnerPayments__["a" /* default */]
      }, {
        path: 'payments/:payment_id/pay/',
        name: 'runner-payments-pay',
        meta: { runnerAuth: true },
        component: __WEBPACK_IMPORTED_MODULE_6__payments_RunnerPaymentPay__["a" /* default */]
      }, {
        path: 'payments/:payment_id/:status/',
        name: 'runner-payments-return',
        meta: { runnerAuth: true },
        component: __WEBPACK_IMPORTED_MODULE_7__payments_RunnerPaymentReturn__["a" /* default */]
      }, {
        path: 'videos/',
        name: 'runner-videos',
        meta: { runnerAuth: true },
        component: __WEBPACK_IMPORTED_MODULE_29__videos_Videos__["a" /* default */]
      }, {
        path: 'forum/',
        name: 'runner-forum',
        component: __WEBPACK_IMPORTED_MODULE_39__layouts_Forum__["a" /* default */]
      }, {
        path: 'notifications/',
        name: 'runner-notifications',
        meta: { runnerAuth: true },
        component: __WEBPACK_IMPORTED_MODULE_27__notifications_Notifications__["a" /* default */]
      }]
    }, {
      path: '*',
      component: __WEBPACK_IMPORTED_MODULE_2__components_NotFoundView__["a" /* default */]
    }]
  }]
});

var hasAccess = function hasAccess(to, role) {
  if (role === 'ADMIN') {
    return true;
  }
  if (to.matched.some(function (record) {
    return record.meta.adminAuth;
  })) {
    return false;
  } else if (to.matched.some(function (record) {
    return record.meta.trainerAuth;
  })) {
    return role === 'TRAINER';
  } else if (to.matched.some(function (record) {
    return record.meta.runnerAuth;
  })) {
    return role === 'RUNNER';
  } else {
    return true;
  }
};

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (!__WEBPACK_IMPORTED_MODULE_40__store__["a" /* default */].getters.isAuthenticated) {
      return next({
        name: 'login',
        query: { redirect: to.fullPath }
      });
    }
    if (hasAccess(to, __WEBPACK_IMPORTED_MODULE_40__store__["a" /* default */].getters.authUser.role_id)) {
      return next();
    } else {
      return next({
        name: 'login',
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_formatters__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PackageForm__ = __webpack_require__(448);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'packages',
  components: { PackageForm: __WEBPACK_IMPORTED_MODULE_8__PackageForm__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__["a" /* ListMixin */]],
  data: function data() {
    return {
      showAdd: false,
      loading: true,
      packages: [],
      headers: [{
        value: 'name',
        text: 'nazwa',
        sortable: true
      }, {
        value: 'price',
        text: 'cena',
        sortable: true
      }, {
        value: 'trainer_name',
        text: 'trener',
        sortable: false
      }, {
        value: 'is_active',
        text: 'aktywny',
        sortable: true
      }, {
        value: 'with_tshirt',
        text: 'koszulka',
        sortable: true
      }, {
        value: 'with_card',
        text: 'karta',
        sortable: true
      }, {
        value: 'actions',
        text: 'akcje',
        align: 'center',
        sortable: false,
        'class': 'px-0'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['allTrainersOptions'])),
  created: function created() {
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["g" /* ALL_TRAINERS_REQUEST */]);
  },

  watch: {
    context: {
      handler: function handler() {
        this.getPackages();
      },

      deep: true
    }
  },
  methods: {
    formatterBool: function formatterBool(data) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils_formatters__["a" /* boolFormatter */])(data);
    },
    getPackages: function getPackages() {
      var _this = this;

      this.loading = true;
      var params = this.prepareParams();
      if (this.context.trainer && this.context.trainer !== null) {
        params['trainer'] = this.context.trainer;
      }
      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* fetchPackages */])(params);
      return promise.then(this.enhanceListData).then(function (data) {
        _this.loading = false;
        _this.packages = data;
        return data;
      });
    },

    refresh: __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.debounce(function () {
      this.getPackages();
    }, 400),
    deleteItem: function deleteItem(item) {
      var _this2 = this;

      this.$root.$confirm('Usuń pakiet', 'Czy na pewno usunąć pakiet?', { confirmText: 'Usuń', color: 'error' }).then(function (willDelete) {
        if (willDelete) {
          var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* deletePackage */])(item);
          return promise.then(function () {
            _this2.refresh();
            __WEBPACK_IMPORTED_MODULE_4_izitoast___default.a.show({
              message: 'Pakiet został usunięty',
              color: 'green'
            });
          }).catch(function () {
            __WEBPACK_IMPORTED_MODULE_4_izitoast___default.a.show({
              message: 'Nie udało się usunąć pakietu. Istnieją przypisani do niego zawodnicy.',
              color: 'red'
            });
          });
        }
      });
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchPackages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updatePackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deletePackage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(12);


var fetchPackages = function fetchPackages(params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/packages/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var createPackage = function createPackage(obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/packages/', obj).then(function (resp) {
    return resp.data;
  });
};

var updatePackage = function updatePackage(obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/packages/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var deletePackage = function deletePackage(obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].delete('/packages/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_Fields__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_formMixin__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Fields: __WEBPACK_IMPORTED_MODULE_2__forms_Fields__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__utils_formMixin__["a" /* default */]],
  props: {
    userPackage: {
      type: Object,
      default: function _default() {
        return { trainer: null, is_active: true };
      }
    }
  },
  data: function data() {
    return {
      isUpdate: false,
      formData: {
        trainer: null,
        is_active: true
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['allTrainersOptions']), {
    fields: function fields() {
      return [{ comp: 'text', id: 'name', label: 'Nazwa', props: {} }, { comp: 'textarea', id: 'description', label: 'Opis', props: {} }, { comp: 'text', id: 'price', label: 'Cena', props: {} }, { comp: 'select', id: 'trainer', label: 'Domyślny trener', props: { items: this.allTrainersOptions, clearable: true } }, { comp: 'checkbox', id: 'with_tshirt', label: 'Koszulka', props: {} }, { comp: 'checkbox', id: 'with_card', label: 'Karta', props: {} }, { comp: 'checkbox', id: 'is_active', label: 'Aktywny', when: this.isUpdate, props: {} }];
    },
    message: function message() {
      return this.isUpdate ? 'Pakiet został edytowany' : 'Pakiet został dodany';
    }
  }),
  created: function created() {
    this.formData = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.userPackage);
    if (this.userPackage.id) {
      this.isUpdate = true;
    }
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["g" /* ALL_TRAINERS_REQUEST */]);
  },

  methods: {
    prepareData: function prepareData() {
      this.formData.trainer = this.formData.trainer || null;
      return this.formData;
    },
    submit: function submit(data) {
      var _this = this;

      if (this.isUpdate) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__api__["d" /* updatePackage */])(data);
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createPackage */])(data).then(function (data) {
          _this.formData = { trainer: null, is_active: true };
          _this.validation.reset();
          return data;
        });
      }
    }
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_components_VTextField__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_components_VTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_components_VTextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_VTextarea__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_VTextarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_VTextarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VSelect__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VCheckbox__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VCheckbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VCheckbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputDate__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    fields: Array,
    object: Object,
    errors: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    fieldUCFirst: function fieldUCFirst(field) {
      return Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["upperFirst"])(Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["camelCase"])(field.id));
    },
    getFieldComp: function getFieldComp(comp) {
      if (typeof comp === 'string') {
        switch (comp) {
          case 'date':
            return __WEBPACK_IMPORTED_MODULE_4__InputDate__["a" /* default */];
          case 'textarea':
            return __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_VTextarea___default.a;
          case 'text':
            return __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_components_VTextField___default.a;
          case 'select':
            return __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VSelect___default.a;
          case 'file':
            // return InputFile
            return __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_components_VTextField___default.a;
          case 'checkbox':
            return __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VCheckbox___default.a;
        }
      }
      return comp;
    },
    hasErrors: function hasErrors(name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0;
    },
    getErrors: function getErrors(name) {
      return this.errors[name] || [];
    }
  }
});

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: String,
    error: Boolean,
    label: String,
    month: Boolean,
    errorMessages: [String, Array]
  },
  data: function data() {
    return {
      dateFormatted: this.formatDate(this.value),
      menu1: false,
      val: null
    };
  },

  watch: {
    value: function value(val) {
      this.dateFormatted = this.formatDate(this.value);
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split$0$split = date.split('T')[0].split('-'),
          _date$split$0$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split$0$split, 3),
          year = _date$split$0$split2[0],
          month = _date$split$0$split2[1],
          day = _date$split$0$split2[2];

      if (day !== undefined) {
        return year + '-' + month + '-' + day;
      } else {
        return year + '-' + month;
      }
    },
    onInput: function onInput(event) {
      if (!event) return null;
      this.$emit('input', event.target.value);
    },
    onDPInput: function onDPInput(val) {
      this.$refs.menu1.save(val);
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export statusFormatter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ListMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentForm__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentStatus__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__runners_RunnerSelect__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_FileUpload__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var statusFormatter = function statusFormatter(value, key, item) {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'payments',
  components: { PaymentForm: __WEBPACK_IMPORTED_MODULE_3__PaymentForm__["a" /* default */], RunnerSelect: __WEBPACK_IMPORTED_MODULE_5__runners_RunnerSelect__["a" /* default */], PaymentStatus: __WEBPACK_IMPORTED_MODULE_4__PaymentStatus__["a" /* default */], FileUpload: __WEBPACK_IMPORTED_MODULE_6__utils_FileUpload__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__utils_ListMixin__["a" /* ListMixin */]],
  data: function data() {
    return {
      context: { rowsPerPage: 10, sortBy: 'period', descending: true },
      menu1: false,
      menu2: false,
      showAdd: false,
      loading: true,
      payments: [],
      headers: [{
        value: 'runner',
        text: 'zawodnik',
        sortable: false
      }, {
        value: 'period',
        text: 'okres',
        sortable: true
      }, {
        value: 'price',
        text: 'cena',
        sortable: true
      }, {
        value: 'payment_status',
        text: 'status',
        sortable: false
      }, {
        value: 'document',
        text: 'dokument',
        sortable: false
      }, {
        value: 'actions',
        text: 'akcje',
        align: 'center',
        sortable: false,
        width: '180px'
      }]
    };
  },

  watch: {
    context: {
      handler: function handler() {
        this.getPayments();
      },

      deep: true
    }
  },
  methods: {
    finish: function finish(e, item) {
      if (e.data && e.data.id) {
        Object(__WEBPACK_IMPORTED_MODULE_0__api__["g" /* patchPayment */])({ id: item.id, document: e.data.id }).then(function (data) {
          item.document_url = data.document_url;
          item.document_filename = data.document_filename;
        });
      }
    },
    getPayments: function getPayments() {
      var _this = this;

      this.loading = true;
      var params = this.prepareParams();
      if (this.context.end !== null) {
        params['period__lte'] = this.context.end;
      }
      if (this.context.start !== null) {
        params['period__gte'] = this.context.start;
      }
      if (this.context.runner !== null) {
        params['runner'] = this.context.runner;
      }
      if (this.context.paymentStatus !== null) {
        params['payment_status'] = this.context.paymentStatus;
      }
      if (params.ordering) {
        params.ordering += ',-id';
      }
      console.log(params);
      var promise = Object(__WEBPACK_IMPORTED_MODULE_0__api__["c" /* fetchPayments */])(params);
      return promise.then(this.enhanceListData).then(function (data) {
        _this.loading = false;
        _this.payments = data;
        return data;
      });
    },

    refresh: __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.debounce(function () {
      this.getPayments();
    }, 400),
    deletePayment: function deletePayment(item) {
      var _this2 = this;

      this.$root.$confirm('Usuń płatnośc', 'Czy na pewno usunąć płatność?', { confirmText: 'Usuń', color: 'error' }).then(function (willDelete) {
        if (willDelete) {
          var promise = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* deletePayment */])(item);
          return promise.then(function () {
            _this2.refresh();
            __WEBPACK_IMPORTED_MODULE_2_izitoast___default.a.show({
              message: 'Płatność została usunięta',
              color: 'green'
            });
          }).catch(function () {
            __WEBPACK_IMPORTED_MODULE_2_izitoast___default.a.show({
              message: 'Nie udało się usunąć płatności. Została już opłacona.',
              color: 'red'
            });
          });
        }
      });
    }
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__runners_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_Fields__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_formMixin__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__runners_RunnerSelect__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_FileUpload__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Fields: __WEBPACK_IMPORTED_MODULE_3__forms_Fields__["a" /* default */], RunnerSelect: __WEBPACK_IMPORTED_MODULE_5__runners_RunnerSelect__["a" /* default */], FileUpload: __WEBPACK_IMPORTED_MODULE_6__utils_FileUpload__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_formMixin__["a" /* default */]],
  props: {
    userPayment: {
      type: Object,
      default: function _default() {
        var today = __WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf('month');
        var dueDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf('month').add(7, 'd');
        return {
          period: __WEBPACK_IMPORTED_MODULE_7_moment___default()(today).format('YYYY-MM'),
          due_date: __WEBPACK_IMPORTED_MODULE_7_moment___default()(dueDate).format('YYYY-MM-DD')
        };
      }
    }
  },
  data: function data() {
    return {
      runner: null,
      isUpdate: false,
      formData: {
        runner: null,
        price: 0
      }
    };
  },

  computed: {
    fields: function fields() {
      return [{ comp: 'date', id: 'period', label: 'Okres', props: { month: true } }, { comp: 'text', id: 'runner', label: 'Zawodnik' }, { comp: 'text', id: 'price', label: 'Cena' }, { comp: 'date', id: 'due_date', label: 'Termin płatności' }, { comp: 'text', id: 'document', label: 'Plik' }];
    },
    message: function message() {
      return this.isUpdate ? 'Płatność została edytowana' : 'Płatność została dodana';
    }
  },
  created: function created() {
    this.formData = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.userPayment);
    if (this.userPayment.id) {
      this.isUpdate = true;
      this.formData.document = undefined;
    }
  },

  methods: {
    deleteFile: function deleteFile() {
      this.formData.document = null;
      this.formData.document_url = null;
    },
    finish: function finish(e) {
      if (e.data && e.data.id) {
        this.formData.document = e.data.id;
      }
    },
    changeRunner: function changeRunner() {
      var _this = this;

      if (this.formData.runner) {
        Object(__WEBPACK_IMPORTED_MODULE_1__runners_api__["g" /* getRunner */])(this.formData.runner).then(function (data) {
          _this.$set(_this.formData, 'price', data.price);
        });
      }
    },
    submit: function submit(data) {
      var _this2 = this;

      if (this.isUpdate) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__api__["j" /* updatePayment */])(data);
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* createPayment */])(data).then(function (data) {
          _this2.formData = { runner: null, price: 0 };
          _this2.validation.reset();
          return data;
        });
      }
    }
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerSelect_vue__ = __webpack_require__(135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_729ebce2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerSelect_vue__ = __webpack_require__(534);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_729ebce2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__runners_api__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: Number,
    error: Boolean,
    label: String,
    errorMessages: [String, Array]
  },
  data: function data() {
    return {
      items: [],
      val: null,
      search: null
    };
  },
  created: function created() {
    var _this = this;

    if (this.value) {
      Object(__WEBPACK_IMPORTED_MODULE_0__runners_api__["g" /* getRunner */])(this.value).then(function (data) {
        _this.val = data;
        _this.updateItems(data.full_name);
      });
    } else {
      this.updateItems(null);
    }
  },

  watch: {
    search: function search(val) {
      this.updateItems(val);
    }
  },
  methods: {
    change: function change(i) {
      if (i) {
        this.$emit('input', i.id);
      } else {
        this.$emit('input', null);
      }
    },
    updateItems: function updateItems(text) {
      var _this2 = this;

      var params = {};
      if (text) {
        params['search'] = text;
      }
      Object(__WEBPACK_IMPORTED_MODULE_0__runners_api__["c" /* fetchRunners */])(params).then(function (data) {
        _this2.items = data.results;
      });
    }
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue__ = __webpack_require__(137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05004f3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUpload_vue__ = __webpack_require__(536);
function injectStyle (ssrContext) {
  __webpack_require__(535)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05004f3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05004f3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'upload-btn',
  props: {
    accept: {
      default: '*',
      type: String
    },
    block: {
      default: false,
      type: Boolean
    },
    fileChangedCallback: {
      default: undefined,
      type: Function
    },
    color: {
      default: 'primary',
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    },
    flat: {
      default: false,
      type: Boolean
    },
    hover: {
      default: true,
      type: Boolean
    },
    icon: {
      default: false,
      type: Boolean
    },
    large: {
      default: false,
      type: Boolean
    },
    loading: {
      default: false,
      type: Boolean
    },
    name: {
      default: 'uploadFile',
      type: String
    },
    outline: {
      default: false,
      type: Boolean
    },
    ripple: {
      default: true,
      type: Boolean
    },
    round: {
      default: false,
      type: Boolean
    },
    small: {
      default: false,
      type: Boolean
    },
    target: {
      type: String
    },
    action: {
      type: String,
      default: 'POST'
    },
    alias: {
      type: String,
      default: 'file'
    },
    title: {
      default: 'Prześlij plik',
      type: String
    }
  },
  data: function data() {
    return {
      file: null
    };
  },

  computed: {
    classes: function classes() {
      var classes = {
        'v-btn--block': this.block,
        'v-btn--flat': this.flat,
        'upload-btn-hover': this.hover,
        'v-btn--icon': this.icon,
        'v-btn--large': this.large,
        'v-btn--loading': this.loading,
        'v-btn--outline': this.outline,
        'v-btn--round': this.round,
        'v-btn--small': this.small,
        'v-btn--disabled': this.disabled
      };
      var classString = '';
      for (var key in classes) {
        if (classes[key]) {
          classString += key + ' ';
        }
      }
      return classString;
    }
  },
  methods: {
    uploadProgress: function uploadProgress(oEvent) {
      if (oEvent.lengthComputable) {
        var percentComplete = Math.round(oEvent.loaded * 100 / oEvent.total);
        this.$emit('progress', percentComplete);
      } else {
        // Unable to compute progress information since the total size is unknown
        this.$emit('progress', false);
      }
    },
    onFileChange: function onFileChange(e) {
      var _this = this;

      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        return;
      };

      this.file = files[0];
      var formData = new FormData();
      formData.append(this.alias, this.file);
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */])({
        method: this.action,
        url: this.target,
        data: formData,
        onUploadProgress: this.uploadProgress
      }).then(function (data) {
        _this.$emit('finish', data);
      });
    }
  }
});

/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_izitoast__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['status', 'id'],
  computed: {
    'statusDisplay': function statusDisplay() {
      var value = this.status;
      if (value === 'paid') {
        return 'Opłacono';
      } else if (value === 'exceeded') {
        return 'Termin przekroczony';
      } else if (value === 'unpaid') {
        return 'Nieopłacone';
      }
      return '';
    }
  },
  methods: {
    setPaid: function setPaid(type) {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__api__["f" /* paidPayment */])(this.id, type).then(function (data) {
        _this.$emit('change', true);
        __WEBPACK_IMPORTED_MODULE_1_izitoast___default.a.show({
          message: 'Opłacono',
          color: 'green'
        });
      });
    },
    setNotPaid: function setNotPaid() {
      var _this2 = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__api__["i" /* unpaidPayment */])(this.id).then(function (data) {
        _this2.$emit('change', false);
        __WEBPACK_IMPORTED_MODULE_1_izitoast___default.a.show({
          message: 'Odznaczono opłacenie',
          color: 'green'
        });
      });
    }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RunnerPaymentStatus__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'payments',
  components: { RunnerPaymentStatus: __WEBPACK_IMPORTED_MODULE_5__RunnerPaymentStatus__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__["a" /* ListMixin */]],
  data: function data() {
    return {
      context: { rowsPerPage: 10, sortBy: 'period', descending: true },
      menu1: false,
      menu2: false,
      loading: true,
      payments: []
    };
  },
  created: function created() {
    if (this.$route.query.status) {
      if (this.$route.query.status === 'success') {
        __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
          message: 'Płatność została zrealizowana',
          color: 'green'
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
          message: 'Płatność nie mogła zostać zrealizowana',
          color: 'red'
        });
      }
    }
  },

  watch: {
    context: {
      handler: function handler() {
        this.getPayments();
      },

      deep: true
    },
    '$route': 'getPayments'
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    headers: function headers() {
      if (this.isTrainer) {
        return [{
          value: 'period',
          text: 'okres',
          sortable: true
        }, {
          value: 'payment_status',
          text: 'status',
          sortable: false
        }];
      } else {
        return [{
          value: 'period',
          text: 'okres',
          sortable: true
        }, {
          value: 'price',
          text: 'cena',
          sortable: true
        }, {
          value: 'payment_status',
          text: 'status',
          sortable: false
        }, {
          value: 'due_date',
          text: 'termin płatności',
          sortable: false
        }, {
          value: 'document',
          text: 'rachunki',
          sortable: false
        }];
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapState */])(['runner']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['isActiveRunner', 'isTrainer'])),
  methods: {
    getPayments: function getPayments() {
      var _this = this;

      this.loading = true;
      var params = this.prepareParams();
      if (this.context.end !== null) {
        params['period__lte'] = this.context.end;
      }
      if (this.context.start !== null) {
        params['period__gte'] = this.context.start;
      }
      if (this.context.paymentStatus !== null) {
        params['payment_status'] = this.context.paymentStatus;
      }
      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["e" /* fetchRunnerPayments */])(this.runner, params);
      return promise.then(this.enhanceListData).then(function (data) {
        _this.loading = false;
        _this.payments = data;
        return data;
      });
    },

    refresh: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function () {
      this.getPayments();
    }, 400)
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['status', 'id', 'runner_id'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    'statusDisplay': function statusDisplay() {
      var value = this.status;
      if (value === 'paid') {
        return 'Opłacono';
      } else if (value === 'exceeded') {
        return 'Termin przekroczony';
      } else if (value === 'unpaid') {
        return 'Nieopłacone';
      }
      return '';
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isActiveRunner']))
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      payment: {},
      dotpay: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(['runner'])),
  created: function created() {
    this.fetchPayment();
  },

  watch: {
    '$route': 'fetchPayment'
  },
  methods: {
    fetchPayment: function fetchPayment() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__api__["d" /* fetchRunnerPayment */])(this.runner, this.$route.params.payment_id).then(function (payment) {
        _this.payment = payment;
      });
    },
    pay: function pay() {
      var _this2 = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__api__["h" /* payRunnerPayment */])(this.runner, this.payment).then(function (data) {
        _this2.dotpay = data;
        _this2.$nextTick().then(function () {
          _this2.$refs.form.submit();
        });
      });
    }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$router.push({ name: 'runner-payments', params: { id: this.$route.params.id }, query: { status: this.$route.params.status } });
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_form_utils__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  validators: {
    'userCredentials.email': function userCredentialsEmail(value) {
      return __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__["Validator"].value(value).required().custom(Object(__WEBPACK_IMPORTED_MODULE_2__utils_form_utils__["a" /* serverValidation */])(this.formErrors, 'email'));
    },
    'userCredentials.password': function userCredentialsPassword(value) {
      return __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__["Validator"].value(value).required().custom(Object(__WEBPACK_IMPORTED_MODULE_2__utils_form_utils__["a" /* serverValidation */])(this.formErrors, 'password'));
    },
    'userCredentials.non_field_errors': function userCredentialsNon_field_errors(value) {
      return __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__["Validator"].value(value).custom(Object(__WEBPACK_IMPORTED_MODULE_2__utils_form_utils__["a" /* serverValidation */])(this.formErrors, 'non_field_errors'));
    }
  },
  data: function data() {
    return {
      userCredentials: {
        email: '',
        password: ''
      },
      progress: false,
      formErrors: []
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      this.$validate().then(function (success) {
        if (success) {
          _this.progress = true;
          _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["m" /* AUTH_REQUEST */], _this.userCredentials).then(function () {
            _this.$router.push({ name: 'app' });
          }).catch(function (data) {
            if (data.response.status === 400) {
              _this.formErrors = data.response.data;
              _this.$validate();
            }
          }).finally(function () {
            _this.progress = false;
          });
        }
      });
    }
  }
});

/***/ }),
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_simple_vue_validator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_simple_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(33);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  validators: {
    'userCredentials.email': function userCredentialsEmail(value) {
      return __WEBPACK_IMPORTED_MODULE_0_simple_vue_validator__["Validator"].value(value).required().email();
    }
  },
  data: function data() {
    return {
      userCredentials: {
        email: ''
      },
      progress: false,
      errors: []
    };
  },

  methods: {
    passwordReset: function passwordReset() {
      var _this = this;

      this.$validate().then(function (success) {
        if (success) {
          Object(__WEBPACK_IMPORTED_MODULE_2__api__["f" /* passwordReset */])(_this.userCredentials.email).then(function (data) {
            __WEBPACK_IMPORTED_MODULE_1_izitoast___default.a.show({
              message: 'Na wskazany adres e-mail zostało wysłane przypomnienie hasła',
              color: 'green'
            });
            _this.$router.push({ name: 'app' });
          });
        }
      });
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_form_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_izitoast__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  validators: {
    'passwordData.new_password1': function passwordDataNew_password1(value) {
      value = value || null;
      return __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__["Validator"].value(value).custom(Object(__WEBPACK_IMPORTED_MODULE_2__utils_form_utils__["a" /* serverValidation */])(this.formErrors, 'new_password1'));
    },
    'passwordData.new_password2': function passwordDataNew_password2(value) {
      value = value || null;
      return __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__["Validator"].value(value).custom(Object(__WEBPACK_IMPORTED_MODULE_2__utils_form_utils__["a" /* serverValidation */])(this.formErrors, 'new_password2'));
    }
  },
  data: function data() {
    return {
      formErrors: {},
      progress: false,
      passwordData: {
        token: this.$route.params.token,
        uid: this.$route.params.uidb64
      },
      error: false
    };
  },

  methods: {
    passwordReset: function passwordReset() {
      var _this = this;

      this.$validate().then(function (success) {
        if (success) {
          Object(__WEBPACK_IMPORTED_MODULE_0__api__["g" /* passwordResetConfirm */])(_this.passwordData).then(function (data) {
            __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
              message: 'Hasło zostało ustawione. Można zalogować się.',
              color: 'green'
            });
            _this.$router.push({ name: 'login' });
            return data;
          }).catch(function (data) {
            if (data.response.status === 404) {
              _this.error = true;
            }
            if (data.response.status === 400) {
              _this.formErrors = data.response.data;
              _this.$validate();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_Fields__ = __webpack_require__(16);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Fields: __WEBPACK_IMPORTED_MODULE_5__forms_Fields__["a" /* default */] },
  validators: {},
  data: function data() {
    return {
      progress: false,
      formErrors: {},
      formData: {},
      trainer: null,
      package: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getPackageById', 'getTrainerById']), {
    fields: function fields() {
      return [{ comp: 'text', id: 'email', label: 'Email*', props: { prependIcon: 'person' } }, { comp: 'text', id: 'password1', label: 'Hasło*', props: { type: 'password', prependIcon: 'lock' } }, { comp: 'text', id: 'password2', label: 'Powtórz hasło*', props: { type: 'password', prependIcon: 'lock' } }, { comp: 'text', id: 'first_name', label: 'Imię*' }, { comp: 'text', id: 'last_name', label: 'Nazwisko*' }, { comp: 'text', id: 'phone', label: 'Telefon*' }, { comp: 'checkbox', id: 'tos', label: 'Akceptuję regulamin*', props: {} }, { comp: 'checkbox', id: 'personal_data', label: 'Wyrażam zgodę na przetwarzanie moich danych osobowych w celu realizacji zamówionych przeze mnie usług.*', props: {} }, { comp: 'checkbox', id: 'health_statement', label: 'Oświadczam, że nie mam przeciwwskazań zdrowotnych do udziału w treningu i mój obecny stan zdrowia pozwala na realizowanie planów treningowych oraz że przystępuję do jego realizacji dobrowolnie i na własną odpowiedzialność. Jednocześnie przyjmuję do świadomości, że trening biegowy wiąże się z wysiłkiem fizycznym i biorę pełną odpowiedzialność za kontuzje z niego wynikające.*', props: {} }, { comp: 'checkbox', id: 'newsletter', label: 'Chcę otrzymywać newsletter. Zezwalam na przetwarzanie moich danych osobowych w celu przysyłania mi informacji marketingowych', props: {} }];
    }
  }),
  created: function created() {
    this.p1 = this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["e" /* ALL_PACKAGES_REQUEST */]);
    this.p2 = this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["g" /* ALL_TRAINERS_REQUEST */]);
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.p1, this.p2]).then(function () {
      if (_this.$route.query.trainer) {
        var trainer = _this.getTrainerById(parseInt(_this.$route.query.trainer));
        if (trainer) {
          _this.formData.registration_trainer = trainer.id;
          _this.trainer = trainer;
        }
      }
      if (_this.$route.query.package) {
        var pck = _this.getPackageById(parseInt(_this.$route.query.package));
        if (pck) {
          _this.formData.registration_package = pck.id;
          _this.package = pck;
          if (_this.package.trainer) {
            var _trainer = _this.getTrainerById(_this.package.trainer);
            _this.trainer = _trainer;
            _this.formData.registration_trainer = _trainer.id;
          }
        }
      }
    });
  },

  methods: {
    registerRunner: function registerRunner() {
      var _this2 = this;

      this.$validate().then(function (success) {
        if (success) {
          _this2.progress = true;
          Object(__WEBPACK_IMPORTED_MODULE_2__api__["h" /* registerRunnerSelf */])(_this2.formData).then(function (data) {
            _this2.formData = {};
            _this2.validation.reset();
            _this2.$router.push({ name: 'registration-completed' });
            return data;
          }).catch(function (data) {
            if (data.response.status === 400) {
              _this2.formErrors = data.response.data;
              _this2.$validate();
            }
          }).finally(function () {
            _this2.progress = false;
          });
        }
      });
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(33);
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      error: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    Object(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* accountConfirmEmail */])(this.token).then(function (data) {
      __WEBPACK_IMPORTED_MODULE_0_izitoast___default.a.show({
        message: 'Konto zostało aktywowane',
        color: 'green'
      });
      _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["o" /* AUTH_TOKEN */], data.token).then(function () {
        _this.$router.push({ name: 'app' });
      });
    }).catch(function (data) {
      if (data.response.status === 404) {
        _this.error = true;
      }
    });
  },

  computed: {
    token: function token() {
      return this.$route.params.token;
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_Fields__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Fields: __WEBPACK_IMPORTED_MODULE_3__forms_Fields__["a" /* default */] },
  validators: {},
  data: function data() {
    return {
      progress: false,
      formErrors: {},
      formData: {
        key: this.$route.params.token
      },
      error: false
    };
  },

  computed: {
    token: function token() {
      return this.$route.params.token;
    },
    fields: function fields() {
      return [{ comp: 'text', id: 'password1', label: 'Hasło', props: { type: 'password', prependIcon: 'lock' } }, { comp: 'text', id: 'password2', label: 'Powtórz hasło', props: { type: 'password', prependIcon: 'lock' } }, { comp: 'checkbox', id: 'tos', label: 'Akceptuję regulamin', props: {} }, { comp: 'checkbox', id: 'personal_data', label: 'Wyrażam zgodę na przetwarzanie moich danych osobowych w celu realizacji zamówionych przeze mnie usług.*', props: {} }, { comp: 'checkbox', id: 'health_statement', label: 'Oświadczam, że nie mam przeciwwskazań zdrowotnych do udziału w treningu i mój obecny stan zdrowia pozwala na realizowanie planów treningowych oraz że przystępuję do jego realizacji dobrowolnie i na własną odpowiedzialność. Jednocześnie przyjmuję do świadomości, że trening biegowy wiąże się z wysiłkiem fizycznym i biorę pełną odpowiedzialność za kontuzje z niego wynikające.*', props: {} }, { comp: 'checkbox', id: 'newsletter', label: 'Chcę otrzymywać newsletter. Zezwalam na przetwarzanie moich danych osobowych w celu przysyłania mi informacji marketingowych', props: {} }];
    }
  },
  methods: {
    confirmRunner: function confirmRunner() {
      var _this = this;

      this.$validate().then(function (success) {
        if (success) {
          _this.progress = true;
          Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* accountRunnerAdminConfirmEmail */])(_this.formData).then(function (data) {
            __WEBPACK_IMPORTED_MODULE_1_izitoast___default.a.show({
              message: 'Konto zostało aktywowane',
              color: 'green'
            });
            _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["o" /* AUTH_TOKEN */], data.token).then(function () {
              _this.$router.push({ name: 'app' });
            });
            return data;
          }).catch(function (data) {
            if (data.response.status === 404) {
              _this.error = true;
            }
            if (data.response.status === 400) {
              _this.formErrors = data.response.data;
              _this.$validate();
            }
          }).finally(function () {
            _this.progress = false;
          });
        }
      });
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_Fields__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Fields: __WEBPACK_IMPORTED_MODULE_3__forms_Fields__["a" /* default */] },
  validators: {},
  data: function data() {
    return {
      progress: false,
      formErrors: {},
      formData: {
        key: this.$route.params.token
      },
      error: false
    };
  },

  computed: {
    token: function token() {
      return this.$route.params.token;
    },
    fields: function fields() {
      return [{ comp: 'text', id: 'password1', label: 'Hasło', props: { type: 'password', prependIcon: 'lock' } }, { comp: 'text', id: 'password2', label: 'Powtórz hasło', props: { type: 'password', prependIcon: 'lock' } }, { comp: 'checkbox', id: 'tos', label: 'Akceptuję regulamin', props: {} }];
    }
  },
  methods: {
    confirmTrainer: function confirmTrainer() {
      var _this = this;

      this.$validate().then(function (success) {
        if (success) {
          _this.progress = true;
          Object(__WEBPACK_IMPORTED_MODULE_0__api__["c" /* accountTrainerAdminConfirmEmail */])(_this.formData).then(function (data) {
            __WEBPACK_IMPORTED_MODULE_1_izitoast___default.a.show({
              message: 'Konto zostało aktywowane',
              color: 'green'
            });
            _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["o" /* AUTH_TOKEN */], data.token).then(function () {
              _this.$router.push({ name: 'app' });
            });
            return data;
          }).catch(function (data) {
            if (data.response.status === 404) {
              _this.error = true;
            }
            if (data.response.status === 400) {
              _this.formErrors = data.response.data;
              _this.$validate();
            }
          }).finally(function () {
            _this.progress = false;
          });
        }
      });
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_Fields__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Fields: __WEBPACK_IMPORTED_MODULE_2__forms_Fields__["a" /* default */] },
  validators: {},
  data: function data() {
    return {
      progress: false,
      formErrors: {},
      formData: {},
      error: false
    };
  },

  computed: {
    fields: function fields() {
      return [{ comp: 'text', id: 'old_password', label: 'Obecne hasło', props: { type: 'password', prependIcon: 'lock' } }, { comp: 'text', id: 'new_password1', label: 'Nowe hasło', props: { type: 'password', prependIcon: 'lock' } }, { comp: 'text', id: 'new_password2', label: 'Powtórz nowe hasło', props: { type: 'password', prependIcon: 'lock' } }];
    }
  },
  methods: {
    passwordChange: function passwordChange() {
      var _this = this;

      this.$validate().then(function (success) {
        if (success) {
          _this.progress = false;
          Object(__WEBPACK_IMPORTED_MODULE_0__api__["e" /* passwordChange */])(_this.formData).then(function (data) {
            __WEBPACK_IMPORTED_MODULE_1_izitoast___default.a.show({
              message: 'Hasło zostało zmienione.',
              color: 'green'
            });
            _this.formData = {};
            return data;
          }).catch(function (data) {
            if (data.response.status === 400) {
              _this.formErrors = data.response.data;
              _this.$validate();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_formatters__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RunnerAddForm__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RunnerUpdateForm__ = __webpack_require__(591);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'runners',
  components: { RunnerAddForm: __WEBPACK_IMPORTED_MODULE_8__RunnerAddForm__["a" /* default */], RunnerUpdateForm: __WEBPACK_IMPORTED_MODULE_9__RunnerUpdateForm__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__["a" /* ListMixin */]],
  data: function data() {
    return {
      showAdd: false,
      loading: true,
      runners: [],
      headers: [{
        value: 'last_name',
        text: 'imię i nazwisko',
        sortable: true
      }, {
        value: 'email',
        text: 'e-mail',
        sortable: true
      }, {
        value: 'package',
        text: 'pakiet',
        sortable: true
      }, {
        value: 'trainer',
        text: 'trener',
        sortable: true
      }, {
        value: 'paid',
        text: 'płatności',
        sortable: false
      }, {
        value: 'last_training',
        text: 'ostatni wpisany trening',
        sortable: true
      }, {
        value: 'is_active',
        text: 'aktywny',
        sortable: true
      }, {
        value: 'newsletter',
        text: 'newsletter',
        sortable: true
      }, {
        value: 'actions',
        text: 'akcje',
        align: 'center',
        sortable: false,
        width: '180px'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['allPackagesOptions', 'allTrainersOptions'])),
  created: function created() {
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["e" /* ALL_PACKAGES_REQUEST */]);
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["g" /* ALL_TRAINERS_REQUEST */]);
  },

  watch: {
    context: {
      handler: function handler() {
        this.getRunners();
      },

      deep: true
    }
  },
  methods: {
    formatterBool: function formatterBool(data) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils_formatters__["a" /* boolFormatter */])(data);
    },
    getRunners: function getRunners(ctx) {
      var _this = this;

      this.loading = true;
      var params = this.prepareParams();
      if (this.context.package !== null) {
        params['package'] = this.context.package;
      }
      if (this.context.trainer !== null) {
        params['trainer'] = this.context.trainer;
      }
      if (this.context.isActive !== null) {
        params['is_active'] = this.context.isActive;
      }
      if (this.context.monthWithoutTraining === true) {
        params['month_without_training'] = this.context.monthWithoutTraining;
      }
      if (this.context.nextMonthWithoutTraining === true) {
        params['next_month_without_training'] = this.context.nextMonthWithoutTraining;
      }
      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* fetchRunners */])(params);
      return promise.then(this.enhanceListData).then(function (data) {
        _this.loading = false;
        _this.runners = data;
        return data;
      });
    },
    sendMailRunner: function sendMailRunner(item) {
      var _this2 = this;

      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["n" /* sendMailRunner */])(item);
      return promise.then(function () {
        _this2.refresh();
        __WEBPACK_IMPORTED_MODULE_4_izitoast___default.a.show({
          message: 'Mail aktywacyjny został wysłany.',
          color: 'green'
        });
      });
    },
    activateRunner: function activateRunner(item) {
      var _this3 = this;

      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* activateRunner */])(item);
      return promise.then(function () {
        _this3.refresh();
        __WEBPACK_IMPORTED_MODULE_4_izitoast___default.a.show({
          message: 'Konto zostało aktywowane',
          color: 'green'
        });
      });
    },
    deactivateRunner: function deactivateRunner(item) {
      var _this4 = this;

      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* deactivateRunner */])(item);
      return promise.then(function () {
        _this4.refresh();
        __WEBPACK_IMPORTED_MODULE_4_izitoast___default.a.show({
          message: 'Konto zostało deaktywowane',
          color: 'green'
        });
      });
    },

    refresh: __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.debounce(function () {
      this.getRunners();
    }, 400)
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_Fields__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_formMixin__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Fields: __WEBPACK_IMPORTED_MODULE_2__forms_Fields__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__utils_formMixin__["a" /* default */]],
  data: function data() {
    return {
      availableTrainers: [],
      formData: {}
    };
  },
  created: function created() {
    this.availableTrainers = this.allTrainersOptions;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    fields: function fields() {
      return [{ comp: 'text', id: 'email', label: 'Email:' }, { comp: 'text', id: 'first_name', label: 'Imię:' }, { comp: 'text', id: 'last_name', label: 'Nazwisko:' }, { comp: 'select', id: 'package', label: 'Pakiet:', props: { items: this.allPackagesOptions } }, { comp: 'select', id: 'trainer', label: 'Trener:', props: { items: this.availableTrainers } }];
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['allPackagesOptions', 'allTrainersOptions', 'getPackageById', 'getTrainerById']), {
    message: function message() {
      return 'Konto zawodnika zostało utworzone.';
    }
  }),
  watch: {
    'formData.package': function formDataPackage(value, oldVal) {
      this.packageChange(value);
    }
  },
  methods: {
    packageChange: function packageChange(value) {
      var packageData = this.getPackageById(value);
      if (packageData && packageData.trainer) {
        var trainer = this.getTrainerById(packageData.trainer);
        if (trainer) {
          this.availableTrainers = [{ value: trainer.id, text: trainer.full_name }];
          this.formData.trainer = trainer.id;
        } else {
          this.availableTrainers = this.allTrainersOptions;
        }
      } else {
        this.availableTrainers = this.allTrainersOptions;
      }
    },
    submit: function submit(data) {
      var _this = this;

      return Object(__WEBPACK_IMPORTED_MODULE_1__api__["m" /* registerRunnerAdmin */])(data).then(function (data) {
        _this.formData = {};
        return data;
      });
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_Fields__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_formMixin__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Fields: __WEBPACK_IMPORTED_MODULE_2__forms_Fields__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__utils_formMixin__["a" /* default */]],
  props: {
    runnerData: {
      type: Object
    }
  },
  data: function data() {
    return {
      availableTrainers: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    fields: function fields() {
      return [{ comp: 'text', id: 'first_name', label: 'Imię:' }, { comp: 'text', id: 'last_name', label: 'Nazwisko:' }, { comp: 'text', id: 'individual_price', label: 'Cena indywidualna:' }, { comp: 'select', id: 'package', label: 'Pakiet:', props: { items: this.allPackagesOptions } }, { comp: 'select', id: 'trainer', label: 'Trener:', props: { items: this.availableTrainers } }];
    },
    message: function message() {
      return 'Konto zawodnika zostało edytowane.';
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['allPackagesOptions', 'allTrainersOptions', 'getPackageById', 'getTrainerById'])),
  created: function created() {
    this.formData = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.runnerData);
    this.packageChange(this.formData.package);
    this.availableTrainers = this.allTrainersOptions;
  },

  watch: {
    'formData.package': function formDataPackage(value, oldVal) {
      this.packageChange(value);
    }
  },
  methods: {
    packageChange: function packageChange(value) {
      var packageData = this.getPackageById(value);
      if (packageData && packageData.trainer) {
        var trainer = this.getTrainerById(packageData.trainer);
        if (trainer) {
          this.availableTrainers = [{ value: trainer.id, text: trainer.full_name }];
          this.formData.trainer = trainer.id;
        } else {
          this.availableTrainers = this.allTrainersOptions;
        }
      } else {
        this.availableTrainers = this.allTrainersOptions;
      }
    },
    submit: function submit(data) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__api__["o" /* updateRunner */])(data);
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_formatters__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RunnerTrainerUpdateForm__ = __webpack_require__(595);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'runners',
  components: { RunnerTrainerUpdateForm: __WEBPACK_IMPORTED_MODULE_7__RunnerTrainerUpdateForm__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__["a" /* ListMixin */]],
  data: function data() {
    return {
      showAdd: false,
      loading: true,
      runners: [],
      headers: [{
        value: 'last_name',
        text: 'imię i nazwisko',
        sortable: true
      }, {
        value: 'package',
        text: 'pakiet',
        sortable: true
      }, {
        value: 'get_tshirt',
        text: 'koszulka',
        sortable: true
      }, {
        value: 'get_card',
        text: 'karta',
        sortable: true
      }, {
        value: 'last_training',
        text: 'ostatni wpisany trening',
        sortable: true
      }, {
        value: 'actions',
        text: 'akcje',
        align: 'center',
        sortable: false,
        width: '180px'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['allPackagesOptions'])),
  created: function created() {
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["e" /* ALL_PACKAGES_REQUEST */]);
  },

  watch: {
    context: {
      handler: function handler() {
        this.getRunners();
      },

      deep: true
    },
    '$route': 'getRunners'
  },
  methods: {
    formatterBool: function formatterBool(data) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils_formatters__["a" /* boolFormatter */])(data);
    },
    getRunners: function getRunners(ctx) {
      var _this = this;

      this.loading = true;
      var params = this.prepareParams();
      if (this.context.package !== null) {
        params['package'] = this.context.package;
      }
      if (this.context.monthWithoutTraining === true) {
        params['month_without_training'] = this.context.monthWithoutTraining;
      }
      if (this.context.nextMonthWithoutTraining === true) {
        params['next_month_without_training'] = this.context.nextMonthWithoutTraining;
      }
      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* fetchTrainerRunners */])(this.$route.params.id, params);
      return promise.then(this.enhanceListData).then(function (data) {
        _this.loading = false;
        _this.runners = data;
        return data;
      });
    },

    refresh: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function () {
      this.getRunners();
    }, 400)
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forms_Fields__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_formMixin__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Fields: __WEBPACK_IMPORTED_MODULE_1__forms_Fields__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__utils_formMixin__["a" /* default */]],
  props: {
    runnerData: {
      type: Object
    }
  },
  computed: {
    fields: function fields() {
      return [{ comp: 'checkbox', id: 'get_tshirt', label: 'Otrzymał koszulkę:' }, { comp: 'checkbox', id: 'get_card', label: 'Otrzymał kartę:' }];
    },
    message: function message() {
      return 'Konto zawodnika zostało edytowane.';
    }
  },
  created: function created() {
    this.formData = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(this.runnerData);
  },

  methods: {
    submit: function submit(data) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__api__["u" /* updateRunnerTrainer */])(this.$route.params.id, data);
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RunnerDataPersonal__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RunnerDataGear__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RunnerDataRunning__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RunnerDataOther__ = __webpack_require__(638);

//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RunnerDataPersonal: __WEBPACK_IMPORTED_MODULE_4__RunnerDataPersonal__["a" /* default */], RunnerDataGear: __WEBPACK_IMPORTED_MODULE_5__RunnerDataGear__["a" /* default */], RunnerDataRunning: __WEBPACK_IMPORTED_MODULE_6__RunnerDataRunning__["a" /* default */], RunnerDataOther: __WEBPACK_IMPORTED_MODULE_7__RunnerDataOther__["a" /* default */] },
  data: function data() {
    return {
      updateMode: false,
      formErrors: {},
      runnerData: {},
      runnerApplicationData: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['allPackagesOptions', 'authUser', 'isAdmin', 'isRunner', 'isActiveRunner']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['runnersTrainer', 'runner'])),
  created: function created() {
    this.fetchRunner();
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["e" /* ALL_PACKAGES_REQUEST */]);
  },

  watch: {
    '$route': 'fetchRunner'
  },
  methods: {
    fetchRunner: function fetchRunner() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__api__["g" /* getRunner */])(this.runner.id).then(function (data) {
        _this.runnerData = data;
      });
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_form_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_picture_input__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RunnerDataField__ = __webpack_require__(54);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PictureInput: __WEBPACK_IMPORTED_MODULE_6_vue_picture_input__["a" /* default */], RunnerDataField: __WEBPACK_IMPORTED_MODULE_8__RunnerDataField__["a" /* default */] },
  validators: {
    'runner.avatar_thumbnail': function runnerAvatar_thumbnail(value) {
      value = value || null;
      return __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__["Validator"].value(value).custom(Object(__WEBPACK_IMPORTED_MODULE_3__utils_form_utils__["a" /* serverValidation */])(this.formErrors, 'avatar_thumbnail'));
    }
  },
  props: {
    runner: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      updateMode: false,
      form: {},
      formErrors: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['allPackagesOptions', 'isAdmin', 'isActiveRunner'])),
  created: function created() {
    this.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.runner);
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["e" /* ALL_PACKAGES_REQUEST */]);
  },

  watch: {
    'runner': function runner(oldVar, newVar) {
      this.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.runner);
    }
  },
  methods: {
    changeAvatar: function changeAvatar(image) {
      this.form.avatar_thumbnail = this.$refs.pictureInput.file;
    },
    updateRunner: function updateRunner() {
      var _this = this;

      this.$validate().then(function (success) {
        if (success) {
          Object(__WEBPACK_IMPORTED_MODULE_1__api__["p" /* updateRunnerData */])(_this.form).then(function (data) {
            _this.validation.reset();
            _this.$emit('runner-updated', data);
            __WEBPACK_IMPORTED_MODULE_5_izitoast___default.a.show({
              message: 'Konto zawodnika zostało edytowane.',
              color: 'green'
            });
            _this.updateMode = false;
            return data;
          }).catch(function (data) {
            if (data.response.status === 400) {
              _this.formErrors = data.response.data;
              _this.$validate();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PictureInput_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5080a0f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PictureInput_vue__ = __webpack_require__(629);
function injectStyle (ssrContext) {
  __webpack_require__(600)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5080a0f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PictureInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5080a0f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PictureInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_max_safe_integer__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'picture-input',
  props: {
    width: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    height: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    margin: {
      type: [String, Number],
      default: 0
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    size: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    name: {
      type: String,
      default: null
    },
    id: {
      type: [String, Number],
      default: null
    },
    buttonClass: {
      type: String,
      default: 'btn btn-primary button'
    },
    removeButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    aspectButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    prefill: {
      type: [String, File],
      default: ''
    },
    prefillOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    crop: {
      type: Boolean,
      default: true
    },
    radius: {
      type: [String, Number],
      default: 0
    },
    removable: {
      type: Boolean,
      default: false
    },
    hideChangeButton: {
      type: Boolean,
      default: false
    },
    autoToggleAspectRatio: {
      type: Boolean,
      default: false
    },
    toggleAspectRatio: {
      type: Boolean,
      default: false
    },
    changeOnClick: {
      type: Boolean,
      default: true
    },
    plain: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 10000
    },
    alertOnError: {
      type: Boolean,
      default: true
    },
    customStrings: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    prefill: function prefill() {
      if (this.prefill) {
        this.preloadImage(this.prefill, this.prefillOptions);
      } else {
        this.removeImage();
      }
    }
  },
  data: function data() {
    return {
      imageSelected: false,
      previewHeight: 0,
      previewWidth: 0,
      draggingOver: false,
      canvasWidth: 0,
      canvasHeight: 0,
      strings: {
        upload: '<p>Your device does not support file uploading.</p>',
        drag: 'Drag an image or <br>click here to select a file',
        tap: 'Tap here to select a photo <br>from your gallery',
        change: 'Change Photo',
        aspect: 'Landscape/Portrait',
        remove: 'Remove Photo',
        select: 'Select a Photo',
        selected: '<p>Photo successfully selected!</p>',
        fileSize: 'The file size exceeds the limit',
        fileType: 'This file type is not supported.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.updateStrings();
    if (this.prefill) {
      this.preloadImage(this.prefill, this.prefillOptions);
    }

    this.$nextTick(function () {
      window.addEventListener('resize', _this.onResize);
      _this.onResize();
    });
    if (this.supportsPreview) {
      this.pixelRatio = Math.round(window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI);
      var canvas = this.$refs.previewCanvas;
      if (canvas.getContext) {
        this.context = canvas.getContext('2d');
        this.context.scale(this.pixelRatio, this.pixelRatio);
      }
    }
    if (this.accept !== 'image/*') {
      this.fileTypes = this.accept.split(',');
      this.fileTypes = this.fileTypes.map(function (s) {
        return s.trim();
      });
    }

    this.canvasWidth = this.width;
    this.canvasHeight = this.height;

    this.$on('error', this.onError);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    this.$off('error', this.onError);
  },

  methods: {
    updateStrings: function updateStrings() {
      for (var s in this.customStrings) {
        if (s in this.strings && typeof this.customStrings[s] === 'string') {
          this.strings[s] = this.customStrings[s];
        }
      }
    },
    onClick: function onClick() {
      if (!this.imageSelected) {
        this.selectImage();
        return;
      }

      if (this.changeOnClick) {
        this.selectImage();
      }

      this.$emit('click');
    },
    onResize: function onResize() {
      this.resizeCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }
    },
    onDragStart: function onDragStart() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = true;
    },
    onDragStop: function onDragStop() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = false;
    },
    onFileDrop: function onFileDrop(e) {
      this.onDragStop();
      this.onFileChange(e);
    },
    onFileChange: function onFileChange(e, prefill) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      if (files[0].size <= 0 || files[0].size > this.size * 1024 * 1024) {
        this.$emit('error', {
          type: 'fileSize',
          fileSize: files[0].size,
          fileType: files[0].type,
          fileName: files[0].name,
          message: this.strings.fileSize + ' (' + this.size + 'MB)'
        });
        return;
      }
      if (files[0].name === this.fileName && files[0].size === this.fileSize && this.fileModified === files[0].lastModified) {
        return;
      }

      this.file = files[0];
      this.fileName = files[0].name;
      this.fileSize = files[0].size;
      this.fileModified = files[0].lastModified;
      this.fileType = files[0].type;

      if (this.accept === 'image/*') {
        if (files[0].type.substr(0, 6) !== 'image/') {
          return;
        }
      } else {
        if (this.fileTypes.indexOf(files[0].type) === -1) {
          this.$emit('error', {
            type: 'fileType',
            fileSize: files[0].size,
            fileType: files[0].type,
            fileName: files[0].name,
            message: this.strings.fileType
          });
          return;
        }
      }
      this.imageSelected = true;
      this.image = '';
      if (this.supportsPreview) {
        this.loadImage(files[0], prefill || false);
      } else {
        if (prefill) {
          this.$emit('prefill');
        } else {
          this.$emit('change', this.image);
        }
      }
    },
    onError: function onError(error) {
      if (this.alertOnError) {
        alert(error.message);
      }
    },
    loadImage: function loadImage(file, prefill) {
      var _this2 = this;

      this.getEXIFOrientation(file, function (orientation) {
        _this2.setOrientation(orientation);
        var reader = new FileReader();
        reader.onload = function (e) {
          _this2.image = e.target.result;
          if (prefill) {
            _this2.$emit('prefill');
          } else {
            _this2.$emit('change', _this2.image);
          }
          _this2.imageObject = new Image();
          _this2.imageObject.onload = function () {
            if (_this2.autoToggleAspectRatio) {
              var canvasOrientation = _this2.getOrientation(_this2.canvasWidth, _this2.canvasHeight);
              var imageOrientation = _this2.getOrientation(_this2.imageObject.width, _this2.imageObject.height);
              if (canvasOrientation !== imageOrientation) {
                _this2.rotateCanvas();
              }
            }
            _this2.drawImage(_this2.imageObject);
          };
          _this2.imageObject.src = _this2.image;
        };
        reader.readAsDataURL(file);
      });
    },
    drawImage: function drawImage(image) {
      this.imageWidth = image.width;
      this.imageHeight = image.height;
      this.imageRatio = image.width / image.height;
      var offsetX = 0;
      var offsetY = 0;
      var scaledWidth = this.previewWidth;
      var scaledHeight = this.previewHeight;
      var previewRatio = this.previewWidth / this.previewHeight;
      if (this.crop) {
        if (this.imageRatio >= previewRatio) {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        } else {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        }
      } else {
        if (this.imageRatio >= previewRatio) {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        } else {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        }
      }
      var canvas = this.$refs.previewCanvas;
      canvas.style.background = 'none';
      canvas.width = this.previewWidth * this.pixelRatio;
      canvas.height = this.previewHeight * this.pixelRatio;
      this.context.setTransform(1, 0, 0, 1, 0, 0);
      this.context.clearRect(0, 0, canvas.width, canvas.height);
      if (this.rotate) {
        this.context.translate(offsetX * this.pixelRatio, offsetY * this.pixelRatio);
        this.context.translate(scaledWidth / 2 * this.pixelRatio, scaledHeight / 2 * this.pixelRatio);
        this.context.rotate(this.rotate);
        offsetX = -scaledWidth / 2;
        offsetY = -scaledHeight / 2;
      }
      this.context.drawImage(image, offsetX * this.pixelRatio, offsetY * this.pixelRatio, scaledWidth * this.pixelRatio, scaledHeight * this.pixelRatio);
    },
    selectImage: function selectImage() {
      this.$refs.fileInput.click();
    },
    removeImage: function removeImage() {
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.type = '';
      this.$refs.fileInput.type = 'file';
      this.fileName = '';
      this.fileType = '';
      this.fileSize = 0;
      this.fileModified = 0;
      this.imageSelected = false;
      this.image = '';
      this.file = null;
      this.imageObject = null;
      this.$refs.previewCanvas.style.backgroundColor = 'rgba(200,200,200,.25)';
      this.$refs.previewCanvas.width = this.previewWidth * this.pixelRatio;
      this.$emit('remove');
    },
    rotateImage: function rotateImage() {
      this.rotateCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }

      var newOrientation = this.getOrientation(this.canvasWidth, this.canvasHeight);
      this.$emit('aspectratiochange', newOrientation);
    },
    resizeCanvas: function resizeCanvas() {
      var previewRatio = this.canvasWidth / this.canvasHeight;
      var newWidth = this.$refs.container.clientWidth;
      if (!this.toggleAspectRatio && newWidth === this.containerWidth) {
        return;
      }
      this.containerWidth = newWidth;
      this.previewWidth = Math.min(this.containerWidth - this.margin * 2, this.canvasWidth);
      this.previewHeight = this.previewWidth / previewRatio;
    },
    getOrientation: function getOrientation(width, height) {
      var orientation = 'square';

      if (width > height) {
        orientation = 'landscape';
      } else if (width < height) {
        orientation = 'portrait';
      }

      return orientation;
    },
    switchCanvasOrientation: function switchCanvasOrientation() {
      var canvasWidth = this.canvasWidth;
      var canvasHeight = this.canvasHeight;

      this.canvasWidth = canvasHeight;
      this.canvasHeight = canvasWidth;
    },
    rotateCanvas: function rotateCanvas() {
      this.switchCanvasOrientation();
      this.resizeCanvas();
    },
    setOrientation: function setOrientation(orientation) {
      this.rotate = false;
      if (orientation === 8) {
        this.rotate = -Math.PI / 2;
      } else if (orientation === 6) {
        this.rotate = Math.PI / 2;
      } else if (orientation === 3) {
        this.rotate = -Math.PI;
      }
    },
    getEXIFOrientation: function getEXIFOrientation(file, callback) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) !== 0xFFD8) {
          return callback(-2);
        }
        var length = view.byteLength;
        var offset = 2;
        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) {
              return callback(-1);
            }
            var little = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;
            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) === 0x0112) {
                return callback(view.getUint16(offset + i * 12 + 8, little));
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }
        return callback(-1);
      };
      reader.readAsArrayBuffer(file.slice(0, 65536));
    },
    preloadImage: function preloadImage(source, options) {
      var _this4 = this;

      // ie 11 support
      var File = window.File;
      try {
        new File([], ''); // eslint-disable-line
      } catch (e) {
        File = function (_Blob) {
          __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(File, _Blob);

          function File(chunks, filename) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, File);

            var _this3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (File.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(File)).call(this, chunks, opts));

            _this3.lastModifiedDate = new Date();
            _this3.lastModified = +_this3.lastModifiedDate;
            _this3.name = filename;
            return _this3;
          }

          return File;
        }(Blob);
      }
      options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, options);
      if ((typeof source === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(source)) === 'object') {
        this.imageSelected = true;
        this.image = '';
        if (this.supportsPreview) {
          this.loadImage(source, true);
        } else {
          this.$emit('prefill');
        }
        return;
      }
      var headers = new Headers();
      headers.append('Accept', 'image/*');
      fetch(source, {
        method: 'GET',
        mode: 'cors',
        headers: headers
      }).then(function (response) {
        return response.blob();
      }).then(function (imageBlob) {
        var e = { target: { files: [] } };
        var fileName = options.fileName || source.split('/').slice(-1)[0];
        var mediaType = options.mediaType || 'image/' + (options.fileType || fileName.split('.').slice(-1)[0]);
        mediaType = mediaType.replace('jpg', 'jpeg');
        e.target.files[0] = new File([imageBlob], fileName, { type: mediaType });
        _this4.onFileChange(e, true);
      }).catch(function (err) {
        _this4.$emit('error', {
          type: 'failedPrefill',
          message: 'Failed loading prefill image: ' + err
        });
      });
    }
  },
  computed: {
    supportsUpload: function supportsUpload() {
      if (navigator.userAgent.match(/(Android (1.0|1.1|1.5|1.6|2.0|2.1))|(Windows Phone (OS 7|8.0))|(XBLWP)|(ZuneWP)|(w(eb)?OSBrowser)|(webOS)|(Kindle\/(1.0|2.0|2.5|3.0))/)) {
        return false;
      }
      var el = document.createElement('input');
      el.type = 'file';
      return !el.disabled;
    },
    supportsPreview: function supportsPreview() {
      return window.FileReader && !!window.CanvasRenderingContext2D;
    },
    supportsDragAndDrop: function supportsDragAndDrop() {
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && !('ontouchstart' in window || navigator.msMaxTouchPoints);
    },
    computedClasses: function computedClasses() {
      var classObject = {};
      classObject['dragging-over'] = this.draggingOver;
      return classObject;
    },
    fontSize: function fontSize() {
      return Math.min(0.04 * this.previewWidth, 21) + 'px';
    }
  }
});

/***/ }),
/* 294 */,
/* 295 */,
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_simple_vue_validator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_simple_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_form_utils__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  validators: {
    'value': function value(_value) {
      _value = _value || null;
      return __WEBPACK_IMPORTED_MODULE_0_simple_vue_validator__["Validator"].value(_value).custom(Object(__WEBPACK_IMPORTED_MODULE_1__utils_form_utils__["a" /* serverValidation */])(this.formErrors, this.field));
    }
  },
  props: {
    props: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    value: {},
    objValue: {},
    label: { type: String },
    description: { type: String },
    editable: { type: Boolean },
    required: { type: Boolean },
    field: { type: String },
    placeholder: { type: String },
    inputId: { type: String },
    formErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    'formErrors': function formErrors(oldVar, newVar) {
      this.$validate();
    }
  },
  methods: {
    onInput: function onInput(value) {
      this.$emit('input', value);
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RunnerDataField__ = __webpack_require__(54);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RunnerDataField: __WEBPACK_IMPORTED_MODULE_4__RunnerDataField__["a" /* default */] },
  validators: {},
  props: {
    runner: {
      type: Object
    }
  },
  data: function data() {
    return {
      updateMode: false,
      form: {},
      formErrors: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['isAdmin', 'isActiveRunner'])),
  created: function created() {
    this.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.runner);
  },

  watch: {
    'runner': function runner(oldVar, newVar) {
      this.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.runner);
    }
  },
  methods: {
    updateRunner: function updateRunner() {
      var _this = this;

      this.$validate().then(function (success) {
        if (success) {
          Object(__WEBPACK_IMPORTED_MODULE_1__api__["p" /* updateRunnerData */])(_this.form).then(function (data) {
            _this.validation.reset();
            _this.$emit('runner-updated', data);
            __WEBPACK_IMPORTED_MODULE_2_izitoast___default.a.show({
              message: 'Konto zawodnika zostało edytowane.',
              color: 'green'
            });
            _this.updateMode = false;
            return data;
          }).catch(function (data) {
            if (data.response.status === 400) {
              _this.formErrors = data.response.data;
              _this.$validate();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RunnerDataField__ = __webpack_require__(54);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RunnerDataField: __WEBPACK_IMPORTED_MODULE_4__RunnerDataField__["a" /* default */] },
  validators: {},
  props: {
    runner: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      updateMode: false,
      form: {},
      formErrors: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['isAdmin', 'isActiveRunner'])),
  created: function created() {
    this.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.runner);
  },

  watch: {
    'runner': function runner(oldVar, newVar) {
      this.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.runner);
    }
  },
  methods: {
    updateRunner: function updateRunner() {
      var _this = this;

      this.$validate().then(function (success) {
        if (success) {
          Object(__WEBPACK_IMPORTED_MODULE_1__api__["p" /* updateRunnerData */])(_this.form).then(function (data) {
            _this.validation.reset();
            _this.$emit('runner-updated', data);
            __WEBPACK_IMPORTED_MODULE_2_izitoast___default.a.show({
              message: 'Konto zawodnika zostało edytowane.',
              color: 'green'
            });
            _this.updateMode = false;
            return data;
          }).catch(function (data) {
            if (data.response.status === 400) {
              _this.formErrors = data.response.data;
              _this.$validate();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RunnerDataField__ = __webpack_require__(54);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RunnerDataField: __WEBPACK_IMPORTED_MODULE_4__RunnerDataField__["a" /* default */] },
  validators: {},
  props: {
    runner: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      updateMode: false,
      form: {},
      formErrors: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['isAdmin', 'isActiveRunner', 'tshirtSizeOptions', 'raceFrequencyOptions'])),
  created: function created() {
    this.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.runner);
  },

  watch: {
    'runner': function runner(oldVar, newVar) {
      this.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.runner);
    }
  },
  methods: {
    updateRunner: function updateRunner() {
      var _this = this;

      this.$validate().then(function (success) {
        if (success) {
          Object(__WEBPACK_IMPORTED_MODULE_1__api__["p" /* updateRunnerData */])(_this.form).then(function (data) {
            _this.validation.reset();
            _this.$emit('runner-updated', data);
            __WEBPACK_IMPORTED_MODULE_2_izitoast___default.a.show({
              message: 'Konto zawodnika zostało edytowane.',
              color: 'green'
            });
            _this.updateMode = false;
            return data;
          }).catch(function (data) {
            if (data.response.status === 400) {
              _this.formErrors = data.response.data;
              _this.$validate();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/damskie.236c21c.png";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/meskie.aecec48.png";

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PackageSelection__ = __webpack_require__(644);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PackageSelection: __WEBPACK_IMPORTED_MODULE_7__PackageSelection__["a" /* default */] },
  validators: {},
  data: function data() {
    return {
      updateMode: true,
      formErrors: {},
      availablePackages: [],
      runner: {},
      form: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['allPackagesFullOptions', 'authUser', 'getPackageById', 'getTrainerById'])),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (parseInt(to.params.id) === __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.authUser.id) {
      next();
    } else {
      next({ name: 'login' });
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.p1]).then(function () {
      Object(__WEBPACK_IMPORTED_MODULE_3__api__["j" /* getRunnerDataPackage */])(_this.$route.params.id).then(function (data) {
        _this.runner = data;
        if (_this.runner.trainer) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.allPackagesFullOptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var pck = _step.value;

              if (pck.trainer === _this.runner.trainer || !pck.trainer) {
                _this.availablePackages.push(pck);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else {
          _this.availablePackages = _this.allPackagesFullOptions;
        }
        _this.form = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, data);
        _this.validation.reset();
      });
    });
  },
  created: function created() {
    this.p1 = this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["e" /* ALL_PACKAGES_REQUEST */]);
  },

  methods: {
    updateRunner: function updateRunner() {
      var _this2 = this;

      this.$validate().then(function (success) {
        if (success) {
          Object(__WEBPACK_IMPORTED_MODULE_3__api__["s" /* updateRunnerDataPackage */])(parseInt(_this2.$route.params.id), _this2.form).then(function (data) {
            _this2.validation.reset();
            _this2.$emit('runner-application-data-updated', data);
            if (data.trainer) {
              _this2.$router.push({ name: 'runner-application-data-first', params: { id: _this2.$route.params.id } });
            } else {
              _this2.$router.push({ name: 'runner-application-data-trainer', params: { id: _this2.$route.params.id } });
            }
            return data;
          }).catch(function (data) {
            if (data.response.status === 400) {
              _this2.formErrors = data.response.data;
              _this2.$validate();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    options: Array,
    value: Number,
    formErrors: Object
  },
  methods: {
    hasErrors: function hasErrors(name) {
      return this.formErrors[name] !== undefined && this.formErrors[name].length > 0;
    },
    getErrors: function getErrors(name) {
      return this.formErrors[name] || [];
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TrainerSelection__ = __webpack_require__(650);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { TrainerSelection: __WEBPACK_IMPORTED_MODULE_6__TrainerSelection__["a" /* default */] },
  validators: {},
  data: function data() {
    return {
      updateMode: true,
      formErrors: {},
      availableTrainers: [],
      runner: {},
      form: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['allPackagesFullOptions', 'allTrainersFullOptions', 'authUser', 'getPackageById', 'getTrainerById'])),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (parseInt(to.params.id) === __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.authUser.id) {
      next();
    } else {
      next({ name: 'login' });
    }
  },
  mounted: function mounted() {
    var _this = this;

    Object(__WEBPACK_IMPORTED_MODULE_2__api__["k" /* getRunnerDataTrainer */])(this.$route.params.id).then(function (data) {
      _this.runner = data;
      _this.form = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data);
      _this.validation.reset();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this.p1, _this.p2]).then(function () {
        _this.packageChange(_this.runner.package);
      });
    });
  },
  created: function created() {
    this.p1 = this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["e" /* ALL_PACKAGES_REQUEST */]);
    this.p2 = this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["g" /* ALL_TRAINERS_REQUEST */]);
  },

  watch: {},
  methods: {
    packageChange: function packageChange(value) {
      var packageData = this.getPackageById(value);
      if (packageData && packageData.trainer) {
        var trainer = this.getTrainerById(packageData.trainer);
        if (trainer) {
          this.availableTrainers = [trainer];
          this.form.trainer = trainer.id;
        } else {
          this.availableTrainers = this.allTrainersFullOptions;
        }
      } else {
        this.availableTrainers = this.allTrainersFullOptions;
      }
    },
    updateRunner: function updateRunner() {
      var _this2 = this;

      this.$validate().then(function (success) {
        if (success) {
          Object(__WEBPACK_IMPORTED_MODULE_2__api__["t" /* updateRunnerDataTrainer */])(parseInt(_this2.$route.params.id), _this2.form).then(function (data) {
            _this2.validation.reset();
            _this2.$emit('runner-application-data-updated', data);
            _this2.$router.push({ name: 'runner-application-data-first', params: { id: _this2.$route.params.id } });
            _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["p" /* RUNNERS_TRAINER_REQUEST */], _this2.form);
            return data;
          }).catch(function (data) {
            if (data.response.status === 400) {
              _this2.formErrors = data.response.data;
              _this2.$validate();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    options: Array,
    value: Number,
    formErrors: Object
  },
  methods: {
    hasErrors: function hasErrors(name) {
      return this.formErrors[name] !== undefined && this.formErrors[name].length > 0;
    },
    getErrors: function getErrors(name) {
      return this.formErrors[name] || [];
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RunnerStepField__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__results_Records__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_RespHeader__ = __webpack_require__(314);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RunnerStepField: __WEBPACK_IMPORTED_MODULE_6__RunnerStepField__["a" /* default */], Records: __WEBPACK_IMPORTED_MODULE_7__results_Records__["a" /* default */], RespHeader: __WEBPACK_IMPORTED_MODULE_8__utils_RespHeader__["a" /* default */] },
  validators: {},
  data: function data() {
    return {
      updateMode: true,
      formErrors: {},
      availableTrainers: [],
      runner: {},
      form: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['allPackagesFullOptions', 'allTrainersFullOptions', 'authUser', 'getPackageById', 'getTrainerById'])),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (parseInt(to.params.id) === __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.authUser.id) {
      next();
    } else {
      next({ name: 'login' });
    }
  },
  mounted: function mounted() {
    var _this = this;

    Object(__WEBPACK_IMPORTED_MODULE_2__api__["h" /* getRunnerData1 */])(this.$route.params.id).then(function (data) {
      _this.runner = data;
      _this.form = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data);
      _this.validation.reset();
    });
  },
  created: function created() {
    this.p1 = this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["e" /* ALL_PACKAGES_REQUEST */]);
    this.p2 = this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["g" /* ALL_TRAINERS_REQUEST */]);
  },

  watch: {
    'form.package': function formPackage(value, oldVal) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.p1, this.p2]).then(function () {
        _this2.packageChange(value);
      });
    }
  },
  methods: {
    packageChange: function packageChange(value) {
      var packageData = this.getPackageById(value);
      if (packageData && packageData.trainer) {
        var trainer = this.getTrainerById(packageData.trainer);
        if (trainer) {
          this.availableTrainers = [trainer];
          this.form.trainer = trainer.id;
        } else {
          this.availableTrainers = this.allTrainersFullOptions;
        }
      } else {
        this.availableTrainers = this.allTrainersFullOptions;
      }
    },
    updateRunner: function updateRunner() {
      var _this3 = this;

      this.$validate().then(function (success) {
        if (success) {
          Object(__WEBPACK_IMPORTED_MODULE_2__api__["q" /* updateRunnerData1 */])(parseInt(_this3.$route.params.id), _this3.form).then(function (data) {
            _this3.validation.reset();
            _this3.$emit('runner-application-data-updated', data);
            _this3.$router.push({ name: 'runner-application-data-second', params: { id: _this3.$route.params.id } });
            return data;
          }).catch(function (data) {
            if (data.response.status === 400) {
              _this3.formErrors = data.response.data;
              _this3.$validate();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerStepField_vue__ = __webpack_require__(308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a6b4a03_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerStepField_vue__ = __webpack_require__(657);
function injectStyle (ssrContext) {
  __webpack_require__(656)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerStepField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a6b4a03_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerStepField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_simple_vue_validator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_simple_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_form_utils__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  validators: {
    'value': function value(_value) {
      _value = _value || null;
      return __WEBPACK_IMPORTED_MODULE_0_simple_vue_validator__["Validator"].value(_value).custom(Object(__WEBPACK_IMPORTED_MODULE_1__utils_form_utils__["a" /* serverValidation */])(this.formErrors, this.field));
    }
  },
  props: {
    props: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    value: {},
    objValue: {},
    label: { type: String },
    description: { type: String },
    editable: { type: Boolean },
    field: { type: String },
    placeholder: { type: String },
    inputId: { type: String },
    formErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    'formErrors': function formErrors(oldVar, newVar) {
      this.$validate();
    }
  },
  methods: {
    onInput: function onInput(value) {
      this.$emit('input', value);
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Records_vue__ = __webpack_require__(310);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c55aca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Records_vue__ = __webpack_require__(665);
function injectStyle (ssrContext) {
  __webpack_require__(658)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Records_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c55aca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Records_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plan_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResultsChart__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecordForm__ = __webpack_require__(663);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ResultsChart: __WEBPACK_IMPORTED_MODULE_4__ResultsChart__["a" /* default */], RecordForm: __WEBPACK_IMPORTED_MODULE_5__RecordForm__["a" /* default */] },
  data: function data() {
    return {
      newRecord: false,
      newRecordObj: {},
      records: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['runner']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['allRaceDistanceStringsOptions'])),
  created: function created() {
    this.refetchView();
  },

  watch: {
    '$route': 'refetchView'
  },
  methods: {
    submitRecord: function submitRecord() {},
    refetchView: function refetchView() {
      this.fetchRecordsList();
      this.newRecord = false;
    },
    fetchRecordsList: function fetchRecordsList() {
      var _this = this;

      var promise = Object(__WEBPACK_IMPORTED_MODULE_2__plan_api__["t" /* fetchRecords */])(this.runner, {});
      return promise.then(function (data) {
        _this.records = data.results;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.records), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var r = _step.value;

            _this.$set(r, 'edit', false);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultsChart_vue__ = __webpack_require__(312);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultsChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(659);



function dataHandler(newData, oldData) {
  if (this.$data._chart) {
    this.$data._chart.destroy();
  }
  this.renderChart(this.chartData, this.options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Line */],
  watch: {
    'chartData': dataHandler
  },
  props: ['chartData', 'options'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plan_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_InputDate__ = __webpack_require__(80);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { InputDate: __WEBPACK_IMPORTED_MODULE_4__forms_InputDate__["a" /* default */] },
  props: {
    record: {
      type: Object,
      default: function _default() {
        return {
          race_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')
        };
      }
    }
  },
  data: function data() {
    return {
      errors: {},
      obj: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['recordsRaceTypesStringsOptions', 'measurableRaceDistanceStreetStringsOptions', 'raceDistanceTrackStringsOptions', 'runner']), {
    isNew: function isNew() {
      return this.obj.id === undefined;
    },
    distanceOptions: function distanceOptions() {
      if (this.obj.race_type === 'street') {
        return this.measurableRaceDistanceStreetStringsOptions;
      }
      if (this.obj.race_type === 'track') {
        return this.raceDistanceTrackStringsOptions;
      }
      return [];
    }
  }),
  created: function created() {
    this.initRecord();
  },

  methods: {
    initRecord: function initRecord() {
      this.obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.record);
    },
    saveRecord: function saveRecord() {
      var _this = this;

      if (this.isNew) {
        var promise = Object(__WEBPACK_IMPORTED_MODULE_2__plan_api__["g" /* createRecord */])(this.runner, this.obj).then(function (data) {
          _this.$emit('created-record', data);
          return data;
        });
      } else {
        promise = Object(__WEBPACK_IMPORTED_MODULE_2__plan_api__["B" /* updateRecord */])(this.runner, this.obj).then(function (data) {
          _this.$emit('updated-record', data, _this.record);
          return data;
        });
      }
      promise.catch(function (data) {
        if (data.response.status === 400) {
          _this.errors = data.response.data;
        }
      });
    },
    getErrors: function getErrors(name) {
      return this.errors[name] || [];
    },
    hasErrors: function hasErrors(name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0;
    },
    resetErrors: function resetErrors() {
      this.errors = {};
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RespHeader_vue__ = __webpack_require__(315);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fa73bd8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RespHeader_vue__ = __webpack_require__(667);
function injectStyle (ssrContext) {
  __webpack_require__(666)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RespHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fa73bd8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RespHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    props: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    color: { type: String }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RunnerStepField__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_RespHeader__ = __webpack_require__(314);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RunnerStepField: __WEBPACK_IMPORTED_MODULE_5__RunnerStepField__["a" /* default */], RespHeader: __WEBPACK_IMPORTED_MODULE_6__utils_RespHeader__["a" /* default */] },
  validators: {},
  data: function data() {
    return {
      updateMode: true,
      formErrors: {},
      runner: {},
      form: {},
      packageWithTshirt: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['allPackagesOptions', 'raceFrequencyOptions', 'tshirtSizeOptions', 'getPackageById'])),
  mounted: function mounted() {
    var _this = this;

    Object(__WEBPACK_IMPORTED_MODULE_1__api__["i" /* getRunnerData2 */])(this.$route.params.id).then(function (data) {
      _this.runner = data;
      _this.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data);
      _this.validation.reset();
    });
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["e" /* ALL_PACKAGES_REQUEST */]).then(function (data) {
      var packageData = _this.getPackageById(_this.$store.state.runner.package);
      _this.packageWithTshirt = packageData.with_tshirt;
    });
  },
  created: function created() {},

  methods: {
    updateRunner: function updateRunner() {
      var _this2 = this;

      this.$validate().then(function (success) {
        if (success) {
          Object(__WEBPACK_IMPORTED_MODULE_1__api__["r" /* updateRunnerData2 */])(_this2.$route.params.id, _this2.form).then(function (data) {
            _this2.validation.reset();
            _this2.$emit('runner-data-updated', data);
            __WEBPACK_IMPORTED_MODULE_2_izitoast___default.a.show({
              message: 'Formularz aplikacyjny został zapisany.',
              color: 'green'
            });
            _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["r" /* RUNNER_DATA_FILLED */]);
            _this2.$router.push({ name: 'runner-payments', params: { id: _this2.$route.params.id } });
            return data;
          }).catch(function (data) {
            if (data.response.status === 400) {
              _this2.formErrors = data.response.data;
              _this2.$validate();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plan_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_calendar__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WorkoutBig__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WorkoutSmall__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WorkoutForm__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RaceBig__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RaceSmall__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RaceForm__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ActivityBig__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ActivitySmall__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ActivityForm__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PlanComments__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PlanRaces__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__notifications_NotificationsPushInit__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__runners_RunnerHeartRate__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuejs_datepicker__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuejs_datepicker_dist_locale__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CopyWorkoutDialog__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_scrollto__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_scrollto__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CopyWorkoutDialog: __WEBPACK_IMPORTED_MODULE_22__CopyWorkoutDialog__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_20_vuejs_datepicker__["a" /* default */],
    WorkoutBig: __WEBPACK_IMPORTED_MODULE_7__WorkoutBig__["a" /* default */],
    WorkoutSmall: __WEBPACK_IMPORTED_MODULE_8__WorkoutSmall__["a" /* default */],
    WorkoutForm: __WEBPACK_IMPORTED_MODULE_9__WorkoutForm__["a" /* default */],
    RaceBig: __WEBPACK_IMPORTED_MODULE_10__RaceBig__["a" /* default */],
    RaceSmall: __WEBPACK_IMPORTED_MODULE_11__RaceSmall__["a" /* default */],
    RaceForm: __WEBPACK_IMPORTED_MODULE_12__RaceForm__["a" /* default */],
    ActivityBig: __WEBPACK_IMPORTED_MODULE_13__ActivityBig__["a" /* default */],
    ActivitySmall: __WEBPACK_IMPORTED_MODULE_14__ActivitySmall__["a" /* default */],
    ActivityForm: __WEBPACK_IMPORTED_MODULE_15__ActivityForm__["a" /* default */],
    PlanComments: __WEBPACK_IMPORTED_MODULE_16__PlanComments__["a" /* default */],
    PlanRaces: __WEBPACK_IMPORTED_MODULE_17__PlanRaces__["a" /* default */],
    NotificationsPushInit: __WEBPACK_IMPORTED_MODULE_18__notifications_NotificationsPushInit__["a" /* default */],
    RunnerHeartRate: __WEBPACK_IMPORTED_MODULE_19__runners_RunnerHeartRate__["a" /* default */]
  },
  props: {
    runnerData: {
      type: Object
    }
  },
  data: function data() {
    return {
      menu1: false,
      menu2: false,
      currentDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('month'),
      currentDateD: __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('month').format('YYYY-MM'),
      currentDateWeek: __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('week'),
      currentDateWeekD: __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('week').format('YYYY-MM-DD'),
      currentEvent: null,
      eventForm: null,
      records: [],
      calendar: null,
      events: [],
      dayStatus: {},
      language: __WEBPACK_IMPORTED_MODULE_21_vuejs_datepicker_dist_locale__["pl"]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['allPackagesOptions', 'authUser', 'isAdmin', 'isRunner', 'trainerRunnersOptions', 'isActiveRunnerTrainer', 'isActiveRunner']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(['runnersTrainer', 'runner']), {
    currentDateWeekString: function currentDateWeekString() {
      return this.currentDateWeek.format('DD-MM-YYYY') + ' - ' + __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.currentDateWeek).endOf('week').format('DD-MM-YYYY');
    },
    currentDateString: function currentDateString() {
      return this.currentDate.format('MMMM YYYY');
    },
    viewType: function viewType() {
      return this.$mq === 'sm' ? 'week' : 'month';
    },
    calendarView: function calendarView() {
      var weeks = [];

      if (this.calendar === null) {
        return {
          totalPlanned: 0,
          totalDone: 0,
          totalPlannedCount: 0,
          totalDoneCount: 0,
          totalMonthPlanned: 0,
          totalMonthDone: 0,
          totalMonthPlannedCount: 0,
          totalMonthDoneCount: 0,
          weeks: []
        };
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.calendar.weeks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var week = _step.value;

          if (this.viewType === 'month') {
            weeks.push(week);
          } else if (this.viewType === 'week') {
            if (week.date.isSame(this.currentDateWeek)) {
              weeks.push(week);
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        totalPlanned: this.calendar.totalPlanned,
        totalDone: this.calendar.totalDone,
        totalPlannedCount: this.calendar.totalPlannedCount,
        totalDoneCount: this.calendar.totalDoneCount,
        totalMonthPlanned: this.calendar.totalMonthPlanned,
        totalMonthDone: this.calendar.totalMonthDone,
        totalMonthPlannedCount: this.calendar.totalMonthPlannedCount,
        totalMonthDoneCount: this.calendar.totalMonthDoneCount,
        weeks: weeks
      };
    }
  }),
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  created: function created() {
    var _this = this;

    this.fetchPlan().then(function () {
      if (_this.$mq === 'sm') {
        _this.$nextTick().then(function () {
          var el = document.getElementById('day-' + __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYMMDD'));
          if (el) {
            var options = {
              easing: 'ease-in',
              offset: -60,
              force: true,
              x: false,
              y: true
            };
            __WEBPACK_IMPORTED_MODULE_23_vue_scrollto___default.a.scrollTo(el, options);
          }
        });
      }
    });
  },

  watch: {
    '$route': 'fetchPlan'
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    nextMonth: function nextMonth() {
      // trzeba zrobic moment aby vue zalapal zmiany i przeliczyl currentDateString
      this.currentDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.currentDate.add(1, 'month'));
      this.currentDateD = this.currentDate.format('YYYY-MM');
      this.changeCurrentDateWeek();
      this.fetchPlan();
    },
    prevMonth: function prevMonth() {
      this.currentDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.currentDate.subtract(1, 'month'));
      this.currentDateD = this.currentDate.format('YYYY-MM');
      this.changeCurrentDateWeek();
      this.fetchPlan();
    },
    changeCurrentDateD: function changeCurrentDateD() {
      this.currentDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.currentDateD);
      this.changeCurrentDateWeek();

      this.fetchPlan();
    },
    nextWeek: function nextWeek() {
      this.currentDateWeek = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.currentDateWeek.add(1, 'week'));
      this.currentDateWeekD = this.currentDateWeek.format('YYYY-MM-DD');
      this.changeCurrentDate();
      this.fetchPlan();
    },
    prevWeek: function prevWeek() {
      this.currentDateWeek = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.currentDateWeek.subtract(1, 'week'));
      this.currentDateWeekD = this.currentDateWeek.format('YYYY-MM-DD');
      this.changeCurrentDate();
      this.fetchPlan();
    },
    changeCurrentDateWeekD: function changeCurrentDateWeekD() {
      this.currentDateWeek = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.currentDateWeekD).startOf('week');
      this.currentDateWeekD = this.currentDateWeek.format('YYYY-MM-DD');
      this.changeCurrentDate();

      this.fetchPlan();
    },
    changeCurrentDateWeek: function changeCurrentDateWeek() {
      this.currentDateWeek = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.currentDate).startOf('week');
      this.currentDateWeekD = this.currentDateWeek.format('YYYY-MM-DD');
    },
    changeCurrentDate: function changeCurrentDate() {
      this.currentDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.currentDateWeek).startOf('month');
      this.currentDateD = this.currentDate.format('YYYY-MM');
    },
    prepareEvent: function prepareEvent(e) {
      this.$set(e, 'dayVisible', true);
      this.$set(e, 'position', null);
      this.$set(e, 'el', null);
      this.$set(e, 'isRace', e.type === 'race');
      this.$set(e, 'isWorkout', e.type === 'workout');
      this.$set(e, 'isActivity', e.type === 'activity');

      if (e.type === 'workout') {
        e.datetime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(e.workout_date);
        e.planned = parseFloat(e.total_distance_planned || 0);
        e.done = parseFloat(e.total_distance_done || 0);
      }
      if (e.type === 'race') {
        e.datetime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(e.race_date);
        e.planned = Math.ceil(parseFloat(e.distance / 1000 || 0));
        e.done = Math.ceil(parseFloat(e.time ? e.distance / 1000 || 0 : 0));
      }
      if (e.type === 'activity') {
        e.datetime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(e.activity_date);
        e.planned = 0;
        e.done = parseFloat(e.total_distance_done || 0);
      }
    },
    fetchPlan: function fetchPlan() {
      var _this2 = this;

      this.fetchRecordsList();
      return Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["q" /* fetchPlan */])(this.runner, { month: this.currentDate.format('YYYY-MM') }).then(function (data) {
        _this2.events = data.events;
        _this2.dayStatus = data.day_status;
        _this2.events.forEach(function (e) {
          _this2.prepareEvent(e);
        });
        _this2.calendar = Object(__WEBPACK_IMPORTED_MODULE_6__utils_calendar__["a" /* getCalendar */])(_this2.currentDate, _this2.events, _this2.dayStatus);
      });
    },
    fetchRecordsList: function fetchRecordsList() {
      var _this3 = this;

      var promise = Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["t" /* fetchRecords */])(this.runner, { month: this.currentDate.format('YYYY-MM') });
      return promise.then(function (data) {
        _this3.records = data.results;
      });
    },
    computePos: function computePos(target) {
      var eventRect = target.closest('.day').getBoundingClientRect();
      var cEventRect = target.closest('.container').getBoundingClientRect();
      var topOffset = 0;
      if (eventRect.top < 70) {
        topOffset = 70 - eventRect.top;
      }
      var width = 350;
      var height = 400;
      var maxLeftOffset = Math.min(eventRect.left - 10, width - eventRect.width);
      var minLeftOffset = 0;
      var minTop = Math.max(0, eventRect.top - cEventRect.top);
      var minLeft = Math.max(0, eventRect.left - cEventRect.left);
      var defaultLeftOffset = (width - eventRect.width) / 2;
      defaultLeftOffset = Math.min(maxLeftOffset, defaultLeftOffset);
      defaultLeftOffset = Math.max(minLeftOffset, defaultLeftOffset);
      var computedLeft = minLeft + window.pageXOffset - defaultLeftOffset;
      var computedTop = minTop - 15 + topOffset;
      var additionalLeftOffset = Math.min(0, cEventRect.right - (computedLeft + width + cEventRect.left));
      var additionalTopOffset = Math.min(0, window.innerHeight - (eventRect.top + height));
      return {
        left: Math.max(0, computedLeft + additionalLeftOffset),
        top: Math.max(70, computedTop + additionalTopOffset)
      };
    },
    handleResize: function handleResize(event) {
      if (this.currentEvent && this.currentEvent.el) {
        var pos = this.computePos(this.currentEvent.el);
        this.currentEvent.position = pos;
      } else if (this.eventForm && this.eventForm.el) {
        var _pos = this.computePos(this.eventForm.el);
        this.eventForm.position = _pos;
      }
    },

    eventClick: function eventClick(ev, jsEvent) {
      this.close();
      var pos = this.computePos(jsEvent.currentTarget);
      ev.position = pos;
      ev.el = jsEvent.currentTarget;
      this.currentEvent = ev;
    },
    dayClick: function dayClick(day, jsEvent) {
      if (jsEvent.target.closest('.bigEvent')) {
        return false;
      }
      this.close();
    },
    insideClick: function insideClick(jsEvent) {
      if (jsEvent.target.closest('form')) {
        return false;
      }
      this.close();
    },
    close: function close() {
      this.closeForm();
      this.closeCurrent();
    },
    closeForm: function closeForm() {
      if (this.eventForm) {
        this.eventForm = null;
      }
    },
    closeCurrent: function closeCurrent() {
      if (this.currentEvent) {
        this.currentEvent = null;
      }
    },
    newEvent: function newEvent(day, jsEvent) {
      var pos = this.computePos(jsEvent.currentTarget);
      this.close();
      this.eventForm = {};
      this.eventForm.el = jsEvent.currentTarget.closest('.day');
      this.eventForm.position = pos;
    },
    newWorkout: function newWorkout(day, jsEvent) {
      this.newEvent(day, jsEvent);
      this.eventForm.workout_date = day.date.format('YYYY-MM-DD');
      this.eventForm.datetime = day.date;
      this.eventForm.workout_type = 'OWB1';
      this.eventForm.isWorkout = true;
    },
    newRace: function newRace(day, jsEvent) {
      this.newEvent(day, jsEvent);
      this.eventForm.race_date = day.date.format('YYYY-MM-DD');
      this.eventForm.datetime = day.date;
      this.eventForm.isRace = true;
    },
    newActivity: function newActivity(day, jsEvent) {
      this.newEvent(day, jsEvent);
      this.eventForm.activity_date = day.date.format('YYYY-MM-DD');
      this.eventForm.datetime = day.date;
      this.eventForm.isActivity = true;
    },
    editEvent: function editEvent(ev) {
      var target = document.getElementById('day-' + ev.datetime.format('YYMMDD'));
      var pos = this.computePos(target);
      this.close();
      this.eventForm = ev;
      this.eventForm.position = pos;
      this.eventForm.el = target;
    },
    createdEvent: function createdEvent(data) {
      this.prepareEvent(data);
      this.close();
      this.fetchPlan();
      this.events.push(data);
      this.calendar = Object(__WEBPACK_IMPORTED_MODULE_6__utils_calendar__["a" /* getCalendar */])(this.currentDate, this.events, this.dayStatus);
    },
    updatedEvent: function updatedEvent(data, ev) {
      this.prepareEvent(data);
      var index = this.events.indexOf(ev);
      this.events[index] = data;
      this.close();
      this.calendar = Object(__WEBPACK_IMPORTED_MODULE_6__utils_calendar__["a" /* getCalendar */])(this.currentDate, this.events, this.dayStatus);
    },
    endedWorkout: function endedWorkout(data, ev) {
      this.$set(ev, 'total_distance_done', data.total_distance_done);
      this.$set(ev, 'runner_pulse', data.runner_pulse);
      this.$set(ev, 'runner_time', data.runner_time);
      this.$set(ev, 'runner_additional_info', data.runner_additional_info);
      this.prepareEvent(data);
      var index = this.events.indexOf(ev);
      this.events[index] = data;
      this.calendar = Object(__WEBPACK_IMPORTED_MODULE_6__utils_calendar__["a" /* getCalendar */])(this.currentDate, this.events, this.dayStatus);
      this.close();
    },
    endedRace: function endedRace(data, ev) {
      this.$set(ev, 'place', data.place);
      this.$set(ev, 'time', data.time);
      this.$set(ev, 'post_remarks', data.post_remarks);
      this.prepareEvent(data);
      var index = this.events.indexOf(ev);
      this.events[index] = data;
      this.calendar = Object(__WEBPACK_IMPORTED_MODULE_6__utils_calendar__["a" /* getCalendar */])(this.currentDate, this.events, this.dayStatus);
      this.close();
    },
    doneWorkoutHandler: function doneWorkoutHandler(ev) {
      var _this4 = this;

      var data = {
        id: ev.id,
        total_distance_planned: ev.total_distance_planned,
        total_distance_done: ev.total_distance_planned
      };
      Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["n" /* doneWorkout */])(this.runner, data).then(function () {
        _this4.$set(ev, 'total_distance_done', ev.total_distance_planned);
        _this4.$set(ev, 'workout_done', true);
        _this4.$set(ev, 'done', parseFloat(ev.total_distance_done) || 0);
        _this4.calendar = Object(__WEBPACK_IMPORTED_MODULE_6__utils_calendar__["a" /* getCalendar */])(_this4.currentDate, _this4.events, _this4.dayStatus);
        _this4.close();
      });
    },
    undoneWorkoutHandler: function undoneWorkoutHandler(ev) {
      var _this5 = this;

      Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["w" /* undoneWorkout */])(this.runner, ev).then(function (data) {
        _this5.$set(ev, 'total_distance_done', null);
        _this5.$set(ev, 'runner_pulse', null);
        _this5.$set(ev, 'runner_time', null);
        _this5.$set(ev, 'runner_additional_info', data.runner_additional_info);
        _this5.$set(ev, 'workout_done', false);
        _this5.$set(ev, 'done', 0);
        _this5.calendar = Object(__WEBPACK_IMPORTED_MODULE_6__utils_calendar__["a" /* getCalendar */])(_this5.currentDate, _this5.events, _this5.dayStatus);
        _this5.close();
      });
    },
    removeWorkout: function removeWorkout(ev) {
      var _this6 = this;

      this.$root.$confirm('Usuń trening', 'Czy na pewno usunąć ten trening?', { confirmText: 'Usuń', color: 'error' }).then(function (willDelete) {
        if (!willDelete) {
          return;
        }
        var promise = Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["l" /* deleteWorkout */])(_this6.runner, ev);
        return promise.then(function () {
          var index = _this6.events.indexOf(ev);
          _this6.events.splice(index, 1);
          _this6.calendar = Object(__WEBPACK_IMPORTED_MODULE_6__utils_calendar__["a" /* getCalendar */])(_this6.currentDate, _this6.events, _this6.dayStatus);
          __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
            message: 'Trening został usunięty',
            color: 'green'
          });
          _this6.close();
        }).catch(function () {
          __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
            message: 'Nie udało się usunąć treningu.',
            color: 'red'
          });
        });
      });
    },
    removeRace: function removeRace(ev) {
      var _this7 = this;

      this.$root.$confirm('Usuń zawody', 'Czy na pewno usunąć te zawody?', { confirmText: 'Usuń', color: 'error' }).then(function (willDelete) {
        if (!willDelete) {
          return;
        }
        var promise = Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["k" /* deleteRace */])(_this7.runner, ev);
        return promise.then(function () {
          _this7.close();
          _this7.fetchPlan();
          __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
            message: 'Zawody zostały usunięte',
            color: 'green'
          });
          _this7.close();
        }).catch(function () {
          __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
            message: 'Nie udało się usunąć zawodów.',
            color: 'red'
          });
        });
      });
    },
    removeActivity: function removeActivity(ev) {
      var _this8 = this;

      this.$root.$confirm('Usuń aktywność', 'Czy na pewno usunąć tą aktywność?', { confirmText: 'Usuń', color: 'error' }).then(function (willDelete) {
        if (!willDelete) {
          return;
        }
        var promise = Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["i" /* deleteActivity */])(_this8.runner, ev);
        return promise.then(function () {
          _this8.close();
          _this8.fetchPlan();
          __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
            message: 'Aktywność została usunięta',
            color: 'green'
          });
          _this8.close();
        }).catch(function () {
          __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
            message: 'Nie udało się usunąć aktywności.',
            color: 'red'
          });
        });
      });
    },
    removeWorkoutsWeek: function removeWorkoutsWeek(week) {
      var _this9 = this;

      this.$root.$confirm('Usuń treningi', 'Czy na pewno usunąć ten treningi z całego tygodnia?', { confirmText: 'Usuń', color: 'error' }).then(function (willDelete) {
        if (!willDelete) {
          return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["v" /* removeWorkoutsWeek */])(_this9.runner, {
          from_start: week.date.format('YYYY-MM-DD')
        }).then(function (data) {
          _this9.fetchPlan();
        });
      });
    },
    doneWorkoutsWeek: function doneWorkoutsWeek(week) {
      var _this10 = this;

      this.$root.$confirm('Treningi wykonane', 'Czy na pewno oznaczyć treningi z całego tygodnia jako wykonane?', { confirmText: 'Tak', color: 'error' }).then(function (ok) {
        if (!ok) {
          return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["o" /* doneWorkoutsWeek */])(_this10.runner, {
          from_start: week.date.format('YYYY-MM-DD')
        }).then(function (data) {
          _this10.fetchPlan();
        });
      });
    },
    undoneWorkoutsWeek: function undoneWorkoutsWeek(week) {
      var _this11 = this;

      this.$root.$confirm('Treningi niewykonane', 'Czy na pewno oznaczyć treningi z całego tygodnia jako niewykonane?', { confirmText: 'Tak', color: 'error' }).then(function (ok) {
        if (!ok) {
          return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["x" /* undoneWorkoutsWeek */])(_this11.runner, {
          from_start: week.date.format('YYYY-MM-DD')
        }).then(function (data) {
          _this11.fetchPlan();
        });
      });
    },
    copyWorkoutsWeek: function copyWorkoutsWeek(week) {
      var _this12 = this;

      Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["c" /* copyWorkoutsWeek */])(this.runner, {
        from_start: week.date.format('YYYY-MM-DD'),
        to_start: week.date.add(7, 'days').format('YYYY-MM-DD')
      }).then(function (data) {
        _this12.fetchPlan();
      });
    },
    copyWorkoutsMonth: function copyWorkoutsMonth(date) {
      var _this13 = this;

      Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["b" /* copyWorkoutsMonth */])(this.runner, {
        from_start: __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).subtract(1, 'months').format('YYYY-MM-DD'),
        to_start: date.format('YYYY-MM-DD')
      }).then(function (data) {
        _this13.fetchPlan();
      });
    },
    copyWorkoutsMonthRunner: function copyWorkoutsMonthRunner(date) {
      var _this14 = this;

      this.$refs.copyWorkout.open({ runners: this.trainerRunnersOptions }).then(function (data) {
        Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["b" /* copyWorkoutsMonth */])(_this14.runner, {
          from_start: date.format('YYYY-MM-DD'),
          to_start: date.format('YYYY-MM-DD'),
          runner: data.value
        }).then(function (data) {
          _this14.fetchPlan();
        });
      });
    },
    openPlanDay: function openPlanDay(day, jsEvent) {
      Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["u" /* openDay */])(this.runner, day.date).then(function () {
        day.isOpen = true;
      });
    },
    closePlanDay: function closePlanDay(day, jsEvent) {
      Object(__WEBPACK_IMPORTED_MODULE_5__plan_api__["a" /* closeDay */])(this.runner, day.date).then(function () {
        day.isOpen = false;
      });
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_TextField__ = __webpack_require__(66);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { TextField: __WEBPACK_IMPORTED_MODULE_4__utils_TextField__["a" /* default */] },
  props: {
    workout: {
      type: Object,
      required: true
    },
    inplace: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      workoutForm: {
        id: this.workout.id,
        runner_additional_info: this.workout.runner_additional_info || undefined,
        runner_pulse: this.workout.runner_pulse || undefined,
        runner_time: this.workout.runner_time || undefined,
        total_distance_done: this.workout.total_distance_done || this.workout.total_distance_planned || undefined
      },
      errors: {},
      edit: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['runner', 'isActiveRunnerTrainer', 'isActiveRunner'])),
  methods: {
    saveWorkout: function saveWorkout() {
      var _this = this;

      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["n" /* doneWorkout */])(this.runner, this.workoutForm).then(function (data) {
        _this.$emit('ended-workout', data, _this.workout);
        _this.edit = false;
        __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
          message: 'Trening został zmieniony',
          color: 'green'
        });
        return data;
      });
      promise.catch(function (data) {
        if (data.response.status === 400) {
          _this.errors = data.response.data;
        }
      });
    },
    getErrors: function getErrors(name) {
      return this.errors[name] || [];
    },
    hasErrors: function hasErrors(name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0;
    },
    resetErrors: function resetErrors() {
      this.errors = {};
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    content: String,
    label: String,
    pre: Boolean
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WorkoutElements__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DoneWorkoutElements__ = __webpack_require__(680);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { WorkoutElements: __WEBPACK_IMPORTED_MODULE_2__WorkoutElements__["a" /* default */], DoneWorkoutElements: __WEBPACK_IMPORTED_MODULE_3__DoneWorkoutElements__["a" /* default */] },
  props: {
    workout: {
      type: Object,
      required: true
    },
    micro: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isActiveRunnerTrainer', 'isActiveRunner']))
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);


//

var MAX_USED = 4;
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    workout: {
      type: Object,
      required: true
    }
  },
  render: function render(h) {
    var usedCounter = 0;
    var children = [];
    var breakMe = false;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.workout.elements.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

        var index = _ref2[0];
        var el = _ref2[1];

        children.push([]);
        var trip = void 0;
        if (el.trip_link) {
          trip = h("li", [h(
            "v-icon",
            {
              directives: [{
                name: "tooltip",
                value: "Miejsce"
              }]
            },
            ["place"]
          ), " ", h(
            "a",
            {
              domProps: {
                "href": el.trip_link
              },
              attrs: { target: "_blank" }
            },
            [el.trip_place]
          )]);
        } else {
          trip = h("li", [h(
            "v-icon",
            {
              directives: [{
                name: "tooltip",
                value: "Miejsce"
              }]
            },
            ["place"]
          ), el.trip_place]);
        }
        var style = el.element_type.includes('OWB1') ? '' : "style-" + this.workout.style;
        var liarray = [[el.with_warmup, h("li", [h("i", {
          directives: [{
            name: "tooltip",
            value: "Rozgrzewka"
          }],
          "class": "fi flaticon-people-1" }), el.warmup || 'Rozgrzewka'])], [el.distance, h(
          "li",
          { "class": style },
          [h("i", {
            directives: [{
              name: "tooltip",
              value: "Dystans"
            }],
            "class": "fi flaticon-road-1" }), " ", el.distance]
        )], [el.distance_string, h(
          "li",
          { "class": style },
          [h("i", {
            directives: [{
              name: "tooltip",
              value: "Dystans"
            }],
            "class": "fi flaticon-road-1" }), " ", el.distance_string]
        )], [el.ascent, h("li", [h(
          "v-icon",
          {
            directives: [{
              name: "tooltip",
              value: "Podbieg"
            }]
          },
          ["trending_up"]
        ), " ", el.ascent])], [el.pulse, h("li", [h("i", {
          directives: [{
            name: "tooltip",
            value: "Puls"
          }],
          "class": "fi flaticon-pulse-line " }), el.pulse, " bpm"])], [el.pace, h("li", [h("i", {
          directives: [{
            name: "tooltip",
            value: "Tempo"
          }],
          "class": "fi flaticon-minutes " }), " ", el.pace])], [el.strength, h("li", [h(
          "i",
          {
            directives: [{
              name: "tooltip",
              value: "Si\u0142a biegowa"
            }],
            "class": "text-icon " },
          ["SB"]
        ), " ", el.strength])], [el.repeats, h("li", [h(
          "i",
          {
            directives: [{
              name: "tooltip",
              value: "Rytmy"
            }],
            "class": "text-icon " },
          ["R"]
        ), " ", el.repeats])], [el.break_time, h("li", [h("i", {
          directives: [{
            name: "tooltip",
            value: "Przerwa"
          }],
          "class": "fi flaticon-people " }), " ", el.break_time])], [el.descent, h("li", [h(
          "v-icon",
          {
            directives: [{
              name: "tooltip",
              value: "Zbieg"
            }]
          },
          ["trending_down"]
        ), " ", el.descent])], [el.trip_place, trip], [el.with_cooling, h("li", [h(
          "i",
          {
            directives: [{
              name: "tooltip",
              value: "Sch\u0142odzenie"
            }],
            "class": "text-icon " },
          ["C"]
        ), " ", el.cooling || 'Schłodzenie'])], [el.other, h("li", [h(
          "v-icon",
          {
            directives: [{
              name: "tooltip",
              value: "Inny trening"
            }]
          },
          ["short_text"]
        ), " ", el.other])]];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(liarray), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var markup = _step3.value;

            if (usedCounter <= MAX_USED) {
              if (markup[0]) {
                children[index].push(markup[1]);
                usedCounter++;
              }
            } else {
              breakMe = true;
              break;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        if (breakMe) {
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (usedCounter > MAX_USED) {
      if (children[children.length - 1].length === 0) {
        children.pop();
        children[children.length - 1].pop();
        children[children.length - 1].pop();
      } else if (children[children.length - 1].length === 1) {
        children.pop();
        children[children.length - 1].pop();
      } else {
        children[children.length - 1].pop();
        children[children.length - 1].pop();
      }
      children[children.length - 1].push(h(
        "li",
        { "class": "text-center" },
        [h("span", ["..."])]
      ));
    }
    var elem = [];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var child = _step2.value;

        elem.push(h("ul", [child]));
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return h("div", [elem]);
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_TextField__ = __webpack_require__(66);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { TextField: __WEBPACK_IMPORTED_MODULE_1__utils_TextField__["a" /* default */] },
  props: {
    workout: {
      type: Object,
      required: true
    }
  },
  computed: {
    allWorkoutDistances: function allWorkoutDistances() {
      var s = '';
      var index = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.workout.elements), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;

          var d = el.distance_string;
          if (d !== undefined && d !== null) {
            if (index > 0) {
              s += ' / ';
            }
            s += d;
            index++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return s;
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WorkoutFormElement__ = __webpack_require__(684);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { WorkoutFormElement: __WEBPACK_IMPORTED_MODULE_7__WorkoutFormElement__["a" /* default */] },
  props: {
    ev: {
      type: Object,
      required: true
    },
    inplace: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      errors: {},
      workoutTemplate: null,
      workout: {}
    };
  },

  watch: {
    'workout.workout_type': {
      handler: function handler(val, oldVal) {
        if (oldVal === undefined && !this.isNew) {
          return;
        }
        this.workoutTypeChange(val);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['allWorkoutsTemplatesOptions', 'getWorkoutTemplateByName', 'runner']), {
    isNew: function isNew() {
      return this.workout.id === undefined;
    }
  }),
  created: function created() {
    var _this = this;

    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["i" /* ALL_WORKOUTS_TEMPLATES_REQUEST */]).then(function () {
      _this.initWorkout();
    });
  },

  methods: {
    initWorkout: function initWorkout() {
      this.workout = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.ev);
      if (this.isNew) {
        this.$set(this.workout, 'elements', []);
        this.$set(this.workout, 'style', 'standard');
        if (this.workout.workout_type) {
          this.workoutTypeChange(this.workout.workout_type);
        }
      } else {
        this.workoutTemplate = this.getWorkoutTemplateByName(this.workout.workout_type);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.workout.elements), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var element = _step.value;

            // tutaj dla skomplikowanych wielokrotnych elementów będzie to znacznie uproszczone
            element.multiple = false;
            element.first = true;
            element.next = false;
            element.types = [element.element_type];
            this.setElementInputs(element);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    },
    distanceRecalculate: function distanceRecalculate() {
      var distance = 0;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.workout.elements), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var element = _step2.value;

          var v = parseFloat(element.distance_string);
          if (!isNaN(v)) {
            distance += v;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (distance > 0) {
        this.$set(this.workout, 'total_distance_planned', distance);
      }
    },
    workoutTypeChange: function workoutTypeChange(value) {
      this.resetErrors();
      this.$set(this.workout, 'elements', []);
      this.workoutTemplate = this.getWorkoutTemplateByName(value);
      this.$set(this.workout, 'style', this.workoutTemplate.style);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.workoutTemplate.elements), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var element = _step3.value;

          var el = {};
          el.multiple = element.multiple;
          el.first = true;
          el.next = false;
          el.types = element.element_types;
          if (element.element_types.length === 1) {
            el.element_type = element.element_types[0];
            this.setElementInputs(el);
            if (el.hasPulse && ['OWB1', 'OWB1+R', 'OWB1+SB', 'OWB1+R+SB'].indexOf(el.element_type) > -1 && this.runner.real_heart_rate_zone) {
              el.pulse = this.runner.real_heart_rate_zone;
            } else {
              el.pulse = '';
            }
            if (el.hasPace && ['OWB1', 'OWB1+R', 'OWB1+SB', 'OWB1+R+SB'].indexOf(el.element_type) > -1 && !this.runner.real_heart_rate_zone) {
              el.pace = this.runner.heart_rate_zone || '';
            } else {
              el.pace = '';
            }
          }
          this.workout.elements.push(el);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    elementTypeChange: function elementTypeChange(el, value) {
      this.$set(el, 'element_type', value);
      this.setElementInputs(el);
      if (el.hasPulse && ['OWB1', 'OWB1+R', 'OWB1+SB', 'OWB1+R+SB'].indexOf(el.element_type) > -1 && this.runner.real_heart_rate_zone) {
        el.pulse = this.runner.real_heart_rate_zone;
      } else {
        el.pulse = '';
      }
      if (el.hasPace && ['OWB1', 'OWB1+R', 'OWB1+SB', 'OWB1+R+SB'].indexOf(el.element_type) > -1 && !this.runner.real_heart_rate_zone) {
        el.pace = this.runner.heart_rate_zone || '';
      } else {
        el.pace = '';
      }
    },
    addNewElement: function addNewElement(el) {
      var newEl = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, el);
      newEl.first = false;
      newEl.next = true;
      var index = this.workout.elements.indexOf(el);
      this.workout.elements.splice(index + 1, 0, newEl);
      if (this.errors && this.errors.elements) {
        this.errors.elements.splice(index + 1, 0, {});
      }
    },
    removeElement: function removeElement(el) {
      var index = this.workout.elements.indexOf(el);
      this.workout.elements.splice(index, 1);
      if (this.errors && this.errors.elements) {
        this.errors.elements.splice(index, 1);
      }
    },
    setElementInputs: function setElementInputs(el) {
      var et = el.element_type;
      if (!et) {
        return;
      }
      this.$set(el, 'hasDistance', false);
      this.$set(el, 'hasDistanceString', false);
      this.$set(el, 'hasPulse', false);
      this.$set(el, 'hasPace', false);
      this.$set(el, 'hasRepeats', false);
      this.$set(el, 'hasStrength', false);
      this.$set(el, 'hasBreak', false);
      this.$set(el, 'hasAscent', false);
      this.$set(el, 'hasDescent', false);
      this.$set(el, 'hasTrip', false);
      this.$set(el, 'hasOther', false);
      this.$set(el, 'hasWarmup', false);
      this.$set(el, 'hasCooling', false);

      if (et === 'OWB1') {
        el.hasDistanceString = true;
        el.hasPulse = true;
        el.hasPace = true;
      } else if (et === 'OWB1+R') {
        el.hasDistanceString = true;
        el.hasPulse = true;
        el.hasPace = true;
        el.hasRepeats = true;
      } else if (et === 'OWB1+SB') {
        el.hasDistanceString = true;
        el.hasPulse = true;
        el.hasPace = true;
        el.hasStrength = true;
      } else if (et === 'OWB1+R+SB') {
        el.hasDistanceString = true;
        el.hasPulse = true;
        el.hasPace = true;
        el.hasStrength = true;
        el.hasRepeats = true;
      } else if (et === 'STD') {
        el.hasDistanceString = true;
        el.hasPulse = true;
        el.hasPace = true;
      } else if (et === 'R') {
        el.hasRepeats = true;
      } else if (et === 'SB') {
        el.hasStrength = true;
      } else if (et === 'R + SB') {
        el.hasStrength = true;
        el.hasRepeats = true;
      } else if (et === 'SPEED') {
        el.hasDistanceString = true;
        el.hasBreak = true;
        el.hasPulse = true;
        el.hasPace = true;
      } else if (et === 'ASCENT') {
        el.hasAscent = true;
        el.hasDescent = true;
        el.hasPulse = true;
        el.hasPace = true;
      } else if (et === 'TRIP') {
        el.hasTrip = true;
      } else if (et === 'LOCATION') {
        el.hasTrip = true;
      } else if (et === 'OTHER') {
        el.hasOther = true;
      } else if (et === 'WARMUP') {
        el.hasWarmup = true;
      } else if (et === 'COOLING') {
        el.hasCooling = true;
      }

      if (!el.hasDistance) {
        el.distance = undefined;
      }
      if (!el.hasDistanceString) {
        el.distance_string = undefined;
      }
      if (!el.hasPulse) {
        el.pulse = undefined;
      }
      if (!el.hasPace) {
        el.pace = undefined;
      }
      if (!el.hasRepeats) {
        el.repeats = undefined;
      }
      if (!el.hasStrength) {
        el.strength = undefined;
      }
      if (!el.hasBreak) {
        el.break_time = undefined;
      }
      if (!el.hasAscent) {
        el.ascent = undefined;
      }
      if (!el.hasDescent) {
        el.descent = undefined;
      }
      if (!el.hasTrip) {
        el.trip_location = undefined;
        el.trip_link = undefined;
      }
      if (!el.hasOther) {
        el.other = undefined;
      }
      if (!el.hasWarmup) {
        el.warmup = undefined;
      }
      if (!el.hasCooling) {
        el.cooling = undefined;
      }
    },
    saveWorkout: function saveWorkout() {
      var _this2 = this;

      if (this.isNew) {
        var promise = Object(__WEBPACK_IMPORTED_MODULE_3__api__["h" /* createWorkout */])(this.runner, this.workout).then(function (data) {
          _this2.$emit('created-workout', data);
          __WEBPACK_IMPORTED_MODULE_6_izitoast___default.a.show({
            message: 'Trening został dodany',
            color: 'green'
          });
          return data;
        });
      } else {
        promise = Object(__WEBPACK_IMPORTED_MODULE_3__api__["C" /* updateWorkout */])(this.runner, this.workout).then(function (data) {
          _this2.$emit('updated-workout', data, _this2.ev);
          __WEBPACK_IMPORTED_MODULE_6_izitoast___default.a.show({
            message: 'Trening został zmieniony',
            color: 'green'
          });
          return data;
        });
      }
      promise.catch(function (data) {
        if (data.response.status === 400) {
          _this2.errors = data.response.data;
        }
      });
    },
    getErrors: function getErrors(name) {
      return this.errors[name] || [];
    },
    hasErrors: function hasErrors(name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0;
    },
    resetErrors: function resetErrors() {
      this.errors = {};
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    element: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    typesItems: function typesItems() {
      var ELEMENT_TYPES = {
        'OWB1': 'OWB1',
        'STD': 'Standardowy',
        'R': 'Rytmy',
        'SB': 'Siła biegowa',
        'R + SB': 'Rytmy i siła biegowa',
        'OWB1+R': 'OWB1 + R',
        'OWB1+SB': 'OWB1 + SB',
        'OWB1+R+SB': 'OWB1 + R + SB',
        'SPEED': 'Akcent',
        'ASCENT': 'Podbieg',
        'TRIP': 'Wycieczka',
        'LOCATION': 'Miejsce',
        'OTHER': 'Inne',
        'WARMUP': 'Rozgrzewka',
        'COOLING': 'Schłodzenie'
      };
      var elements = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.element.types), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var et = _step.value;

          elements.push({ text: ELEMENT_TYPES[et] || et, value: et });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return elements;
    }
  },
  methods: {
    elementTypeChange: function elementTypeChange(el, value) {
      this.$emit('type-change-element', this.element, value);
    },
    addNewElement: function addNewElement(el) {
      this.$emit('add-element', this.element);
    },
    removeElement: function removeElement(el) {
      this.$emit('remove-element', this.element);
    },
    getErrors: function getErrors(name) {
      return this.errors[name] || [];
    },
    hasErrors: function hasErrors(name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0;
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_TextField__ = __webpack_require__(66);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { TextField: __WEBPACK_IMPORTED_MODULE_4__utils_TextField__["a" /* default */] },
  props: {
    race: {
      type: Object,
      required: true
    },
    inplace: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      raceForm: {
        id: this.race.id,
        time: this.race.time || undefined,
        place: this.race.place || undefined,
        post_remarks: this.race.post_remarks || undefined
      },
      errors: {},
      edit: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['runner', 'isActiveRunnerTrainer', 'isActiveRunner']), {
    measureable: function measureable() {
      return this.race.distance_string !== 'other' && this.race.distance_string !== 'ultra';
    }
  }),
  methods: {
    saveRace: function saveRace() {
      var _this = this;

      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["m" /* doneRace */])(this.runner, this.raceForm).then(function (data) {
        _this.$emit('ended-race', data, _this.race);
        _this.edit = false;
        __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
          message: 'Wynik został zmieniony',
          color: 'green'
        });
        return data;
      });
      promise.catch(function (data) {
        if (data.response.status === 400) {
          _this.errors = data.response.data;
        }
      });
    },
    getErrors: function getErrors(name) {
      return this.errors[name] || [];
    },
    hasErrors: function hasErrors(name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0;
    },
    resetErrors: function resetErrors() {
      this.errors = {};
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    race: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isActiveRunnerTrainer', 'isActiveRunner']), {
    measureable: function measureable() {
      return this.race.distance_string !== 'other' && this.race.distance_string !== 'ultra';
    }
  })
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_izitoast__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    ev: {
      type: Object,
      required: true
    },
    inplace: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      errors: {},
      race: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['allRaceTypesStringsOptions', 'raceDistanceStreetStringsOptions', 'allRaceDistanceStringsOptions', 'raceDistanceTrackStringsOptions', 'allRacePrioritiesOptions', 'runner']), {
    isNew: function isNew() {
      return this.race.id === undefined;
    },
    distanceOptions: function distanceOptions() {
      if (this.race.race_type === 'street') {
        return this.raceDistanceStreetStringsOptions;
      }
      if (this.race.race_type === 'track') {
        return this.raceDistanceTrackStringsOptions;
      }
      return [{
        text: 'inne',
        value: 'other'
      }];
    }
  }),
  created: function created() {
    this.initRace();
  },

  methods: {
    initRace: function initRace() {
      this.race = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.ev);
    },
    changeRaceType: function changeRaceType() {
      if (this.race.race_type !== 'street' && this.race.race_type !== 'track') {
        this.race.distance_string = 'other';
      } else {
        this.race.distance_string = null;
      }
    },
    saveRace: function saveRace() {
      var _this = this;

      if (this.isNew) {
        var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* createRace */])(this.runner, this.race).then(function (data) {
          _this.$emit('created-race', data);
          __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
            message: 'Zawody zostały dodane',
            color: 'green'
          });
          return data;
        });
      } else {
        promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["A" /* updateRace */])(this.runner, this.race).then(function (data) {
          _this.$emit('updated-race', data, _this.ev);
          __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
            message: 'Zawody zostały zmienione',
            color: 'green'
          });
          return data;
        });
      }
      promise.catch(function (data) {
        if (data.response.status === 400) {
          _this.errors = data.response.data;
        }
      });
    },
    getErrors: function getErrors(name) {
      return this.errors[name] || [];
    },
    hasErrors: function hasErrors(name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0;
    },
    resetErrors: function resetErrors() {
      this.errors = {};
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_TextField__ = __webpack_require__(66);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { TextField: __WEBPACK_IMPORTED_MODULE_2__utils_TextField__["a" /* default */] },
  props: {
    activity: {
      type: Object,
      required: true
    },
    inplace: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['runner', 'isActiveRunnerTrainer', 'isActiveRunner']))
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isActiveRunner']))
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_izitoast__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    ev: {
      type: Object,
      required: true
    },
    inplace: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      errors: {},
      activity: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['runner']), {
    isNew: function isNew() {
      return this.activity.id === undefined;
    }
  }),
  created: function created() {
    this.initActivity();
  },

  methods: {
    initActivity: function initActivity() {
      this.activity = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.ev);
    },
    saveActivity: function saveActivity() {
      var _this = this;

      if (this.isNew) {
        var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["d" /* createActivity */])(this.runner, this.activity).then(function (data) {
          _this.$emit('created-activity', data);
          __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
            message: 'Aktywność została dodana',
            color: 'green'
          });
          return data;
        });
      } else {
        promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["y" /* updateActivity */])(this.runner, this.activity).then(function (data) {
          _this.$emit('updated-activity', data, _this.ev);
          __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
            message: 'Aktywność została zmieniona',
            color: 'green'
          });
          return data;
        });
      }
      promise.catch(function (data) {
        if (data.response.status === 400) {
          _this.errors = data.response.data;
        }
      });
    },
    getErrors: function getErrors(name) {
      return this.errors[name] || [];
    },
    hasErrors: function hasErrors(name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0;
    },
    resetErrors: function resetErrors() {
      this.errors = {};
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PlanComment__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PlanCommentForm__ = __webpack_require__(703);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PlanComment: __WEBPACK_IMPORTED_MODULE_6__PlanComment__["a" /* default */], PlanCommentForm: __WEBPACK_IMPORTED_MODULE_7__PlanCommentForm__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__["a" /* ListMixin */]],
  props: {
    month: {
      type: Object
    }
  },
  data: function data() {
    return {
      loading: true,
      commentsList: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['runner']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['isActiveRunnerTrainer', 'isActiveRunner'])),
  created: function created() {
    this.fetchPlanComments();
  },

  watch: {
    '$route': 'fetchPlanComments',
    context: {
      handler: function handler() {
        this.fetchPlanComments();
      },

      deep: true
    }
  },
  methods: {
    refresh: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function () {
      this.fetchPlanComments();
    }, 400),
    fetchPlanComments: function fetchPlanComments() {
      var _this = this;

      var params = this.prepareParams();
      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["p" /* fetchComments */])(this.runner, params);
      return promise.then(this.enhanceListData).then(function (data) {
        _this.loading = false;
        _this.commentsList = data;
        return data;
      });
    },
    addComment: function addComment(item) {
      this.fetchPlanComments();
    },
    changeComment: function changeComment(item) {
      this.$set(item, 'edit', true);
    },
    removeComment: function removeComment(item) {
      var _this2 = this;

      this.$root.$confirm('Usuń komentarz', 'Czy na pewno usunąć ten komentarz?', { confirmText: 'Usuń', color: 'error' }).then(function (willDelete) {
        if (willDelete) {
          var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["j" /* deleteComment */])(_this2.runner, item);
          return promise.then(function () {
            _this2.refresh();
            __WEBPACK_IMPORTED_MODULE_5_izitoast___default.a.show({
              message: 'Komentarz został usunięty',
              color: 'green'
            });
          }).catch(function () {
            __WEBPACK_IMPORTED_MODULE_5_izitoast___default.a.show({
              message: 'Nie udało się usunąć komentarza.',
              color: 'red'
            });
          });
        }
      });
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    comment: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['authUser']), {
    content: function content() {
      return this.comment.comment.replace(/\n/g, '<br>');
    }
  })
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_Fields__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_formMixin__ = __webpack_require__(29);

//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Fields: __WEBPACK_IMPORTED_MODULE_4__forms_Fields__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__utils_formMixin__["a" /* default */]],
  props: {
    month: {
      type: Object
    },
    comment: {
      type: Object,
      default: function _default() {
        return {
          month: this.month.format('YYYY-MM-DD')
        };
      }
    }
  },
  data: function data() {
    return {
      isUpdate: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['runner']), {
    fields: function fields() {
      return [{ comp: 'textarea', id: 'comment', label: 'Komentarz' }];
    },
    message: function message() {
      return this.isUpdate ? 'Komentarz został edytowany' : 'Komentarz został dodany';
    }
  }),
  created: function created() {
    this.formData = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.comment);
    if (this.comment.id) {
      this.isUpdate = true;
    }
  },

  methods: {
    submit: function submit(data) {
      var _this = this;

      if (this.isUpdate) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__api__["z" /* updateComment */])(this.runner, data);
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_1__api__["e" /* createComment */])(this.runner, data).then(function (data) {
          _this.formData = {
            month: _this.month.format('YYYY-MM-DD')
          };
          _this.validation.reset();
          return data;
        });
      }
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plan_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'races',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__["a" /* ListMixin */]],
  data: function data() {
    return {
      context: {
        rowsPerPage: 3,
        sortBy: 'race_date',
        descending: false },
      perPageOptions: [3, 5, 10],
      type: null,
      loading: true,
      races: [],
      headers: [{
        value: 'name',
        text: 'nazwa',
        sortable: true
      }, {
        value: 'race_type',
        text: 'rodzaj',
        sortable: true
      }, {
        value: 'distance',
        text: 'dystans',
        sortable: true
      }, {
        value: 'priority',
        text: 'priorytet',
        sortable: true
      }, {
        value: 'race_date',
        text: 'tygodni do zawodów',
        sortable: true
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['runner']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['allRaceDistanceStringsOptions', 'allRaceTypesStringsOptions'])),
  watch: {
    '$route': 'getRaces',
    context: {
      handler: function handler(a, b) {
        if (a.page === b.page && a.page !== 1) {
          this.context.page = 1;
        } else {
          this.getRaces();
        }
      },

      deep: true
    }
  },
  methods: {
    weeksToRace: function weeksToRace(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(), 'weeks');
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('LL');
    },
    getRaces: function getRaces() {
      var _this = this;

      this.loading = true;
      var params = this.prepareParams();
      if (this.context.priority !== null) {
        params['priority'] = this.context.priority;
      }
      if (this.context.raceType !== null) {
        params['race_type'] = this.context.raceType;
      }
      if (this.context.raceType !== null) {
        params['race_type'] = this.context.raceType;
      }
      if (this.context.distance) {
        params['distance_string'] = this.context.distance;
      }
      params['race_date__gte'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD');
      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__plan_api__["r" /* fetchRaces */])(this.runner, params);
      return promise.then(this.enhanceListData).then(function (data) {
        _this.loading = false;
        _this.races = data;
        return data;
      });
    },

    refresh: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function () {
      this.getRaces();
    }, 400)
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationsPushInit_vue__ = __webpack_require__(336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27362cc1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationsPushInit_vue__ = __webpack_require__(709);
function injectStyle (ssrContext) {
  __webpack_require__(708)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationsPushInit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27362cc1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationsPushInit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_push_js__ = __webpack_require__(337);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mini: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      status: ''
    };
  },
  created: function created() {
    this.getStatus();
  },

  methods: {
    getStatus: function getStatus() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0__utils_push_js__["a" /* compatibleBrowser */]()) {
        if (Notification.permission === 'denied') {
          this.status = 'denied';
        } else {
          navigator.serviceWorker.ready.then(function (swRegistration) {
            swRegistration.pushManager.getSubscription().then(function (subscription) {
              var isSubscribed = !(subscription === null);
              if (isSubscribed) {
                _this.status = 'granted';
              } else {
                _this.status = 'ready';
              }
            });
          });
        }
      } else {
        this.status = 'unsupported';
      }
    },
    subscribe: function subscribe() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_push_js__["c" /* subscribeUser */]().then(function () {
        _this2.status = 'granted';
      }).catch(function () {
        _this2.status = 'denied';
      });
    },
    unsubscribe: function unsubscribe() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_push_js__["d" /* unsubscribe */]().then(function () {
        _this3.status = 'ready';
      });
    }
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export urlB64ToUint8Array */
/* harmony export (immutable) */ __webpack_exports__["b"] = initializePush;
/* harmony export (immutable) */ __webpack_exports__["a"] = compatibleBrowser;
/* harmony export (immutable) */ __webpack_exports__["c"] = subscribeUser;
/* harmony export (immutable) */ __webpack_exports__["d"] = unsubscribe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api__ = __webpack_require__(12);



var applicationServerPublicKey = "BIygLDmQaArsSBV3-1wv1OSDUn_23BmqG-LVEXp-s14AyaLMZNLLQbiAlcMl8jKYUCqN9XCOSe5cYqCu7GWJZPM";

function urlB64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function initializePush() {
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    navigator.serviceWorker.ready.then(function (swRegistration) {
      swRegistration.pushManager.getSubscription().then(function (subscription) {
        updateSubscriptionOnServer(subscription);
      });
    });
  }
}

function compatibleBrowser() {
  return 'serviceWorker' in navigator && 'PushManager' in window;
}

function subscribeUser() {
  var applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    navigator.serviceWorker.ready.then(function (swRegistration) {
      swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
      }).then(function (subscription) {
        updateSubscriptionOnServer(subscription, true);
        resolve(subscription);
      }).catch(function (err) {
        console.log('Failed to subscribe the user: ', err);
        reject(err);
      });
    });
  });
}

function unsubscribe() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    navigator.serviceWorker.ready.then(function (swRegistration) {
      swRegistration.pushManager.getSubscription().then(function (subscription) {
        var isSubscribed = !(subscription === null);
        if (isSubscribed) {
          var oldSubscription = subscription.toJSON();
          subscription.unsubscribe().then(function () {
            __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].post('/devices/', {
              'delete': true,
              'endpoint': oldSubscription.endpoint,
              'auth': oldSubscription.keys.auth,
              'p256dh': oldSubscription.keys.p256dh
            });
            resolve();
          });
        }
      });
    });
  });
}

function updateSubscriptionOnServer(subscription, registration) {
  if (subscription) {
    subscription = subscription.toJSON();
    if (__WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].defaults.headers.common['Authorization'] === undefined) {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].post('/devices/', {
      'endpoint': subscription.endpoint,
      'auth': subscription.keys.auth,
      'p256dh': subscription.keys.p256dh,
      'registration': !!registration
    });
  }
}

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      edit: false,
      form: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['runner']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['isActiveRunnerTrainer']), {
    heart_rate_zone: function heart_rate_zone() {
      return this.runner.real_heart_rate_zone || this.runner.heart_rate_zone || 'brak';
    }
  }),
  created: function created() {
    this.form = this.runner;
  },

  methods: {
    save: function save() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__api__["l" /* patchRunnerTrainer */])(this.runner.trainer, { 'id': this.runner.id, 'heart_rate_zone': this.form.heart_rate_zone }).then(function (data) {
        _this.$emit('runner-changed', data);
        __WEBPACK_IMPORTED_MODULE_2_izitoast___default.a.show({
          message: 'OWB1 został edytowany',
          color: 'green'
        });
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["t" /* RUNNER_SUCCESS */], data);
        _this.edit = false;
      }).catch(function (data) {
        if (data.response.status === 400) {
          __WEBPACK_IMPORTED_MODULE_2_izitoast___default.a.show({
            message: 'Nie udało się edytować',
            color: 'red'
          });
        }
      });
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      runner: null,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        runners: [],
        color: 'primary',
        width: 400

      }
    };
  },

  methods: {
    open: function open(options) {
      var _this = this;

      this.dialog = true;
      this.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.options, options);

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
      });
    },
    agree: function agree() {
      this.resolve({ value: this.runner });
      this.dialog = false;
    },
    cancel: function cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PulseZonesForm__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PulseZones__ = __webpack_require__(720);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'packages',
  components: { PulseZonesForm: __WEBPACK_IMPORTED_MODULE_8__PulseZonesForm__["a" /* default */], PulseZones: __WEBPACK_IMPORTED_MODULE_9__PulseZones__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__["a" /* ListMixin */]],
  data: function data() {
    return {
      showAdd: false,
      loading: true,
      pulseZonesList: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapState */])(['runner']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['isActiveRunnerTrainer', 'isActiveRunner'])),
  created: function created() {
    this.fetchPulseZonesList();
  },

  watch: {
    '$route': 'fetchPulseZonesList',
    'currentPage': 'fetchPulseZonesList',
    'perPage': function perPage(oldValue, newValue) {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.fetchPulseZonesList();
      }
    }
  },
  methods: {
    refresh: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function () {
      this.fetchPulseZonesList();
    }, 400),
    fetchPulseZonesList: function fetchPulseZonesList() {
      var _this = this;

      var params = this.prepareParams();
      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* fetchPulseZones */])(this.runner, params);
      return promise.then(this.enhanceListData).then(function (data) {
        _this.loading = false;
        _this.pulseZonesList = data;
        return data;
      });
    },
    changePulseZones: function changePulseZones(item) {
      this.$set(item, 'edit', true);
    },
    removePulseZones: function removePulseZones(item) {
      var _this2 = this;

      this.$root.$confirm('Usuń test', 'Czy na pewno usunąć test?', { confirmText: 'Usuń', color: 'error' }).then(function (willDelete) {
        if (willDelete) {
          var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* deletePulseZones */])(_this2.runner, item);
          return promise.then(function () {
            _this2.refresh();
            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["s" /* RUNNER_REQUEST */], [_this2.runner.id, true]);
            __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
              message: 'Test został usunięty',
              color: 'green'
            });
          }).catch(function () {
            __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
              message: 'Nie udało się usunąć testu.',
              color: 'red'
            });
          });
        }
      });
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchPulseZones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPulseZones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updatePulseZones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deletePulseZones; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(12);


var fetchPulseZones = function fetchPulseZones(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/runners/' + runner.id + '/pulse_zones/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var createPulseZones = function createPulseZones(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/runners/' + runner.id + '/pulse_zones/', obj).then(function (resp) {
    return resp.data;
  });
};
var updatePulseZones = function updatePulseZones(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/runners/' + runner.id + '/pulse_zones/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var deletePulseZones = function deletePulseZones(runner, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].delete('/runners/' + runner.id + '/pulse_zones/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PulseZonesForm_vue__ = __webpack_require__(343);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45396efb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PulseZonesForm_vue__ = __webpack_require__(719);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PulseZonesForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45396efb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PulseZonesForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_Fields__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_formMixin__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Fields: __WEBPACK_IMPORTED_MODULE_4__forms_Fields__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__utils_formMixin__["a" /* default */]],
  props: {
    pulseZones: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isUpdate: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['runner']), {
    fields: function fields() {
      return [{ comp: 'date', id: 'test_date', label: 'Data badania' }, { comp: 'text', id: 'zone_1', label: 'Strefa regeneracji aktywnej', props: { suffix: '[bpm]' } }, { comp: 'text', id: 'zone_2', label: 'Próg tlenowy', props: { suffix: '[bpm]' } }, { comp: 'text', id: 'zone_4', label: 'Próg anaerobowy', props: { suffix: '[bpm]' } }, { comp: 'text', id: 'hrmax', label: 'HRmax', props: { suffix: '[bpm]' } }];
    },
    message: function message() {
      return this.isUpdate ? 'Test został edytowany' : 'Test został dodany';
    }
  }),
  created: function created() {
    this.formData = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.pulseZones);
    if (this.pulseZones.id) {
      this.isUpdate = true;
    }
  },

  methods: {
    submit: function submit(data) {
      var _this = this;

      if (this.isUpdate) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__api__["d" /* updatePulseZones */])(this.runner, data).then(function (data) {
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["s" /* RUNNER_REQUEST */], [_this.runner.id, true]);
          return data;
        });
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createPulseZones */])(this.runner, data).then(function (data) {
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["s" /* RUNNER_REQUEST */], [_this.runner.id, true]);
          _this.formData = {};
          _this.validation.reset();
          return data;
        });
      }
    }
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PulseZonesForm__ = __webpack_require__(342);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PulseZonesForm: __WEBPACK_IMPORTED_MODULE_2__PulseZonesForm__["a" /* default */] },
  props: {
    pulseZones: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      edit: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isActiveRunnerTrainer', 'isActiveRunner']))
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plan_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ResultsChart__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Records__ = __webpack_require__(309);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ResultsChart: __WEBPACK_IMPORTED_MODULE_6__ResultsChart__["a" /* default */], Records: __WEBPACK_IMPORTED_MODULE_7__Records__["a" /* default */] },
  data: function data() {
    return {
      menu1: false,
      menu2: false,
      showChart: true,
      results: [],
      chartData: {},
      chartOptions: {
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              reverse: true,
              suggestedMin: 0,
              suggestedMax: 10 * 60,
              callback: function callback(value, index, values) {
                var duration = __WEBPACK_IMPORTED_MODULE_5_moment___default.a.duration(value, 'seconds');
                return __WEBPACK_IMPORTED_MODULE_5_moment___default.a.utc(duration.as('milliseconds')).format('HH:mm:ss');
              }
            },
            gridLines: {
              color: '#80cbc4',
              zeroLineColor: '#80cbc4'
            }
          }],
          xAxes: [{
            gridLines: {
              color: '#80cbc4'
            }
          }]
        },
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: function label(tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';
              if (label) {
                label += ': ';
              }
              var value = tooltipItem.yLabel;
              var duration = __WEBPACK_IMPORTED_MODULE_5_moment___default.a.duration(value, 'seconds');
              label += __WEBPACK_IMPORTED_MODULE_5_moment___default.a.utc(duration.as('milliseconds')).format('HH:mm:ss');
              return label;
            }
          }
        }
      },
      chartFilter: {
        distance: null,
        start: null,
        end: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['runner']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['allRaceDistanceStringsOptions'])),
  created: function created() {
    this.refetchView();
  },

  watch: {
    '$route': 'refetchView'
  },
  methods: {
    setDistance: function setDistance(distance) {
      this.chartFilter.distance = distance;
      this.refreshChart();
    },

    refreshChart: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function () {
      this.fetchResultsChart();
    }, 400),
    refetchView: function refetchView() {
      this.fetchResultsChart();
    },
    fetchResultsChart: function fetchResultsChart() {
      var _this = this;

      var params = { done: true };
      if (this.chartFilter.distance) {
        params['distance_string'] = this.chartFilter.distance;
      } else {
        this.chartData = {};
        return;
      }
      if (this.chartFilter.end) {
        params['race_date__lte'] = this.chartFilter.end;
      }
      if (this.chartFilter.start) {
        params['race_date__gte'] = this.chartFilter.start;
      }
      var promise = Object(__WEBPACK_IMPORTED_MODULE_2__plan_api__["s" /* fetchRacesSimple */])(this.runner, params);
      return promise.then(function (data) {
        var labels = [];
        var times = [];
        _this.results = data;
        var min = 60 * 60 * 60;
        var max = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var race = _step.value;

            labels.push(__WEBPACK_IMPORTED_MODULE_5_moment___default()(race.race_date).format('DD-MM-YYYY'));
            var timeSeconds = __WEBPACK_IMPORTED_MODULE_5_moment___default.a.duration(race.time).asSeconds();
            times.push(timeSeconds);
            min = Math.min(timeSeconds, min);
            max = Math.max(timeSeconds, max);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (min > max) {
          min = 0;
        }
        var eps = (max - min) / 5;
        min = Math.max(min - eps, 0);
        max = max + eps > 0 ? max + eps : 60 * 10;

        _this.chartData = {
          labels: labels,
          datasets: [{
            label: 'Czas',
            backgroundColor: '#f87979',
            borderColor: '#f87979',
            data: times,
            fill: false,
            lineTension: 0
          }]
        };
        _this.chartOptions.scales.yAxes[0].ticks.suggestedMin = min;
        _this.chartOptions.scales.yAxes[0].ticks.suggestedMax = max;
        _this.showChart = true;
      });
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotificationsSettings__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationsPushInit__ = __webpack_require__(335);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: { NotificationsSettings: __WEBPACK_IMPORTED_MODULE_5__NotificationsSettings__["a" /* default */], NotificationsPushInit: __WEBPACK_IMPORTED_MODULE_6__NotificationsPushInit__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__["a" /* ListMixin */]],
  data: function data() {
    return {
      notificationsList: [],
      enablePush: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['authUser'])),
  created: function created() {
    this.fetchNotificationsList();
  },

  watch: {
    '$route': 'fetchNotificationsList',
    context: {
      handler: function handler() {
        this.fetchNotificationsList();
      },

      deep: true
    }
  },
  methods: {
    refresh: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function () {
      this.fetchNotificationsList();
    }, 400),
    goToData: function goToData(item) {
      if (item && item.data && item.data.url) {
        console.log(item.data.url);
        this.$router.push(item.data.url);
      }
    },
    fetchNotificationsList: function fetchNotificationsList() {
      var _this = this;

      this.loading = true;
      var params = this.prepareParams();
      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* fetchNotifications */])(this.authUser, params);
      return promise.then(this.enhanceListData).then(function (data) {
        Object(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* readAll */])();
        _this.loading = false;
        _this.notificationsList = data;
      });
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return readAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchUserSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateUserSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(12);


var fetchNotifications = function fetchNotifications(user, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/notifications/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var readAll = function readAll(user) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/notifications/read/').then(function (resp) {
    return resp.data;
  });
};

var fetchUserSettings = function fetchUserSettings() {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/notifications/user_settings/').then(function (resp) {
    return resp.data;
  });
};

var updateUserSettings = function updateUserSettings(data) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/notifications/user_settings/', data).then(function (resp) {
    return resp.data;
  });
};

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_izitoast__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      formErrors: {},
      form: {}
    };
  },
  created: function created() {
    this.fetchSettings();
  },

  watch: {
    'user': 'fetchSettings'
  },
  methods: {
    fetchSettings: function fetchSettings() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* fetchUserSettings */])().then(function (data) {
        _this.form = data;
        _this.$emit('push-status', data.push);
      });
    },
    save: function save() {
      var _this2 = this;

      var promise = Object(__WEBPACK_IMPORTED_MODULE_0__api__["d" /* updateUserSettings */])(this.form);
      promise.then(function (data) {
        _this2.$emit('update-user-settings', data);
        __WEBPACK_IMPORTED_MODULE_1_izitoast___default.a.show({
          message: 'Ustawienia zostały edytowane',
          color: 'green'
        });
        _this2.$emit('push-status', data.push);
      }).catch(function (data) {
        __WEBPACK_IMPORTED_MODULE_1_izitoast___default.a.show({
          message: 'Nie udało się edytować ustawień',
          color: 'red'
        });
      });
    }
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plan_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_formatters__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RaceForm__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RaceResultsForm__ = __webpack_require__(734);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'races',
  components: { RaceForm: __WEBPACK_IMPORTED_MODULE_7__RaceForm__["a" /* default */], RaceResultsForm: __WEBPACK_IMPORTED_MODULE_8__RaceResultsForm__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__["a" /* ListMixin */]],
  data: function data() {
    return {
      context: {
        rowsPerPage: 10,
        sortBy: 'race_date',
        descending: true },
      type: null,
      showAdd: false,
      loading: true,
      menu1: false,
      menu2: false,
      races: [],
      headers: [{
        value: 'race_date',
        text: 'data',
        sortable: true
      }, {
        value: 'name',
        text: 'nazwa',
        sortable: true
      }, {
        value: 'city',
        text: 'miasto',
        sortable: true
      }, {
        value: 'race_type',
        text: 'rodzaj',
        sortable: true
      }, {
        value: 'distance',
        text: 'dystans',
        sortable: true
      }, {
        value: 'certified',
        text: 'atest',
        sortable: true
      }, {
        value: 'priority',
        text: 'priorytet',
        sortable: true
      }, {
        value: 'time',
        text: 'czas',
        sortable: true
      }, {
        value: 'actions',
        text: 'akcje',
        align: 'center',
        sortable: false,
        width: '180px'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['runner']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['allRaceDistanceStringsOptions', 'allRaceTypesStringsOptions'])),
  watch: {
    context: {
      handler: function handler(a, b) {
        if (a.page === b.page && a.page !== 1) {
          this.context.page = 1;
        } else {
          this.getRaces();
        }
      },

      deep: true
    },
    '$route': 'getRaces'
  },
  methods: {
    formatterBool: function formatterBool(data) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_formatters__["a" /* boolFormatter */])(data);
    },
    getRaces: function getRaces() {
      var _this = this;

      this.loading = true;
      var params = this.prepareParams();
      if (this.context.priority !== null) {
        params['priority'] = this.context.priority;
      }
      if (this.context.raceType !== null) {
        params['race_type'] = this.context.raceType;
      }
      if (this.context.raceType !== null) {
        params['race_type'] = this.context.raceType;
      }
      if (this.context.distance) {
        params['distance_string'] = this.context.distance;
      }
      if (this.context.end) {
        params['race_date__lte'] = this.context.end;
      }
      if (this.context.start) {
        params['race_date__gte'] = this.context.start;
      }
      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__plan_api__["r" /* fetchRaces */])(this.runner, params);
      return promise.then(this.enhanceListData).then(function (data) {
        _this.loading = false;
        _this.races = data;
        return data;
      });
    },
    expand: function expand(props, type) {
      if (this.type === type) {
        props.expanded = !props.expanded;
      } else {
        this.type = type;
        props.expanded = true;
      }
    },
    deleteItem: function deleteItem(item) {
      var _this2 = this;

      this.$root.$confirm('Usuń zawody', 'Czy na pewno usunąć zawody?', { confirmText: 'Usuń', color: 'error' }).then(function (willDelete) {
        if (willDelete) {
          var promise = Object(__WEBPACK_IMPORTED_MODULE_1__plan_api__["k" /* deleteRace */])(_this2.runner, item);
          return promise.then(function () {
            _this2.refresh();
            __WEBPACK_IMPORTED_MODULE_6_izitoast___default.a.show({
              message: 'Zawody zostały usunięte',
              color: 'green'
            });
          }).catch(function () {
            __WEBPACK_IMPORTED_MODULE_6_izitoast___default.a.show({
              message: 'Nie udało się usunąć zawodów.',
              color: 'red'
            });
          });
        }
      });
    },

    refresh: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function () {
      this.getRaces();
    }, 400)
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plan_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_InputDate__ = __webpack_require__(80);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { InputDate: __WEBPACK_IMPORTED_MODULE_4__forms_InputDate__["a" /* default */] },
  props: {
    raceData: {
      type: Object,
      default: function _default() {
        return {
          distance_string: null,
          priority: 'B'
        };
      }
    }
  },
  data: function data() {
    return {
      errors: {},
      race: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['allRaceTypesStringsOptions', 'raceDistanceStreetStringsOptions', 'allRaceDistanceStringsOptions', 'raceDistanceTrackStringsOptions', 'allRacePrioritiesOptions', 'runner']), {
    isNew: function isNew() {
      return this.race.id === undefined;
    },
    distanceOptions: function distanceOptions() {
      if (this.race.race_type === 'street') {
        return this.raceDistanceStreetStringsOptions;
      }
      if (this.race.race_type === 'track') {
        return this.raceDistanceTrackStringsOptions;
      }
      return [{
        text: 'inne',
        value: 'other'
      }];
    }
  }),
  created: function created() {
    this.initRace();
  },

  methods: {
    initRace: function initRace() {
      this.race = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.raceData);
    },
    changeRaceType: function changeRaceType() {
      if (this.race.race_type !== 'street' && this.race.race_type !== 'track') {
        this.race.distance_string = 'other';
      } else {
        this.race.distance_string = null;
      }
    },
    saveRace: function saveRace() {
      var _this = this;

      if (this.isNew) {
        var promise = Object(__WEBPACK_IMPORTED_MODULE_1__plan_api__["f" /* createRace */])(this.runner, this.race).then(function (data) {
          _this.$emit('success', data);
          __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
            message: 'Zawody zostały dodane',
            color: 'green'
          });
          return data;
        });
      } else {
        promise = Object(__WEBPACK_IMPORTED_MODULE_1__plan_api__["A" /* updateRace */])(this.runner, this.race).then(function (data) {
          _this.$emit('success', data);
          __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
            message: 'Zawody zostały zmienione',
            color: 'green'
          });
          return data;
        });
      }
      promise.catch(function (data) {
        if (data.response.status === 400) {
          _this.errors = data.response.data;
        }
      });
    },
    getErrors: function getErrors(name) {
      return this.errors[name] || [];
    },
    hasErrors: function hasErrors(name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0;
    },
    resetErrors: function resetErrors() {
      this.errors = {};
    }
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plan_api__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_izitoast__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    raceData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      errors: {},
      race: {
        id: this.raceData.id,
        time: this.raceData.time || undefined,
        place: this.raceData.place || undefined,
        post_remarks: this.raceData.post_remarks || undefined
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['runner'])),
  created: function created() {
    this.initRace();
  },

  methods: {
    initRace: function initRace() {
      this.race = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.raceData);
    },
    saveRace: function saveRace() {
      var _this = this;

      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__plan_api__["m" /* doneRace */])(this.runner, this.race).then(function (data) {
        _this.$emit('success', data);
        _this.edit = false;
        __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
          message: 'Wynik został zmieniony',
          color: 'green'
        });
        return data;
      });
      promise.catch(function (data) {
        if (data.response.status === 400) {
          _this.errors = data.response.data;
        }
      });
    },
    getErrors: function getErrors(name) {
      return this.errors[name] || [];
    },
    hasErrors: function hasErrors(name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0;
    },
    resetErrors: function resetErrors() {
      this.errors = {};
    }
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VideoForm__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VideoItem__ = __webpack_require__(740);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VideoForm: __WEBPACK_IMPORTED_MODULE_6__VideoForm__["a" /* default */], VideoItem: __WEBPACK_IMPORTED_MODULE_7__VideoItem__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__utils_ListMixin__["a" /* ListMixin */]],
  data: function data() {
    return {
      showAdd: false,
      loading: true,
      videosList: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['isAdmin', 'isTrainer', 'trainer', 'runner'])),
  watch: {
    '$route': 'fetchVideoList',
    context: {
      handler: function handler() {
        this.fetchVideoList();
      },

      deep: true
    }
  },
  methods: {
    refresh: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function () {
      this.fetchVideoList();
    }, 400),
    fetchVideoList: function fetchVideoList() {
      var _this = this;

      this.loading = true;
      var params = this.prepareParams();
      var promise = void 0;
      if (this.isAdmin) {
        promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["e" /* fetchAdminVideo */])(params);
      } else if (this.isTrainer) {
        promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["g" /* fetchTrainerVideo */])(this.trainer, params);
      } else {
        promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* fetchRunnerVideo */])(this.runner, params);
      }

      return promise.then(this.enhanceListData).then(function (data) {
        _this.loading = false;
        _this.videosList = data;
        return data;
      });
    },
    changeVideo: function changeVideo(item) {
      this.$set(item, 'edit', true);
    },
    removeVideo: function removeVideo(item) {
      var _this2 = this;

      this.$root.$confirm('Usuń wideo', 'Czy na pewno usunąć wideo?', { confirmText: 'Usuń', color: 'error' }).then(function (willDelete) {
        if (willDelete) {
          var promise = void 0;
          if (_this2.isAdmin) {
            promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* deleteAdminVideo */])(item);
          } else if (_this2.isTrainer) {
            promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["d" /* deleteTrainerVideo */])(_this2.trainer, item);
          }
          return promise.then(function () {
            _this2.refresh();
            __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
              message: 'Film został usunięty',
              color: 'green'
            });
          }).catch(function () {
            __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
              message: 'Nie udało się usunąć filmu.',
              color: 'red'
            });
          });
        }
      });
    }
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchAdminVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchTrainerVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchRunnerVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createAdminVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateAdminVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createTrainerVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateTrainerVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteAdminVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteTrainerVideo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(12);


var fetchAdminVideo = function fetchAdminVideo(params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/videos/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var fetchTrainerVideo = function fetchTrainerVideo(trainer, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/trainers/' + trainer.id + '/videos/', { params: params }).then(function (resp) {
    return resp.data;
  });
};
var fetchRunnerVideo = function fetchRunnerVideo(runner, params) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/runners/' + runner.id + '/videos/', { params: params }).then(function (resp) {
    return resp.data;
  });
};

var createAdminVideo = function createAdminVideo(obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/videos/', obj).then(function (resp) {
    return resp.data;
  });
};
var updateAdminVideo = function updateAdminVideo(obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/videos/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};
var createTrainerVideo = function createTrainerVideo(trainer, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/trainers/' + trainer.id + '/videos/', obj).then(function (resp) {
    return resp.data;
  });
};
var updateTrainerVideo = function updateTrainerVideo(trainer, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/trainers/' + trainer.id + '/videos/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

var deleteAdminVideo = function deleteAdminVideo(obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].delete('/videos/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};
var deleteTrainerVideo = function deleteTrainerVideo(trainer, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].delete('/trainers/' + trainer.id + '/videos/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoForm_vue__ = __webpack_require__(355);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b6bb4d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoForm_vue__ = __webpack_require__(739);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b6bb4d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_YouTubeUrlNormalize__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_Fields__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_formMixin__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Fields: __WEBPACK_IMPORTED_MODULE_4__forms_Fields__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__utils_formMixin__["a" /* default */]],
  props: {
    video: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      link: null,
      isUpdate: false,
      formData: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['trainer', 'isAdmin', 'isTrainer']), {
    fields: function fields() {
      return [{ comp: 'text', id: 'link', label: 'Link do wideo:', listeners: { change: this.normalize } }];
    },
    message: function message() {
      return this.isUpdate ? 'Wideo zostało edytowane' : 'Wideo zostało dodane';
    }
  }),
  created: function created() {
    this.formData = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(this.video);
    if (this.video.id) {
      this.isUpdate = true;
      this.link = this.formData.link;
    }
  },

  methods: {
    normalize: function normalize() {
      var o = Object(__WEBPACK_IMPORTED_MODULE_2__utils_YouTubeUrlNormalize__["a" /* YouTubeUrlNormalize */])(this.formData.link);
      this.formData.link = o.link;
      if (o.error) {
        this.link = false;
      } else {
        this.link = this.formData.link;
      }
    },
    submit: function submit(data) {
      var _this = this;

      var promise = void 0;
      if (this.isUpdate) {
        if (this.isAdmin) {
          promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["h" /* updateAdminVideo */])(data);
        } else if (this.isTrainer) {
          promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["i" /* updateTrainerVideo */])(this.trainer, data);
        }
      } else {
        if (this.isAdmin) {
          promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* createAdminVideo */])(data);
        } else if (this.isTrainer) {
          promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* createTrainerVideo */])(this.trainer, data);
        }
        promise = promise.then(function (data) {
          _this.formData = {};
          _this.validation.reset();
          return data;
        });
      }
      return promise;
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VideoForm__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_get_youtube_id__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_get_youtube_id___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_get_youtube_id__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VideoForm: __WEBPACK_IMPORTED_MODULE_2__VideoForm__["a" /* default */] },
  props: {
    video: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      edit: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isAdmin', 'isTrainer']), {
    videoId: function videoId() {
      return __WEBPACK_IMPORTED_MODULE_3_get_youtube_id___default()(this.video.link);
    }
  })
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PlaceholderItem__ = __webpack_require__(746);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var PlaceholderForm = function PlaceholderForm() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 799));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'packages',
  components: { PlaceholderForm: PlaceholderForm, PlaceholderItem: __WEBPACK_IMPORTED_MODULE_5__PlaceholderItem__["a" /* default */] },
  data: function data() {
    return {
      title: '',
      showAdd: false,
      placeholdersList: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['isAdmin'])),
  created: function created() {
    this.fetchPage();
  },

  watch: {
    '$route': 'fetchPage'
  },
  methods: {
    refresh: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function () {
      this.fetchPage();
    }, 400),
    fetchPage: function fetchPage() {
      var _this = this;

      var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* fetchPage */])(this.$route.params.slug);

      return promise.then(function (data) {
        _this.title = data.title;
        _this.placeholdersList = data.placeholders;
      });
    },
    changePlaceholder: function changePlaceholder(item) {
      this.$set(item, 'edit', true);
    },
    removePlaceholder: function removePlaceholder(item) {
      var _this2 = this;

      this.$root.$confirm('Usuń element', 'Czy na pewno usunąć ten element?', { confirmText: 'Usuń', color: 'error' }).then(function (willDelete) {
        if (willDelete) {
          var promise = Object(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* deletePlaceholder */])(_this2.$route.params.slug, item);
          return promise.then(function () {
            _this2.refresh();
            __WEBPACK_IMPORTED_MODULE_2_izitoast___default.a.show({
              message: 'Element został usunięty',
              color: 'green'
            });
          }).catch(function () {
            __WEBPACK_IMPORTED_MODULE_2_izitoast___default.a.show({
              message: 'Nie udało się usunąć elementu.',
              color: 'red'
            });
          });
        }
      });
    }
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    placeholder: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isAdmin']))
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ListMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_formatters__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TrainerAddForm__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TrainerUpdateForm__ = __webpack_require__(752);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'trainers',
  components: { TrainerAddForm: __WEBPACK_IMPORTED_MODULE_5__TrainerAddForm__["a" /* default */], TrainerUpdateForm: __WEBPACK_IMPORTED_MODULE_6__TrainerUpdateForm__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__utils_ListMixin__["a" /* ListMixin */]],
  data: function data() {
    return {
      showAdd: false,
      loading: true,
      trainers: [],
      headers: [{
        value: 'last_name',
        text: 'imię i nazwisko',
        sortable: true
      }, {
        value: 'email',
        text: 'e-mail',
        sortable: true
      }, {
        value: 'is_active',
        text: 'aktywny',
        sortable: true
      }, {
        value: 'actions',
        text: 'akcje',
        align: 'center',
        sortable: false,
        width: '180px'
      }]
    };
  },

  watch: {
    context: {
      handler: function handler() {
        this.getTrainers();
      },

      deep: true
    }
  },
  methods: {
    formatterBool: function formatterBool(data) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_formatters__["a" /* boolFormatter */])(data);
    },
    getTrainers: function getTrainers() {
      var _this = this;

      this.loading = true;
      var params = this.prepareParams();
      if (this.context.isActive !== null) {
        params['is_active'] = this.context.isActive;
      }
      var promise = Object(__WEBPACK_IMPORTED_MODULE_0__api__["d" /* fetchTrainers */])(params);
      return promise.then(this.enhanceListData).then(function (data) {
        _this.loading = false;
        _this.trainers = data;
        return data;
      });
    },
    sendMailTrainer: function sendMailTrainer(item) {
      var _this2 = this;

      var promise = Object(__WEBPACK_IMPORTED_MODULE_0__api__["g" /* sendMailTrainer */])(item);
      return promise.then(function () {
        _this2.refresh();
        __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
          message: 'Mail aktywacyjny został wysłany.',
          color: 'green'
        });
      });
    },
    activateTrainer: function activateTrainer(item) {
      var _this3 = this;

      var promise = Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* activateTrainer */])(item);
      return promise.then(function () {
        _this3.refresh();
        __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
          message: 'Konto zostało aktywowane',
          color: 'green'
        });
      });
    },
    deactivateTrainer: function deactivateTrainer(item) {
      var _this4 = this;

      var promise = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* deactivateTrainer */])(item);
      return promise.then(function () {
        _this4.refresh();
        __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
          message: 'Konto zostało deaktywowane',
          color: 'green'
        });
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.show({
          message: 'Nie udało się deaktywować trenera. Istnieją przypisani do niego zawodnicy.',
          color: 'red'
        });
      });
    },

    refresh: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function () {
      this.getTrainers();
    }, 400)
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forms_Fields__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_formMixin__ = __webpack_require__(29);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Fields: __WEBPACK_IMPORTED_MODULE_1__forms_Fields__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__utils_formMixin__["a" /* default */]],
  data: function data() {
    return {
      formData: {}
    };
  },

  computed: {
    fields: function fields() {
      return [{ comp: 'text', id: 'email', label: 'Email:' }, { comp: 'text', id: 'first_name', label: 'Imię:' }, { comp: 'text', id: 'last_name', label: 'Nazwisko:' }];
    },
    message: function message() {
      return 'Konto trenera zostało utworzone.';
    }
  },
  methods: {
    submit: function submit(data) {
      var _this = this;

      return Object(__WEBPACK_IMPORTED_MODULE_0__api__["f" /* registerTrainerAdmin */])(data).then(function (data) {
        _this.formData = {};
        return data;
      });
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forms_Fields__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_formMixin__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Fields: __WEBPACK_IMPORTED_MODULE_1__forms_Fields__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__utils_formMixin__["a" /* default */]],
  props: {
    trainerData: {
      type: Object
    }
  },
  computed: {
    fields: function fields() {
      return [{ comp: 'text', id: 'first_name', label: 'Imię:' }, { comp: 'text', id: 'last_name', label: 'Nazwisko:' }];
    },
    message: function message() {
      return 'Konto trenera zostało edytowane.';
    }
  },
  created: function created() {
    this.formData = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(this.trainerData);
  },

  methods: {
    submit: function submit(data) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__api__["h" /* updateTrainer */])(data);
    }
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_form_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_izitoast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_picture_input__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__runners_RunnerDataField__ = __webpack_require__(54);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PictureInput: __WEBPACK_IMPORTED_MODULE_5_vue_picture_input__["a" /* default */], RunnerDataField: __WEBPACK_IMPORTED_MODULE_7__runners_RunnerDataField__["a" /* default */] },
  validators: {
    'runner.avatar_thumbnail': function runnerAvatar_thumbnail(value) {
      value = value || null;
      return __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__["Validator"].value(value).custom(Object(__WEBPACK_IMPORTED_MODULE_3__utils_form_utils__["a" /* serverValidation */])(this.formErrors, 'avatar_thumbnail'));
    }
  },
  data: function data() {
    return {
      updateMode: false,
      form: {},
      formErrors: {},
      trainer: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['authUser']), {
    isSelf: function isSelf() {
      return parseInt(this.$route.params.id) === this.authUser.id;
    }
  }),
  watch: {
    '$route': 'fetchTrainer'
  },
  mounted: function mounted() {
    this.fetchTrainer();
  },

  methods: {
    fetchTrainer: function fetchTrainer() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__api__["e" /* getTrainer */])(this.$route.params.id).then(function (data) {
        _this.trainer = data;
        _this.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.trainer);
      });
    },
    changeAvatar: function changeAvatar(image) {
      this.form.avatar_thumbnail = this.$refs.pictureInput.file;
    },
    updateTrainer: function updateTrainer() {
      var _this2 = this;

      this.$validate().then(function (success) {
        if (success) {
          Object(__WEBPACK_IMPORTED_MODULE_1__api__["h" /* updateTrainer */])(_this2.form).then(function (data) {
            _this2.validation.reset();
            _this2.$emit('trainer-updated', data);
            __WEBPACK_IMPORTED_MODULE_4_izitoast___default.a.show({
              message: 'Konto trenera zostało edytowane.',
              color: 'green'
            });
            _this2.updateMode = false;
            _this2.trainer = data;
            return data;
          }).catch(function (data) {
            if (data.response.status === 400) {
              _this2.formErrors = data.response.data;
              _this2.$validate();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['runnersTrainer'])),
  created: function created() {
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["p" /* RUNNERS_TRAINER_REQUEST */], __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.runner);
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    year: function year() {
      return new Date().getFullYear();
    }
  }
});

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.9c371be.jpg";

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-symbol.5dbae21.jpg";

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdminNav__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TrainerNav__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RunnerNav__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { AdminNav: __WEBPACK_IMPORTED_MODULE_2__AdminNav__["a" /* default */], TrainerNav: __WEBPACK_IMPORTED_MODULE_3__TrainerNav__["a" /* default */], RunnerNav: __WEBPACK_IMPORTED_MODULE_4__RunnerNav__["a" /* default */] },
  data: function data() {
    return {
      navVisible: false,
      miniNav: false,
      mobilePoint: 1264
    };
  },
  mounted: function mounted() {
    if (window.innerWidth > this.mobilePoint) {
      this.navVisible = true;
    }
  },

  methods: {
    toggleNav: function toggleNav() {
      if (window.innerWidth > this.mobilePoint) {
        this.navVisible = true;
        this.miniNav = !this.miniNav;
      } else {
        this.navVisible = !this.navVisible;
        this.miniNav = false;
      }
    },

    logout: function logout() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["l" /* AUTH_LOGOUT */]);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isAuthenticated', 'authUser', 'userLoaded', 'isTrainer', 'isRunner', 'isAdmin']), {
    year: function year() {
      return new Date().getFullYear();
    }
  })
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mini: Boolean,
    list: Boolean
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isAdmin', 'isTrainer', 'isRunner', 'authUser']), {
    links: function links() {
      return [{ visible: true, to: { name: 'packages' }, name: 'Pakiety', icon: 'bookmarks' }, { visible: true, to: { name: 'runners-admin' }, name: 'Zawodnicy', icon: 'directions_run' }, { visible: true, to: { name: 'trainers-admin' }, name: 'Trenerzy', icon: 'people' }, { visible: true, to: { name: 'admin-videos' }, name: 'Filmy', icon: 'movie' }, { visible: true, to: { name: 'pages-admin', params: { slug: 'discounts' } }, name: 'Zniżki', icon: 'card_giftcard' }, { visible: true, to: { name: 'pages-admin', params: { slug: 'explanations' } }, name: 'Objaśnienia', icon: 'contact_support' }, { visible: true, to: { name: 'payments-admin' }, name: 'Płatności', icon: 'attach_money' }, { visible: true, to: { name: 'forum-admin' }, name: 'Forum', icon: 'forum' }, { visible: this.isTrainer, to: { name: 'trainer-panel', params: { id: this.authUser.id } }, name: 'Panel trenera', icon: 'view_carousel' }];
    }
  })
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mini: Boolean,
    list: Boolean
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isAdmin', 'isTrainer', 'isRunner', 'authUser']), {
    links: function links() {
      return [{ visible: true, to: { name: 'trainer-data', params: { id: this.authUser.id } }, name: 'Dane', icon: 'person' }, { visible: true, to: { name: 'trainer-runners', params: { id: this.authUser.id } }, name: 'Zawodnicy', icon: 'directions_run' }, { visible: true, to: { name: 'trainer-videos', params: { id: this.authUser.id } }, name: 'Filmy', icon: 'movie' }, { visible: true, to: { name: 'trainer-pages', params: { id: this.authUser.id, slug: 'discounts' } }, name: 'Zniżki', icon: 'card_giftcard' }, { visible: true, to: { name: 'trainer-pages', params: { id: this.authUser.id, slug: 'explanations' } }, name: 'Objaśnienia', icon: 'contact_support' }, { visible: true, to: { name: 'trainer-notifications', params: { id: this.authUser.id } }, name: 'Powiadomienia', icon: 'notifications' }, { visible: true, to: { name: 'trainer-forum', params: { id: this.authUser.id } }, name: 'Forum', icon: 'forum' }];
    }
  })
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mini: Boolean,
    list: Boolean
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isAdmin', 'isTrainer', 'isRunner', 'authUser']), {
    links: function links() {
      return [{ visible: true, to: { name: 'runner-data', params: { id: this.$route.params.id } }, name: 'Dane', icon: 'person' }, { visible: true, to: { name: 'runner-plan', params: { id: this.$route.params.id } }, name: 'Plan treningowy', icon: 'calendar_today' }, { visible: true, to: { name: 'runner-hrmax', params: { id: this.$route.params.id } }, name: 'Badania', icon: 'favorite_border' }, { visible: true, to: { name: 'runner-pages', params: { id: this.$route.params.id, slug: 'discounts' } }, name: 'Zniżki', icon: 'card_giftcard' }, { visible: true, to: { name: 'runner-pages', params: { id: this.$route.params.id, slug: 'explanations' } }, name: 'Objaśnienia', icon: 'contact_support' }, { visible: true, to: { name: 'runner-progression', params: { id: this.$route.params.id } }, name: 'Rekordy', icon: 'show_chart' }, { visible: true, to: { name: 'runner-races', params: { id: this.$route.params.id } }, name: 'Zawody', icon: 'directions_run' }, { visible: true, to: { name: 'runner-payments', params: { id: this.$route.params.id } }, name: 'Płatności', icon: 'attach_money' }, { visible: true, to: { name: 'runner-videos', params: { id: this.$route.params.id } }, name: 'Filmy', icon: 'movie' }, { visible: true, to: { name: 'runner-notifications', params: { id: this.$route.params.id } }, name: 'Powiadomienia', icon: 'notifications' }, { visible: true, to: { name: 'runner-forum', params: { id: this.$route.params.id } }, name: 'Forum', icon: 'forum' }];
    }
  })
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isAdmin']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['trainer', 'adminTrainers'])),
  created: function created() {
    if (this.isAdmin) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["c" /* ADMIN_TRAINERS_REQUEST */]);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["w" /* TRAINER_REQUEST */], to.params.id).then(function () {
      next();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["w" /* TRAINER_REQUEST */], to.params.id).then(function () {
      next();
    });
  },

  methods: {
    nextTrainer: function nextTrainer() {
      var _this = this;

      var trainers = this.adminTrainers;
      var newIndex = void 0;
      var index = trainers.findIndex(function (elem) {
        return _this.trainer.id === elem.id;
      });
      if (index < 0) {
        return;
      }
      if (index === trainers.length - 1) {
        newIndex = 0;
      } else {
        newIndex = index + 1;
      }
      this.$router.push({ name: this.$route.name, params: { id: trainers[newIndex].id } });
    },
    prevTrainer: function prevTrainer() {
      var _this2 = this;

      var trainers = this.adminTrainers;
      var newIndex = void 0;
      var index = trainers.findIndex(function (elem) {
        return _this2.trainer.id === elem.id;
      });
      if (index < 0) {
        return;
      }
      if (index === 0) {
        newIndex = trainers.length - 1;
      } else {
        newIndex = index - 1;
      }
      this.$router.push({ name: this.$route.name, params: { id: trainers[newIndex].id } });
    }
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    fluid: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isAdmin', 'isTrainer', 'isRunner']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['runnersTrainer', 'runner', 'trainerRunners', 'adminRunners'])),
  created: function created() {
    var _this = this;

    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["p" /* RUNNERS_TRAINER_REQUEST */], __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.runner).then(function () {
      if (_this.isTrainer) {
        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["u" /* TRAINERS_RUNNERS_REQUEST */], __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.runnersTrainer);
      }
      if (_this.isAdmin) {
        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["a" /* ADMIN_RUNNERS_REQUEST */]);
      }
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["s" /* RUNNER_REQUEST */], [to.params.id]).then(function (runner) {
      var runnerSelf = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.isRunner && runner.id === __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.authUser.id;
      if (runnerSelf && !runner.data_filled && to.name !== 'runner-application-data-package' && to.name !== 'runner-application-data-trainer' && to.name !== 'runner-application-data-first' && to.name !== 'runner-application-data-second') {
        if (!runner.package) {
          return next({ name: 'runner-application-data-package', params: { id: runner.id } });
        } else if (!runner.trainer) {
          return next({ name: 'runner-application-data-trainer', params: { id: runner.id } });
        } else {
          return next({ name: 'runner-application-data-first', params: { id: runner.id } });
        }
      } else if (runnerSelf && !runner.account_paid && to.name !== 'runner-plan' && to.name !== 'runner-payments' && to.name !== 'runner-payments-pay' && to.name !== 'runner-payments-return' && to.name !== 'runner-application-data-package' && to.name !== 'runner-application-data-trainer' && to.name !== 'runner-application-data-first' && to.name !== 'runner-application-data-second') {
        return next({ name: 'runner-payments', params: { id: runner.id } });
      } else {
        return next();
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["s" /* RUNNER_REQUEST */], [to.params.id]).then(function (runner) {
      var runnerSelf = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.isRunner && runner.id === __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.authUser.id;
      var trainerSelf = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.isTrainer && runner.trainer === __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.authUser.id;
      if (runnerSelf && !runner.data_filled && to.name !== 'runner-application-data-package' && to.name !== 'runner-application-data-trainer' && to.name !== 'runner-application-data-first' && to.name !== 'runner-application-data-second') {
        if (!runner.package) {
          return next({ name: 'runner-application-data-package', params: { id: runner.id } });
        } else if (!runner.trainer) {
          return next({ name: 'runner-application-data-trainer', params: { id: runner.id } });
        } else {
          return next({ name: 'runner-application-data-first', params: { id: runner.id } });
        }
      } else if (runnerSelf && !runner.account_paid && to.name !== 'runner-plan' && to.name !== 'runner-payments' && to.name !== 'runner-payments-pay' && to.name !== 'runner-payments-return' && to.name !== 'runner-application-data-package' && to.name !== 'runner-application-data-trainer' && to.name !== 'runner-application-data-first' && to.name !== 'runner-application-data-second') {
        return next({ name: 'runner-payments', params: { id: runner.id } });
      }
      if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.isAdmin || trainerSelf || runnerSelf) {
        return next();
      } else {
        return next({ name: 'login' });
      }
    });
  },

  methods: {
    rereadRunner: function rereadRunner() {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["s" /* RUNNER_REQUEST */], [this.runner.id, true]);
    },
    nextRunner: function nextRunner() {
      var _this2 = this;

      var runners = this.isAdmin ? this.adminRunners : this.trainerRunners;
      var newIndex = void 0;
      var index = runners.findIndex(function (elem) {
        return _this2.runner.id === elem.id;
      });
      if (index < 0) {
        return;
      }
      if (index === runners.length - 1) {
        newIndex = 0;
      } else {
        newIndex = index + 1;
      }
      this.$router.push({ name: this.$route.name, params: { id: runners[newIndex].id } });
    },
    prevRunner: function prevRunner() {
      var _this3 = this;

      var runners = this.isAdmin ? this.adminRunners : this.trainerRunners;
      var newIndex = void 0;
      var index = runners.findIndex(function (elem) {
        return _this3.runner.id === elem.id;
      });
      if (index < 0) {
        return;
      }
      if (index === 0) {
        newIndex = runners.length - 1;
      } else {
        newIndex = index - 1;
      }
      this.$router.push({ name: this.$route.name, params: { id: runners[newIndex].id } });
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    setSize: function setSize(el) {
      var iframe = el.target;
      iframe.height = iframe.contentWindow.document.body.scrollHeight + 50 + 'px';
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    type: String,
    tooltip: {},
    small: Boolean
  },
  computed: {
    tooltipContent: function tooltipContent() {
      return window.innerWidth > 768 ? this.tooltip : null;
    }
  }
});

/***/ }),
/* 375 */,
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPlaceholder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updatePlaceholder; });
/* unused harmony export changePlaceholderPosition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deletePlaceholder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(12);


var fetchPage = function fetchPage(slug) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].get('/pages/' + slug + '/').then(function (resp) {
    return resp.data;
  });
};

var createPlaceholder = function createPlaceholder(slug, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].post('/pages/' + slug + '/placeholders/', obj).then(function (resp) {
    return resp.data;
  });
};
var updatePlaceholder = function updatePlaceholder(slug, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/pages/' + slug + '/placeholders/' + obj.id + '/', obj).then(function (resp) {
    return resp.data;
  });
};
var changePlaceholderPosition = function changePlaceholderPosition(slug, pid, change) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].put('/pages/' + slug + '/placeholders/' + pid + '/change_position/', change).then(function (resp) {
    return resp.data;
  });
};

var deletePlaceholder = function deletePlaceholder(slug, obj) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].delete('/pages/' + slug + '/placeholders/' + obj.id + '/').then(function (resp) {
    return resp.data;
  });
};

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_simple_vue_validator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_simple_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mdi_font_css_materialdesignicons_css__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__mdi_font_css_materialdesignicons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_tooltip__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_RpIcon__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_mq__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_push_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__stylus_main_styl__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__stylus_main_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__stylus_main_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_util_colors__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuetify_es5_util_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_youtube_embed__ = __webpack_require__(795);




















var pallete = {
  primary: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_util_colors___default.a.teal.base,
  secondary: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_util_colors___default.a.teal.darken2,
  accent: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_util_colors___default.a.amber.darken4,
  tertiary: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_util_colors___default.a.lightBlue.darken3,
  error: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_util_colors___default.a.red.base,
  warning: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_util_colors___default.a.yellow.darken1,
  info: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_util_colors___default.a.blue.lighten2,
  success: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_util_colors___default.a.green.base
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_mq__["a" /* default */], {
  breakpoints: { // default breakpoints - customize this
    sm: 960,
    md: 1250,
    lg: Infinity
  }
});

__WEBPACK_IMPORTED_MODULE_12_moment___default.a.locale('pl');

__WEBPACK_IMPORTED_MODULE_8_simple_vue_validator___default.a.extendTemplates({
  required: 'To pole jest wymagane',
  email: 'Niepoprawny adres e-mail',
  between: 'Wartość musi znajdować się pomiędzy {0} a {1}.',
  optionCombiner: function optionCombiner(options) {
    if (options.length > 2) {
      options = [options.slice(0, options.length - 1).join('，'), options[options.length - 1]];
    }
    return options.join(' lub ');
  }
});
var pl = {
  dataIterator: {
    rowsPerPageText: 'Pozycji na stronie:',
    rowsPerPageAll: 'Wszystkie',
    pageText: '{0}-{1} z {2}',
    noResultsText: 'Nie znaleziono danych',
    nextPage: 'Następna strona',
    prevPage: 'Poprzednia strona'
  },
  dataTable: {
    rowsPerPageText: 'Wierszy na stronie:'
  },
  noDataText: 'Brak danych'
};
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_simple_vue_validator___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_youtube_embed__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_v_tooltip__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vuetify___default.a, {
  theme: pallete,
  lang: {
    locales: { pl: pl },
    current: 'pl'
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('rp-icon', __WEBPACK_IMPORTED_MODULE_11__utils_RpIcon__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('default', function (input, property) {
  return input === undefined || input === '' || input === null ? property : input;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('formatDate', function (value, format) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_12_moment___default()(String(value)).format(format);
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

var token = localStorage.getItem('user-token');
var promise;
if (token) {
  __WEBPACK_IMPORTED_MODULE_7__utils_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Token ' + token;
  promise = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["z" /* USER_REQUEST */]);
} else {
  promise = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(null);
}

promise.finally(function () {
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
  });
  Object(__WEBPACK_IMPORTED_MODULE_14__utils_push_js__["b" /* initializePush */])();
});

/***/ }),
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b52372e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(410);
function injectStyle (ssrContext) {
  __webpack_require__(402)
  __webpack_require__(404)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b52372e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */,
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDialog_vue__ = __webpack_require__(101);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_412c57b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmDialog_vue__ = __webpack_require__(409);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_412c57b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.options.width},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.cancel($event)}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":_vm.options.color,"dense":"","flat":""}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.message),expression:"!!message"}]},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('v-card-actions',{staticClass:"pt-0"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.options.color + ' darken-1',"flat":"flat"},nativeOn:{"click":function($event){return _vm.agree($event)}}},[_vm._v(_vm._s(_vm.options.confirmText))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey","flat":"flat"},nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v(_vm._s(_vm.options.cancelText))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('confirm-dialog',{ref:"confirm"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 411 */,
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df441b38_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundView_vue__ = __webpack_require__(413);
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df441b38_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("Nie znaleziono strony")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Packages_vue__ = __webpack_require__(103);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d782f1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Packages_vue__ = __webpack_require__(531);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Packages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d782f1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Packages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_api__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_api__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__trainers_api__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__runners_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(102);




var _types$AUTH_REQUEST$t;








/* harmony default export */ __webpack_exports__["a"] = (_types$AUTH_REQUEST$t = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* AUTH_REQUEST */], function (_ref, user) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* AUTH_REQUEST */]);
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_4__auth_api__["d" /* login */](user).then(function (resp) {
      var token = resp.data.key;
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["n" /* AUTH_SUCCESS */], token);
      dispatch(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["z" /* USER_REQUEST */]).then(function (resp) {
        resolve(resp);
      });
    }).catch(function (err) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* AUTH_ERROR */], err);
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* AUTH_TOKEN */], function (_ref2, token) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["n" /* AUTH_SUCCESS */], token);
  return dispatch(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["z" /* USER_REQUEST */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* AUTH_LOGOUT */], function (_ref3) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* AUTH_LOGOUT */]);
  __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push({ name: 'app' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["z" /* USER_REQUEST */], function (_ref4) {
  var commit = _ref4.commit,
      dispatch = _ref4.dispatch;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["z" /* USER_REQUEST */]);
  return __WEBPACK_IMPORTED_MODULE_4__auth_api__["i" /* user */]().then(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["A" /* USER_SUCCESS */], resp);
    return resp;
  }).catch(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["y" /* USER_ERROR */]);
    dispatch(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* AUTH_LOGOUT */]);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* ALL_TRAINERS_REQUEST */], function (_ref5) {
  var commit = _ref5.commit,
      dispatch = _ref5.dispatch,
      state = _ref5.state;

  if (state.initial.allTrainers.length > 0) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
  }
  return Object(__WEBPACK_IMPORTED_MODULE_5__utils_api__["a" /* default */])({ url: '/trainers/?pagination=false&is_active=true' }).then(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* ALL_TRAINERS_SUCCESS */], resp);
  }).catch(function (resp) {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["w" /* TRAINER_REQUEST */], function (_ref6, trainerId) {
  var commit = _ref6.commit,
      dispatch = _ref6.dispatch,
      state = _ref6.state;

  if (state.trainer && state.trainer.id === parseInt(trainerId)) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(state.trainer);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_6__trainers_api__["e" /* getTrainer */])(trainerId).then(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["x" /* TRAINER_SUCCESS */], resp);
    return resp;
  }).catch(function (resp) {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["s" /* RUNNER_REQUEST */], function (_ref7, _ref8) {
  var commit = _ref7.commit,
      dispatch = _ref7.dispatch,
      state = _ref7.state,
      getters = _ref7.getters;

  var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref8, 2),
      runnerId = _ref9[0],
      force = _ref9[1];

  if (!force && state.runner && state.runner.id === parseInt(runnerId)) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(state.runner);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_7__runners_api__["g" /* getRunner */])(runnerId).then(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["t" /* RUNNER_SUCCESS */], resp);
    return resp;
  }).catch(function (resp) {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["p" /* RUNNERS_TRAINER_REQUEST */], function (_ref10, runner) {
  var commit = _ref10.commit,
      dispatch = _ref10.dispatch,
      state = _ref10.state;

  if (!runner.trainer) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(null);
  }
  if (state.runnersTrainer && state.runnersTrainer.id === runner.trainer) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(state.runnersTrainer);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_6__trainers_api__["e" /* getTrainer */])(runner.trainer).then(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["q" /* RUNNERS_TRAINER_SUCCESS */], resp);
    return resp;
  }).catch(function (resp) {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["u" /* TRAINERS_RUNNERS_REQUEST */], function (_ref11, trainer) {
  var commit = _ref11.commit,
      dispatch = _ref11.dispatch,
      state = _ref11.state;

  if (state.trainerRunners.length > 0 && state.trainerRunners[0].trainer === trainer.id) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(state.trainerRunners);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_7__runners_api__["e" /* fetchSimpleTrainerRunners */])(trainer.id).then(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["v" /* TRAINERS_RUNNERS_SUCCESS */], resp);
    return resp;
  }).catch(function (resp) {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* ADMIN_RUNNERS_REQUEST */], function (_ref12) {
  var commit = _ref12.commit,
      dispatch = _ref12.dispatch,
      state = _ref12.state;

  if (state.adminRunners.length > 0) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(state.adminRunners);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_7__runners_api__["d" /* fetchSimpleAdminRunners */])().then(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* ADMIN_RUNNERS_SUCCESS */], resp);
    return resp;
  }).catch(function (resp) {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* ADMIN_TRAINERS_REQUEST */], function (_ref13) {
  var commit = _ref13.commit,
      dispatch = _ref13.dispatch,
      state = _ref13.state;

  if (state.adminTrainers.length > 0) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(state.adminTrainers);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_6__trainers_api__["c" /* fetchSimpleAdminTrainers */])().then(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* ADMIN_TRAINERS_SUCCESS */], resp);
    return resp;
  }).catch(function (resp) {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* ALL_PACKAGES_REQUEST */], function (_ref14) {
  var commit = _ref14.commit,
      dispatch = _ref14.dispatch,
      state = _ref14.state;

  if (state.initial.allPackages.length > 0) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
  }
  return Object(__WEBPACK_IMPORTED_MODULE_5__utils_api__["a" /* default */])({ url: '/packages/?pagination=false&is_active=true' }).then(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* ALL_PACKAGES_SUCCESS */], resp);
  }).catch(function (resp) {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* ALL_WORKOUTS_TEMPLATES_REQUEST */], function (_ref15) {
  var commit = _ref15.commit,
      dispatch = _ref15.dispatch,
      state = _ref15.state;
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (state.initial.allWorkoutsTemplates.length > 0 && !force) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
  }
  return Object(__WEBPACK_IMPORTED_MODULE_5__utils_api__["a" /* default */])({ url: '/workouts_templates/' }).then(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* ALL_WORKOUTS_TEMPLATES_SUCCESS */], resp);
  }).catch(function (resp) {});
}), _types$AUTH_REQUEST$t);

/***/ }),
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  isAuthenticated: function isAuthenticated(state) {
    return !!state.token;
  },
  authUser: function authUser(state) {
    return state.user || null;
  },
  trainer: function trainer(state) {
    return state.trainer || null;
  },
  runner: function runner(state) {
    return state.runner || null;
  },
  runnersTrainer: function runnersTrainer(state) {
    return state.runnersTrainer || null;
  },

  isAdmin: function isAdmin(state) {
    return state.user && state.user.role_id === 'ADMIN';
  },
  isTrainer: function isTrainer(state) {
    return state.user && state.user.role_id === 'TRAINER';
  },
  isRunner: function isRunner(state) {
    return state.user && state.user.role_id === 'RUNNER';
  },
  isActiveRunnerTrainer: function isActiveRunnerTrainer(state, getters) {
    return getters.isAdmin || getters.isTrainer && getters.runnersTrainer && getters.runnersTrainer.id === getters.authUser.id;
  },
  isActiveRunner: function isActiveRunner(state, getters) {
    return getters.isRunner && getters.runner && getters.userLoaded && getters.runner.id === getters.authUser.id;
  },
  userLoaded: function userLoaded(state) {
    return state.user !== null;
  },

  allPackagesOptions: function allPackagesOptions(state) {
    return state.initial.allPackages.map(function (x) {
      return { value: x.id, text: x.name };
    });
  },
  allPackagesFullOptions: function allPackagesFullOptions(state) {
    return state.initial.allPackages;
  },
  getPackageById: function getPackageById(state) {
    return function (id) {
      return state.initial.allPackages.find(function (packageData) {
        return packageData.id === id;
      });
    };
  },
  allTrainersOptions: function allTrainersOptions(state) {
    return state.initial.allTrainers.map(function (x) {
      return { value: x.id, text: x.full_name };
    });
  },
  allTrainersFullOptions: function allTrainersFullOptions(state) {
    return state.initial.allTrainers;
  },
  trainerRunnersOptions: function trainerRunnersOptions(state) {
    return state.trainerRunners.map(function (x) {
      return { value: x.id, text: x.full_name };
    });
  },
  getTrainerById: function getTrainerById(state) {
    return function (id) {
      return state.initial.allTrainers.find(function (trainerData) {
        return trainerData.id === id;
      });
    };
  },
  raceFrequencyOptions: function raceFrequencyOptions(state) {
    return state.initial.raceFrequency;
  },
  tshirtSizeOptions: function tshirtSizeOptions(state) {
    return state.initial.tshirtSize;
  },
  allWorkoutsTemplatesOptions: function allWorkoutsTemplatesOptions(state) {
    return state.initial.allWorkoutsTemplates.map(function (x) {
      return { value: x.name, text: x.name };
    });
  },
  getWorkoutTemplateByName: function getWorkoutTemplateByName(state) {
    return function (name) {
      return state.initial.allWorkoutsTemplates.find(function (workoutTemplateData) {
        return workoutTemplateData.name === name;
      });
    };
  },
  allRaceDistanceStringsOptions: function allRaceDistanceStringsOptions(state) {
    return state.initial.raceDistanceStrings;
  },
  raceDistanceTrackStringsOptions: function raceDistanceTrackStringsOptions(state) {
    return state.initial.raceDistanceTrackStrings;
  },
  raceDistanceStreetStringsOptions: function raceDistanceStreetStringsOptions(state) {
    return state.initial.raceDistanceStreetStrings;
  },
  allRaceTypesStringsOptions: function allRaceTypesStringsOptions(state) {
    return state.initial.raceTypesStrings;
  },
  recordsRaceTypesStringsOptions: function recordsRaceTypesStringsOptions(state) {
    return state.initial.recordsRaceTypesStrings;
  },
  measurableRaceDistanceStringsOptions: function measurableRaceDistanceStringsOptions(state) {
    return state.initial.measurableRaceDistanceStrings;
  },
  measurableRaceDistanceStreetStringsOptions: function measurableRaceDistanceStreetStringsOptions(state) {
    return state.initial.measurableRaceDistanceStreetStrings;
  },
  allRacePrioritiesOptions: function allRacePrioritiesOptions(state) {
    return state.initial.racePriorities.map(function (x) {
      return { value: x, text: x };
    });
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api__ = __webpack_require__(12);


var _types$AUTH_REQUEST$t;




/* harmony default export */ __webpack_exports__["a"] = (_types$AUTH_REQUEST$t = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* AUTH_REQUEST */], function (state) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["z" /* USER_REQUEST */], function (state) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["y" /* USER_ERROR */], function (state) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* AUTH_SUCCESS */], function (state, token) {
  state.token = token;
  localStorage.setItem('user-token', token); // store the token in localstorage
  __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Token ' + token;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* AUTH_ERROR */], function (state) {
  localStorage.removeItem('user-token'); // if the request fails, remove any possible user token if possible
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* AUTH_LOGOUT */], function (state) {
  state.token = '';
  localStorage.removeItem('user-token');
  delete __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].defaults.headers.common['Authorization'];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["A" /* USER_SUCCESS */], function (state, resp) {
  state.user = resp.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* ALL_PACKAGES_SUCCESS */], function (state, resp) {
  state.initial.allPackages = resp.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* ALL_TRAINERS_SUCCESS */], function (state, resp) {
  state.initial.allTrainers = resp.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["x" /* TRAINER_SUCCESS */], function (state, data) {
  state.trainer = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["t" /* RUNNER_SUCCESS */], function (state, data) {
  state.runner = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["r" /* RUNNER_DATA_FILLED */], function (state) {
  state.runner.data_filled = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["q" /* RUNNERS_TRAINER_SUCCESS */], function (state, data) {
  state.runnersTrainer = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["v" /* TRAINERS_RUNNERS_SUCCESS */], function (state, data) {
  state.trainerRunners = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* ADMIN_RUNNERS_SUCCESS */], function (state, data) {
  state.adminRunners = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* ADMIN_TRAINERS_SUCCESS */], function (state, data) {
  state.adminTrainers = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AUTH_REQUEST$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* ALL_WORKOUTS_TEMPLATES_SUCCESS */], function (state, resp) {
  state.initial.allWorkoutsTemplates = resp.data;
}), _types$AUTH_REQUEST$t);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageForm_vue__ = __webpack_require__(113);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb7bb568_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageForm_vue__ = __webpack_require__(530);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb7bb568_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 449 */,
/* 450 */,
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */,
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */,
/* 455 */,
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */,
/* 458 */,
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */,
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */,
/* 473 */,
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */,
/* 476 */,
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */,
/* 479 */,
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */,
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */,
/* 503 */,
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */,
/* 506 */,
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */,
/* 520 */,
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */,
/* 523 */,
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{ref:"menu1",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.val,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.val=$event},"update:return-value":function($event){_vm.val=$event}},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{attrs:{"slot":"activator","value":_vm.dateFormatted,"label":_vm.label,"prepend-icon":"event","readonly":"","clearable":"","error":_vm.error,"error-messages":_vm.errorMessages},on:{"input":_vm.onInput},slot:"activator"}),_vm._v(" "),_c('v-date-picker',{attrs:{"value":_vm.value,"no-title":"","type":_vm.month ? 'month' : 'date',"locale":"pl"},on:{"input":_vm.onDPInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.fields),function(field){return [_vm._t(("field" + (_vm.fieldUCFirst(field))),[(field.when === undefined ? true : field.when)?_c(_vm.getFieldComp(field.comp),_vm._b({key:field.id,tag:"component",attrs:{"label":field.label,"error":_vm.hasErrors(field.id),"error-messages":_vm.getErrors(field.id)},on:{"input":function($event){delete _vm.errors[field.id]},"change":function($event){delete _vm.errors[field.id]}},model:{value:(_vm.object[field.id]),callback:function ($$v) {_vm.$set(_vm.object, field.id, $$v)},expression:"object[field.id]"}},'component',field.props,false)):_vm._e()],{"field":field,"error":_vm.hasErrors(field.id),"errorMessages":_vm.getErrors(field.id)})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"sm8":"","md6":"","lg5":""}},[_c('v-form',{staticClass:"elevation-2 pa-3",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('Fields',_vm._b({},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false)),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-datatable"},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Pakiety")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.showAdd)?_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":function($event){_vm.showAdd = true}}},[_vm._v("dodaj pakiet")]):_vm._e(),_vm._v(" "),(_vm.showAdd)?_c('v-btn',{attrs:{"flat":"","small":""},on:{"click":function($event){_vm.showAdd = false}}},[_vm._v("ukryj")]):_vm._e()],1)],1),_vm._v(" "),_c('v-slide-y-transition',[(_vm.showAdd)?_c('v-card',{staticClass:"mt-2"},[_c('package-form',{on:{"success":function($event){_vm.showAdd = false; _vm.refresh()}}})],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2 pb-1"},[_c('v-card-title',[_c('v-form',{staticClass:"flex"},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-text-field',{attrs:{"clearable":"","label":"Szukaj"},model:{value:(_vm.context.searchQuery),callback:function ($$v) {_vm.$set(_vm.context, "searchQuery", $$v)},expression:"context.searchQuery"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-select',{attrs:{"items":_vm.allTrainersOptions,"label":"Trener","clearable":""},model:{value:(_vm.context.trainer),callback:function ($$v) {_vm.$set(_vm.context, "trainer", $$v)},expression:"context.trainer"}})],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.packages,"pagination":_vm.context,"rows-per-page-items":_vm.perPageOptions,"total-items":_vm.rowsTotal,"loading":_vm.loading},on:{"update:pagination":function($event){_vm.context=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.trainer_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatterBool(props.item.is_active)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatterBool(props.item.with_tshirt)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatterBool(props.item.with_card)))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_c('rp-icon',{staticClass:"mr-2",attrs:{"type":"edit","tooltip":"edytuj"},on:{"click":function($event){props.expanded = !props.expanded}}}),_vm._v(" "),_c('rp-icon',{attrs:{"type":"delete","tooltip":"usuń"},on:{"click":function($event){return _vm.deleteItem(props.item)}}})],1)])]}},{key:"expand",fn:function(props){return [_c('package-form',{attrs:{"user-package":props.item},on:{"success":function($event){props.expanded = false; _vm.refresh()}}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminPayments_vue__ = __webpack_require__(132);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3a34900_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminPayments_vue__ = __webpack_require__(541);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminPayments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3a34900_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminPayments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentForm_vue__ = __webpack_require__(133);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cab66d60_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentForm_vue__ = __webpack_require__(538);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cab66d60_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-autocomplete',{attrs:{"items":_vm.items,"label":_vm.label || 'Wybierz zawodnika',"cache-items":"","item-text":"full_name","item-value":"id","search-input":_vm.search,"return-object":"","clearable":"","error":_vm.error,"error-messages":_vm.errorMessages},on:{"change":_vm.change,"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-btn"},[_c('label',{class:("v-btn " + _vm.classes + _vm.color + " upload-btn")},[_c('input',{attrs:{"type":"file","name":_vm.name,"accept":_vm.accept},on:{"change":_vm.onFileChange}}),_vm._v(" "),(_vm.file)?_c('span',[_vm._v(_vm._s(_vm.file.name))]):_c('span',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")]),_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 138,
	"./af.js": 138,
	"./ar": 139,
	"./ar-dz": 140,
	"./ar-dz.js": 140,
	"./ar-kw": 141,
	"./ar-kw.js": 141,
	"./ar-ly": 142,
	"./ar-ly.js": 142,
	"./ar-ma": 143,
	"./ar-ma.js": 143,
	"./ar-sa": 144,
	"./ar-sa.js": 144,
	"./ar-tn": 145,
	"./ar-tn.js": 145,
	"./ar.js": 139,
	"./az": 146,
	"./az.js": 146,
	"./be": 147,
	"./be.js": 147,
	"./bg": 148,
	"./bg.js": 148,
	"./bm": 149,
	"./bm.js": 149,
	"./bn": 150,
	"./bn.js": 150,
	"./bo": 151,
	"./bo.js": 151,
	"./br": 152,
	"./br.js": 152,
	"./bs": 153,
	"./bs.js": 153,
	"./ca": 154,
	"./ca.js": 154,
	"./cs": 155,
	"./cs.js": 155,
	"./cv": 156,
	"./cv.js": 156,
	"./cy": 157,
	"./cy.js": 157,
	"./da": 158,
	"./da.js": 158,
	"./de": 159,
	"./de-at": 160,
	"./de-at.js": 160,
	"./de-ch": 161,
	"./de-ch.js": 161,
	"./de.js": 159,
	"./dv": 162,
	"./dv.js": 162,
	"./el": 163,
	"./el.js": 163,
	"./en-SG": 164,
	"./en-SG.js": 164,
	"./en-au": 165,
	"./en-au.js": 165,
	"./en-ca": 166,
	"./en-ca.js": 166,
	"./en-gb": 167,
	"./en-gb.js": 167,
	"./en-ie": 168,
	"./en-ie.js": 168,
	"./en-il": 169,
	"./en-il.js": 169,
	"./en-nz": 170,
	"./en-nz.js": 170,
	"./eo": 171,
	"./eo.js": 171,
	"./es": 172,
	"./es-do": 173,
	"./es-do.js": 173,
	"./es-us": 174,
	"./es-us.js": 174,
	"./es.js": 172,
	"./et": 175,
	"./et.js": 175,
	"./eu": 176,
	"./eu.js": 176,
	"./fa": 177,
	"./fa.js": 177,
	"./fi": 178,
	"./fi.js": 178,
	"./fo": 179,
	"./fo.js": 179,
	"./fr": 180,
	"./fr-ca": 181,
	"./fr-ca.js": 181,
	"./fr-ch": 182,
	"./fr-ch.js": 182,
	"./fr.js": 180,
	"./fy": 183,
	"./fy.js": 183,
	"./ga": 184,
	"./ga.js": 184,
	"./gd": 185,
	"./gd.js": 185,
	"./gl": 186,
	"./gl.js": 186,
	"./gom-latn": 187,
	"./gom-latn.js": 187,
	"./gu": 188,
	"./gu.js": 188,
	"./he": 189,
	"./he.js": 189,
	"./hi": 190,
	"./hi.js": 190,
	"./hr": 191,
	"./hr.js": 191,
	"./hu": 192,
	"./hu.js": 192,
	"./hy-am": 193,
	"./hy-am.js": 193,
	"./id": 194,
	"./id.js": 194,
	"./is": 195,
	"./is.js": 195,
	"./it": 196,
	"./it-ch": 197,
	"./it-ch.js": 197,
	"./it.js": 196,
	"./ja": 198,
	"./ja.js": 198,
	"./jv": 199,
	"./jv.js": 199,
	"./ka": 200,
	"./ka.js": 200,
	"./kk": 201,
	"./kk.js": 201,
	"./km": 202,
	"./km.js": 202,
	"./kn": 203,
	"./kn.js": 203,
	"./ko": 204,
	"./ko.js": 204,
	"./ku": 205,
	"./ku.js": 205,
	"./ky": 206,
	"./ky.js": 206,
	"./lb": 207,
	"./lb.js": 207,
	"./lo": 208,
	"./lo.js": 208,
	"./lt": 209,
	"./lt.js": 209,
	"./lv": 210,
	"./lv.js": 210,
	"./me": 211,
	"./me.js": 211,
	"./mi": 212,
	"./mi.js": 212,
	"./mk": 213,
	"./mk.js": 213,
	"./ml": 214,
	"./ml.js": 214,
	"./mn": 215,
	"./mn.js": 215,
	"./mr": 216,
	"./mr.js": 216,
	"./ms": 217,
	"./ms-my": 218,
	"./ms-my.js": 218,
	"./ms.js": 217,
	"./mt": 219,
	"./mt.js": 219,
	"./my": 220,
	"./my.js": 220,
	"./nb": 221,
	"./nb.js": 221,
	"./ne": 222,
	"./ne.js": 222,
	"./nl": 223,
	"./nl-be": 224,
	"./nl-be.js": 224,
	"./nl.js": 223,
	"./nn": 225,
	"./nn.js": 225,
	"./pa-in": 226,
	"./pa-in.js": 226,
	"./pl": 227,
	"./pl.js": 227,
	"./pt": 228,
	"./pt-br": 229,
	"./pt-br.js": 229,
	"./pt.js": 228,
	"./ro": 230,
	"./ro.js": 230,
	"./ru": 231,
	"./ru.js": 231,
	"./sd": 232,
	"./sd.js": 232,
	"./se": 233,
	"./se.js": 233,
	"./si": 234,
	"./si.js": 234,
	"./sk": 235,
	"./sk.js": 235,
	"./sl": 236,
	"./sl.js": 236,
	"./sq": 237,
	"./sq.js": 237,
	"./sr": 238,
	"./sr-cyrl": 239,
	"./sr-cyrl.js": 239,
	"./sr.js": 238,
	"./ss": 240,
	"./ss.js": 240,
	"./sv": 241,
	"./sv.js": 241,
	"./sw": 242,
	"./sw.js": 242,
	"./ta": 243,
	"./ta.js": 243,
	"./te": 244,
	"./te.js": 244,
	"./tet": 245,
	"./tet.js": 245,
	"./tg": 246,
	"./tg.js": 246,
	"./th": 247,
	"./th.js": 247,
	"./tl-ph": 248,
	"./tl-ph.js": 248,
	"./tlh": 249,
	"./tlh.js": 249,
	"./tr": 250,
	"./tr.js": 250,
	"./tzl": 251,
	"./tzl.js": 251,
	"./tzm": 252,
	"./tzm-latn": 253,
	"./tzm-latn.js": 253,
	"./tzm.js": 252,
	"./ug-cn": 254,
	"./ug-cn.js": 254,
	"./uk": 255,
	"./uk.js": 255,
	"./ur": 256,
	"./ur.js": 256,
	"./uz": 257,
	"./uz-latn": 258,
	"./uz-latn.js": 258,
	"./uz.js": 257,
	"./vi": 259,
	"./vi.js": 259,
	"./x-pseudo": 260,
	"./x-pseudo.js": 260,
	"./yo": 261,
	"./yo.js": 261,
	"./zh-cn": 262,
	"./zh-cn.js": 262,
	"./zh-hk": 263,
	"./zh-hk.js": 263,
	"./zh-tw": 264,
	"./zh-tw.js": 264
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 537;

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"sm8":"","md6":"","lg5":""}},[_c('v-form',{staticClass:"elevation-2 pa-3",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('Fields',_vm._b({scopedSlots:_vm._u([{key:"fieldRunner",fn:function(ref){
var field = ref.field;
var error = ref.error;
var errorMessages = ref.errorMessages;
return [_c('runner-select',{staticClass:"mr-2",attrs:{"error":error,"error-messages":errorMessages},on:{"input":_vm.changeRunner},model:{value:(_vm.formData.runner),callback:function ($$v) {_vm.$set(_vm.formData, "runner", $$v)},expression:"formData.runner"}})]}},{key:"fieldDocument",fn:function(ref){
var field = ref.field;
return [(_vm.formData.document_url)?_c('div',[_c('a',{attrs:{"href":_vm.formData.document_url}},[_vm._v("\n              "+_vm._s(_vm.formData.document_filename))]),_vm._v(" "),_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Usuń'),expression:"'Usuń'"}],staticClass:"ml-2",on:{"click":function($event){$event.stopPropagation();return _vm.deleteFile($event)}}},[_vm._v("close")])],1):_c('file-upload',{attrs:{"target":"uploads/","action":"POST","small":""},on:{"finish":_vm.finish}})]}}])},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false)),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentStatus_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_757d1858_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentStatus_vue__ = __webpack_require__(540);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_757d1858_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm.statusDisplay)+"\n  "),(_vm.status === 'paid')?_c('rp-icon',{attrs:{"type":"remove_circle_outline","tooltip":"odznacz opłacenie"},on:{"click":_vm.setNotPaid}}):_vm._e(),_vm._v(" "),(_vm.status !== 'paid')?_c('v-menu',{attrs:{"offset-y":""}},[_c('rp-icon',{attrs:{"slot":"activator","type":"add_circle_outline","tooltip":"zaznacz opłacenie"},slot:"activator"}),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.setPaid('cash')}}},[_c('v-list-tile-title',[_vm._v("paragon - gotówka")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.setPaid('transfer')}}},[_c('v-list-tile-title',[_vm._v("paragon - przelew")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.setPaid('no_receipt')}}},[_c('v-list-tile-title',[_vm._v("bez paragonu")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-datatable"},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Płatności")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.showAdd)?_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":function($event){_vm.showAdd = true}}},[_vm._v("dodaj płatność")]):_vm._e(),_vm._v(" "),(_vm.showAdd)?_c('v-btn',{attrs:{"flat":"","small":""},on:{"click":function($event){_vm.showAdd = false}}},[_vm._v("ukryj")]):_vm._e()],1)],1),_vm._v(" "),_c('v-slide-y-transition',[(_vm.showAdd)?_c('v-card',{staticClass:"mt-2"},[_c('payment-form',{on:{"success":function($event){_vm.showAdd = false; _vm.refresh()}}})],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2 pb-1"},[_c('v-card-title',[_c('v-form',{staticClass:"flex"},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('runner-select',{staticClass:"mr-2",model:{value:(_vm.context.runner),callback:function ($$v) {_vm.$set(_vm.context, "runner", $$v)},expression:"context.runner"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-select',{attrs:{"items":[{value: 'paid', text: 'Opłacone'}, {value: 'unpaid', text: 'Nieopłacone'}, {value: 'exceeded', text: 'Przekroczono termin'}],"label":"Status płatności","clearable":""},model:{value:(_vm.context.paymentStatus),callback:function ($$v) {_vm.$set(_vm.context, "paymentStatus", $$v)},expression:"context.paymentStatus"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-menu',{ref:"menu1",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.context.start,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.context, "start", $event)},"update:return-value":function($event){return _vm.$set(_vm.context, "start", $event)}},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Data od","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.context.start),callback:function ($$v) {_vm.$set(_vm.context, "start", $$v)},expression:"context.start"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"type":"month","no-title":"","locale":"pl"},on:{"input":function($event){return _vm.$refs.menu1.save(_vm.context.start)}},model:{value:(_vm.context.start),callback:function ($$v) {_vm.$set(_vm.context, "start", $$v)},expression:"context.start"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-menu',{ref:"menu2",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.context.end,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.context, "end", $event)},"update:return-value":function($event){return _vm.$set(_vm.context, "end", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Data do","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.context.end),callback:function ($$v) {_vm.$set(_vm.context, "end", $$v)},expression:"context.end"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"type":"month","no-title":"","locale":"pl"},on:{"input":function($event){return _vm.$refs.menu2.save(_vm.context.end)}},model:{value:(_vm.context.end),callback:function ($$v) {_vm.$set(_vm.context, "end", $$v)},expression:"context.end"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.payments,"pagination":_vm.context,"rows-per-page-items":_vm.perPageOptions,"total-items":_vm.rowsTotal,"loading":_vm.loading},on:{"update:pagination":function($event){_vm.context=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_c('router-link',{attrs:{"to":{ name: 'runner-payments', params: { id: props.item.runner }}}},[_vm._v("\n            "+_vm._s(props.item.runner_name)+"\n          ")])],1),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(_vm._f("formatDate")(props.item.period,'MMMM YYYY'))+"\n        ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.price))]),_vm._v(" "),_c('td',[_c('payment-status',{attrs:{"status":props.item.payment_status,"id":props.item.id},on:{"change":_vm.refresh}})],1),_vm._v(" "),_c('td',[(props.item.document_url)?_c('a',{attrs:{"href":props.item.document_url}},[_vm._v("\n            "+_vm._s(props.item.document_filename))]):_c('file-upload',{attrs:{"target":"uploads/","action":"POST","small":true},on:{"finish":function($event){return _vm.finish($event, props.item)}}})],1),_vm._v(" "),_c('td',{staticClass:"actions"},[_c('rp-icon',{staticClass:"mr-2",attrs:{"type":"edit","tooltip":"edytuj"},on:{"click":function($event){props.expanded = !props.expanded}}}),_vm._v(" "),(props.item.payment_status !== 'paid')?_c('rp-icon',{attrs:{"type":"delete","tooltip":"usuń"},on:{"click":function($event){return _vm.deletePayment(props.item)}}}):_vm._e()],1)])]}},{key:"expand",fn:function(props){return [_c('payment-form',{attrs:{"user-payment":props.item},on:{"success":function($event){props.expanded = false; _vm.refresh()}}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerPayments_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ce53368_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerPayments_vue__ = __webpack_require__(545);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerPayments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ce53368_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerPayments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerPaymentStatus_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dee0be0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerPaymentStatus_vue__ = __webpack_require__(544);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerPaymentStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dee0be0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerPaymentStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.status === 'paid')?_c('span',[_vm._v("Opłacono")]):_vm._e(),_vm._v(" "),(_vm.status !== 'paid' && _vm.isActiveRunner)?_c('v-btn',{attrs:{"flat":"","color":"primary","to":{name: 'runner-payments-pay', params: {id: _vm.runner_id, payment_id: _vm.id}}}},[_vm._v("Zapłać")]):_vm._e(),_vm._v(" "),(_vm.status !== 'paid' && !_vm.isActiveRunner)?_c('span',[_vm._v("Nieopłacono")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-datatable"},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Płatności")])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2 pb-1"},[_c('v-card-title',[_c('v-form',{staticClass:"flex"},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-select',{attrs:{"items":[{value: 'paid', text: 'Opłacone'}, {value: 'unpaid', text: 'Nieopłacone'}, {value: 'exceeded', text: 'Przekroczono termin'}],"label":"Status płatności","clearable":""},model:{value:(_vm.context.paymentStatus),callback:function ($$v) {_vm.$set(_vm.context, "paymentStatus", $$v)},expression:"context.paymentStatus"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-menu',{ref:"menu1",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.context.start,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.context, "start", $event)},"update:return-value":function($event){return _vm.$set(_vm.context, "start", $event)}},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Data od","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.context.start),callback:function ($$v) {_vm.$set(_vm.context, "start", $$v)},expression:"context.start"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"type":"month","no-title":"","locale":"pl"},on:{"input":function($event){return _vm.$refs.menu1.save(_vm.context.start)}},model:{value:(_vm.context.start),callback:function ($$v) {_vm.$set(_vm.context, "start", $$v)},expression:"context.start"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-menu',{ref:"menu2",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.context.end,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.context, "end", $event)},"update:return-value":function($event){return _vm.$set(_vm.context, "end", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Data do","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.context.end),callback:function ($$v) {_vm.$set(_vm.context, "end", $$v)},expression:"context.end"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"type":"month","no-title":"","locale":"pl"},on:{"input":function($event){return _vm.$refs.menu2.save(_vm.context.end)}},model:{value:(_vm.context.end),callback:function ($$v) {_vm.$set(_vm.context, "end", $$v)},expression:"context.end"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.payments,"pagination":_vm.context,"rows-per-page-items":_vm.perPageOptions,"total-items":_vm.rowsTotal,"loading":_vm.loading},on:{"update:pagination":function($event){_vm.context=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_vm._v("\n          "+_vm._s(_vm._f("formatDate")(props.item.period,'MMMM YYYY'))+"\n        ")]),_vm._v(" "),(!_vm.isTrainer)?_c('td',[_vm._v(_vm._s(props.item.price))]):_vm._e(),_vm._v(" "),_c('td',[_c('runner-payment-status',{attrs:{"status":props.item.payment_status,"id":props.item.id,"runner_id":_vm.runner.id},on:{"change":_vm.refresh}})],1),_vm._v(" "),(!_vm.isTrainer)?_c('td',[_vm._v("\n          "+_vm._s(_vm._f("formatDate")(props.item.due_date,'YYYY-MM-DD'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isTrainer)?_c('td',[(props.item.document_url)?_c('a',{attrs:{"href":props.item.document_url}},[_vm._v("\n            "+_vm._s(props.item.document_filename))]):_vm._e()]):_vm._e()])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerPaymentPay_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0080e506_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerPaymentPay_vue__ = __webpack_require__(548);
function injectStyle (ssrContext) {
  __webpack_require__(547)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerPaymentPay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0080e506_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerPaymentPay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payments"},[_c('v-card',{staticClass:"payments"},[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Płatność")])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md8":"","lg6":"","xl4":""}},[_c('v-list',[_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{staticClass:"d-inline-block",attrs:{"xs12":"","sm6":""}},[_vm._v("\n                    Za okres\n                  ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-sm-right d-inline-block",attrs:{"xs12":"","sm6":""}},[_vm._v("\n                    "+_vm._s(_vm._f("formatDate")(_vm.payment.period,'MMMM YYYY'))+"\n                  ")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{staticClass:"d-inline-block",attrs:{"xs12":"","sm6":""}},[_vm._v("\n                    Kwota\n                  ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-sm-right d-inline-block",attrs:{"xs12":"","sm6":""}},[_vm._v("\n                    "+_vm._s(_vm.payment.price)+" PLN\n                  ")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{staticClass:"d-inline-block",attrs:{"xs12":"","sm6":""}},[_vm._v("\n                    Termin płatności\n                  ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-sm-right d-inline-block",attrs:{"xs12":"","sm6":""}},[_vm._v("\n                    "+_vm._s(_vm._f("formatDate")(_vm.payment.due_date,'LL'))+"\n                  ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md10":"","lg10":"","xl6":""}},[_c('v-layout',{staticClass:"mb-4",attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{staticClass:"d-inline-block payment-method-left",attrs:{"xs12":"","sm6":""}},[_c('div',{staticClass:"payment-header"},[_vm._v("\n          Przelew online\n        ")]),_vm._v(" "),_c('div',{staticClass:"payment-content left"},[_c('div',{staticClass:"payment-logo"},[_c('img',{attrs:{"src":__webpack_require__(549)}})]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.pay}},[_vm._v("Zapłać")]),_vm._v(" "),_c('form',{ref:"form",attrs:{"method":"POST","action":_vm.dotpay.gateway_url}},[_c('input',{attrs:{"type":"hidden","name":"id"},domProps:{"value":_vm.dotpay.id}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"firstname"},domProps:{"value":_vm.dotpay.firstname}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"lastname"},domProps:{"value":_vm.dotpay.lastname}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"email"},domProps:{"value":_vm.dotpay.email}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"currency"},domProps:{"value":_vm.dotpay.currency}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"amount"},domProps:{"value":_vm.dotpay.amount}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"description"},domProps:{"value":_vm.dotpay.description}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"type"},domProps:{"value":_vm.dotpay.type}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"URL"},domProps:{"value":_vm.dotpay.URL}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"URLC"},domProps:{"value":_vm.dotpay.URLC}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"control"},domProps:{"value":_vm.dotpay.control}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"chk"},domProps:{"value":_vm.dotpay.chk}})])],1)]),_vm._v(" "),_c('v-flex',{staticClass:"d-inline-block",attrs:{"xs12":"","sm6":""}},[_c('div',{staticClass:"payment-header"},[_vm._v("\n          Zapłać przelewem tradycyjnym\n        ")]),_vm._v(" "),_c('div',{staticClass:"payment-content"},[_c('table',[_c('tr',[_c('th',[_vm._v("Nr konta")]),_vm._v(" "),_c('td',[_vm._v("70 1140 2004 0000 3702 7603 4279")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Nazwa odbiorcy")]),_vm._v(" "),_c('td',[_vm._v("Inżynieria Biegania Dawid Malina")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Adres odbiorcy")]),_vm._v(" "),_c('td',[_vm._v("ul. ks. Konrada Szwedy 7B/10"),_c('br'),_vm._v("44-207 Rybnik")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Tytułem")]),_vm._v(" "),_c('td',[_vm._v("Płatność "+_vm._s(_vm.payment.id))])])])])])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dotpay_logo.3db7213.png";

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerPaymentReturn_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b810e7f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerPaymentReturn_vue__ = __webpack_require__(551);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerPaymentReturn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b810e7f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerPaymentReturn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.params.status == 'success')?_c('p',[_vm._v("Płatność została zrealizowana.")]):_c('p',[_vm._v("Płatność nie została zrealizowana.")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'runner-payments', params: {id: _vm.$route.params.id}}}},[_vm._v("Powrót do listy płatności")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_016fc2f3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(570);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_016fc2f3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-start":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md8":"","lg8":"","xl5":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Dzienniczek treningowy")])],1),_vm._v(" "),_c('form',{staticClass:"login",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.validation.hasError('userCredentials.non_field_errors'),"type":"error"}},_vm._l((_vm.validation.allErrors('userCredentials.non_field_errors')),function(error){return _c('span',[_vm._v(_vm._s(error))])}),0),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"person","error-messages":_vm.validation.allErrors('userCredentials.email'),"name":"login","label":"E-mail","type":"text"},model:{value:(_vm.userCredentials.email),callback:function ($$v) {_vm.$set(_vm.userCredentials, "email", $$v)},expression:"userCredentials.email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock","error-messages":_vm.validation.allErrors('userCredentials.password'),"name":"password","label":"Hasło","id":"password","type":"password"},model:{value:(_vm.userCredentials.password),callback:function ($$v) {_vm.$set(_vm.userCredentials, "password", $$v)},expression:"userCredentials.password"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","sm9":""}},[_c('v-btn',{attrs:{"color":"accent","flat":"","to":{name: 'register-self'}}},[_vm._v("Zarejestruj się")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","flat":"","to":{name: 'password-reset'}}},[_vm._v("Nie pamiętasz hasła?")])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-md-right",attrs:{"xs12":"","sm3":""}},[_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zaloguj")])],1)],1)],1),_vm._v(" "),(_vm.progress)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordReset_vue__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08d5f2c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordReset_vue__ = __webpack_require__(572);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordReset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08d5f2c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordReset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-start":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Resetowanie hasła")])],1),_vm._v(" "),_c('form',{staticClass:"login",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.passwordReset($event)}}},[_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.validation.hasError('userCredentials.non_field_errors'),"type":"error"}},_vm._l((_vm.validation.allErrors('userCredentials.non_field_errors')),function(error){return _c('span',[_vm._v(_vm._s(error))])}),0),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"person","error-messages":_vm.validation.allErrors('userCredentials.email'),"name":"login","label":"E-mail","type":"text"},model:{value:(_vm.userCredentials.email),callback:function ($$v) {_vm.$set(_vm.userCredentials, "email", $$v)},expression:"userCredentials.email"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Wyślij przypomnienie")])],1)],1),_vm._v(" "),(_vm.progress)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordResetConfirm_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_292413fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordResetConfirm_vue__ = __webpack_require__(574);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordResetConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_292413fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordResetConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-start":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ustaw nowe hasło")])],1),_vm._v(" "),_c('form',{staticClass:"login",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.passwordReset($event)}}},[_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.error || this.formErrors.token,"type":"error"}},[_vm._v("\n            Podany link do resetu hasła nie istnieje\n          ")]),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.validation.hasError('passwordData.non_field_errors'),"type":"error"}},_vm._l((_vm.validation.allErrors('passwordData.non_field_errors')),function(error){return _c('span',[_vm._v(_vm._s(error))])}),0),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock","error-messages":_vm.validation.allErrors('passwordData.new_password1'),"name":"password","label":"Hasło","id":"password","type":"password"},model:{value:(_vm.passwordData.new_password1),callback:function ($$v) {_vm.$set(_vm.passwordData, "new_password1", $$v)},expression:"passwordData.new_password1"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock","error-messages":_vm.validation.allErrors('passwordData.new_password2'),"name":"password","label":"Powtórz hasło","id":"password","type":"password"},model:{value:(_vm.passwordData.new_password2),callback:function ($$v) {_vm.$set(_vm.passwordData, "new_password2", $$v)},expression:"passwordData.new_password2"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Ustaw nowe hasło")])],1)],1),_vm._v(" "),(_vm.progress)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerSelfRegister_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d86c7a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerSelfRegister_vue__ = __webpack_require__(577);
function injectStyle (ssrContext) {
  __webpack_require__(576)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerSelfRegister_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d86c7a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerSelfRegister_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-start":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Rejestracja konta")])],1),_vm._v(" "),_c('form',{staticClass:"login",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.registerRunner($event)}}},[_c('v-layout',[(_vm.package)?_c('v-card',{staticClass:"name-card trainer-card"},[_c('v-card-text',[_c('div',[_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.package.name))]),_vm._v(" "),_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.package.price)+" zł")]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.package.description))])])])],1):_vm._e(),_vm._v(" "),(_vm.trainer)?_c('v-card',{staticClass:"name-card trainer-card"},[_c('v-card-text',[_c('div',{staticClass:"layout ma-0 align-center column"},[_c('div',{staticClass:"subheading"},[_vm._v("Wybrany trener")]),_vm._v(" "),_c('v-avatar',{attrs:{"size":"120","color":"primary"}},[(_vm.trainer.avatar_thumbnail)?_c('img',{attrs:{"width":"200","src":_vm.trainer.avatar_thumbnail}}):_vm._e(),_vm._v(" "),(!_vm.trainer.avatar_thumbnail)?_c('img',{attrs:{"width":"200","src":__webpack_require__(40)}}):_vm._e()])],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.trainer.full_name))])])])],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('Fields',_vm._b({scopedSlots:_vm._u([{key:"fieldTos",fn:function(ref){
var error = ref.error;
var errorMessages = ref.errorMessages;
var field = ref.field;
return [_c('v-checkbox',_vm._b({key:field.id,attrs:{"error":error,"error-messages":errorMessages},on:{"input":function($event){delete _vm.errors[field.id]},"change":function($event){delete _vm.errors[field.id]}},model:{value:(_vm.formData.tos),callback:function ($$v) {_vm.$set(_vm.formData, "tos", $$v)},expression:"formData.tos"}},'v-checkbox',field.props,false),[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n                  Akceptuję\n                  "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('a',{attrs:{"slot":"activator","target":"_blank","href":"http://inzynieriabiegania.pl/regulamin"},on:{"click":function($event){$event.stopPropagation();}},slot:"activator"},[_vm._v("regulamin")]),_vm._v("\n                    Otwórz w nowym oknie\n                  ")]),_vm._v("\n                  *\n                ")],1)])]}}])},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false))],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zarejestruj")])],1)],1),_vm._v(" "),(_vm.progress)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e87175e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationCompleted_vue__ = __webpack_require__(579);
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e87175e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationCompleted_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-start":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-card-text',[_c('strong',[_vm._v("Twoje konto zostało zarejestrowane.")]),_vm._v(" "),_c('p',[_vm._v("Na podany adres e-mail została wysłana wiadomość aktywacyjna. Aby aktywować konto przejdź na adres podany w wiadomości.")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountConfirmEmail_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7e473b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountConfirmEmail_vue__ = __webpack_require__(581);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountConfirmEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7e473b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountConfirmEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('p',{staticClass:"text-xs-center"},[_vm._v("Podany link aktywacyjny nie istnieje.")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountRunnerAdminConfirmEmail_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a3983f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountRunnerAdminConfirmEmail_vue__ = __webpack_require__(583);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountRunnerAdminConfirmEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a3983f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountRunnerAdminConfirmEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('p',{staticClass:"text-xs-center"},[_vm._v("Podany link aktywacyjny nie istnieje.")]):_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-start":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Aktywacja konta")])],1),_vm._v(" "),_c('form',{staticClass:"login",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.confirmRunner($event)}}},[_c('v-card-text',[_c('Fields',_vm._b({scopedSlots:_vm._u([{key:"fieldTos",fn:function(ref){
var error = ref.error;
var errorMessages = ref.errorMessages;
var field = ref.field;
return [_c('v-checkbox',_vm._b({key:field.id,attrs:{"error":error,"error-messages":errorMessages},on:{"input":function($event){delete _vm.errors[field.id]},"change":function($event){delete _vm.errors[field.id]}},model:{value:(_vm.formData.tos),callback:function ($$v) {_vm.$set(_vm.formData, "tos", $$v)},expression:"formData.tos"}},'v-checkbox',field.props,false),[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n                  Akceptuję\n                  "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('a',{attrs:{"slot":"activator","target":"_blank","href":"http://inzynieriabiegania.pl/regulamin"},on:{"click":function($event){$event.stopPropagation();}},slot:"activator"},[_vm._v("regulamin")]),_vm._v("\n                    Otwórz w nowym oknie\n                  ")]),_vm._v("\n                  *\n                ")],1)])]}}])},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false))],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Aktywuj konto")])],1)],1),_vm._v(" "),(_vm.progress)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountTrainerAdminConfirmEmail_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da43e534_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountTrainerAdminConfirmEmail_vue__ = __webpack_require__(585);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountTrainerAdminConfirmEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da43e534_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountTrainerAdminConfirmEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('p',{staticClass:"text-xs-center"},[_vm._v("Podany link aktywacyjny nie istnieje.")]):_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-start":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Aktywacja konta")])],1),_vm._v(" "),_c('form',{staticClass:"login",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.confirmTrainer($event)}}},[_c('v-card-text',[_c('Fields',_vm._b({},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false))],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Aktywuj konto")])],1)],1),_vm._v(" "),(_vm.progress)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4305e196_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__ = __webpack_require__(587);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4305e196_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-start":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Zmień hasło")])],1),_vm._v(" "),_c('form',{staticClass:"login",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.passwordChange($event)}}},[_c('v-card-text',[_c('Fields',_vm._b({},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false))],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Ustaw nowe hasło")])],1)],1),_vm._v(" "),(_vm.progress)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminRunners_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0654e849_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminRunners_vue__ = __webpack_require__(593);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminRunners_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0654e849_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminRunners_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerAddForm_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c440a9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerAddForm_vue__ = __webpack_require__(590);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerAddForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c440a9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerAddForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"sm8":"","md6":"","lg5":""}},[_c('v-form',{staticClass:"elevation-2 pa-3",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('Fields',_vm._b({},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false)),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerUpdateForm_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656bce13_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerUpdateForm_vue__ = __webpack_require__(592);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerUpdateForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656bce13_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerUpdateForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"sm8":"","md6":"","lg5":""}},[_c('v-form',{staticClass:"elevation-2 pa-3",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('Fields',_vm._b({},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false)),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-datatable"},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Zawodnicy")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.showAdd)?_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":function($event){_vm.showAdd = true}}},[_vm._v("dodaj zawodnika")]):_vm._e(),_vm._v(" "),(_vm.showAdd)?_c('v-btn',{attrs:{"flat":"","small":""},on:{"click":function($event){_vm.showAdd = false}}},[_vm._v("ukryj")]):_vm._e()],1)],1),_vm._v(" "),_c('v-slide-y-transition',[(_vm.showAdd)?_c('v-card',{staticClass:"mt-2"},[_c('runner-add-form',{on:{"success":function($event){_vm.showAdd = false; _vm.refresh()}}})],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2 pb-1"},[_c('v-card-title',[_c('v-form',{staticClass:"flex"},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"clearable":"","label":"Szukaj"},model:{value:(_vm.context.searchQuery),callback:function ($$v) {_vm.$set(_vm.context, "searchQuery", $$v)},expression:"context.searchQuery"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.allTrainersOptions,"label":"Trener","clearable":""},model:{value:(_vm.context.trainer),callback:function ($$v) {_vm.$set(_vm.context, "trainer", $$v)},expression:"context.trainer"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.allPackagesOptions,"label":"Pakiet","clearable":""},model:{value:(_vm.context.package),callback:function ($$v) {_vm.$set(_vm.context, "package", $$v)},expression:"context.package"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-select',{attrs:{"items":[{text: 'Tak', value: true}, {text: 'Nie', value: false}],"label":"Konto aktywne","clearable":""},model:{value:(_vm.context.isActive),callback:function ($$v) {_vm.$set(_vm.context, "isActive", $$v)},expression:"context.isActive"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","lg3":""}},[_c('v-checkbox',{attrs:{"label":"Bez treningu w tym miesiącu"},model:{value:(_vm.context.monthWithoutTraining),callback:function ($$v) {_vm.$set(_vm.context, "monthWithoutTraining", $$v)},expression:"context.monthWithoutTraining"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","lg3":""}},[_c('v-checkbox',{attrs:{"label":"Bez treningu w następnym miesiącu"},model:{value:(_vm.context.nextMonthWithoutTraining),callback:function ($$v) {_vm.$set(_vm.context, "nextMonthWithoutTraining", $$v)},expression:"context.nextMonthWithoutTraining"}})],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.runners,"pagination":_vm.context,"rows-per-page-items":_vm.perPageOptions,"total-items":_vm.rowsTotal,"loading":_vm.loading},on:{"update:pagination":function($event){_vm.context=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_c('router-link',{attrs:{"to":{ name: 'runner-plan', params: { id: props.item.id }}}},[_vm._v("\n            "+_vm._s(props.item.first_name)+" "+_vm._s(props.item.last_name)+"\n          ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.package_name))]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(props.item.trainer_data ? props.item.trainer_data.name : '')+"\n        ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatterBool(props.item.account_paid)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(props.item.last_training,'LL') || 'Brak'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatterBool(props.item.is_active)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatterBool(props.item.newsletter)))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_c('rp-icon',{staticClass:"mr-2",attrs:{"type":"edit","tooltip":"edytuj"},on:{"click":function($event){props.expanded = !props.expanded}}}),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"grey darken-2"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{attrs:{"to":{ name: 'runner-data', params: { id: props.item.id }}}},[_c('v-list-tile-title',[_vm._v("Szczegóły")])],1),_vm._v(" "),(props.item.is_active)?_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();return _vm.deactivateRunner(props.item)}}},[_c('v-list-tile-title',[_vm._v("Deaktywuj konto")])],1):_vm._e(),_vm._v(" "),(!props.item.is_active)?_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();return _vm.activateRunner(props.item)}}},[_c('v-list-tile-title',[_vm._v("Aktywuj konto")])],1):_vm._e()],1)],1)],1)])]}},{key:"expand",fn:function(props){return [_c('runner-update-form',{attrs:{"runner-data":props.item},on:{"success":function($event){props.expanded = false; _vm.refresh()}}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerRunners_vue__ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a20c21ba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerRunners_vue__ = __webpack_require__(597);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerRunners_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a20c21ba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerRunners_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerTrainerUpdateForm_vue__ = __webpack_require__(289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22afccd0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerTrainerUpdateForm_vue__ = __webpack_require__(596);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerTrainerUpdateForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22afccd0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerTrainerUpdateForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"sm8":"","md6":"","lg5":""}},[_c('v-form',{staticClass:"elevation-2 pa-3",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('Fields',_vm._b({},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false)),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-datatable"},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Zawodnicy")])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2 pb-1"},[_c('v-card-title',[_c('v-form',{staticClass:"flex"},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"clearable":"","label":"Szukaj"},model:{value:(_vm.context.searchQuery),callback:function ($$v) {_vm.$set(_vm.context, "searchQuery", $$v)},expression:"context.searchQuery"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.allPackagesOptions,"label":"Pakiet","clearable":""},model:{value:(_vm.context.package),callback:function ($$v) {_vm.$set(_vm.context, "package", $$v)},expression:"context.package"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","lg3":""}},[_c('v-checkbox',{attrs:{"label":"Bez treningu w tym miesiącu"},model:{value:(_vm.context.monthWithoutTraining),callback:function ($$v) {_vm.$set(_vm.context, "monthWithoutTraining", $$v)},expression:"context.monthWithoutTraining"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","lg3":""}},[_c('v-checkbox',{attrs:{"label":"Bez treningu w następnym miesiącu"},model:{value:(_vm.context.nextMonthWithoutTraining),callback:function ($$v) {_vm.$set(_vm.context, "nextMonthWithoutTraining", $$v)},expression:"context.nextMonthWithoutTraining"}})],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.runners,"pagination":_vm.context,"rows-per-page-items":_vm.perPageOptions,"total-items":_vm.rowsTotal,"loading":_vm.loading},on:{"update:pagination":function($event){_vm.context=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_c('router-link',{attrs:{"to":{ name: 'runner-plan', params: { id: props.item.id }}}},[_vm._v("\n            "+_vm._s(props.item.first_name)+" "+_vm._s(props.item.last_name)+"\n          ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.package_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatterBool(props.item.get_tshirt)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatterBool(props.item.get_card)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(props.item.last_training,'LL') || 'Brak'))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_c('rp-icon',{staticClass:"mr-2",attrs:{"type":"edit","tooltip":"edytuj"},on:{"click":function($event){props.expanded = !props.expanded}}})],1)])]}},{key:"expand",fn:function(props){return [_c('runner-trainer-update-form',{attrs:{"runner-data":props.item},on:{"success":function($event){props.expanded = false; _vm.refresh()}}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerData_vue__ = __webpack_require__(290);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_141e8d41_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerData_vue__ = __webpack_require__(641);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_141e8d41_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerDataPersonal_vue__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f269925_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerDataPersonal_vue__ = __webpack_require__(632);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerDataPersonal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f269925_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerDataPersonal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"picture-input",attrs:{"id":"picture-input"}},[(!_vm.supportsUpload)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.strings.upload)}}):(_vm.supportsPreview)?_c('div',[_c('div',{staticClass:"preview-container",style:({maxWidth: _vm.previewWidth + 'px', height: _vm.previewHeight + 'px', borderRadius: _vm.radius + '%'})},[_c('canvas',{ref:"previewCanvas",staticClass:"picture-preview",class:_vm.computedClasses,style:({height: _vm.previewHeight + 'px', zIndex: _vm.zIndex + 1 }),on:{"drag":function($event){$event.stopPropagation();$event.preventDefault();},"dragover":function($event){$event.stopPropagation();$event.preventDefault();},"dragstart":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStart($event)},"dragenter":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStart($event)},"dragend":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStop($event)},"dragleave":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStop($event)},"drop":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onFileDrop($event)},"click":function($event){$event.preventDefault();return _vm.onClick($event)}}}),_vm._v(" "),(!_vm.imageSelected && !_vm.plain)?_c('div',{staticClass:"picture-inner",style:({top: -_vm.previewHeight + 'px', marginBottom: -_vm.previewHeight + 'px', fontSize: _vm.fontSize, borderRadius: _vm.radius + '%', zIndex: _vm.zIndex + 2})},[(_vm.supportsDragAndDrop)?_c('span',{staticClass:"picture-inner-text",domProps:{"innerHTML":_vm._s(_vm.strings.drag)}}):_c('span',{staticClass:"picture-inner-text",domProps:{"innerHTML":_vm._s(_vm.strings.tap)}})]):_vm._e()]),_vm._v(" "),(_vm.imageSelected && !_vm.hideChangeButton)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();return _vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.change))]):_vm._e(),_vm._v(" "),(_vm.imageSelected && _vm.removable)?_c('button',{class:_vm.removeButtonClass,on:{"click":function($event){$event.preventDefault();return _vm.removeImage($event)}}},[_vm._v(_vm._s(_vm.strings.remove))]):_vm._e(),_vm._v(" "),(_vm.imageSelected && _vm.toggleAspectRatio && _vm.width !== _vm.height)?_c('button',{class:_vm.aspectButtonClass,on:{"click":function($event){$event.preventDefault();return _vm.rotateImage($event)}}},[_vm._v(_vm._s(_vm.strings.aspect))]):_vm._e()]):_c('div',[(!_vm.imageSelected)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();return _vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.select))]):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.strings.selected)}}),_vm._v(" "),(!_vm.hideChangeButton)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();return _vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.change))]):_vm._e(),_vm._v(" "),(_vm.removable)?_c('button',{class:_vm.removeButtonClass,on:{"click":function($event){$event.preventDefault();return _vm.removeImage($event)}}},[_vm._v(_vm._s(_vm.strings.remove))]):_vm._e()])]),_vm._v(" "),_c('input',{ref:"fileInput",attrs:{"type":"file","name":_vm.name,"id":_vm.id,"accept":_vm.accept},on:{"change":_vm.onFileChange}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',{staticClass:"runner-fields",on:{"click":function($event){}}},[_c('v-list-tile-content',[(_vm.editable)?_c('div',{staticClass:"full_width"},[_vm._t("default",[_c('v-text-field',_vm._b({attrs:{"type":"text","label":_vm.label + (_vm.required ? '*' : ''),"value":_vm.value,"error":_vm.validation.hasError('value'),"error-messages":_vm.validation.allErrors('value')},on:{"input":_vm.onInput}},'v-text-field',_vm.props,false))],{"error":_vm.validation.hasError('value'),"errorMessages":_vm.validation.allErrors('value'),"label":_vm.label})],2):_vm._e(),_vm._v(" "),(_vm.description && _vm.editable)?_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._v(" "),(!_vm.editable)?_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),(!_vm.editable)?_c('v-list-tile-title',{staticStyle:{"white-space":"pre-wrap"}},[_vm._t("value",[_vm._v(_vm._s(_vm.objValue))],{"value":_vm.objValue})],2):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.updateRunner($event)}}},[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("OSOBOWE")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.isActiveRunner || _vm.isAdmin)?_c('v-btn',{attrs:{"color":"accent","small":""},on:{"click":function($event){$event.preventDefault();_vm.updateMode = !_vm.updateMode}}},[_vm._v("edytuj")]):_vm._e(),_vm._v(" "),(_vm.isActiveRunner)?_c('v-btn',{attrs:{"color":"light-blue darken-3","small":"","to":{name: 'runner-change-password'}}},[_vm._v("zmień hasło")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mt-5",attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[(_vm.updateMode)?_c('div',{attrs:{"role":"group"}},[_c('picture-input',{ref:"pictureInput",attrs:{"width":"200","height":"200","margin":"8","size":"10","buttonClass":"btn btn-outline-secondary","customStrings":{
            upload: '<p>Urządzenie nie obsługiwane.</p>',
            drag: 'Upuść plik lub <br/>kliknij aby wybrać',
            tap: 'Dotknij aby wybrać zdjęcie<br>z Twojej galerii',
            change: 'Zmień obraz',
            remove: 'Usuń obraz',
            select: 'Wybierz obraz',
            selected: '<p>Photo successfully selected!</p>',
            fileSize: 'The file size exceeds the limit',
            fileType: 'This file type is not supported.',
            aspect: 'Landscape/Portrait'
          }},on:{"change":_vm.changeAvatar}})],1):_vm._e(),_vm._v(" "),(!_vm.updateMode && _vm.runner.avatar_thumbnail)?_c('img',{staticClass:"d-inline-block avatar",attrs:{"width":"200","id":"avatar_thumbnailInput","src":_vm.runner.avatar_thumbnail}}):_vm._e(),_vm._v(" "),(!_vm.updateMode && !_vm.runner.avatar_thumbnail)?_c('img',{staticClass:"d-inline-block avatar",attrs:{"width":"200","id":"avatar_thumbnailInput","src":__webpack_require__(40)}}):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":"","lg4":""}},[_c('v-list',{attrs:{"two-line":""}},[_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Imię","required":"","objValue":_vm.runner.first_name,"formErrors":_vm.formErrors,"field":'first_name'},model:{value:(_vm.form.first_name),callback:function ($$v) {_vm.$set(_vm.form, "first_name", $$v)},expression:"form.first_name"}}),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Nazwisko","required":"","objValue":_vm.runner.last_name,"formErrors":_vm.formErrors,"field":'last_name'},model:{value:(_vm.form.last_name),callback:function ($$v) {_vm.$set(_vm.form, "last_name", $$v)},expression:"form.last_name"}}),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Telefon","objValue":_vm.runner.phone,"formErrors":_vm.formErrors,"field":'phone'},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}},[_c('a',{attrs:{"slot":"value","href":'tel:' + _vm.runner.phone},slot:"value"},[_vm._v(_vm._s(_vm.runner.phone))])]),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":false,"label":"Email","objValue":_vm.runner.email,"field":'email'}},[_c('a',{attrs:{"slot":"value","href":'mailto:' + _vm.runner.email},slot:"value"},[_vm._v(_vm._s(_vm.runner.email))])])],1),_vm._v(" "),(_vm.updateMode)?_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":"","lg4":"","offset-sm6":"","offset-md4":"","offset-lg0":""}},[_c('v-list',{attrs:{"two-line":""}},[_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Pakiet","objValue":_vm.runner.package_name,"formErrors":_vm.formErrors,"field":'package'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var error = ref.error;
          var label = ref.label;
return [_c('v-select',{attrs:{"error":error,"label":label,"items":_vm.allPackagesOptions},model:{value:(_vm.form.package),callback:function ($$v) {_vm.$set(_vm.form, "package", $$v)},expression:"form.package"}})]}}]),model:{value:(_vm.form.package),callback:function ($$v) {_vm.$set(_vm.form, "package", $$v)},expression:"form.package"}}),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Trener","objValue":_vm.runner.trainer_name,"formErrors":_vm.formErrors,"props":{disabled: true},"description":"Aby zmienić trenera skontaktuj się z obsługą","field":'trainer'},model:{value:(_vm.runner.trainer_name),callback:function ($$v) {_vm.$set(_vm.runner, "trainer_name", $$v)},expression:"runner.trainer_name"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerDataGear_vue__ = __webpack_require__(297);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f61b958_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerDataGear_vue__ = __webpack_require__(634);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerDataGear_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f61b958_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerDataGear_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.updateRunner($event)}}},[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("SPRZĘTOWE")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.isActiveRunner || _vm.isAdmin)?_c('v-btn',{attrs:{"color":"accent","small":""},on:{"click":function($event){$event.preventDefault();_vm.updateMode = !_vm.updateMode}}},[_vm._v("edytuj")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":"","lg4":"","offset-sm6":"","offset-md4":"","offset-lg3":""}},[_c('v-list',{attrs:{"two-line":""}},[_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Zegarek z funkcją GPS","objValue":_vm.runner.gps_watch ? 'TAK' : 'NIE',"formErrors":_vm.formErrors,"field":'gps_watch'},model:{value:(_vm.form.gps_watch),callback:function ($$v) {_vm.$set(_vm.form, "gps_watch", $$v)},expression:"form.gps_watch"}},[_c('v-switch',{attrs:{"label":("Zegarek z funkcją GPS: " + (_vm.form.gps_watch ? 'TAK' : 'NIE'))},model:{value:(_vm.form.gps_watch),callback:function ($$v) {_vm.$set(_vm.form, "gps_watch", $$v)},expression:"form.gps_watch"}})],1),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Zegarek z funkcją mierzenia tętna","objValue":_vm.runner.pulse_watch ? 'TAK' : 'NIE',"formErrors":_vm.formErrors,"field":'pulse_watch'},model:{value:(_vm.form.pulse_watch),callback:function ($$v) {_vm.$set(_vm.form, "pulse_watch", $$v)},expression:"form.pulse_watch"}},[_c('v-switch',{attrs:{"label":("Zegarek z funkcją mierzenia tętna: " + (_vm.form.pulse_watch ? 'TAK' : 'NIE'))},model:{value:(_vm.form.pulse_watch),callback:function ($$v) {_vm.$set(_vm.form, "pulse_watch", $$v)},expression:"form.pulse_watch"}})],1),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Marka i model zegarka","objValue":_vm.runner.watch_model,"formErrors":_vm.formErrors,"field":'watch_model'},model:{value:(_vm.form.watch_model),callback:function ($$v) {_vm.$set(_vm.form, "watch_model", $$v)},expression:"form.watch_model"}}),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Marka i model butów biegowych","objValue":_vm.runner.shoes_model,"formErrors":_vm.formErrors,"field":'shoes_model'},model:{value:(_vm.form.shoes_model),callback:function ($$v) {_vm.$set(_vm.form, "shoes_model", $$v)},expression:"form.shoes_model"}})],1),_vm._v(" "),(_vm.updateMode)?_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerDataRunning_vue__ = __webpack_require__(298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4459cfb4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerDataRunning_vue__ = __webpack_require__(637);
function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerDataRunning_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4459cfb4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerDataRunning_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.updateRunner($event)}}},[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("BIEGOWE")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.isActiveRunner || _vm.isAdmin)?_c('v-btn',{attrs:{"color":"accent","small":""},on:{"click":function($event){$event.preventDefault();_vm.updateMode = !_vm.updateMode}}},[_vm._v("edytuj")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":"","lg4":"","offset-sm6":"","offset-md4":"","offset-lg3":""}},[_c('v-list',{attrs:{"two-line":""}},[_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Staż biegowy","required":"","objValue":_vm.runner.training_practice,"formErrors":_vm.formErrors,"field":'training_practice'},model:{value:(_vm.form.training_practice),callback:function ($$v) {_vm.$set(_vm.form, "training_practice", $$v)},expression:"form.training_practice"}}),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Tygodniowy kilometraż","required":"","objValue":_vm.runner.weekly_mileage,"formErrors":_vm.formErrors,"field":'weekly_mileage'},model:{value:(_vm.form.weekly_mileage),callback:function ($$v) {_vm.$set(_vm.form, "weekly_mileage", $$v)},expression:"form.weekly_mileage"}}),_vm._v(" "),_c('runner-data-field',{class:{bigger: _vm.updateMode},attrs:{"editable":_vm.updateMode,"label":"Aktualny cel główny","required":"","objValue":_vm.runner.main_goal,"formErrors":_vm.formErrors,"field":'main_goal'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var error = ref.error;
var errorMessages = ref.errorMessages;
var label = ref.label;
return [_c('v-textarea',{attrs:{"label":label + '*',"error":error,"error-messages":errorMessages},model:{value:(_vm.form.main_goal),callback:function ($$v) {_vm.$set(_vm.form, "main_goal", $$v)},expression:"form.main_goal"}})]}}]),model:{value:(_vm.form.main_goal),callback:function ($$v) {_vm.$set(_vm.form, "main_goal", $$v)},expression:"form.main_goal"}}),_vm._v(" "),_c('runner-data-field',{class:{bigger: _vm.updateMode},attrs:{"editable":_vm.updateMode,"label":"Aktualne cele dodatkowe","objValue":_vm.runner.additional_goal,"formErrors":_vm.formErrors,"field":'additional_goal'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var error = ref.error;
var errorMessages = ref.errorMessages;
var label = ref.label;
return [_c('v-textarea',{attrs:{"label":label,"error":error,"error-messages":errorMessages},model:{value:(_vm.form.additional_goal),callback:function ($$v) {_vm.$set(_vm.form, "additional_goal", $$v)},expression:"form.additional_goal"}})]}}]),model:{value:(_vm.form.additional_goal),callback:function ($$v) {_vm.$set(_vm.form, "additional_goal", $$v)},expression:"form.additional_goal"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":"","lg4":"","offset-sm6":"","offset-md4":"","offset-lg0":""}},[_c('v-list',{attrs:{"two-line":""}},[_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Ilość treningów","description":"Ilość dni treningowych w tygodniu","required":"","objValue":_vm.runner.training_days_number,"formErrors":_vm.formErrors,"field":'training_days_number'},model:{value:(_vm.form.training_days_number),callback:function ($$v) {_vm.$set(_vm.form, "training_days_number", $$v)},expression:"form.training_days_number"}}),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Dni treningowe","description":"Proponowane dni treningowe w tygodniu","required":"","objValue":_vm.runner.training_days ? _vm.runner.training_days.join(', ') : '',"formErrors":_vm.formErrors,"field":'training_days'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var error = ref.error;
var errorMessages = ref.errorMessages;
var label = ref.label;
return [_c('v-select',{attrs:{"menu-props":{ maxHeight: '400' },"error":error,"label":label + '*',"error-messages":errorMessages,"multiple":"","items":['poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota', 'niedziela']},model:{value:(_vm.form.training_days),callback:function ($$v) {_vm.$set(_vm.form, "training_days", $$v)},expression:"form.training_days"}})]}}]),model:{value:(_vm.form.training_days),callback:function ($$v) {_vm.$set(_vm.form, "training_days", $$v)},expression:"form.training_days"}}),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Czas sesji treningowej","description":"Najdłuższy czas jednej sesji treningowej","objValue":_vm.runner.training_session_length,"formErrors":_vm.formErrors,"field":'training_session_length'},model:{value:(_vm.form.training_session_length),callback:function ($$v) {_vm.$set(_vm.form, "training_session_length", $$v)},expression:"form.training_session_length"}}),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Przeciwwskazania","description":"Przeciwwskazania do uprawniania sportu","required":"","objValue":_vm.runner.contraindications,"formErrors":_vm.formErrors,"field":'contraindications'},model:{value:(_vm.form.contraindications),callback:function ($$v) {_vm.$set(_vm.form, "contraindications", $$v)},expression:"form.contraindications"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":"","lg4":"","offset-sm6":"","offset-md4":"","offset-lg3":""}},[(_vm.updateMode)?_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerDataOther_vue__ = __webpack_require__(299);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a099db9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerDataOther_vue__ = __webpack_require__(640);
function injectStyle (ssrContext) {
  __webpack_require__(639)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerDataOther_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a099db9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerDataOther_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.updateRunner($event)}}},[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("POZOSTAŁE")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.isActiveRunner || _vm.isAdmin)?_c('v-btn',{attrs:{"color":"accent","small":""},on:{"click":function($event){$event.preventDefault();_vm.updateMode = !_vm.updateMode}}},[_vm._v("edytuj")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":"","lg4":"","offset-sm6":"","offset-md4":"","offset-lg3":""}},[_c('v-list',{attrs:{"two-line":""}},[_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Inne aplikacje biegowe","description":"Konta na innych platformach biegowych np. GarminConnect, PolarFlow, Endomondo itp.","objValue":_vm.runner.other_running_platforms_accounts || 'NIE',"formErrors":_vm.formErrors,"placeholder":"jeśli tak to na jakich?","field":'other_running_platforms_accounts'},model:{value:(_vm.form.other_running_platforms_accounts),callback:function ($$v) {_vm.$set(_vm.form, "other_running_platforms_accounts", $$v)},expression:"form.other_running_platforms_accounts"}}),_vm._v(" "),(_vm.runner.package_with_tshirt)?_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Rozmiar koszulki","objValue":_vm.runner.tshirt_size_display,"formErrors":_vm.formErrors,"field":'tshirt_size'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var error = ref.error;
var label = ref.label;
var errorMessages = ref.errorMessages;
return [_c('v-select',{attrs:{"error":error,"error-messages":errorMessages,"label":label,"items":_vm.tshirtSizeOptions},model:{value:(_vm.form.tshirt_size),callback:function ($$v) {_vm.$set(_vm.form, "tshirt_size", $$v)},expression:"form.tshirt_size"}}),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n                Sprawdź rozmiar:\n                  "),_c('v-tooltip',{attrs:{"open-delay":"100","bottom":""}},[_c('span',{staticClass:"primary--text",attrs:{"slot":"activator","color":"primary","id":"womanTshirtSize"},slot:"activator"},[_vm._v("damskie")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(300)}})]),_vm._v(",\n                  "),_c('v-tooltip',{attrs:{"open-delay":"100","bottom":""}},[_c('span',{staticClass:"primary--text",attrs:{"slot":"activator","color":"primary","id":"manTshirtSize"},slot:"activator"},[_vm._v("męskie")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(301)}})])],1)]}}],null,false,4085704985),model:{value:(_vm.form.tshirt_size),callback:function ($$v) {_vm.$set(_vm.form, "tshirt_size", $$v)},expression:"form.tshirt_size"}}):_vm._e(),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Udział w zawodach","description":"Częstotliwość uczestnictwa w zawodach*","required":"","objValue":_vm.runner.race_frequency_display,"formErrors":_vm.formErrors,"field":'race_frequency'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var error = ref.error;
var label = ref.label;
return [_c('v-select',{attrs:{"error":error,"label":label + '*',"items":_vm.raceFrequencyOptions},model:{value:(_vm.form.race_frequency),callback:function ($$v) {_vm.$set(_vm.form, "race_frequency", $$v)},expression:"form.race_frequency"}})]}}]),model:{value:(_vm.form.race_frequency),callback:function ($$v) {_vm.$set(_vm.form, "race_frequency", $$v)},expression:"form.race_frequency"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":"","lg4":"","offset-sm6":"","offset-md4":"","offset-lg0":""}},[_c('v-list',{attrs:{"two-line":""}},[_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Treningi z trenerem","description":"Wcześniejsze treningi pod okiem trenera? Jeśli tak to jak długo?","objValue":_vm.runner.training_with_trainer || 'NIE',"formErrors":_vm.formErrors,"field":'training_with_trainer'},model:{value:(_vm.form.training_with_trainer),callback:function ($$v) {_vm.$set(_vm.form, "training_with_trainer", $$v)},expression:"form.training_with_trainer"}}),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Inne uprawiane sporty","objValue":_vm.runner.other_activities || 'NIE',"formErrors":_vm.formErrors,"field":'other_activities'},model:{value:(_vm.form.other_activities),callback:function ($$v) {_vm.$set(_vm.form, "other_activities", $$v)},expression:"form.other_activities"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":"","lg4":"","offset-sm6":"","offset-md4":"","offset-lg3":""}},[(_vm.updateMode)?_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('runner-data-personal',{attrs:{"runner":_vm.runnerData},on:{"runner-updated":_vm.fetchRunner}}),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('runner-data-gear',{attrs:{"runner":_vm.runnerData},on:{"runner-updated":_vm.fetchRunner}}),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('runner-data-running',{attrs:{"runner":_vm.runnerData},on:{"runner-updated":_vm.fetchRunner}}),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('runner-data-other',{attrs:{"runner":_vm.runnerData},on:{"runner-updated":_vm.fetchRunner}}),_vm._v(" "),_c('v-divider',{staticClass:"pb-2"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerApplicationDataPackage_vue__ = __webpack_require__(302);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d75e0ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerApplicationDataPackage_vue__ = __webpack_require__(647);
function injectStyle (ssrContext) {
  __webpack_require__(643)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerApplicationDataPackage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d75e0ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerApplicationDataPackage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageSelection_vue__ = __webpack_require__(303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_219cccb6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageSelection_vue__ = __webpack_require__(646);
function injectStyle (ssrContext) {
  __webpack_require__(645)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageSelection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_219cccb6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageSelection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"Rtable Rtable--5cols Rtable--collapse"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.options),function(option){return _c('div',{staticClass:"Rtable-row",class:{selected: _vm.value==option.id}},[_c('div',{staticClass:"Rtable-cell name-cell"},[_c('div',{staticClass:"Rtable-cell--content"},[_vm._v(_vm._s(option.name))])]),_vm._v(" "),_c('div',{staticClass:"Rtable-cell description-cell"},[_c('div',{staticClass:"Rtable-cell--content"},[_vm._v(_vm._s(option.description))])]),_vm._v(" "),_c('div',{staticClass:"Rtable-cell price-cell"},[_c('div',{staticClass:"Rtable-cell--content"},[_vm._v(_vm._s(option.price)+" zł")])]),_vm._v(" "),_c('div',{staticClass:"Rtable-cell action-cell"},[_c('div',{staticClass:"Rtable-cell--content"},[_c('v-btn',{attrs:{"block":"","color":"primary"},on:{"click":function($event){return _vm.$emit('input', option.id)}}},[_vm._v("Wybierz")])],1)])])})],2),_vm._v(" "),(_vm.hasErrors('package'))?_c('div',{staticClass:"error--text text-xs-center"},[_vm._v("\n      Musisz wybrać pakiet.\n  ")]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Rtable-row Rtable-row--head"},[_c('div',{staticClass:"Rtable-cell name-cell column-heading"},[_vm._v("nazwa")]),_vm._v(" "),_c('div',{staticClass:"Rtable-cell description-cell column-heading"},[_vm._v("opis")]),_vm._v(" "),_c('div',{staticClass:"Rtable-cell price-cell column-heading"},[_vm._v("cena")]),_vm._v(" "),_c('div',{staticClass:"Rtable-cell action-cell column-heading"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Informacje zgłoszeniowe")]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2 pb-1"},[_c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.updateRunner($event)}}},[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"tertiary"}},[_c('v-toolbar-title',[_vm._v("Pakiet")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('div',{staticClass:"subheading text-xs-center mt-5"},[_vm._v("Wybierz pakiet")]),_vm._v(" "),_c('package-selection',{attrs:{"options":_vm.availablePackages,"formErrors":_vm.formErrors},on:{"input":_vm.updateRunner},model:{value:(_vm.form.package),callback:function ($$v) {_vm.$set(_vm.form, "package", $$v)},expression:"form.package"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":""}},[_c('v-flex',{staticClass:"step-buttons"},[(_vm.updateMode)?_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Dalej")]):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerApplicationDataTrainer_vue__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_666163d9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerApplicationDataTrainer_vue__ = __webpack_require__(653);
function injectStyle (ssrContext) {
  __webpack_require__(649)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerApplicationDataTrainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_666163d9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerApplicationDataTrainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerSelection_vue__ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d574c7c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerSelection_vue__ = __webpack_require__(652);
function injectStyle (ssrContext) {
  __webpack_require__(651)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerSelection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d574c7c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerSelection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:"scroll-layout"},[_vm._l((_vm.options),function(trainer){return [_c('v-card',{staticClass:"name-card",class:{selected: _vm.value==trainer.id}},[_c('v-card-text',[_c('div',{staticClass:"layout ma-0 align-center column"},[_c('v-avatar',{attrs:{"size":"120","color":"primary"}},[(trainer.avatar_thumbnail)?_c('img',{attrs:{"width":"200","src":trainer.avatar_thumbnail}}):_vm._e(),_vm._v(" "),(!trainer.avatar_thumbnail)?_c('img',{attrs:{"width":"200","src":__webpack_require__(40)}}):_vm._e()])],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(trainer.full_name))]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(trainer.about))])])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"block":"","color":"primary"},on:{"click":function($event){return _vm.$emit('input', trainer.id)}}},[_vm._v("Wybierz")])],1)],1)]})],2),_vm._v(" "),(_vm.hasErrors('trainer'))?_c('div',{staticClass:"error--text text-xs-center"},[_vm._v("\n      Musisz wybrać trenera.\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Informacje zgłoszeniowe")]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2 pb-1"},[_c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.updateRunner($event)}}},[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"tertiary"}},[_c('v-toolbar-title',[_vm._v("TRENER")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('div',{staticClass:"subheading text-xs-center mt-5"},[_vm._v("Wybierz trenera")]),_vm._v(" "),_c('trainer-selection',{attrs:{"options":_vm.availableTrainers,"formErrors":_vm.formErrors},on:{"input":_vm.updateRunner},model:{value:(_vm.form.trainer),callback:function ($$v) {_vm.$set(_vm.form, "trainer", $$v)},expression:"form.trainer"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":""}},[_c('v-flex',{staticClass:"step-buttons"},[_c('v-btn',{staticClass:"mr-4",attrs:{"dark":"","to":{name: 'runner-application-data-package', params: {id: _vm.$route.params.id}},"color":"tertiary"}},[_vm._v("Wstecz")]),_vm._v(" "),(_vm.updateMode)?_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Dalej")]):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerApplicationDataFirst_vue__ = __webpack_require__(306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_275e03f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerApplicationDataFirst_vue__ = __webpack_require__(668);
function injectStyle (ssrContext) {
  __webpack_require__(655)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerApplicationDataFirst_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_275e03f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerApplicationDataFirst_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.editable)?_c('div',{staticClass:"full_width"},[_vm._t("default",[_c('v-text-field',_vm._b({attrs:{"type":"text","label":_vm.label,"value":_vm.value,"error":_vm.validation.hasError('value'),"error-messages":_vm.validation.allErrors('value'),"hint":_vm.description,"persistent-hint":""},on:{"input":_vm.onInput}},'v-text-field',_vm.props,false))],{"error":_vm.validation.hasError('value'),"errorMessages":_vm.validation.allErrors('value'),"label":_vm.label})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecordForm_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_661de568_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecordForm_vue__ = __webpack_require__(664);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecordForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_661de568_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecordForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('v-select',{attrs:{"items":_vm.recordsRaceTypesStringsOptions,"label":"Rodzaj","error":_vm.hasErrors('race_type'),"error-messages":_vm.getErrors('race_type')},model:{value:(_vm.obj.race_type),callback:function ($$v) {_vm.$set(_vm.obj, "race_type", $$v)},expression:"obj.race_type"}})],1),_vm._v(" "),_c('td',[_c('v-select',{attrs:{"label":"Dystans","items":_vm.distanceOptions,"error":_vm.hasErrors('distance_string'),"error-messages":_vm.getErrors('distance_string')},model:{value:(_vm.obj.distance_string),callback:function ($$v) {_vm.$set(_vm.obj, "distance_string", $$v)},expression:"obj.distance_string"}})],1),_vm._v(" "),_c('td',[_c('v-text-field',{attrs:{"label":"Czas","placeholder":"hh:mm:ss","error":_vm.hasErrors('time'),"error-messages":_vm.getErrors('time')},model:{value:(_vm.obj.time),callback:function ($$v) {_vm.$set(_vm.obj, "time", $$v)},expression:"obj.time"}})],1),_vm._v(" "),_c('td',[_c('input-date',{attrs:{"label":"Data","error":_vm.hasErrors('race_date'),"error-messages":_vm.getErrors('race_date')},model:{value:(_vm.obj.race_date),callback:function ($$v) {_vm.$set(_vm.obj, "race_date", $$v)},expression:"obj.race_date"}})],1),_vm._v(" "),_c('td',[_c('rp-icon',{staticClass:"mr-1",attrs:{"type":"save","tooltip":"zapisz"},nativeOn:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.saveRecord($event)}}}),_vm._v(" "),_c('rp-icon',{staticClass:"mr-1",attrs:{"type":"undo","tooltip":"anuluj"},nativeOn:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('close')}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"v-table__overflow res-table"},[(_vm.records)?_c('table',{staticClass:"v-table theme--light"},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.records),function(record){return [(!record.edit)?_c('tr',{staticClass:"detail-row",on:{"click":function($event){return _vm.$emit('set-distance', record.distance_string)}}},[_c('td',[_vm._v(_vm._s(record.race_type_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(record.distance_string_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(record.time))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(record.race_date,'LL')))]),_vm._v(" "),_c('td',[_c('rp-icon',{staticClass:"mr-2",attrs:{"type":"edit","tooltip":"edytuj"},nativeOn:{"click":function($event){$event.preventDefault();$event.stopPropagation();record.edit = !record.edit}}})],1)]):_c('record-form',{staticClass:"edit-row",attrs:{"record":record},on:{"close":function($event){record.edit = !record.edit},"created-record":_vm.refetchView,"updated-record":_vm.refetchView}})]}),_vm._v(" "),(_vm.newRecord)?[_c('record-form',{staticClass:"edit-row",on:{"close":function($event){_vm.newRecord = !_vm.newRecord},"created-record":_vm.refetchView,"updated-record":_vm.refetchView}})]:_vm._e()],2)]):_vm._e()]),_vm._v(" "),_c('rp-icon',{staticClass:"mr-2",attrs:{"type":"add_circle","tooltip":"dodaj"},on:{"click":function($event){_vm.newRecord = !_vm.newRecord}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"table-distance"},[_vm._v("Typ")]),_vm._v(" "),_c('th',{staticClass:"table-distance"},[_vm._v("Dystans")]),_vm._v(" "),_c('th',{staticClass:"table-time"},[_vm._v("Czas")]),_vm._v(" "),_c('th',{staticClass:"table-date"},[_vm._v("Data")]),_vm._v(" "),_c('th',{staticClass:"table-actions"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-sheet',{staticClass:"pb-2 sheet-header d-flex",attrs:{"min-height":"48","dark":"","color":_vm.color}},[_c('v-container',{staticClass:"pt-1 pb-0 fluid",attrs:{"color":"primary"}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-space-between":""}},[_vm._t("default",[_c('v-flex',{staticClass:"d-inline-block header--title"},[_vm._t("left")],2),_vm._v(" "),_c('v-flex',{staticClass:"text-md-right"},[_vm._t("right")],2)])],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Informacje zgłoszeniowe")]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2 pb-1"},[_c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.updateRunner($event)}}},[_c('resp-header',{attrs:{"color":"tertiary"}},[_c('template',{slot:"left"},[_vm._v("\n          BIEGOWE\n        ")]),_vm._v(" "),_c('span',{attrs:{"slot":"right"},slot:"right"},[_vm._v("\n          Wypełnij poniższe dane aby trener mógł sporządzić optymalny dla Ciebie plan treningowy\n        ")])],2),_vm._v(" "),_c('v-layout',{staticClass:"grid-gap my-4",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":"","lg4":""}},[_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Staż biegowy*","objValue":_vm.runner.training_practice,"formErrors":_vm.formErrors,"field":'training_practice'},model:{value:(_vm.form.training_practice),callback:function ($$v) {_vm.$set(_vm.form, "training_practice", $$v)},expression:"form.training_practice"}}),_vm._v(" "),_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Tygodniowy kilometraż*","objValue":_vm.runner.weekly_mileage,"formErrors":_vm.formErrors,"field":'weekly_mileage'},model:{value:(_vm.form.weekly_mileage),callback:function ($$v) {_vm.$set(_vm.form, "weekly_mileage", $$v)},expression:"form.weekly_mileage"}}),_vm._v(" "),_c('runner-step-field',{class:{bigger: _vm.updateMode},attrs:{"editable":_vm.updateMode,"label":"Aktualny cel główny*","objValue":_vm.runner.main_goal,"formErrors":_vm.formErrors,"field":'main_goal'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var error = ref.error;
var errorMessages = ref.errorMessages;
var label = ref.label;
return [_c('v-textarea',{attrs:{"label":label,"error":error,"error-messages":errorMessages,"rows":"3","auto-grow":""},model:{value:(_vm.form.main_goal),callback:function ($$v) {_vm.$set(_vm.form, "main_goal", $$v)},expression:"form.main_goal"}})]}}]),model:{value:(_vm.form.main_goal),callback:function ($$v) {_vm.$set(_vm.form, "main_goal", $$v)},expression:"form.main_goal"}}),_vm._v(" "),_c('runner-step-field',{class:{bigger: _vm.updateMode},attrs:{"editable":_vm.updateMode,"label":"Aktualne cele dodatkowe","objValue":_vm.runner.additional_goal,"formErrors":_vm.formErrors,"field":'additional_goal'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var error = ref.error;
var errorMessages = ref.errorMessages;
var label = ref.label;
return [_c('v-textarea',{attrs:{"label":label,"error":error,"error-messages":errorMessages,"rows":"3","auto-grow":""},model:{value:(_vm.form.additional_goal),callback:function ($$v) {_vm.$set(_vm.form, "additional_goal", $$v)},expression:"form.additional_goal"}})]}}]),model:{value:(_vm.form.additional_goal),callback:function ($$v) {_vm.$set(_vm.form, "additional_goal", $$v)},expression:"form.additional_goal"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":"","lg4":""}},[_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Ilość treningów*","description":"Ilość dni treningowych w tygodniu","objValue":_vm.runner.training_days_number,"formErrors":_vm.formErrors,"field":'training_days_number'},model:{value:(_vm.form.training_days_number),callback:function ($$v) {_vm.$set(_vm.form, "training_days_number", $$v)},expression:"form.training_days_number"}}),_vm._v(" "),_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Dni treningowe*","description":"Proponowane dni treningowe w tygodniu","objValue":_vm.runner.training_days,"formErrors":_vm.formErrors,"field":'training_days'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var error = ref.error;
var errorMessages = ref.errorMessages;
var label = ref.label;
return [_c('v-select',{attrs:{"menu-props":{ maxHeight: '400' },"error":error,"label":label,"error-messages":errorMessages,"multiple":"","items":['poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota', 'niedziela']},model:{value:(_vm.form.training_days),callback:function ($$v) {_vm.$set(_vm.form, "training_days", $$v)},expression:"form.training_days"}})]}}]),model:{value:(_vm.form.training_days),callback:function ($$v) {_vm.$set(_vm.form, "training_days", $$v)},expression:"form.training_days"}}),_vm._v(" "),_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Czas sesji treningowej","description":"Najdłuższy czas jednej sesji treningowej","objValue":_vm.runner.training_session_length,"formErrors":_vm.formErrors,"field":'training_session_length'},model:{value:(_vm.form.training_session_length),callback:function ($$v) {_vm.$set(_vm.form, "training_session_length", $$v)},expression:"form.training_session_length"}}),_vm._v(" "),_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Przeciwwskazania*","description":"Przeciwwskazania do uprawniania sportu","objValue":_vm.runner.contraindications,"formErrors":_vm.formErrors,"field":'contraindications'},model:{value:(_vm.form.contraindications),callback:function ($$v) {_vm.$set(_vm.form, "contraindications", $$v)},expression:"form.contraindications"}})],1)],1),_vm._v(" "),_c('resp-header',{attrs:{"color":"tertiary"}},[_c('template',{slot:"left"},[_vm._v("\n          REKORDY\n        ")]),_vm._v(" "),_c('span',{attrs:{"slot":"right"},slot:"right"},[_vm._v("\n          Dodaj swoje rekordy życiowe dla wybranych przez siebie dystansów\n        ")])],2),_vm._v(" "),_c('v-layout',{staticClass:"grid-gap my-4",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg10":"","xl8":""}},[_c('records')],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":""}},[_c('v-flex',{staticClass:"step-buttons"},[_c('v-btn',{staticClass:"mr-4",attrs:{"dark":"","to":{name: 'runner-application-data-trainer', params: {id: _vm.$route.params.id}},"color":"tertiary"}},[_vm._v("Wstecz")]),_vm._v(" "),(_vm.updateMode)?_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Dalej")]):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerApplicationDataSecond_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0595ae89_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerApplicationDataSecond_vue__ = __webpack_require__(670);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerApplicationDataSecond_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0595ae89_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerApplicationDataSecond_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Informacje zgłoszeniowe")]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2 pb-1"},[_c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.updateRunner($event)}}},[_c('resp-header',{attrs:{"color":"tertiary"}},[_c('template',{slot:"left"},[_vm._v("\n          SPRZĘTOWE\n        ")]),_vm._v(" "),_c('span',{attrs:{"slot":"right"},slot:"right"},[_vm._v("\n          Wypełnij poniższe dane aby trener mógł sporządzić optymalny dla Ciebie plan treningowy\n        ")])],2),_vm._v(" "),_c('v-layout',{staticClass:"grid-gap my-4",attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":"","lg4":""}},[_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Zegarek z funkcją GPS","objValue":_vm.runner.gps_watch ? 'TAK' : 'NIE',"formErrors":_vm.formErrors,"field":'gps_watch'},model:{value:(_vm.form.gps_watch),callback:function ($$v) {_vm.$set(_vm.form, "gps_watch", $$v)},expression:"form.gps_watch"}},[_c('v-switch',{attrs:{"label":("Zegarek z funkcją GPS: " + (_vm.form.gps_watch ? 'TAK' : 'NIE'))},model:{value:(_vm.form.gps_watch),callback:function ($$v) {_vm.$set(_vm.form, "gps_watch", $$v)},expression:"form.gps_watch"}})],1),_vm._v(" "),_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Zegarek z funkcją mierzenia tętna","objValue":_vm.runner.pulse_watch ? 'TAK' : 'NIE',"formErrors":_vm.formErrors,"field":'pulse_watch'},model:{value:(_vm.form.pulse_watch),callback:function ($$v) {_vm.$set(_vm.form, "pulse_watch", $$v)},expression:"form.pulse_watch"}},[_c('v-switch',{attrs:{"label":("Zegarek z funkcją mierzenia tętna: " + (_vm.form.pulse_watch ? 'TAK' : 'NIE'))},model:{value:(_vm.form.pulse_watch),callback:function ($$v) {_vm.$set(_vm.form, "pulse_watch", $$v)},expression:"form.pulse_watch"}})],1),_vm._v(" "),_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Marka i model zegarka","objValue":_vm.runner.watch_model,"formErrors":_vm.formErrors,"field":'watch_model'},model:{value:(_vm.form.watch_model),callback:function ($$v) {_vm.$set(_vm.form, "watch_model", $$v)},expression:"form.watch_model"}}),_vm._v(" "),_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Marka i model butów biegowych","objValue":_vm.runner.shoes_model,"formErrors":_vm.formErrors,"field":'shoes_model'},model:{value:(_vm.form.shoes_model),callback:function ($$v) {_vm.$set(_vm.form, "shoes_model", $$v)},expression:"form.shoes_model"}})],1)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"tertiary"}},[_c('v-toolbar-title',[_vm._v("POZOSTAŁE")])],1),_vm._v(" "),_c('v-layout',{staticClass:"grid-gap my-4",attrs:{"row":"","justify-center":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":"","lg4":""}},[_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Inne aplikacje biegowe","description":"Konta na innych platformach biegowych np. GarminConnect, PolarFlow, Endomondo itp.","objValue":_vm.runner.other_running_platforms_accounts || 'NIE',"formErrors":_vm.formErrors,"placeholder":"jeśli tak to na jakich?","field":'other_running_platforms_accounts'},model:{value:(_vm.form.other_running_platforms_accounts),callback:function ($$v) {_vm.$set(_vm.form, "other_running_platforms_accounts", $$v)},expression:"form.other_running_platforms_accounts"}}),_vm._v(" "),(_vm.runner.package_with_tshirt)?_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Rozmiar koszulki","objValue":_vm.runner.tshirt_size_display,"formErrors":_vm.formErrors,"field":'tshirt_size'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var error = ref.error;
var label = ref.label;
var errorMessages = ref.errorMessages;
return [_c('v-select',{attrs:{"error":error,"hide-details":!error,"error-messages":errorMessages,"label":label,"items":_vm.tshirtSizeOptions},model:{value:(_vm.form.tshirt_size),callback:function ($$v) {_vm.$set(_vm.form, "tshirt_size", $$v)},expression:"form.tshirt_size"}}),_vm._v(" "),_c('span',{staticClass:"v-messages theme--light"},[_vm._v("\n                    Sprawdź rozmiar:\n                      "),_c('v-tooltip',{attrs:{"open-delay":"100","bottom":""}},[_c('span',{staticClass:"primary--text",attrs:{"slot":"activator","color":"primary","id":"womanTshirtSize"},slot:"activator"},[_vm._v("damskie")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(300)}})]),_vm._v(",\n                      "),_c('v-tooltip',{attrs:{"open-delay":"100","bottom":""}},[_c('span',{staticClass:"primary--text",attrs:{"slot":"activator","color":"primary","id":"manTshirtSize"},slot:"activator"},[_vm._v("męskie")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(301)}})])],1)]}}],null,false,1689349403),model:{value:(_vm.form.tshirt_size),callback:function ($$v) {_vm.$set(_vm.form, "tshirt_size", $$v)},expression:"form.tshirt_size"}}):_vm._e(),_vm._v(" "),_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Udział w zawodach*","description":"Częstotliwość uczestnictwa w zawodach","objValue":_vm.runner.race_frequency_display,"formErrors":_vm.formErrors,"field":'race_frequency'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var error = ref.error;
var errorMessages = ref.errorMessages;
var label = ref.label;
return [_c('v-select',{attrs:{"error":error,"error-messages":errorMessages,"label":label,"items":_vm.raceFrequencyOptions},model:{value:(_vm.form.race_frequency),callback:function ($$v) {_vm.$set(_vm.form, "race_frequency", $$v)},expression:"form.race_frequency"}})]}}]),model:{value:(_vm.form.race_frequency),callback:function ($$v) {_vm.$set(_vm.form, "race_frequency", $$v)},expression:"form.race_frequency"}}),_vm._v(" "),_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Wyrażam zgodę na rozpoczęcie realizacji usługi przed upływem 14-dniowego terminu na odstąpienie od umowy zawartej na odległość, wynikającego z art. 27 ustawy z 30 maja 2014 roku o prawach konsumenta. Jednocześnie przyjmuję do wiadomości, że wyrażenie powyższej zgody jest jednoznaczne z utratą prawa do odstąpienia od umowy (art. 38 pkt. 13 ustawy z 30 maja 2014 roku o prawach konsumenta).*","objValue":_vm.runner.contract ? 'TAK' : 'NIE',"formErrors":_vm.formErrors,"field":'contract'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var error = ref.error;
var label = ref.label;
var errorMessages = ref.errorMessages;
return [_c('v-checkbox',{attrs:{"error":error,"errorMessages":errorMessages,"label":"Wyrażam zgodę na rozpoczęcie realizacji usługi przed upływem 14-dniowego terminu na odstąpienie od umowy zawartej na odległość, wynikającego z art. 27 ustawy z 30 maja 2014 roku o prawach konsumenta. Jednocześnie przyjmuję do wiadomości, że wyrażenie powyższej zgody jest jednoznaczne z utratą prawa do odstąpienia od umowy (art. 38 pkt. 13 ustawy z 30 maja 2014 roku o prawach konsumenta).*"},model:{value:(_vm.form.contract),callback:function ($$v) {_vm.$set(_vm.form, "contract", $$v)},expression:"form.contract"}})]}}]),model:{value:(_vm.form.contract),callback:function ($$v) {_vm.$set(_vm.form, "contract", $$v)},expression:"form.contract"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":"","lg4":""}},[_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Treningi z trenerem","description":"Wcześniejsze treningi pod okiem trenera? Jeśli tak to jak długo?","objValue":_vm.runner.training_with_trainer || 'NIE',"formErrors":_vm.formErrors,"field":'training_with_trainer'},model:{value:(_vm.form.training_with_trainer),callback:function ($$v) {_vm.$set(_vm.form, "training_with_trainer", $$v)},expression:"form.training_with_trainer"}}),_vm._v(" "),_c('runner-step-field',{attrs:{"editable":_vm.updateMode,"label":"Inne uprawiane sporty","objValue":_vm.runner.other_activities || 'NIE',"formErrors":_vm.formErrors,"field":'other_activities'},model:{value:(_vm.form.other_activities),callback:function ($$v) {_vm.$set(_vm.form, "other_activities", $$v)},expression:"form.other_activities"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":""}},[_c('v-flex',{staticClass:"step-buttons"},[_c('v-btn',{staticClass:"mr-4",attrs:{"dark":"","to":{name: 'runner-application-data-first', params: {id: _vm.$route.params.id}},"color":"tertiary"}},[_vm._v("Wstecz")]),_vm._v(" "),(_vm.updateMode)?_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Dalej")]):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue__ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42780e44_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plan_vue__ = __webpack_require__(717);
function injectStyle (ssrContext) {
  __webpack_require__(672)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42780e44_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCalendar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var getCalendar = function getCalendar(date, events, dayStatus) {
  var startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).startOf('month').startOf('isoWeek');
  var endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).endOf('month').endOf('isoWeek').add(1, 'd');
  var arrays = [];
  var currentArray = [];
  var planned = 0;
  var done = 0;
  var totalPlanned = 0;
  var totalDone = 0;
  var totalPlannedCount = 0;
  var totalDoneCount = 0;
  var totalMonthPlanned = 0;
  var totalMonthDone = 0;
  var totalMonthPlannedCount = 0;
  var totalMonthDoneCount = 0;
  for (var m = __WEBPACK_IMPORTED_MODULE_1_moment___default()(startDate); m.isBefore(endDate); m.add(1, 'd')) {
    var day = { date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(m), otherMonth: !m.isSame(date, 'month'), events: [], isOpen: !!dayStatus[m.format('YYYY-MM-DD')] };
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(events), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var ev = _step.value;

        if (m.isSame(ev.datetime, 'day')) {
          if (ev.type === 'race') {
            day.events = [];
          }
          day.events.push(ev);
          if (ev.type !== 'activity') {
            // aktywności nie wchodzą w zaplanowane
            planned += ev.planned;
            totalPlannedCount += 1;
            if (!day.otherMonth) {
              totalMonthPlannedCount += 1;
            }
          }
          done += ev.done;
          if (ev.done !== 0 && ev.type !== 'activity') {
            totalDoneCount += 1;
            if (!day.otherMonth) {
              totalMonthDoneCount += 1;
            }
          }
          if (ev.type !== 'activity') {
            totalPlanned += ev.planned;
          }
          totalDone += ev.done;
          if (!day.otherMonth) {
            if (ev.type !== 'activity') {
              totalMonthPlanned += ev.planned;
            }
            totalMonthDone += ev.done;
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    currentArray.push(day);
    if (m.day() === 0) {
      arrays.push({ date: currentArray[0].date, 'days': currentArray, 'totalPlanned': Math.round(planned), 'totalDone': Math.round(done) });
      currentArray = [];
      planned = 0;
      done = 0;
    }
  }
  return {
    totalPlanned: Math.round(totalPlanned),
    totalDone: Math.round(totalDone),
    totalPlannedCount: totalPlannedCount,
    totalDoneCount: totalDoneCount,
    totalMonthPlanned: Math.round(totalMonthPlanned),
    totalMonthDone: Math.round(totalMonthDone),
    totalMonthPlannedCount: totalMonthPlannedCount,
    totalMonthDoneCount: totalMonthDoneCount,
    weeks: arrays
  };
};

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkoutBig_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3013de6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkoutBig_vue__ = __webpack_require__(677);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkoutBig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3013de6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkoutBig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-field"},[_c('div',{staticClass:"text-field__prepend-outer"},[_vm._t("prepend")],2),_vm._v(" "),_c('div',{staticClass:"text-field__control"},[_c('div',{staticClass:"text-field__label"},[_vm._t("label",[_vm._v(_vm._s(_vm.label))])],2),_vm._v(" "),_c('div',{staticClass:"text-field__content",class:{pre: _vm.pre}},[_vm._t("default",[_vm._v(_vm._s(_vm.content))])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bigEvent workout",class:{floating: !_vm.inplace, 'undone': _vm.workout.workout_done === false, 'done': _vm.workout.workout_done === true},style:(_vm.inplace ? {} : {left: _vm.workout.position.left + 'px', top: _vm.workout.position.top + 'px'})},[_c('div',{staticClass:"event-header"},[_c('span',{staticClass:"event-date"},[_vm._v(_vm._s(_vm.workout.datetime.date())+" "),(_vm.$mq == 'sm')?[_vm._v("("+_vm._s(_vm.workout.datetime.format('ddd'))+")")]:_vm._e()],2),_vm._v(" "),_c('span',{staticClass:"event-name",class:'style-' + _vm.workout.style},[_vm._v(_vm._s(_vm.workout.workout_type))]),_vm._v(" "),_c('span',{staticClass:"event-actions"},[(_vm.isActiveRunnerTrainer)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Edytuj'),expression:"'Edytuj'"}],staticClass:"click-effect",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('edit-workout')}}},[_vm._v("edit")]):_vm._e(),_vm._v(" "),(_vm.isActiveRunnerTrainer)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Usuń'),expression:"'Usuń'"}],staticClass:"click-effect",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove-workout')}}},[_vm._v("delete")]):_vm._e(),_vm._v(" "),(!_vm.inplace)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Zamknij'),expression:"'Zamknij'"}],staticClass:"click-effect ml-2",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_vm._v("close")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"event-content"},[_c('div',{staticClass:"event-content__header"},[_vm._v("\n      Zaplanowany trening\n      "),(_vm.isActiveRunnerTrainer)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Edytuj trening'),expression:"'Edytuj trening'"}],staticClass:"click-effect",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('edit-workout')}}},[_vm._v("edit")]):_vm._e()],1),_vm._v(" "),_vm._l((_vm.workout.elements),function(el){return [_c('ul',[(el.with_warmup)?_c('li',[_c('TextField',{attrs:{"label":"Rozgrzewka"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Rozgrzewka'),expression:"'Rozgrzewka'"}],staticClass:"fi flaticon-people-1 ",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n          "+_vm._s(_vm._f("default")(el.warmup,'Standardowa rozgrzewka'))+"\n        ")])],1):_vm._e(),_vm._v(" "),(el.distance)?_c('li',{class:[el.element_type.includes('OWB1') ? '' : 'style-' + _vm.workout.style]},[_c('TextField',{attrs:{"label":"Dystans"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans'),expression:"'Dystans'"}],staticClass:"fi flaticon-road-1 ",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n          "+_vm._s(el.distance)+"\n        ")])],1):_vm._e(),_vm._v(" "),(el.distance_string)?_c('li',{class:[el.element_type.includes('OWB1') ? '' : 'style-' + _vm.workout.style]},[_c('TextField',{attrs:{"label":"Dystans"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans'),expression:"'Dystans'"}],staticClass:"fi flaticon-road-1 ",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n          "+_vm._s(el.distance_string)+"\n        ")])],1):_vm._e(),_vm._v(" "),(el.ascent)?_c('li',[_c('TextField',{attrs:{"label":"Podbieg"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Podbieg'),expression:"'Podbieg'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("trending_up")]),_vm._v("\n          "+_vm._s(el.ascent)+"\n        ")],1)],1):_vm._e(),_vm._v(" "),(el.pulse)?_c('li',[_c('TextField',{attrs:{"label":"Tętno"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Tętno'),expression:"'Tętno'"}],staticClass:"fi flaticon-pulse-line ",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n          "+_vm._s(el.pulse)+" bpm\n        ")])],1):_vm._e(),_vm._v(" "),(el.pace)?_c('li',[_c('TextField',{attrs:{"label":"Tempo"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Tempo'),expression:"'Tempo'"}],staticClass:"fi flaticon-minutes ",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n          "+_vm._s(el.pace)+"\n        ")])],1):_vm._e(),_vm._v(" "),(el.strength)?_c('li',[_c('TextField',{attrs:{"label":"Siła biegowa"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Siła biegowa'),expression:"'Siła biegowa'"}],staticClass:"text-icon ",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("SB")]),_vm._v("\n          "+_vm._s(el.strength)+"\n        ")])],1):_vm._e(),_vm._v(" "),(el.repeats)?_c('li',[_c('TextField',{attrs:{"label":"Rytmy"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Rytmy'),expression:"'Rytmy'"}],staticClass:"text-icon ",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("R")]),_vm._v("\n          "+_vm._s(el.repeats)+"\n        ")])],1):_vm._e(),_vm._v(" "),(el.break_time)?_c('li',[_c('TextField',{attrs:{"label":"Przerwa"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Przerwa'),expression:"'Przerwa'"}],staticClass:"fi flaticon-people ",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n          "+_vm._s(el.break_time)+"\n        ")])],1):_vm._e(),_vm._v(" "),(el.descent)?_c('li',[_c('TextField',{attrs:{"label":"Zbieg"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Zbieg'),expression:"'Zbieg'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("trending_down")]),_vm._v("\n          "+_vm._s(el.descent)+"\n        ")],1)],1):_vm._e(),_vm._v(" "),(el.trip_place)?_c('li',[_c('TextField',{attrs:{"label":"Miejsce"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Miejsce'),expression:"'Miejsce'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("place")]),_vm._v(" "),(el.trip_link)?_c('a',{attrs:{"href":el.trip_link,"target":"_blank"}},[_vm._v(_vm._s(el.trip_place))]):_vm._e(),_vm._v(" "),(!el.trip_link)?_c('span',[_vm._v(_vm._s(el.trip_place))]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(el.with_cooling)?_c('li',[_c('TextField',{attrs:{"label":"Schłodzenie"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Schłodzenie'),expression:"'Schłodzenie'"}],staticClass:"text-icon ",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("C")]),_vm._v("\n          "+_vm._s(_vm._f("default")(el.cooling,'Standardowe schłodzenie'))+"\n        ")])],1):_vm._e(),_vm._v(" "),(el.other)?_c('li',[_c('TextField',{attrs:{"label":"Inny trening"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Inny trening'),expression:"'Inny trening'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("short_text")]),_vm._v("\n          "+_vm._s(el.other)+"\n        ")],1)],1):_vm._e()]),_vm._v(" "),_c('hr')]}),_vm._v(" "),(_vm.workout.additional_info)?_c('div',[_c('TextField',{attrs:{"label":"Informacje od trenera","pre":""}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Informacje od trenera'),expression:"'Informacje od trenera'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("info")]),_vm._v(_vm._s(_vm.workout.additional_info)+"\n        ")],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"event-results"},[_c('div',{staticClass:"event-results__header"},[_vm._v("\n        Rezultat zawodnika\n        "),(!_vm.edit && (_vm.isActiveRunnerTrainer || _vm.isActiveRunner))?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.workout.total_distance_done ? 'Edytuj rezultat' : 'Dodaj rezultat'),expression:"workout.total_distance_done ? 'Edytuj rezultat' : 'Dodaj rezultat'"}],staticClass:"ml-auto",on:{"click":function($event){$event.stopPropagation();_vm.edit=true}}},[(!_vm.workout.total_distance_done)?_c('v-icon',{staticClass:"click-effect"},[_vm._v("add_circle_outline")]):_vm._e(),_vm._v(" "),(_vm.workout.total_distance_done)?_c('v-icon',{staticClass:"click-effect"},[_vm._v("edit")]):_vm._e()],1):_vm._e()]),_vm._v(" "),(!_vm.edit)?_c('ul',[(_vm.workout.runner_time)?_c('li',[_c('TextField',{attrs:{"label":"Tempo/Czas"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Tempo/Czas'),expression:"'Tempo/Czas'"}],staticClass:"fi flaticon-minutes ",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n            "+_vm._s(_vm.workout.runner_time)+"\n          ")])],1):_vm._e(),_vm._v(" "),(_vm.workout.runner_pulse)?_c('li',[_c('TextField',{attrs:{"label":"Tętno"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Tętno'),expression:"'Tętno'"}],staticClass:"fi flaticon-pulse-line ",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n            "+_vm._s(_vm.workout.runner_pulse)+" bpm\n          ")])],1):_vm._e(),_vm._v(" "),(_vm.workout.total_distance_done)?_c('li',[_c('TextField',{attrs:{"label":"Pokonany dystans"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Pokonany dystans'),expression:"'Pokonany dystans'"}],staticClass:"fi flaticon-road-1 ",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n            "+_vm._s(_vm.workout.total_distance_done)+" km\n          ")])],1):_vm._e(),_vm._v(" "),(_vm.workout.runner_additional_info)?_c('li',[_c('TextField',{attrs:{"label":"Informacje od zawodnika","pre":""}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Informacje od zawodnika'),expression:"'Informacje od zawodnika'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("info")]),_vm._v(_vm._s(_vm.workout.runner_additional_info)+"\n            ")],1)],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.edit && (_vm.isActiveRunnerTrainer || _vm.isActiveRunner))?_c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.saveWorkout($event)}}},[_c('v-text-field',{attrs:{"label":"Pokonany dystans","error":_vm.hasErrors('total_distance_done'),"error-messages":_vm.getErrors('total_distance_done')},model:{value:(_vm.workoutForm.total_distance_done),callback:function ($$v) {_vm.$set(_vm.workoutForm, "total_distance_done", $$v)},expression:"workoutForm.total_distance_done"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Pokonany dystans'),expression:"'Pokonany dystans'"}],staticClass:"fi flaticon-road-1",attrs:{"slot":"prepend"},slot:"prepend"})]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Tętno","error":_vm.hasErrors('runner_pulse'),"error-messages":_vm.getErrors('runner_pulse')},model:{value:(_vm.workoutForm.runner_pulse),callback:function ($$v) {_vm.$set(_vm.workoutForm, "runner_pulse", $$v)},expression:"workoutForm.runner_pulse"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Tętno'),expression:"'Tętno'"}],staticClass:"fi flaticon-pulse-line",attrs:{"slot":"prepend"},slot:"prepend"})]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Tempo/Czas","error":_vm.hasErrors('runner_time'),"error-messages":_vm.getErrors('runner_time')},model:{value:(_vm.workoutForm.runner_time),callback:function ($$v) {_vm.$set(_vm.workoutForm, "runner_time", $$v)},expression:"workoutForm.runner_time"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Czas'),expression:"'Czas'"}],staticClass:"fi flaticon-minutes",attrs:{"slot":"prepend"},slot:"prepend"})]),_vm._v(" "),_c('v-textarea',{attrs:{"label":"Informacje dodatkowe","error":_vm.hasErrors('runner_additional_info'),"error-messages":_vm.getErrors('runner_additional_info'),"auto-grow":"","box":""},model:{value:(_vm.workoutForm.runner_additional_info),callback:function ($$v) {_vm.$set(_vm.workoutForm, "runner_additional_info", $$v)},expression:"workoutForm.runner_additional_info"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Informacje dodatkowe'),expression:"'Informacje dodatkowe'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("info")])],1),_vm._v(" "),_c('div',{staticClass:"save-button-container"},[_c('v-btn',{staticClass:"very-small",attrs:{"small":"","color":"primary","type":"submit"}},[_vm._v("\n            zapisz\n            "),_c('v-icon',{attrs:{"right":"","small":""}},[_vm._v("save")])],1)],1)],1):_vm._e()],1)],2),_vm._v(" "),_c('div',{staticClass:"event-footer"},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Suma kilometrów'),expression:"'Suma kilometrów'"}]},[_c('v-icon',[_vm._v("mdi-sigma")]),_vm._v(_vm._s(_vm.workout.total_distance_done || (_vm.workout.workout_done === false ? 0 : _vm.workout.total_distance_planned))+" km")],1),_vm._v(" "),_c('span',[((_vm.isActiveRunner || _vm.isActiveRunnerTrainer) && _vm.workout.workout_done !== true)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Trening wykonany'),expression:"'Trening wykonany'"}],staticClass:"click-effect",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('done-workout')}}},[_vm._v("done")]):_vm._e(),_vm._v(" "),((_vm.isActiveRunner || _vm.isActiveRunnerTrainer) && _vm.workout.workout_done !== false)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Trening niewykonany'),expression:"'Trening niewykonany'"}],staticClass:"click-effect",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('undone-workout')}}},[_vm._v("clear")]):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkoutSmall_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7680cb72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkoutSmall_vue__ = __webpack_require__(682);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkoutSmall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7680cb72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkoutSmall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkoutElements_vue__ = __webpack_require__(321);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkoutElements_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoneWorkoutElements_vue__ = __webpack_require__(322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_272e1c46_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoneWorkoutElements_vue__ = __webpack_require__(681);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoneWorkoutElements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_272e1c46_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoneWorkoutElements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-results"},[_c('div',{staticClass:"event-results__header"},[_vm._v("\n    Rezultat zawodnika\n  ")]),_vm._v(" "),_c('ul',[(_vm.workout.total_distance_done)?_c('li',[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Zaplanowany dystans'),expression:"'Zaplanowany dystans'"}],staticClass:"fi flaticon-road-1 ",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n        "+_vm._s(_vm.allWorkoutDistances)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.workout.runner_time)?_c('li',[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Tempo/Czas'),expression:"'Tempo/Czas'"}],staticClass:"fi flaticon-minutes ",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n        "+_vm._s(_vm.workout.runner_time)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.workout.runner_pulse)?_c('li',[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Tętno'),expression:"'Tętno'"}],staticClass:"fi flaticon-pulse-line ",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n        "+_vm._s(_vm.workout.runner_pulse)+" bpm\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event workout",class:{'undone': _vm.workout.workout_done === false, 'done': _vm.workout.workout_done === true}},[_c('div',{staticClass:"event-header"},[_c('span',{staticClass:"event-date"},[_vm._v(_vm._s(_vm.workout.datetime.date()))]),_vm._v(" "),_c('span',{staticClass:"event-name",class:'style-' + _vm.workout.style},[_vm._v(_vm._s(_vm.workout.workout_type))]),_vm._v(" "),_c('span',{staticClass:"event-actions"},[(_vm.isActiveRunnerTrainer)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Edytuj'),expression:"'Edytuj'"}],staticClass:"click-effect",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('edit-workout')}}},[_vm._v("edit")]):_vm._e(),_vm._v(" "),(_vm.isActiveRunnerTrainer)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Usuń'),expression:"'Usuń'"}],staticClass:"click-effect",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove-workout')}}},[_vm._v("delete")]):_vm._e()],1)]),_vm._v(" "),(!_vm.micro)?_c('div',{staticClass:"event-content"},[(_vm.workout.total_distance_done === null)?_c('workout-elements',{attrs:{"workout":_vm.workout}}):_c('done-workout-elements',{attrs:{"workout":_vm.workout}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"event-footer"},[_c('span',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Suma kilometrów'),expression:"'Suma kilometrów'"}]},[_c('v-icon',[_vm._v("mdi-sigma")]),_vm._v(_vm._s(_vm.workout.total_distance_done || (_vm.workout.workout_done === false ? 0 : _vm.workout.total_distance_planned))+" km")],1),_vm._v(" "),(_vm.workout.additional_info)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.workout.additional_info),expression:"workout.additional_info"}]},[_c('v-icon',[_vm._v("info")])],1):_vm._e()]),_vm._v(" "),_c('span',[((_vm.isActiveRunner || _vm.isActiveRunnerTrainer) && _vm.workout.workout_done !== true)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Trening wykonany'),expression:"'Trening wykonany'"}],staticClass:"click-effect",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('done-workout')}}},[_vm._v("done")]):_vm._e(),_vm._v(" "),((_vm.isActiveRunner || _vm.isActiveRunnerTrainer) && _vm.workout.workout_done !== false)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Trening niewykonany'),expression:"'Trening niewykonany'"}],staticClass:"click-effect",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('undone-workout')}}},[_vm._v("clear")]):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkoutForm_vue__ = __webpack_require__(323);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f21c656_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkoutForm_vue__ = __webpack_require__(686);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkoutForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f21c656_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkoutForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkoutFormElement_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b41efc4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkoutFormElement_vue__ = __webpack_require__(685);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkoutFormElement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b41efc4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkoutFormElement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',[(_vm.element.types.length > 1)?_c('li',[_c('v-select',{attrs:{"label":"Typ","items":_vm.typesItems,"dense":""},on:{"change":function($event){return _vm.elementTypeChange(_vm.element, $event)}},model:{value:(_vm.element.element_type),callback:function ($$v) {_vm.$set(_vm.element, "element_type", $$v)},expression:"element.element_type"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Typ'),expression:"'Typ'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("directions_run")])],1)],1):_vm._e(),_vm._v(" "),(_vm.element.hasWarmup)?_c('li',[_c('v-text-field',{attrs:{"label":"Rozgrzewka","error":_vm.hasErrors('warmup'),"error-messages":_vm.getErrors('warmup')},model:{value:(_vm.element.warmup),callback:function ($$v) {_vm.$set(_vm.element, "warmup", $$v)},expression:"element.warmup"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Rozgrzewka'),expression:"'Rozgrzewka'"}],staticClass:"fi flaticon-people-1",attrs:{"slot":"prepend"},slot:"prepend"})])],1):_vm._e(),_vm._v(" "),(_vm.element.hasDistance)?_c('li',[_c('v-text-field',{attrs:{"label":"Dystans","error":_vm.hasErrors('distance'),"error-messages":_vm.getErrors('distance')},on:{"change":function($event){return _vm.$emit('distance-recalculate')}},model:{value:(_vm.element.distance),callback:function ($$v) {_vm.$set(_vm.element, "distance", $$v)},expression:"element.distance"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans'),expression:"'Dystans'"}],staticClass:"fi flaticon-road-1",attrs:{"slot":"prepend"},slot:"prepend"})])],1):_vm._e(),_vm._v(" "),(_vm.element.hasDistanceString)?_c('li',[_c('v-text-field',{attrs:{"label":"Dystans","error":_vm.hasErrors('distance_string'),"error-messages":_vm.getErrors('distance_string')},on:{"change":function($event){return _vm.$emit('distance-recalculate')}},model:{value:(_vm.element.distance_string),callback:function ($$v) {_vm.$set(_vm.element, "distance_string", $$v)},expression:"element.distance_string"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans'),expression:"'Dystans'"}],staticClass:"fi flaticon-road-1",attrs:{"slot":"prepend"},slot:"prepend"})])],1):_vm._e(),_vm._v(" "),(_vm.element.hasAscent)?_c('li',[_c('v-text-field',{attrs:{"label":"Podbieg","error":_vm.hasErrors('ascent'),"error-messages":_vm.getErrors('ascent')},model:{value:(_vm.element.ascent),callback:function ($$v) {_vm.$set(_vm.element, "ascent", $$v)},expression:"element.ascent"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Podbieg'),expression:"'Podbieg'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("trending_up")])],1)],1):_vm._e(),_vm._v(" "),(_vm.element.hasPulse)?_c('li',[_c('v-text-field',{attrs:{"label":"Tętno","error":_vm.hasErrors('pulse'),"error-messages":_vm.getErrors('pulse')},model:{value:(_vm.element.pulse),callback:function ($$v) {_vm.$set(_vm.element, "pulse", $$v)},expression:"element.pulse"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Tętno'),expression:"'Tętno'"}],staticClass:"fi flaticon-pulse-line",attrs:{"slot":"prepend"},slot:"prepend"})])],1):_vm._e(),_vm._v(" "),(_vm.element.hasPace)?_c('li',[_c('v-text-field',{attrs:{"label":"Tempo","error":_vm.hasErrors('pace'),"error-messages":_vm.getErrors('pace')},model:{value:(_vm.element.pace),callback:function ($$v) {_vm.$set(_vm.element, "pace", $$v)},expression:"element.pace"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Tempo'),expression:"'Tempo'"}],staticClass:"fi flaticon-minutes",attrs:{"slot":"prepend"},slot:"prepend"})])],1):_vm._e(),_vm._v(" "),(_vm.element.hasStrength)?_c('li',[_c('v-text-field',{attrs:{"label":"Siła biegowa","error":_vm.hasErrors('strength'),"error-messages":_vm.getErrors('strength')},model:{value:(_vm.element.strength),callback:function ($$v) {_vm.$set(_vm.element, "strength", $$v)},expression:"element.strength"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Siła biegowa'),expression:"'Siła biegowa'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("SB")])])],1):_vm._e(),_vm._v(" "),(_vm.element.hasRepeats)?_c('li',[_c('v-text-field',{attrs:{"label":"Rytmy","error":_vm.hasErrors('repeats'),"error-messages":_vm.getErrors('repeats')},model:{value:(_vm.element.repeats),callback:function ($$v) {_vm.$set(_vm.element, "repeats", $$v)},expression:"element.repeats"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Rytmy'),expression:"'Rytmy'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("R")])])],1):_vm._e(),_vm._v(" "),(_vm.element.hasBreak)?_c('li',[_c('v-text-field',{attrs:{"label":"Przerwa","error":_vm.hasErrors('break_time'),"error-messages":_vm.getErrors('break_time')},model:{value:(_vm.element.break_time),callback:function ($$v) {_vm.$set(_vm.element, "break_time", $$v)},expression:"element.break_time"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Przerwa'),expression:"'Przerwa'"}],staticClass:"fi flaticon-people",attrs:{"slot":"prepend"},slot:"prepend"})])],1):_vm._e(),_vm._v(" "),(_vm.element.hasDescent)?_c('li',[_c('v-text-field',{attrs:{"label":"Zbieg","error":_vm.hasErrors('descent'),"error-messages":_vm.getErrors('descent')},model:{value:(_vm.element.descent),callback:function ($$v) {_vm.$set(_vm.element, "descent", $$v)},expression:"element.descent"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Zbieg'),expression:"'Zbieg'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("trending_down")])],1)],1):_vm._e(),_vm._v(" "),(_vm.element.hasTrip)?_c('li',[_c('v-text-field',{attrs:{"label":"Miejsce","error":_vm.hasErrors('trip_place'),"error-messages":_vm.getErrors('trip_place')},model:{value:(_vm.element.trip_place),callback:function ($$v) {_vm.$set(_vm.element, "trip_place", $$v)},expression:"element.trip_place"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Miejsce'),expression:"'Miejsce'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("place")])],1)],1):_vm._e(),_vm._v(" "),(_vm.element.hasTrip)?_c('li',[_c('v-text-field',{attrs:{"label":"Miejsce (link)","error":_vm.hasErrors('trip_link'),"error-messages":_vm.getErrors('trip_link')},model:{value:(_vm.element.trip_link),callback:function ($$v) {_vm.$set(_vm.element, "trip_link", $$v)},expression:"element.trip_link"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Miejsce (link)'),expression:"'Miejsce (link)'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("insert_link")])],1)],1):_vm._e(),_vm._v(" "),(_vm.element.hasCooling)?_c('li',[_c('v-text-field',{attrs:{"label":"Schłodzenie","error":_vm.hasErrors('cooling'),"error-messages":_vm.getErrors('cooling')},model:{value:(_vm.element.cooling),callback:function ($$v) {_vm.$set(_vm.element, "cooling", $$v)},expression:"element.cooling"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Schłodzenie'),expression:"'Schłodzenie'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("C")])])],1):_vm._e(),_vm._v(" "),(_vm.element.hasOther)?_c('li',[_c('v-text-field',{attrs:{"label":"Inny trening","error":_vm.hasErrors('other'),"error-messages":_vm.getErrors('other')},model:{value:(_vm.element.other),callback:function ($$v) {_vm.$set(_vm.element, "other", $$v)},expression:"element.other"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Inny trening'),expression:"'Inny trening'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("short_text")])],1)],1):_vm._e()]),_vm._v(" "),(_vm.element.multiple)?_c('div',{staticClass:"element-actions"},[(_vm.element.multiple)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dodaj'),expression:"'Dodaj'"}],staticClass:"click-effect",on:{"click":function($event){$event.stopPropagation();return _vm.addNewElement(_vm.element)}}},[_vm._v("add_circle_outline")]):_vm._e(),_vm._v(" "),(_vm.element.next)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Usuń'),expression:"'Usuń'"}],staticClass:"click-effect",on:{"click":function($event){$event.stopPropagation();return _vm.removeElement(_vm.element)}}},[_vm._v("remove_circle_outline")]):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bigEvent newEvent workout",class:{floating: !_vm.inplace},style:(_vm.inplace ? {} : {left: _vm.ev.position.left + 'px', top: _vm.ev.position.top + 'px'})},[_c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.saveWorkout($event)}}},[_c('div',{staticClass:"event-header"},[_c('span',{staticClass:"event-date"},[_vm._v(_vm._s(_vm.ev.datetime.date())+" "),(_vm.$mq == 'sm')?[_vm._v("("+_vm._s(_vm.ev.datetime.format('ddd'))+")")]:_vm._e()],2),_vm._v(" "),_c('span',{staticClass:"event-name"},[_c('v-select',{staticClass:"event-select",attrs:{"items":_vm.allWorkoutsTemplatesOptions,"dark":"","dense":""},on:{"change":_vm.workoutTypeChange},model:{value:(_vm.workout.workout_type),callback:function ($$v) {_vm.$set(_vm.workout, "workout_type", $$v)},expression:"workout.workout_type"}})],1),_vm._v(" "),_c('span',{staticClass:"event-actions"},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Zamknij'),expression:"'Zamknij'"}],staticClass:"click-effect ml-2",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_vm._v("close")])],1)]),_vm._v(" "),_c('div',{staticClass:"event-content"},[_vm._l((_vm.workout.elements),function(el,index){return _c('workout-form-element',{key:index,attrs:{"element":el,"errors":_vm.errors.elements ? _vm.errors.elements[index] : {}},on:{"remove-element":_vm.removeElement,"add-element":_vm.addNewElement,"type-change-element":_vm.elementTypeChange,"distance-recalculate":_vm.distanceRecalculate}})}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Suma kilometrów","error":_vm.hasErrors('total_distance_planned'),"error-messages":_vm.getErrors('total_distance_planned')},model:{value:(_vm.workout.total_distance_planned),callback:function ($$v) {_vm.$set(_vm.workout, "total_distance_planned", $$v)},expression:"workout.total_distance_planned"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Suma kilometrów'),expression:"'Suma kilometrów'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("mdi-sigma")])],1),_vm._v(" "),_c('v-textarea',{attrs:{"label":"Informacje dodatkowe","error":_vm.hasErrors('additional_info'),"error-messages":_vm.getErrors('additional_info'),"auto-grow":"","box":""},model:{value:(_vm.workout.additional_info),callback:function ($$v) {_vm.$set(_vm.workout, "additional_info", $$v)},expression:"workout.additional_info"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Informacje dodatkowe'),expression:"'Informacje dodatkowe'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("info")])],1),_vm._v(" "),_c('div',{staticClass:"save-button-container"},[_c('v-btn',{staticClass:"very-small",attrs:{"small":"","color":"primary","type":"submit"}},[_vm._v("\n        zapisz\n        "),_c('v-icon',{attrs:{"right":"","small":""}},[_vm._v("save")])],1)],1)],2),_vm._v(" "),_c('div',{staticClass:"event-footer"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceBig_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_131cdd0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceBig_vue__ = __webpack_require__(688);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceBig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_131cdd0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceBig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bigEvent race",class:{floating: !_vm.inplace},style:(_vm.inplace ? {} : {left: _vm.race.position.left + 'px', top: _vm.race.position.top + 'px'})},[_c('div',{staticClass:"event-header"},[_c('span',{staticClass:"event-date"},[_vm._v(_vm._s(_vm.race.datetime.date())+" "),(_vm.$mq == 'sm')?[_vm._v("("+_vm._s(_vm.race.datetime.format('ddd'))+")")]:_vm._e()],2),_vm._v(" "),_c('span',{staticClass:"event-name"},[_vm._v("ZAWODY")]),_vm._v(" "),_c('span',{staticClass:"event-actions"},[(_vm.isActiveRunnerTrainer || _vm.isActiveRunner)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Edytuj'),expression:"'Edytuj'"}],staticClass:"click-effect",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('edit-race')}}},[_vm._v("edit")]):_vm._e(),_vm._v(" "),(_vm.isActiveRunnerTrainer || _vm.isActiveRunner)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Usuń'),expression:"'Usuń'"}],staticClass:"click-effect",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove-race')}}},[_vm._v("delete")]):_vm._e(),_vm._v(" "),(!_vm.inplace)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Zamknij'),expression:"'Zamknij'"}],staticClass:"click-effect ml-2",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_vm._v("close")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"event-content"},[_c('div',{staticClass:"event-content__header"},[_vm._v("\n      Zaplanowane zawody\n      "),(_vm.isActiveRunnerTrainer || _vm.isActiveRunner)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Edytuj zawody'),expression:"'Edytuj zawody'"}],staticClass:"click-effect",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('edit-race')}}},[_vm._v("edit")]):_vm._e()],1),_vm._v(" "),_c('ul',[(_vm.measureable)?_c('li',[_c('TextField',{attrs:{"label":"Dystans"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans'),expression:"'Dystans'"}],staticClass:"fi flaticon-road-1",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n          "+_vm._s(_vm.race.race_type_name)+": "+_vm._s(_vm.race.distance_string_name)+"\n        ")])],1):_vm._e(),_vm._v(" "),(!_vm.measureable)?_c('li',[_c('TextField',{attrs:{"label":"Dystans"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans'),expression:"'Dystans'"}],staticClass:"fi flaticon-road-1",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n          "+_vm._s(_vm.race.race_type_name)+": "+_vm._s(_vm.race.distance_km)+" km\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.race.race_type === 'street')?_c('li',[_c('TextField',{attrs:{"label":"Atest"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Atest'),expression:"'Atest'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("spellcheck")]),_vm._v("\n          "+_vm._s(_vm.race.certified ? 'Tak': 'Nie')+"\n        ")],1)],1):_vm._e(),_vm._v(" "),_c('li',[_c('TextField',{attrs:{"label":"Priorytet"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Priorytet'),expression:"'Priorytet'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("P")]),_vm._v("\n          "+_vm._s(_vm.race.priority)+"\n        ")])],1),_vm._v(" "),_c('li',[_c('TextField',{attrs:{"label":"Nazwa"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Nazwa'),expression:"'Nazwa'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("N")]),_vm._v("\n          "+_vm._s(_vm.race.name)+"\n        ")])],1),_vm._v(" "),_c('li',[_c('TextField',{attrs:{"label":"Miasto"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Miasto'),expression:"'Miasto'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("location_city")]),_vm._v("\n          "+_vm._s(_vm.race.city)+"\n        ")],1)],1)]),_vm._v(" "),(_vm.race.trainer_remarks)?_c('div',[_c('TextField',{attrs:{"label":"Informacje od trenera"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Informacje od trenera'),expression:"'Informacje od trenera'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("info")]),_vm._v("\n          "+_vm._s(_vm.race.trainer_remarks)+"\n        ")],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"event-results"},[_c('div',{staticClass:"event-results__header"},[_vm._v("\n        Rezultat zawodnika\n        "),(!_vm.edit && (_vm.isActiveRunnerTrainer || _vm.isActiveRunner))?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.race.time ? 'Edytuj wynik' : 'Dodaj wynik'),expression:"race.time ? 'Edytuj wynik' : 'Dodaj wynik'"}],staticClass:"ml-auto",on:{"click":function($event){$event.stopPropagation();_vm.edit=true}}},[(!_vm.race.time)?_c('v-icon',{staticClass:"click-effect"},[_vm._v("add_circle_outline")]):_vm._e(),_vm._v(" "),(_vm.race.time)?_c('v-icon',{staticClass:"click-effect"},[_vm._v("edit")]):_vm._e()],1):_vm._e()]),_vm._v(" "),(!_vm.edit)?_c('ul',[(_vm.race.time)?_c('li',[_c('TextField',{attrs:{"label":"Czas"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Czas'),expression:"'Czas'"}],staticClass:"fi flaticon-minutes ",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n            "+_vm._s(_vm.race.time)+"\n          ")])],1):_vm._e(),_vm._v(" "),(_vm.race.place)?_c('li',[_c('TextField',{attrs:{"label":"Miejsce"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Miejsce'),expression:"'Miejsce'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("M")]),_vm._v("\n            "+_vm._s(_vm.race.place)+"\n          ")])],1):_vm._e(),_vm._v(" "),(_vm.race.post_remarks)?_c('li',[_c('TextField',{attrs:{"label":"Informacje od zawodnika","pre":""}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Informacje od zawodnika'),expression:"'Informacje od zawodnika'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("info")]),_vm._v(_vm._s(_vm.race.post_remarks)+"\n            ")],1)],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.edit && (_vm.isActiveRunnerTrainer || _vm.isActiveRunner))?_c('v-form',{attrs:{"inline":"","novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.saveRace($event)}}},[_c('v-text-field',{attrs:{"label":"Czas","error":_vm.hasErrors('time'),"error-messages":_vm.getErrors('time'),"placeholder":"H:M:S"},model:{value:(_vm.raceForm.time),callback:function ($$v) {_vm.$set(_vm.raceForm, "time", $$v)},expression:"raceForm.time"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Czas'),expression:"'Czas'"}],staticClass:"fi flaticon-minutes",attrs:{"slot":"prepend"},slot:"prepend"})]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Miejsce","error":_vm.hasErrors('place'),"error-messages":_vm.getErrors('place')},model:{value:(_vm.raceForm.place),callback:function ($$v) {_vm.$set(_vm.raceForm, "place", $$v)},expression:"raceForm.place"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Miejsce'),expression:"'Miejsce'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("M")])]),_vm._v(" "),_c('v-textarea',{attrs:{"label":"Informacje dodatkowe","error":_vm.hasErrors('post_remarks'),"error-messages":_vm.getErrors('post_remarks'),"auto-grow":"","box":""},model:{value:(_vm.raceForm.post_remarks),callback:function ($$v) {_vm.$set(_vm.raceForm, "post_remarks", $$v)},expression:"raceForm.post_remarks"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Informacje dodatkowe'),expression:"'Informacje dodatkowe'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("info")])],1),_vm._v(" "),_c('div',{staticClass:"save-button-container"},[_c('v-btn',{staticClass:"very-small",attrs:{"small":"","dark":"","color":"tertiary","type":"submit"}},[_vm._v("\n            zapisz\n            "),_c('v-icon',{attrs:{"right":"","small":""}},[_vm._v("save")])],1)],1)],1):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"event-footer"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceSmall_vue__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_257d1c70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceSmall_vue__ = __webpack_require__(690);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceSmall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_257d1c70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceSmall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event race"},[_c('div',{staticClass:"event-header"},[_c('span',{staticClass:"event-date"},[_vm._v(_vm._s(_vm.race.datetime.date()))]),_vm._v(" "),_c('span',{staticClass:"event-name"},[_vm._v("ZAWODY")]),_vm._v(" "),_c('span',{staticClass:"event-actions"},[(_vm.isActiveRunnerTrainer || _vm.isActiveRunner)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Edytuj'),expression:"'Edytuj'"}],staticClass:"click-effect",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('edit-race')}}},[_vm._v("edit")]):_vm._e(),_vm._v(" "),(_vm.isActiveRunnerTrainer || _vm.isActiveRunner)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Usuń'),expression:"'Usuń'"}],staticClass:"click-effect",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove-race')}}},[_vm._v("delete")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"event-content"},[_c('ul',[(!_vm.measureable)?_c('li',[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans'),expression:"'Dystans'"}],staticClass:"fi flaticon-road-1 mr-1"}),_vm._v(" "+_vm._s(_vm.race.race_type_name)+": "+_vm._s(_vm.race.distance_km)+" km")]):_vm._e(),_vm._v(" "),(_vm.measureable)?_c('li',[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans'),expression:"'Dystans'"}],staticClass:"fi flaticon-road-1 mr-1"}),_vm._v(" "+_vm._s(_vm.race.race_type_name)+": "+_vm._s(_vm.race.distance_string_name))]):_vm._e(),_vm._v(" "),_c('li',[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Priorytet'),expression:"'Priorytet'"}],staticClass:"text-icon mr-1"},[_vm._v("P")]),_vm._v(" "+_vm._s(_vm.race.priority))]),_vm._v(" "),_c('li',[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Nazwa'),expression:"'Nazwa'"}],staticClass:"text-icon mr-1"},[_vm._v("N")]),_vm._v(" "+_vm._s(_vm.race.name))])])]),_vm._v(" "),_c('div',{staticClass:"event-footer"},[_c('span'),_vm._v(" "),(_vm.race.trainer_remarks)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.race.trainer_remarks),expression:"race.trainer_remarks"}]},[_c('v-icon',[_vm._v("info")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceForm_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f822a59_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceForm_vue__ = __webpack_require__(692);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f822a59_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bigEvent newEvent race",class:{floating: !_vm.inplace},style:(_vm.inplace ? {} : {left: _vm.ev.position.left + 'px', top: _vm.ev.position.top + 'px'})},[_c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.saveRace($event)}}},[_c('div',{staticClass:"event-header"},[_c('span',{staticClass:"event-date"},[_vm._v(_vm._s(_vm.ev.datetime.date())+" "),(_vm.$mq == 'sm')?[_vm._v("("+_vm._s(_vm.ev.datetime.format('ddd'))+")")]:_vm._e()],2),_vm._v(" "),_c('span',{staticClass:"event-name"},[_vm._v("\n      ZAWODY\n    ")]),_vm._v(" "),_c('span',{staticClass:"event-actions"},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Zamknij'),expression:"'Zamknij'"}],staticClass:"click-effect ml-2",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_vm._v("close")])],1)]),_vm._v(" "),_c('div',{staticClass:"event-content"},[_c('ul',[_c('li',[_c('v-text-field',{attrs:{"label":"Nazwa","error":_vm.hasErrors('name'),"error-messages":_vm.getErrors('name')},model:{value:(_vm.race.name),callback:function ($$v) {_vm.$set(_vm.race, "name", $$v)},expression:"race.name"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Nazwa'),expression:"'Nazwa'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("N")])])],1),_vm._v(" "),_c('li',[_c('v-text-field',{attrs:{"label":"Miasto","error":_vm.hasErrors('city'),"error-messages":_vm.getErrors('city')},model:{value:(_vm.race.city),callback:function ($$v) {_vm.$set(_vm.race, "city", $$v)},expression:"race.city"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Miasto'),expression:"'Miasto'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("location_city")])],1)],1),_vm._v(" "),_c('li',[_c('v-select',{attrs:{"items":_vm.allRaceTypesStringsOptions,"label":"Rodzaj","error":_vm.hasErrors('race_type'),"error-messages":_vm.getErrors('race_type')},on:{"change":_vm.changeRaceType},model:{value:(_vm.race.race_type),callback:function ($$v) {_vm.$set(_vm.race, "race_type", $$v)},expression:"race.race_type"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Nazwa'),expression:"'Nazwa'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("R")])])],1),_vm._v(" "),(['street', 'track'].indexOf(_vm.race.race_type) > -1)?_c('li',[_c('v-select',{attrs:{"label":"Dystans","items":_vm.distanceOptions,"error":_vm.hasErrors('distance_string'),"error-messages":_vm.getErrors('distance_string')},model:{value:(_vm.race.distance_string),callback:function ($$v) {_vm.$set(_vm.race, "distance_string", $$v)},expression:"race.distance_string"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans'),expression:"'Dystans'"}],staticClass:"fi flaticon-road-1",attrs:{"slot":"prepend"},slot:"prepend"})])],1):_vm._e(),_vm._v(" "),(['other', 'ultra'].indexOf(_vm.race.distance_string) > -1)?_c('li',[_c('v-text-field',{attrs:{"label":"Dystans w kilometrach","error":_vm.hasErrors('distance_km'),"error-messages":_vm.getErrors('distance_km')},model:{value:(_vm.race.distance_km),callback:function ($$v) {_vm.$set(_vm.race, "distance_km", $$v)},expression:"race.distance_km"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans w kilometrach'),expression:"'Dystans w kilometrach'"}],staticClass:"fi flaticon-road-1",attrs:{"slot":"prepend"},slot:"prepend"})])],1):_vm._e(),_vm._v(" "),(_vm.race.race_type === 'street')?_c('li',[_c('v-checkbox',{attrs:{"label":"Atest","error":_vm.hasErrors('certified'),"error-messages":_vm.getErrors('certified')},model:{value:(_vm.race.certified),callback:function ($$v) {_vm.$set(_vm.race, "certified", $$v)},expression:"race.certified"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Atest'),expression:"'Atest'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("spellcheck")])],1)],1):_vm._e(),_vm._v(" "),_c('li',[_c('v-select',{attrs:{"label":"Priorytet","items":_vm.allRacePrioritiesOptions,"error":_vm.hasErrors('priority'),"error-messages":_vm.getErrors('priority'),"dense":""},model:{value:(_vm.race.priority),callback:function ($$v) {_vm.$set(_vm.race, "priority", $$v)},expression:"race.priority"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Priorytet'),expression:"'Priorytet'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("P")])])],1)]),_vm._v(" "),_c('v-textarea',{attrs:{"label":"Informacje dodatkowe","error":_vm.hasErrors('trainer_remarks'),"error-messages":_vm.getErrors('trainer_remarks'),"auto-grow":"","box":""},model:{value:(_vm.race.trainer_remarks),callback:function ($$v) {_vm.$set(_vm.race, "trainer_remarks", $$v)},expression:"race.trainer_remarks"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Informacje dodatkowe'),expression:"'Informacje dodatkowe'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("info")])],1),_vm._v(" "),_c('div',{staticClass:"save-button-container"},[_c('v-btn',{staticClass:"very-small",attrs:{"small":"","dark":"","color":"tertiary","type":"submit"}},[_vm._v("\n        zapisz\n        "),_c('v-icon',{attrs:{"right":"","small":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"event-footer"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityBig_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e11cfa9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityBig_vue__ = __webpack_require__(694);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityBig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e11cfa9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityBig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bigEvent activity",class:{floating: !_vm.inplace},style:(_vm.inplace ? {} : {left: _vm.activity.position.left + 'px', top: _vm.activity.position.top + 'px'})},[_c('div',{staticClass:"event-header"},[_c('span',{staticClass:"event-date"},[_vm._v(_vm._s(_vm.activity.datetime.date())+" "),(_vm.$mq == 'sm')?[_vm._v("("+_vm._s(_vm.activity.datetime.format('ddd'))+")")]:_vm._e()],2),_vm._v(" "),_c('span',{staticClass:"event-name"},[_vm._v("AKTYWNOŚĆ")]),_vm._v(" "),_c('span',{staticClass:"event-actions"},[(_vm.isActiveRunner)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Edytuj'),expression:"'Edytuj'"}],staticClass:"click-effect",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('edit-activity')}}},[_vm._v("edit")]):_vm._e(),_vm._v(" "),(_vm.isActiveRunner)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Usuń'),expression:"'Usuń'"}],staticClass:"click-effect",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove-activity')}}},[_vm._v("delete")]):_vm._e(),_vm._v(" "),(!_vm.inplace)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Zamknij'),expression:"'Zamknij'"}],staticClass:"click-effect ml-2",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_vm._v("close")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"event-content"},[_c('div',{staticClass:"event-content__header"},[_vm._v("\n      Wykonana aktywność\n      "),(_vm.isActiveRunner)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Edytuj aktywność'),expression:"'Edytuj aktywność'"}],staticClass:"click-effect",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('edit-activity')}}},[_vm._v("edit")]):_vm._e()],1),_vm._v(" "),_c('ul',[_c('li',[_c('TextField',{attrs:{"label":"Opis","pre":""}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Opis'),expression:"'Opis'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("O")]),_vm._v(_vm._s(_vm.activity.runner_additional_info)+"\n        ")])],1),_vm._v(" "),_c('li',[_c('TextField',{attrs:{"label":"Dystans"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans'),expression:"'Dystans'"}],staticClass:"fi flaticon-road-1",attrs:{"slot":"prepend"},slot:"prepend"}),_vm._v("\n          "+_vm._s(_vm.activity.total_distance_done)+"\n        ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"event-footer"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivitySmall_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1daa8062_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivitySmall_vue__ = __webpack_require__(696);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivitySmall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1daa8062_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivitySmall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event activity"},[_c('div',{staticClass:"event-header"},[_c('span',{staticClass:"event-date"},[_vm._v(_vm._s(_vm.activity.datetime.date()))]),_vm._v(" "),_c('span',{staticClass:"event-name"},[_vm._v("AKTYWNOŚĆ")]),_vm._v(" "),_c('span',{staticClass:"event-actions"},[(_vm.isActiveRunner)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Edytuj'),expression:"'Edytuj'"}],staticClass:"click-effect",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('edit-activity')}}},[_vm._v("edit")]):_vm._e(),_vm._v(" "),(_vm.isActiveRunner)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Usuń'),expression:"'Usuń'"}],staticClass:"click-effect",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove-activity')}}},[_vm._v("delete")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"event-content"},[_c('ul',[_c('li',[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Opis'),expression:"'Opis'"}],staticClass:"text-icon mr-1"},[_vm._v("O")]),_vm._v(" "+_vm._s(_vm.activity.runner_additional_info))]),_vm._v(" "),_c('li',[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans'),expression:"'Dystans'"}],staticClass:"fi flaticon-road-1 mr-1"}),_vm._v(" "+_vm._s(_vm.activity.total_distance_done))])])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-footer"},[_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityForm_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab29625e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityForm_vue__ = __webpack_require__(698);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab29625e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bigEvent newEvent activity",class:{floating: !_vm.inplace},style:(_vm.inplace ? {} : {left: _vm.ev.position.left + 'px', top: _vm.ev.position.top + 'px'})},[_c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.saveActivity($event)}}},[_c('div',{staticClass:"event-header"},[_c('span',{staticClass:"event-date"},[_vm._v(_vm._s(_vm.ev.datetime.date())+" "),(_vm.$mq == 'sm')?[_vm._v("("+_vm._s(_vm.ev.datetime.format('ddd'))+")")]:_vm._e()],2),_vm._v(" "),_c('span',{staticClass:"event-name"},[_vm._v("\n      AKTYWNOŚĆ\n    ")]),_vm._v(" "),_c('span',{staticClass:"event-actions"},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Zamknij'),expression:"'Zamknij'"}],staticClass:"click-effect ml-2",attrs:{"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_vm._v("close")])],1)]),_vm._v(" "),_c('div',{staticClass:"event-content"},[_c('ul',[_c('li',[_c('v-textarea',{attrs:{"label":"Opis","error":_vm.hasErrors('runner_additional_info'),"error-messages":_vm.getErrors('runner_additional_info'),"auto-grow":"","box":""},model:{value:(_vm.activity.runner_additional_info),callback:function ($$v) {_vm.$set(_vm.activity, "runner_additional_info", $$v)},expression:"activity.runner_additional_info"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Opis'),expression:"'Opis'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("O")])])],1),_vm._v(" "),_c('li',[_c('v-text-field',{attrs:{"label":"Dystans","error":_vm.hasErrors('total_distance_done'),"error-messages":_vm.getErrors('total_distance_done')},model:{value:(_vm.activity.total_distance_done),callback:function ($$v) {_vm.$set(_vm.activity, "total_distance_done", $$v)},expression:"activity.total_distance_done"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans'),expression:"'Dystans'"}],staticClass:"fi flaticon-road-1",attrs:{"slot":"prepend"},slot:"prepend"})])],1)]),_vm._v(" "),_c('div',{staticClass:"save-button-container"},[_c('v-btn',{staticClass:"very-small",attrs:{"small":"","dark":"","color":"accent","type":"submit"}},[_vm._v("\n        zapisz\n        "),_c('v-icon',{attrs:{"right":"","small":""}},[_vm._v("save")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"event-footer"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanComments_vue__ = __webpack_require__(331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b2a4370_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlanComments_vue__ = __webpack_require__(705);
function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanComments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b2a4370_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlanComments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanComment_vue__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_430788be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlanComment_vue__ = __webpack_require__(702);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanComment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_430788be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlanComment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-content',[_c('v-list-tile-sub-title',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.comment.user_full_name)+" "+_vm._s(_vm._f("formatDate")(_vm.comment.created_at,'LLL')))]),_vm._v(" "),_c('div',{staticClass:"pa-3",domProps:{"innerHTML":_vm._s(_vm.content)}})],1),_vm._v(" "),(_vm.comment.user === _vm.authUser.user)?_c('v-list-tile-action',[_c('rp-icon',{attrs:{"type":"edit","tooltip":"edytuj"},on:{"click":function($event){return _vm.$emit('change-comment')}}}),_vm._v(" "),_c('rp-icon',{attrs:{"type":"delete","tooltip":"usuń"},on:{"click":function($event){return _vm.$emit('remove-comment')}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanCommentForm_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a28c8ff_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlanCommentForm_vue__ = __webpack_require__(704);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanCommentForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a28c8ff_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlanCommentForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('Fields',_vm._b({},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false)),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Wyślij")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-3"},[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("\n        Komentarze\n      ")])],1),_vm._v(" "),(_vm.isActiveRunnerTrainer || _vm.isActiveRunner)?_c('div',{staticClass:"pa-3"},[_c('plan-comment-form',{attrs:{"month":_vm.month},on:{"success":_vm.addComment}})],1):_vm._e(),_vm._v(" "),_c('v-data-iterator',{staticClass:"comments",attrs:{"items":_vm.commentsList,"pagination":_vm.context,"rows-per-page-items":_vm.perPageOptions,"total-items":_vm.rowsTotal,"loading":_vm.loading,"content-tag":"v-list","content-props":{twoLine: true}},on:{"update:pagination":function($event){_vm.context=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return [(!props.item.edit)?_c('plan-comment',{attrs:{"comment":props.item},on:{"change-comment":function($event){return _vm.changeComment(props.item)},"remove-comment":function($event){return _vm.removeComment(props.item)}}}):_vm._e(),_vm._v(" "),(props.item.edit)?_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-content',{staticClass:"d-block"},[_c('plan-comment-form',{attrs:{"comment":props.item},on:{"success":function($event){props.item.edit = false; _vm.refresh()}}})],1)],1):_vm._e(),_vm._v(" "),_c('v-divider')]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanRaces_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5157b8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlanRaces_vue__ = __webpack_require__(707);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanRaces_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5157b8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlanRaces_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-datatable"},[_c('v-card',{staticClass:"mt-2 pb-1"},[_c('v-card-title',[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("\n          Najbliższe zawody\n        ")])],1),_vm._v(" "),_c('v-form',{staticClass:"flex"},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl4":""}},[_c('v-select',{attrs:{"items":[{text: 'A', value: 'A'}, {text: 'B', value: 'B'}, {text: 'C', value: 'C'}],"label":"Priorytet","clearable":""},model:{value:(_vm.context.priority),callback:function ($$v) {_vm.$set(_vm.context, "priority", $$v)},expression:"context.priority"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl4":""}},[_c('v-select',{attrs:{"items":_vm.allRaceTypesStringsOptions,"label":"Rodzaj","clearable":""},model:{value:(_vm.context.raceType),callback:function ($$v) {_vm.$set(_vm.context, "raceType", $$v)},expression:"context.raceType"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl4":""}},[_c('v-select',{attrs:{"items":_vm.allRaceDistanceStringsOptions,"label":"Dystans (tylko uliczne i bieżnia)","clearable":""},model:{value:(_vm.context.distance),callback:function ($$v) {_vm.$set(_vm.context, "distance", $$v)},expression:"context.distance"}})],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.races,"pagination":_vm.context,"rows-per-page-items":_vm.perPageOptions,"total-items":_vm.rowsTotal,"loading":_vm.loading},on:{"update:pagination":function($event){_vm.context=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.race_type_name))]),_vm._v(" "),(['other', 'ultra'].indexOf(props.item.distance_string) > -1)?_c('td',[_vm._v(_vm._s(props.item.distance_km)+" km")]):_vm._e(),_vm._v(" "),(['other', 'ultra'].indexOf(props.item.distance_string) === -1)?_c('td',[_vm._v(_vm._s(props.item.distance_string_name))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.priority))]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.formatDate(props.item.race_date)),expression:"formatDate(props.item.race_date)"}]},[_vm._v(_vm._s(_vm.weeksToRace(props.item.race_date)))])])])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-text"},[(!_vm.mini)?[(_vm.status==='denied')?_c('p',[_vm._v("\n      Powiadomienia zostały zablokowane. Należy odblokować je w opcjach przeglądarki oraz odświeżyć aplikację.\n    ")]):_vm._e(),_vm._v(" "),(_vm.status==='granted')?_c('p',[_vm._v("\n      Powiadomienia dla tej przeglądarki są włączone.\n      "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":_vm.unsubscribe}},[_vm._v("Wyłącz")])],1):_vm._e(),_vm._v(" "),(_vm.status==='unsupported')?_c('p',[_vm._v("\n      Ta przeglądarka nie obsługuje powiadomień.\n    ")]):_vm._e(),_vm._v(" "),(_vm.status==='ready')?_c('p',[_vm._v("\n      Aby otrzymywać powiadomienia push bezpośrednio do przeglądarki\n      "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":_vm.subscribe}},[_vm._v("Włącz powiadomienia")])],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.mini && _vm.status==='ready')?_c('p',[_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":_vm.subscribe}},[_vm._v("Włącz powiadomienia")])],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerHeartRate_vue__ = __webpack_require__(338);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2697cc3a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerHeartRate_vue__ = __webpack_require__(711);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerHeartRate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2697cc3a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerHeartRate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_vm._v("\n  OWB1:\n  "),(!_vm.edit)?_c('span',[_vm._v(_vm._s(_vm.heart_rate_zone)+" "),(_vm.runner.real_heart_rate_zone)?_c('span',[_vm._v("bpm")]):_c('span',[_vm._v("min/km")]),_vm._v(" "),(_vm.isActiveRunnerTrainer && !_vm.runner.real_heart_rate_zone)?_c('rp-icon',{attrs:{"type":"edit","tooltip":"edytuj"},on:{"click":function($event){_vm.edit=true}}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.edit)?_c('v-form',{staticClass:"d-inline-block",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('v-text-field',{staticClass:"d-inline-block",model:{value:(_vm.form.heart_rate_zone),callback:function ($$v) {_vm.$set(_vm.form, "heart_rate_zone", $$v)},expression:"form.heart_rate_zone"}}),_vm._v("\n    min/km\n    "),_c('v-btn',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Zapisz'),expression:"'Zapisz'"}],attrs:{"icon":"","type":"submit"}},[_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v("\n        save\n      ")])],1),_vm._v(" "),_c('rp-icon',{attrs:{"type":"clear","tooltip":"anuluj"},on:{"click":function($event){_vm.edit=false}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 712 */,
/* 713 */,
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CopyWorkoutDialog_vue__ = __webpack_require__(339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78793ed4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CopyWorkoutDialog_vue__ = __webpack_require__(715);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CopyWorkoutDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78793ed4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CopyWorkoutDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.options.width},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.cancel($event)}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":_vm.options.color,"dense":"","flat":""}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Wybierz zawodnika")])],1),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"label":"Zawodnik","items":_vm.options.runners},model:{value:(_vm.runner),callback:function ($$v) {_vm.runner=$$v},expression:"runner"}})],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pt-0"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.options.color + ' darken-1',"flat":"flat"},nativeOn:{"click":function($event){return _vm.agree($event)}}},[_vm._v("Kopiuj")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey","flat":"flat"},nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v("Anuluj")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 716 */,
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan"},[_c('copy-workout-dialog',{ref:"copyWorkout"}),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-layout',[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md4":""}},[(_vm.$mq !== 'sm')?_c('span',{staticClass:"d-inline-block"},[_c('v-btn',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('poprzedni'),expression:"'poprzedni'"}],staticClass:"upper",attrs:{"flat":"","small":"","icon":""},on:{"click":function($event){return _vm.prevMonth()}}},[_c('v-icon',[_vm._v("\n                    keyboard_arrow_left\n                  ")])],1),_vm._v(" "),_c('v-menu',{ref:"menu1",staticClass:"d-inline-block",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.currentDateD,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.currentDateD=$event},"update:return-value":function($event){_vm.currentDateD=$event}},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{staticClass:"small-input",attrs:{"slot":"activator","label":"","readonly":""},slot:"activator",model:{value:(_vm.currentDateString),callback:function ($$v) {_vm.currentDateString=$$v},expression:"currentDateString"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"type":"month","no-title":"","locale":"pl"},on:{"change":_vm.changeCurrentDateD,"input":function($event){return _vm.$refs.menu1.save(_vm.currentDateD)}},model:{value:(_vm.currentDateD),callback:function ($$v) {_vm.currentDateD=$$v},expression:"currentDateD"}})],1),_vm._v(" "),_c('v-btn',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('następny'),expression:"'następny'"}],staticClass:"upper",attrs:{"flat":"","small":"","icon":""},on:{"click":function($event){return _vm.nextMonth()}}},[_c('v-icon',[_vm._v("\n                    keyboard_arrow_right\n                  ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.$mq === 'sm')?_c('span',{staticClass:"d-inline-block"},[_c('v-btn',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('poprzedni'),expression:"'poprzedni'"}],staticClass:"upper",attrs:{"flat":"","small":"","icon":""},on:{"click":function($event){return _vm.prevWeek()}}},[_c('v-icon',[_vm._v("\n                    keyboard_arrow_left\n                  ")])],1),_vm._v(" "),_c('v-menu',{ref:"menu2",staticClass:"d-inline-block",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.currentDateWeekD,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.currentDateWeekD=$event},"update:return-value":function($event){_vm.currentDateWeekD=$event}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"","readonly":""},slot:"activator",model:{value:(_vm.currentDateWeekString),callback:function ($$v) {_vm.currentDateWeekString=$$v},expression:"currentDateWeekString"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"first-day-of-week":"1","no-title":"","locale":"pl"},on:{"change":_vm.changeCurrentDateWeekD,"input":function($event){return _vm.$refs.menu2.save(_vm.currentDateWeekD)}},model:{value:(_vm.currentDateWeekD),callback:function ($$v) {_vm.currentDateWeekD=$$v},expression:"currentDateWeekD"}})],1),_vm._v(" "),_c('v-btn',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('następny'),expression:"'następny'"}],staticClass:"upper",attrs:{"flat":"","small":"","icon":""},on:{"click":function($event){return _vm.nextWeek()}}},[_c('v-icon',[_vm._v("\n                    keyboard_arrow_right\n                  ")])],1)],1):_vm._e()]),_vm._v(" "),(_vm.isActiveRunnerTrainer)?_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"header-text"},[_c('span',[_vm._v("Nowy trening")]),_vm._v(" "),_c('rp-icon',{attrs:{"type":"arrow_forward","tooltip":"skopiuj treningi z poprzedniego miesiąca"},on:{"click":function($event){return _vm.copyWorkoutsMonth(_vm.currentDate)}}}),_vm._v(" "),_c('rp-icon',{attrs:{"type":"people","tooltip":"skopiuj treningi innego zawodnika"},on:{"click":function($event){return _vm.copyWorkoutsMonthRunner(_vm.currentDate)}}})],1)]):_vm._e(),_vm._v(" "),(_vm.runner.user === _vm.authUser.user)?_c('notifications-push-init',{attrs:{"mini":""}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('table',{attrs:{"id":"calendar"}},[_c('tr',{staticClass:"weekdays"},[_c('th',{staticClass:"nohover",attrs:{"scope":"col"}}),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Poniedziałek")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Wtorek")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Środa")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Czwartek")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Piątek")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Sobota")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Niedziela")]),_vm._v(" "),_c('th',{staticClass:"nohover",attrs:{"scope":"col"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Suma kilometrów'),expression:"'Suma kilometrów'"}]},[_vm._v("mdi-sigma")])],1)]),_vm._v(" "),_vm._l((_vm.calendarView.weeks),function(week){return _c('tr',{staticClass:"days"},[_c('td',{staticClass:"nohover"},[_c('span',{staticClass:"icon-group"},[(_vm.isActiveRunnerTrainer)?_c('span',{staticClass:"week-icon"},[_c('rp-icon',{attrs:{"type":"done","small":"","tooltip":"oznacz treningi jako wykonane"},on:{"click":function($event){return _vm.doneWorkoutsWeek(week)}}})],1):_vm._e(),_vm._v(" "),(_vm.isActiveRunnerTrainer)?_c('span',{staticClass:"week-icon"},[_c('rp-icon',{attrs:{"type":"clear","small":"","tooltip":"oznacz treningi jako niewykonane"},on:{"click":function($event){return _vm.undoneWorkoutsWeek(week)}}})],1):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"icon-group"},[(_vm.isActiveRunnerTrainer)?_c('span',{staticClass:"week-icon"},[_c('rp-icon',{attrs:{"type":"delete","small":"","tooltip":"usuń treningi z tego tygodnia"},on:{"click":function($event){return _vm.removeWorkoutsWeek(week)}}})],1):_vm._e(),_vm._v(" "),(_vm.isActiveRunnerTrainer)?_c('span',{staticClass:"week-icon"},[_c('rp-icon',{attrs:{"type":"arrow_downward","small":"","tooltip":"skopiuj treningi na następny tydzień"},on:{"click":function($event){return _vm.copyWorkoutsWeek(week)}}})],1):_vm._e()])]),_vm._v(" "),_vm._l((week.days),function(day,index){return _c('td',{staticClass:"day",class:{ 'other-month': day.otherMonth },attrs:{"id":'day-' + day.date.format('YYMMDD')},on:{"click":function($event){$event.stopPropagation();return _vm.dayClick(day, $event)}}},[(!day.events.length && (_vm.$mq !== 'sm' || !_vm.eventForm || !_vm.eventForm.datetime.isSame(day.date, 'day')))?[_c('div',{staticClass:"day-date"},[_vm._v(_vm._s(day.date.date())+" "),(_vm.$mq == 'sm')?[_vm._v("("+_vm._s(day.date.format('dddd'))+")")]:_vm._e()],2)]:_vm._e(),_vm._v(" "),_vm._l((day.events),function(ev){return (_vm.$mq !== 'sm')?[(ev.dayVisible && ev.isWorkout)?_c('workout-small',{key:ev.id,attrs:{"micro":day.events.length > 1,"workout":ev},on:{"edit-workout":function($event){return _vm.editEvent(ev)},"done-workout":function($event){return _vm.doneWorkoutHandler(ev)},"undone-workout":function($event){return _vm.undoneWorkoutHandler(ev)},"remove-workout":function($event){return _vm.removeWorkout(ev)}},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.eventClick(ev, $event)}}}):_vm._e(),_vm._v(" "),(ev.dayVisible && ev.isRace)?_c('race-small',{key:ev.id,attrs:{"race":ev},on:{"edit-race":function($event){return _vm.editEvent(ev)},"remove-race":function($event){return _vm.removeRace(ev)}},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.eventClick(ev, $event)}}}):_vm._e(),_vm._v(" "),(ev.dayVisible && ev.isActivity)?_c('activity-small',{key:ev.id,attrs:{"activity":ev},on:{"edit-activity":function($event){return _vm.editEvent(ev)},"remove-activity":function($event){return _vm.removeActivity(ev)}},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.eventClick(ev, $event)}}}):_vm._e()]:_vm._e()}),_vm._v(" "),_vm._l((day.events),function(ev){return (_vm.$mq === 'sm')?[(ev.dayVisible && ev.isWorkout && _vm.eventForm !== ev)?_c('workout-big',{key:ev.id,attrs:{"inplace":"","workout":ev},on:{"edit-workout":function($event){return _vm.editEvent(ev)},"done-workout":function($event){return _vm.doneWorkoutHandler(ev)},"undone-workout":function($event){return _vm.undoneWorkoutHandler(ev)},"remove-workout":function($event){return _vm.removeWorkout(ev)},"ended-workout":_vm.endedWorkout}}):_vm._e(),_vm._v(" "),(ev.dayVisible && ev.isRace && _vm.eventForm !== ev)?_c('race-big',{key:ev.id,attrs:{"inplace":"","race":ev},on:{"edit-race":function($event){return _vm.editEvent(ev)},"remove-race":function($event){return _vm.removeRace(ev)},"ended-race":_vm.endedRace}}):_vm._e(),_vm._v(" "),(ev.dayVisible && ev.isActivity && _vm.eventForm !== ev)?_c('activity-big',{key:ev.id,attrs:{"inplace":"","activity":ev},on:{"edit-activity":function($event){return _vm.editEvent(ev)},"remove-activity":function($event){return _vm.removeActivity(ev)}}}):_vm._e()]:_vm._e()}),_vm._v(" "),(_vm.$mq === 'sm')?[(_vm.eventForm && _vm.eventForm.isWorkout && _vm.eventForm.datetime.isSame(day.date, 'day'))?_c('workout-form',{attrs:{"inplace":"","ev":_vm.eventForm},on:{"close":function($event){return _vm.closeForm()},"created-workout":_vm.createdEvent,"updated-workout":_vm.updatedEvent}}):_vm._e(),_vm._v(" "),(_vm.eventForm && _vm.eventForm.isRace && _vm.eventForm.datetime.isSame(day.date, 'day'))?_c('race-form',{attrs:{"inplace":"","ev":_vm.eventForm},on:{"close":function($event){return _vm.closeForm()},"created-race":_vm.createdEvent,"updated-race":_vm.updatedEvent}}):_vm._e(),_vm._v(" "),(_vm.eventForm && _vm.eventForm.isActivity && _vm.eventForm.datetime.isSame(day.date, 'day'))?_c('activity-form',{attrs:{"inplace":"","ev":_vm.eventForm},on:{"close":function($event){return _vm.closeForm()},"created-activity":_vm.createdEvent,"updated-activity":_vm.updatedEvent}}):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"day-actions"},[_c('span',[(!day.isOpen && _vm.isActiveRunner)?_c('rp-icon',{staticClass:"very-small",attrs:{"tooltip":"Dzień niedostępny","type":"block"},on:{"click":function($event){return _vm.openPlanDay(day, $event)}}}):_vm._e(),_vm._v(" "),(day.isOpen && _vm.isActiveRunner)?_c('rp-icon',{staticClass:"very-small",attrs:{"tooltip":"Dzień dostępny","type":"check_circle_outline"},on:{"click":function($event){return _vm.closePlanDay(day, $event)}}}):_vm._e(),_vm._v(" "),(!day.isOpen && !_vm.isActiveRunner)?_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dzień niedostępny'),expression:"'Dzień niedostępny'"}],staticClass:"very-small"},[_vm._v("block")]):_vm._e()],1),_vm._v(" "),_c('span',[(day.isOpen && _vm.isActiveRunnerTrainer)?_c('v-btn',{staticClass:"very-small",attrs:{"small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.newWorkout(day, $event)}}},[_vm._v("\n                      trening\n                      "),_c('v-icon',{attrs:{"right":"","small":""}},[_vm._v("add_circle")])],1):_vm._e(),_vm._v(" "),(day.isOpen && (_vm.isActiveRunnerTrainer || _vm.isActiveRunner))?_c('v-btn',{staticClass:"very-small",attrs:{"small":"","dark":"","color":"tertiary"},on:{"click":function($event){$event.stopPropagation();return _vm.newRace(day, $event)}}},[_vm._v("\n                      zawody\n                      "),_c('v-icon',{attrs:{"right":"","small":""}},[_vm._v("add_circle")])],1):_vm._e(),_vm._v(" "),(day.isOpen && _vm.isActiveRunner)?_c('v-btn',{staticClass:"very-small",attrs:{"small":"","dark":"","color":"accent"},on:{"click":function($event){$event.stopPropagation();return _vm.newActivity(day, $event)}}},[_vm._v("\n                      aktywność\n                      "),_c('v-icon',{attrs:{"right":"","small":""}},[_vm._v("add_circle")])],1):_vm._e()],1)])],2)}),_vm._v(" "),_c('td',{staticClass:"nohover week-summary"},[_c('div',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Zaplanowano'),expression:"'Zaplanowano'"}]},[_c('div',{staticClass:"week-summary-distance"},[_vm._v(_vm._s(week.totalPlanned))]),_vm._v("km")])]),_vm._v(" "),_c('div',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Wykonano'),expression:"'Wykonano'"}]},[_c('div',{staticClass:"week-summary-distance"},[_vm._v(_vm._s(week.totalDone))]),_vm._v("km")])])])],2)})],2),_vm._v(" "),_c('runner-heart-rate'),_vm._v(" "),(_vm.$mq !== 'sm')?[(_vm.currentEvent && _vm.currentEvent.isWorkout)?_c('workout-big',{key:_vm.currentEvent.id,attrs:{"workout":_vm.currentEvent},on:{"close":function($event){return _vm.closeCurrent()},"edit-workout":function($event){return _vm.editEvent(_vm.currentEvent)},"done-workout":function($event){return _vm.doneWorkoutHandler(_vm.currentEvent)},"undone-workout":function($event){return _vm.undoneWorkoutHandler(_vm.currentEvent)},"remove-workout":function($event){return _vm.removeWorkout(_vm.currentEvent)},"ended-workout":_vm.endedWorkout},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.insideClick($event)}}}):_vm._e(),_vm._v(" "),(_vm.currentEvent && _vm.currentEvent.isRace)?_c('race-big',{key:_vm.currentEvent.id,attrs:{"race":_vm.currentEvent},on:{"close":function($event){return _vm.closeCurrent()},"edit-race":function($event){return _vm.editEvent(_vm.currentEvent)},"remove-race":function($event){return _vm.removeRace(_vm.currentEvent)},"ended-race":_vm.endedRace},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.insideClick($event)}}}):_vm._e(),_vm._v(" "),(_vm.currentEvent && _vm.currentEvent.isActivity)?_c('activity-big',{key:_vm.currentEvent.id,attrs:{"activity":_vm.currentEvent},on:{"close":function($event){return _vm.closeCurrent()},"edit-activity":function($event){return _vm.editEvent(_vm.currentEvent)},"remove-activity":function($event){return _vm.removeActivity(_vm.currentEvent)}},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.insideClick($event)}}}):_vm._e(),_vm._v(" "),(_vm.eventForm && _vm.eventForm.isWorkout)?_c('workout-form',{attrs:{"ev":_vm.eventForm},on:{"close":function($event){return _vm.closeForm()},"created-workout":_vm.createdEvent,"updated-workout":_vm.updatedEvent}}):_vm._e(),_vm._v(" "),(_vm.eventForm && _vm.eventForm.isRace)?_c('race-form',{attrs:{"ev":_vm.eventForm},on:{"close":function($event){return _vm.closeForm()},"created-race":_vm.createdEvent,"updated-race":_vm.updatedEvent}}):_vm._e(),_vm._v(" "),(_vm.eventForm && _vm.eventForm.isActivity)?_c('activity-form',{attrs:{"ev":_vm.eventForm},on:{"close":function($event){return _vm.closeForm()},"created-activity":_vm.createdEvent,"updated-activity":_vm.updatedEvent}}):_vm._e()]:_vm._e()],2)],1)],1)],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"align-start":"","justify-space-around":"","row":"","wrap":"","fill-height":""}},[_c('v-flex',{attrs:{"sm12":"","lg6":""}},[_c('v-card',[_c('plan-races')],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"align-start":"","justify-space-around":"","row":"","wrap":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","lg6":""}},[_c('v-card',{staticClass:"pa-3"},[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("\n              Podsumowanie miesiąca\n            ")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-content',[_vm._v("\n                Suma km z planu: "+_vm._s(_vm.calendarView.totalMonthPlanned)+"\n              ")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-content',[_vm._v("\n                Suma km wykonana: "+_vm._s(_vm.calendarView.totalMonthDone)+"\n              ")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-content',[_vm._v("\n                Zaplanowanych treningów/zawodów:  "+_vm._s(_vm.calendarView.totalMonthPlannedCount)+"\n              ")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-content',[_vm._v("\n                Wykonanych treningów/zawodów: "+_vm._s(_vm.calendarView.totalMonthDoneCount)+"\n              ")])],1)],1)],1)],1),_vm._v(" "),(_vm.records.length > 0)?_c('v-flex',{attrs:{"xs12":"","lg6":""}},[_c('v-card',{staticClass:"pa-3"},[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("\n              Nowe rekordy\n            ")])],1),_vm._v(" "),(_vm.records)?_c('table',{staticClass:"v-table theme--light"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Dystans")]),_vm._v(" "),_c('th',[_vm._v("Czas")]),_vm._v(" "),_c('th',[_vm._v("Data")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.records),function(record){return _c('tr',[_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(record.distance_string_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(record.time))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("formatDate")(record.race_date,'LL')))])])}),0)]):_vm._e()],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"align-start":"","justify-space-around":"","row":"","wrap":"","fill-height":""}},[_c('v-flex',{attrs:{"sm12":"","lg6":""}},[_c('v-card',[_c('plan-comments',{attrs:{"month":_vm.currentDate}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhysicalTests_vue__ = __webpack_require__(340);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245ec94e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhysicalTests_vue__ = __webpack_require__(723);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhysicalTests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245ec94e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhysicalTests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',[_c('v-form',{staticClass:"elevation-2 pa-3",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('Fields',_vm._b({},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false)),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PulseZones_vue__ = __webpack_require__(344);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76e9ec8a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PulseZones_vue__ = __webpack_require__(722);
function injectStyle (ssrContext) {
  __webpack_require__(721)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76e9ec8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PulseZones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76e9ec8a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PulseZones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elevation-2"},[(_vm.edit)?_c('pulse-zones-form',{attrs:{"pulse-zones":_vm.pulseZones},on:{"success":function($event){_vm.edit=false;_vm.$emit('success')}}}):_vm._e(),_vm._v(" "),(!_vm.edit)?_c('table',{staticClass:"v-table pzone-table"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"blue-grey lighten-4"},[_c('th',[_vm._v("\n          Regeneracji aktywnej\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(_vm.pulseZones.zone_1)+"\n        ")])]),_vm._v(" "),_c('tr',{staticClass:"light-blue lighten-3"},[_c('th',[_vm._v("\n          Niskiej intensywności\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(_vm.pulseZones.zone_1)+" - "+_vm._s(_vm.pulseZones.zone_2)+"\n        ")])]),_vm._v(" "),_c('tr',{staticClass:"light-blue lighten-1"},[_c('th',[_vm._v("\n          Próg tlenowy\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(_vm.pulseZones.zone_2)+"\n        ")])]),_vm._v(" "),_c('tr',{staticClass:"green lighten-1"},[_c('th',[_vm._v("\n          Średniej intensywności\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(_vm.pulseZones.zone_2)+" - "+_vm._s(_vm.pulseZones.zone_3)+"\n        ")])]),_vm._v(" "),_c('tr',{staticClass:"yellow lighten-1"},[_c('th',[_vm._v("\n          Wysokiej intensywności\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(_vm.pulseZones.zone_3)+" - "+_vm._s(_vm.pulseZones.zone_4)+"\n        ")])]),_vm._v(" "),_c('tr',{staticClass:"orange lighten-1"},[_c('th',[_vm._v("\n          Próg anaerobowy\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(_vm.pulseZones.zone_4)+"\n        ")])]),_vm._v(" "),_c('tr',{staticClass:"red lighten-1"},[_c('th',[_vm._v("\n          Wysokiej intensywności interwałowej\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(_vm.pulseZones.zone_4)+" - "+_vm._s(_vm.pulseZones.hrmax)+"\n        ")])]),_vm._v(" "),_c('tr',{staticClass:"red darken-1"},[_c('th',[_vm._v("\n          HRmax\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(_vm.pulseZones.hrmax)+"\n        ")])])])]):_vm._e(),_vm._v(" "),_c('v-toolbar',{attrs:{"color":"primary","flat":"","dark":"","dense":""}},[_c('v-toolbar-title',[_c('div',{staticClass:"body-2"},[_vm._v("Data badania: "+_vm._s(_vm._f("formatDate")(_vm.pulseZones.test_date,'LL')))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.isActiveRunnerTrainer || _vm.isActiveRunner)?_c('rp-icon',{attrs:{"type":"edit","tooltip":"edytuj","dark":""},on:{"click":function($event){_vm.edit = !_vm.edit}}}):_vm._e(),_vm._v(" "),(_vm.isActiveRunnerTrainer || _vm.isActiveRunner)?_c('rp-icon',{attrs:{"type":"delete","tooltip":"usuń","dark":""},on:{"click":function($event){_vm.$emit('remove-pulse-zones'); _vm.edit=false}}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"primary theme--dark"},[_c('th',[_vm._v("Strefy tętna")]),_vm._v(" "),_c('th',[_vm._v("Progi")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"physical_tests"},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Badanie wydolnościowe")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.showAdd && (_vm.isActiveRunnerTrainer || _vm.isActiveRunner))?_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":function($event){_vm.showAdd = true}}},[_vm._v("dodaj badanie")]):_vm._e(),_vm._v(" "),(_vm.showAdd)?_c('v-btn',{attrs:{"flat":"","small":""},on:{"click":function($event){_vm.showAdd = false}}},[_vm._v("ukryj")]):_vm._e()],1)],1),_vm._v(" "),_c('v-slide-y-transition',[(_vm.showAdd)?_c('v-card',{staticClass:"mt-2"},[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"sm8":"","md6":"","lg5":""}},[_c('pulse-zones-form',{on:{"success":function($event){_vm.showAdd = false; _vm.refresh()}}})],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2 pb-1"},[_c('v-data-iterator',{attrs:{"items":_vm.pulseZonesList,"pagination":_vm.context,"rows-per-page-items":_vm.perPageOptions,"total-items":_vm.rowsTotal,"loading":_vm.loading,"content-tag":"v-container","grid-list-xl":""},on:{"update:pagination":function($event){_vm.context=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md8":"","lg6":"","xl4":""}},[(!props.item.edit)?_c('pulse-zones',{attrs:{"pulse-zones":props.item},on:{"success":function($event){return _vm.refresh()},"remove-pulse-zones":function($event){return _vm.removePulseZones(props.item)}}}):_vm._e()],1)],1)}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de132e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__ = __webpack_require__(725);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de132e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results"},[_c('v-card',{staticClass:"records"},[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Rekordy")])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg10":"","xl8":""}},[_c('records',{on:{"set-distance":_vm.setDistance}})],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-4 mb-2"}),_vm._v(" "),_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Progres wyników")])],1),_vm._v(" "),_c('v-card-title',[_c('v-form',{staticClass:"flex"},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-select',{attrs:{"items":_vm.allRaceDistanceStringsOptions,"label":"Dystans","clearable":""},on:{"change":_vm.refreshChart,"input":_vm.refreshChart},model:{value:(_vm.chartFilter.distance),callback:function ($$v) {_vm.$set(_vm.chartFilter, "distance", $$v)},expression:"chartFilter.distance"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-menu',{ref:"menu1",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.chartFilter.start,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.chartFilter, "start", $event)},"update:return-value":function($event){return _vm.$set(_vm.chartFilter, "start", $event)}},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Data od","prepend-icon":"event","readonly":"","clearable":""},on:{"change":_vm.refreshChart,"input":_vm.refreshChart},slot:"activator",model:{value:(_vm.chartFilter.start),callback:function ($$v) {_vm.$set(_vm.chartFilter, "start", $$v)},expression:"chartFilter.start"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","locale":"pl"},on:{"input":function($event){return _vm.$refs.menu1.save(_vm.chartFilter.start)}},model:{value:(_vm.chartFilter.start),callback:function ($$v) {_vm.$set(_vm.chartFilter, "start", $$v)},expression:"chartFilter.start"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-menu',{ref:"menu2",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.chartFilter.end,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.chartFilter, "end", $event)},"update:return-value":function($event){return _vm.$set(_vm.chartFilter, "end", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Data do","prepend-icon":"event","readonly":"","clearable":""},on:{"change":_vm.refreshChart,"input":_vm.refreshChart},slot:"activator",model:{value:(_vm.chartFilter.end),callback:function ($$v) {_vm.$set(_vm.chartFilter, "end", $$v)},expression:"chartFilter.end"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","locale":"pl"},on:{"input":function($event){return _vm.$refs.menu2.save(_vm.chartFilter.end)}},model:{value:(_vm.chartFilter.end),callback:function ($$v) {_vm.$set(_vm.chartFilter, "end", $$v)},expression:"chartFilter.end"}})],1)],1)],1)],1)],1),_vm._v(" "),(_vm.showChart)?_c('div',{staticClass:"chart-container"},[_c('results-chart',{attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptions,"css-classes":"chart-inner-container"}})],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfdaa20e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__(730);
function injectStyle (ssrContext) {
  __webpack_require__(727)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfdaa20e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationsSettings_vue__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b40a6e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationsSettings_vue__ = __webpack_require__(729);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationsSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b40a6e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationsSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('v-switch',{staticClass:"d-inline-block",attrs:{"label":"Email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}}),_vm._v(" "),_c('v-switch',{staticClass:"d-inline-block",attrs:{"label":"Push (powiadomienia do przeglądarki i mobilne)"},model:{value:(_vm.form.push),callback:function ($$v) {_vm.$set(_vm.form, "push", $$v)},expression:"form.push"}}),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","small":"","color":"primary"}},[_vm._v("Zapisz")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications"},[_c('v-card',[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Powiadomienia")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('notifications-settings',{attrs:{"user":_vm.authUser},on:{"push-status":function($event){_vm.enablePush = $event}}})],1),_vm._v(" "),_c('v-flex',[(_vm.enablePush)?_c('notifications-push-init',{staticClass:"mt-2"}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-5",attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"sm8":""}},[_c('v-card',[_c('v-data-iterator',{attrs:{"items":_vm.notificationsList,"pagination":_vm.context,"rows-per-page-items":_vm.perPageOptions,"total-items":_vm.rowsTotal,"loading":_vm.loading,"content-tag":"v-list","content-props":{twoLine: true}},on:{"update:pagination":function($event){_vm.context=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('v-list-tile',{on:{"click":function($event){return _vm.goToData(props.item)}}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{staticClass:"d-inline-block notification-text",attrs:{"xs12":"","md8":""}},[_vm._v("\n                    "+_vm._s(props.item.message)+"\n                  ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-md-right d-inline-block",attrs:{"xs12":"","md4":""}},[_c('v-list-tile-action-text',[_vm._v(_vm._s(_vm._f("formatDate")(props.item.created_at,'LLL')))])],1)],1)],1),_vm._v(" "),_c('v-divider')]}}])})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Races_vue__ = __webpack_require__(349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcf598a6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Races_vue__ = __webpack_require__(736);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Races_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcf598a6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Races_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceForm_vue__ = __webpack_require__(350);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95040032_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceForm_vue__ = __webpack_require__(733);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95040032_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"sm8":"","md6":"","lg5":""}},[_c('v-form',{staticClass:"elevation-2 pa-3 race-form",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.saveRace($event)}}},[_c('input-date',{attrs:{"label":"Data","error":_vm.hasErrors('race_date'),"error-messages":_vm.getErrors('race_date')},model:{value:(_vm.race.race_date),callback:function ($$v) {_vm.$set(_vm.race, "race_date", $$v)},expression:"race.race_date"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Nazwa","error":_vm.hasErrors('name'),"error-messages":_vm.getErrors('name')},model:{value:(_vm.race.name),callback:function ($$v) {_vm.$set(_vm.race, "name", $$v)},expression:"race.name"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Nazwa'),expression:"'Nazwa'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("N")])]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Miasto","error":_vm.hasErrors('city'),"error-messages":_vm.getErrors('city')},model:{value:(_vm.race.city),callback:function ($$v) {_vm.$set(_vm.race, "city", $$v)},expression:"race.city"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Miasto'),expression:"'Miasto'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("location_city")])],1),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.allRaceTypesStringsOptions,"label":"Rodzaj","error":_vm.hasErrors('race_type'),"error-messages":_vm.getErrors('race_type')},on:{"change":_vm.changeRaceType},model:{value:(_vm.race.race_type),callback:function ($$v) {_vm.$set(_vm.race, "race_type", $$v)},expression:"race.race_type"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Rodzaj'),expression:"'Rodzaj'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("R")])]),_vm._v(" "),(['street', 'track'].indexOf(_vm.race.race_type) > -1)?_c('v-select',{attrs:{"label":"Dystans","items":_vm.distanceOptions,"error":_vm.hasErrors('distance_string'),"error-messages":_vm.getErrors('distance_string')},model:{value:(_vm.race.distance_string),callback:function ($$v) {_vm.$set(_vm.race, "distance_string", $$v)},expression:"race.distance_string"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans'),expression:"'Dystans'"}],staticClass:"fi flaticon-road-1",attrs:{"slot":"prepend"},slot:"prepend"})]):_vm._e(),_vm._v(" "),(['other', 'ultra'].indexOf(_vm.race.distance_string) > -1)?_c('v-text-field',{attrs:{"label":"Dystans w kilometrach","error":_vm.hasErrors('distance_km'),"error-messages":_vm.getErrors('distance_km')},model:{value:(_vm.race.distance_km),callback:function ($$v) {_vm.$set(_vm.race, "distance_km", $$v)},expression:"race.distance_km"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dystans w kilometrach'),expression:"'Dystans w kilometrach'"}],staticClass:"fi flaticon-road-1",attrs:{"slot":"prepend"},slot:"prepend"})]):_vm._e(),_vm._v(" "),(_vm.race.race_type === 'street')?_c('v-checkbox',{attrs:{"label":"Atest","error":_vm.hasErrors('certified'),"error-messages":_vm.getErrors('certified')},model:{value:(_vm.race.certified),callback:function ($$v) {_vm.$set(_vm.race, "certified", $$v)},expression:"race.certified"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Atest'),expression:"'Atest'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("spellcheck")])],1):_vm._e(),_vm._v(" "),_c('v-select',{attrs:{"label":"Priorytet","items":_vm.allRacePrioritiesOptions,"error":_vm.hasErrors('priority'),"error-messages":_vm.getErrors('priority'),"dense":""},model:{value:(_vm.race.priority),callback:function ($$v) {_vm.$set(_vm.race, "priority", $$v)},expression:"race.priority"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Priorytet'),expression:"'Priorytet'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("P")])]),_vm._v(" "),_c('v-textarea',{attrs:{"label":"Informacje dodatkowe","error":_vm.hasErrors('trainer_remarks'),"error-messages":_vm.getErrors('trainer_remarks'),"auto-grow":"","box":""},model:{value:(_vm.race.trainer_remarks),callback:function ($$v) {_vm.$set(_vm.race, "trainer_remarks", $$v)},expression:"race.trainer_remarks"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Informacje dodatkowe'),expression:"'Informacje dodatkowe'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("info")])],1),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceResultsForm_vue__ = __webpack_require__(351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cb5a18c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceResultsForm_vue__ = __webpack_require__(735);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaceResultsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cb5a18c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaceResultsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"sm8":"","md6":"","lg5":""}},[_c('v-form',{staticClass:"elevation-2 pa-3 race-form",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.saveRace($event)}}},[_c('v-text-field',{attrs:{"label":"Czas","placeholder":"H:M:S","error":_vm.hasErrors('time'),"error-messages":_vm.getErrors('time')},model:{value:(_vm.race.time),callback:function ($$v) {_vm.$set(_vm.race, "time", $$v)},expression:"race.time"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Czas'),expression:"'Czas'"}],staticClass:"fi flaticon-minutes",attrs:{"slot":"prepend"},slot:"prepend"})]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Miejsce","error":_vm.hasErrors('place'),"error-messages":_vm.getErrors('place')},model:{value:(_vm.race.place),callback:function ($$v) {_vm.$set(_vm.race, "place", $$v)},expression:"race.place"}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Miejsce'),expression:"'Miejsce'"}],staticClass:"text-icon",attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("M")])]),_vm._v(" "),_c('v-textarea',{attrs:{"label":"Informacje dodatkowe","error":_vm.hasErrors('post_remarks'),"error-messages":_vm.getErrors('post_remarks'),"auto-grow":"","box":""},model:{value:(_vm.race.post_remarks),callback:function ($$v) {_vm.$set(_vm.race, "post_remarks", $$v)},expression:"race.post_remarks"}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Informacje dodatkowe'),expression:"'Informacje dodatkowe'"}],attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v("info")])],1),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-datatable"},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Zawody")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.showAdd)?_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":function($event){_vm.showAdd = true}}},[_vm._v("dodaj zawody")]):_vm._e(),_vm._v(" "),(_vm.showAdd)?_c('v-btn',{attrs:{"flat":"","small":""},on:{"click":function($event){_vm.showAdd = false}}},[_vm._v("ukryj")]):_vm._e()],1)],1),_vm._v(" "),_c('v-slide-y-transition',[(_vm.showAdd)?_c('v-card',{staticClass:"mt-2"},[_c('race-form',{on:{"success":function($event){_vm.showAdd = false; _vm.refresh()}}})],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2 pb-1"},[_c('v-card-title',[_c('v-form',{staticClass:"flex"},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-text-field',{attrs:{"clearable":"","label":"Szukaj (nazwa lub miasto)"},model:{value:(_vm.context.searchQuery),callback:function ($$v) {_vm.$set(_vm.context, "searchQuery", $$v)},expression:"context.searchQuery"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-select',{attrs:{"items":[{text: 'A', value: 'A'}, {text: 'B', value: 'B'}, {text: 'C', value: 'C'}],"label":"Priorytet","clearable":""},model:{value:(_vm.context.priority),callback:function ($$v) {_vm.$set(_vm.context, "priority", $$v)},expression:"context.priority"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-select',{attrs:{"items":_vm.allRaceTypesStringsOptions,"label":"Rodzaj","clearable":""},model:{value:(_vm.context.raceType),callback:function ($$v) {_vm.$set(_vm.context, "raceType", $$v)},expression:"context.raceType"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-select',{attrs:{"items":_vm.allRaceDistanceStringsOptions,"label":"Dystans (tylko uliczne i bieżnia)","clearable":""},model:{value:(_vm.context.distance),callback:function ($$v) {_vm.$set(_vm.context, "distance", $$v)},expression:"context.distance"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-menu',{ref:"menu1",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.context.start,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.context, "start", $event)},"update:return-value":function($event){return _vm.$set(_vm.context, "start", $event)}},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Data od","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.context.start),callback:function ($$v) {_vm.$set(_vm.context, "start", $$v)},expression:"context.start"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","locale":"pl"},on:{"input":function($event){return _vm.$refs.menu1.save(_vm.context.start)}},model:{value:(_vm.context.start),callback:function ($$v) {_vm.$set(_vm.context, "start", $$v)},expression:"context.start"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-menu',{ref:"menu2",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.context.end,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.context, "end", $event)},"update:return-value":function($event){return _vm.$set(_vm.context, "end", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Data do","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.context.end),callback:function ($$v) {_vm.$set(_vm.context, "end", $$v)},expression:"context.end"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","locale":"pl"},on:{"input":function($event){return _vm.$refs.menu2.save(_vm.context.end)}},model:{value:(_vm.context.end),callback:function ($$v) {_vm.$set(_vm.context, "end", $$v)},expression:"context.end"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.races,"pagination":_vm.context,"rows-per-page-items":_vm.perPageOptions,"total-items":_vm.rowsTotal,"loading":_vm.loading},on:{"update:pagination":function($event){_vm.context=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_vm._v("\n          "+_vm._s(_vm._f("formatDate")(props.item.race_date,'LL'))+"\n        ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.city))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.race_type_name))]),_vm._v(" "),(['other', 'ultra'].indexOf(props.item.distance_string) > -1)?_c('td',[_vm._v(_vm._s(props.item.distance_km)+" km")]):_vm._e(),_vm._v(" "),(['other', 'ultra'].indexOf(props.item.distance_string) === -1)?_c('td',[_vm._v(_vm._s(props.item.distance_string_name))]):_vm._e(),_vm._v(" "),(props.item.race_type == 'street')?_c('td',[_vm._v(_vm._s(_vm.formatterBool(props.item.certified)))]):_c('td',[_vm._v("--")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.priority))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.time))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_c('rp-icon',{staticClass:"mr-2",attrs:{"type":"edit","tooltip":"edytuj"},on:{"click":function($event){return _vm.expand(props, 'edit')}}}),_vm._v(" "),_c('rp-icon',{staticClass:"mr-2",attrs:{"type":"timer","tooltip":"rezultat"},on:{"click":function($event){return _vm.expand(props, 'result')}}}),_vm._v(" "),_c('rp-icon',{attrs:{"type":"delete","tooltip":"usuń"},on:{"click":function($event){return _vm.deleteItem(props.item)}}})],1)])]}},{key:"expand",fn:function(props){return [(_vm.type == 'edit')?_c('race-form',{attrs:{"race-data":props.item},on:{"success":function($event){props.expanded = false; _vm.refresh()}}}):_vm._e(),_vm._v(" "),(_vm.type == 'result')?_c('race-results-form',{attrs:{"race-data":props.item},on:{"success":function($event){props.expanded = false; _vm.refresh()}}}):_vm._e()]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Videos_vue__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c955e7f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Videos_vue__ = __webpack_require__(744);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Videos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c955e7f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Videos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return YouTubeUrlNormalize; });
var getVidId = function getVidId(url) {
  var vidId;
  if (url.indexOf('youtube.com/watch?v=') !== -1) {
    // https://m.youtube.com/watch?v=e3S9KINoH2M
    vidId = url.substr(url.indexOf('youtube.com/watch?v=') + 20);
  } else if (url.indexOf('youtube.com/watch/?v=') !== -1) {
    // https://m.youtube.com/watch/?v=e3S9KINoH2M
    vidId = url.substr(url.indexOf('youtube.com/watch/?v=') + 21);
  } else if (url.indexOf('youtu.be') !== -1) {
    vidId = url.substr(url.indexOf('youtu.be') + 9);
  } else if (url.indexOf('www.youtube.com/embed/') !== -1) {
    vidId = url.substr(url.indexOf('www.youtube.com/embed/') + 22);
  } else if (url.indexOf('?v=') !== -1) {
    // http://m.youtube.com/?v=tbBTNCfe1Bc
    vidId = url.substr(url.indexOf('?v=') + 3, 11);
  } else {
    console.warn('YouTubeUrlNormalize getVidId not a youTube Video: ' + url);
    vidId = null;
  }

  if (vidId !== null && vidId.indexOf('&') !== -1) {
    vidId = vidId.substr(0, vidId.indexOf('&'));
  }
  return vidId;
};

var YouTubeUrlNormalize = function YouTubeUrlNormalize(url) {
  var rtn = url;
  if (url) {
    var vidId = getVidId(url);
    if (vidId) {
      rtn = 'https://www.youtube.com/embed/' + vidId;
    } else {
      rtn = url;
    }
  }

  return { 'link': rtn, 'error': vidId === null };
};

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{staticClass:"elevation-2 pa-3",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('Fields',_vm._b({},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false)),_vm._v(" "),(_vm.link === false)?_c('div',[_vm._v("Link nieprawidłowy")]):_vm._e(),_vm._v(" "),(_vm.link)?_c('iframe',{attrs:{"width":"420","height":"315","src":_vm.link}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-1"},[_c('v-btn',{attrs:{"variant":"secondary"},on:{"click":_vm.normalize}},[_vm._v("Sprawdź")]),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoItem_vue__ = __webpack_require__(356);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33396eb0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoItem_vue__ = __webpack_require__(743);
function injectStyle (ssrContext) {
  __webpack_require__(741)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33396eb0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */,
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.edit)?_c('video-form',{attrs:{"video":_vm.video},on:{"succes":function($event){_vm.edit=false}}}):_vm._e(),_vm._v(" "),(!_vm.edit)?_c('div',{staticClass:"vcontainer"},[_c('iframe',{staticClass:"video",attrs:{"src":'//www.youtube.com/embed/' + _vm.videoId,"frameborder":"0","allowfullscreen":""}})]):_vm._e(),_vm._v(" "),_c('v-toolbar',{attrs:{"color":"primary","dark":"","dense":""}},[_c('v-toolbar-title',[_c('div',{staticClass:"body-2"},[_vm._v("Dodany "+_vm._s(_vm._f("formatDate")(_vm.video.created_at,'LL'))+" przez "+_vm._s(_vm.video.user_name))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.isAdmin || _vm.isTriner)?_c('rp-icon',{attrs:{"type":"edit","tooltip":"edytuj","dark":""},on:{"click":function($event){_vm.edit = !_vm.edit}}}):_vm._e(),_vm._v(" "),(_vm.isAdmin || _vm.isTriner)?_c('rp-icon',{attrs:{"type":"delete","tooltip":"usuń","dark":""},on:{"click":function($event){_vm.$emit('remove-video'); _vm.edit=false}}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videos"},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Materiały wideo")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.showAdd && (_vm.isAdmin || _vm.isTrainer))?_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":function($event){_vm.showAdd = true}}},[_vm._v("dodaj wideo")]):_vm._e(),_vm._v(" "),(_vm.showAdd)?_c('v-btn',{attrs:{"flat":"","small":""},on:{"click":function($event){_vm.showAdd = false}}},[_vm._v("ukryj")]):_vm._e()],1)],1),_vm._v(" "),_c('v-slide-y-transition',[(_vm.showAdd)?_c('v-card',{staticClass:"mt-2"},[_c('v-container',[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"sm8":"","md6":"","lg5":""}},[_c('video-form',{on:{"success":function($event){_vm.showAdd = false; _vm.refresh()}}})],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2 pb-1"},[_c('v-data-iterator',{attrs:{"items":_vm.videosList,"pagination":_vm.context,"rows-per-page-items":_vm.perPageOptions,"total-items":_vm.rowsTotal,"loading":_vm.loading,"content-tag":"v-container","grid-list-xl":""},on:{"update:pagination":function($event){_vm.context=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md8":"","lg6":""}},[_c('v-card',[_c('video-item',{attrs:{"video":props.item},on:{"remove-video":function($event){return _vm.removeVideo(props.item)}}})],1)],1)],1)}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__ = __webpack_require__(357);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10fbe1bb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__ = __webpack_require__(748);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10fbe1bb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaceholderItem_vue__ = __webpack_require__(358);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a74d48_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaceholderItem_vue__ = __webpack_require__(747);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaceholderItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a74d48_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaceholderItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.placeholder.content)}}),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[(_vm.isAdmin)?_c('rp-icon',{attrs:{"type":"edit","tooltip":"edytuj"},on:{"click":function($event){return _vm.$emit('change-placeholder')}}}):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('rp-icon',{attrs:{"type":"delete","tooltip":"usuń"},on:{"click":function($event){return _vm.$emit('remove-placeholder')}}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2 pa-4 placeholdersList"},_vm._l((_vm.placeholdersList),function(item){return _c('div',{key:item.id,staticClass:"mt-2"},[(!item.edit)?_c('placeholder-item',{attrs:{"placeholder":item},on:{"change-placeholder":function($event){return _vm.changePlaceholder(item)},"remove-placeholder":function($event){return _vm.removePlaceholder(item)}}}):_vm._e(),_vm._v(" "),(item.edit)?_c('placeholder-form',{attrs:{"slug":_vm.$route.params.slug,"placeholder":item},on:{"success":function($event){item.edit = false; _vm.refresh()}}}):_vm._e(),_vm._v(" "),_c('v-divider')],1)}),0),_vm._v(" "),_c('v-slide-y-transition',[(_vm.showAdd)?_c('v-card',{staticClass:"mt-2"},[_c('placeholder-form',{attrs:{"slug":_vm.$route.params.slug},on:{"success":function($event){_vm.showAdd = false; _vm.refresh()}}})],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2"},[(_vm.isAdmin)?_c('v-toolbar',{attrs:{"dark":"","flat":"","dense":"","color":"primary"}},[_c('v-spacer'),_vm._v(" "),(!_vm.showAdd)?_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":function($event){_vm.showAdd = true}}},[_vm._v("dodaj")]):_vm._e(),_vm._v(" "),(_vm.showAdd)?_c('v-btn',{attrs:{"flat":"","small":""},on:{"click":function($event){_vm.showAdd = false}}},[_vm._v("ukryj")]):_vm._e()],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminTrainers_vue__ = __webpack_require__(359);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1c736a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminTrainers_vue__ = __webpack_require__(754);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminTrainers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1c736a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminTrainers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerAddForm_vue__ = __webpack_require__(360);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53dc9258_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerAddForm_vue__ = __webpack_require__(751);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerAddForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53dc9258_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerAddForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"sm8":"","md6":"","lg5":""}},[_c('v-form',{staticClass:"elevation-2 pa-3",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('Fields',_vm._b({},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false)),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerUpdateForm_vue__ = __webpack_require__(361);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ff5d91a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerUpdateForm_vue__ = __webpack_require__(753);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerUpdateForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ff5d91a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerUpdateForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{attrs:{"sm8":"","md6":"","lg5":""}},[_c('v-form',{staticClass:"elevation-2 pa-3",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('Fields',_vm._b({},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false)),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-datatable"},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Trenerzy")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.showAdd)?_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":function($event){_vm.showAdd = true}}},[_vm._v("dodaj trenera")]):_vm._e(),_vm._v(" "),(_vm.showAdd)?_c('v-btn',{attrs:{"flat":"","small":""},on:{"click":function($event){_vm.showAdd = false}}},[_vm._v("ukryj")]):_vm._e()],1)],1),_vm._v(" "),_c('v-slide-y-transition',[(_vm.showAdd)?_c('v-card',{staticClass:"mt-2"},[_c('trainer-add-form',{on:{"success":function($event){_vm.showAdd = false; _vm.refresh()}}})],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"mt-2 pb-1"},[_c('v-card-title',[_c('v-form',{staticClass:"flex"},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-text-field',{attrs:{"clearable":"","label":"Szukaj"},model:{value:(_vm.context.searchQuery),callback:function ($$v) {_vm.$set(_vm.context, "searchQuery", $$v)},expression:"context.searchQuery"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-select',{attrs:{"items":[{text: 'Tak', value: true}, {text: 'Nie', value: false}],"label":"Konto aktywne","clearable":""},model:{value:(_vm.context.isActive),callback:function ($$v) {_vm.$set(_vm.context, "isActive", $$v)},expression:"context.isActive"}})],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.trainers,"pagination":_vm.context,"rows-per-page-items":_vm.perPageOptions,"total-items":_vm.rowsTotal,"loading":_vm.loading},on:{"update:pagination":function($event){_vm.context=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_c('router-link',{attrs:{"to":{ name: 'trainer-runners', params: { id: props.item.id }}}},[_vm._v("\n            "+_vm._s(props.item.first_name)+" "+_vm._s(props.item.last_name)+"\n          ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatterBool(props.item.is_active)))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_c('rp-icon',{staticClass:"mr-2",attrs:{"type":"edit","tooltip":"edytuj"},on:{"click":function($event){props.expanded = !props.expanded}}}),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"grey darken-2"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{attrs:{"to":{ name: 'trainer-data', params: { id: props.item.id }}}},[_c('v-list-tile-title',[_vm._v("Szczegóły")])],1),_vm._v(" "),(props.item.is_active)?_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();return _vm.deactivateTrainer(props.item)}}},[_c('v-list-tile-title',[_vm._v("Deaktywuj konto")])],1):_vm._e(),_vm._v(" "),(!props.item.is_active)?_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();return _vm.activateTrainer(props.item)}}},[_c('v-list-tile-title',[_vm._v("Aktywuj konto")])],1):_vm._e()],1)],1)],1)])]}},{key:"expand",fn:function(props){return [_c('trainer-update-form',{attrs:{"trainer-data":props.item},on:{"success":function($event){props.expanded = false; _vm.refresh()}}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerData_vue__ = __webpack_require__(362);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d4df839_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerData_vue__ = __webpack_require__(757);
function injectStyle (ssrContext) {
  __webpack_require__(756)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d4df839_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.updateTrainer($event)}}},[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.trainer.full_name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","small":""},on:{"click":function($event){$event.preventDefault();_vm.updateMode = !_vm.updateMode}}},[_vm._v("edytuj")]),_vm._v(" "),(_vm.isSelf)?_c('v-btn',{attrs:{"color":"light-blue darken-3","small":"","to":{name: 'trainer-change-password'}}},[_vm._v("zmień hasło")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mt-5",attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[(_vm.updateMode)?_c('div',{attrs:{"role":"group"}},[_c('picture-input',{ref:"pictureInput",attrs:{"width":"200","height":"200","margin":"8","size":"10","buttonClass":"btn btn-outline-secondary","customStrings":{
            upload: '<p>Urządzenie nie obsługiwane.</p>',
            drag: 'Upuść plik lub <br/>kliknij aby wybrać',
            change: 'Zmień obraz',
            remove: 'Usuń obraz',
            select: 'Wybierz obraz',
            selected: '<p>Photo successfully selected!</p>',
            fileSize: 'The file size exceeds the limit',
            fileType: 'This file type is not supported.',
            aspect: 'Landscape/Portrait'
          }},on:{"change":_vm.changeAvatar}})],1):_vm._e(),_vm._v(" "),(!_vm.updateMode && _vm.trainer.avatar_thumbnail)?_c('img',{staticClass:"d-inline-block avatar",attrs:{"width":"200","id":"avatar_thumbnailInput","src":_vm.trainer.avatar_thumbnail}}):_vm._e(),_vm._v(" "),(!_vm.updateMode && !_vm.trainer.avatar_thumbnail)?_c('img',{staticClass:"d-inline-block avatar",attrs:{"width":"200","id":"avatar_thumbnailInput","src":__webpack_require__(40)}}):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":"","lg4":""}},[_c('v-list',{staticClass:"personal-fields",attrs:{"two-line":""}},[_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Imię","required":"","objValue":_vm.trainer.first_name,"formErrors":_vm.formErrors,"field":'first_name'},model:{value:(_vm.form.first_name),callback:function ($$v) {_vm.$set(_vm.form, "first_name", $$v)},expression:"form.first_name"}}),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Nazwisko","required":"","objValue":_vm.trainer.last_name,"formErrors":_vm.formErrors,"field":'last_name'},model:{value:(_vm.form.last_name),callback:function ($$v) {_vm.$set(_vm.form, "last_name", $$v)},expression:"form.last_name"}}),_vm._v(" "),_c('runner-data-field',{attrs:{"editable":_vm.updateMode,"label":"Telefon","objValue":_vm.trainer.phone,"formErrors":_vm.formErrors,"field":'phone'},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}},[_c('a',{attrs:{"slot":"value","href":'tel:' + _vm.trainer.phone},slot:"value"},[_vm._v(_vm._s(_vm.trainer.phone))])]),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v("Email")]),_vm._v(" "),_c('v-list-tile-title',[_c('a',{attrs:{"href":'mailto:' + _vm.trainer.email}},[_vm._v(_vm._s(_vm.trainer.email))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":"","lg4":"","offset-sm6":"","offset-md4":"","offset-lg0":""}},[_c('v-list',{staticClass:"personal-fields mt-2",attrs:{"two-line":""}},[_c('runner-data-field',{class:{bigger: _vm.updateMode},attrs:{"editable":_vm.updateMode,"label":"O sobie","objValue":_vm.trainer.about,"formErrors":_vm.formErrors,"field":'about'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var error = ref.error;
          var errorMessages = ref.errorMessages;
          var label = ref.label;
return [_c('v-textarea',{attrs:{"label":label,"error":error,"error-messages":errorMessages,"auto-grow":""},model:{value:(_vm.form.about),callback:function ($$v) {_vm.$set(_vm.form, "about", $$v)},expression:"form.about"}})]}}]),model:{value:(_vm.form.about),callback:function ($$v) {_vm.$set(_vm.form, "about", $$v)},expression:"form.about"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":"","lg4":"","offset-sm6":"","offset-md4":"","offset-lg3":""}},[(_vm.updateMode)?_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Zapisz")]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerDataPresentation_vue__ = __webpack_require__(363);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6625eb92_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerDataPresentation_vue__ = __webpack_require__(760);
function injectStyle (ssrContext) {
  __webpack_require__(759)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerDataPresentation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6625eb92_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerDataPresentation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Twój trener")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mt-5",attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[(_vm.runnersTrainer.avatar_thumbnail)?_c('img',{staticClass:"d-inline-block avatar",attrs:{"width":"200","src":_vm.runnersTrainer.avatar_thumbnail}}):_vm._e(),_vm._v(" "),(!_vm.runnersTrainer.avatar_thumbnail)?_c('img',{staticClass:"d-inline-block avatar",attrs:{"width":"200","src":__webpack_require__(40)}}):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":"","lg4":""}},[_c('v-list',{staticClass:"personal-fields",attrs:{"two-line":""}},[_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v("Imię i nazwisko")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm.runnersTrainer.full_name))])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v("Telefon")]),_vm._v(" "),_c('v-list-tile-title',[_c('a',{attrs:{"href":'tel:' + _vm.runnersTrainer.phone}},[_vm._v(_vm._s(_vm.runnersTrainer.phone))])])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v("Email")]),_vm._v(" "),_c('v-list-tile-title',[_c('a',{attrs:{"href":'mailto:' + _vm.runnersTrainer.email}},[_vm._v(_vm._s(_vm.runnersTrainer.email))])])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v("O sobie")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm.runnersTrainer.about))])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnauthenticatedLayout_vue__ = __webpack_require__(364);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdedc388_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnauthenticatedLayout_vue__ = __webpack_require__(762);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnauthenticatedLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdedc388_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnauthenticatedLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-toolbar',{attrs:{"color":"white","fixed":"","clipped-left":"","app":""}},[_c('v-toolbar-title',[_c('v-img',{staticClass:"hidden-sm-and-down",attrs:{"width":"150","src":__webpack_require__(365)}}),_vm._v(" "),_c('v-img',{staticClass:"hidden-md-and-up",attrs:{"width":"30","src":__webpack_require__(366)}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"to":{name: 'login'},"color":"primary"}},[_vm._v("Zaloguj")]),_vm._v(" "),_c('v-btn',{attrs:{"to":{name: 'register-self'},"color":"accent"}},[_vm._v("Zarejestruj")])],1),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',[_c('v-flex',[_c('router-view')],1)],1)],1)],1),_vm._v(" "),_c('v-footer',{staticClass:"justify-center",attrs:{"absolute":"","inset":"","app":""}},[_c('span',[_vm._v("© Inżynieria Biegania "+_vm._s(new Date().getFullYear()))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLayout_vue__ = __webpack_require__(367);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdcad6c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLayout_vue__ = __webpack_require__(771);
function injectStyle (ssrContext) {
  __webpack_require__(764)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdcad6c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminNav_vue__ = __webpack_require__(368);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_397dcf60_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminNav_vue__ = __webpack_require__(766);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_397dcf60_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.list)?_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},_vm._l((_vm.links),function(item){return (item.visible)?_c('v-btn',{key:item.name,attrs:{"flat":"","to":item.to}},[_vm._v(_vm._s(item.name))]):_vm._e()}),1):_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.links),function(item){return (item.visible)?_c('v-list-tile',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({content: _vm.mini ? item.name : null}),expression:"{content: mini ? item.name : null}"}],key:item.name,attrs:{"to":item.to}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)],1):_vm._e()}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerNav_vue__ = __webpack_require__(369);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b44e848_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerNav_vue__ = __webpack_require__(768);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b44e848_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.list)?_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},_vm._l((_vm.links),function(item){return (item.visible)?_c('v-btn',{key:item.name,attrs:{"flat":"","to":item.to}},[_vm._v(_vm._s(item.name))]):_vm._e()}),1):_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.links),function(item){return (item.visible)?_c('v-list-tile',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({content: _vm.mini ? item.name : null}),expression:"{content: mini ? item.name : null}"}],key:item.name,attrs:{"to":item.to}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)],1):_vm._e()}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerNav_vue__ = __webpack_require__(370);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb5f7cf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerNav_vue__ = __webpack_require__(770);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb5f7cf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.list)?_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},_vm._l((_vm.links),function(item){return (item.visible)?_c('v-btn',{key:item.name,attrs:{"flat":"","to":item.to}},[_vm._v(_vm._s(item.name))]):_vm._e()}),1):_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.links),function(item){return (item.visible)?_c('v-list-tile',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({content: _vm.mini ? item.name : null}),expression:"{content: mini ? item.name : null}"}],key:item.name,attrs:{"to":item.to}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)],1):_vm._e()}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-navigation-drawer',{attrs:{"fixed":"","clipped":"","app":"","mobile-break-point":_vm.mobilePoint,"mini-variant":_vm.miniNav},model:{value:(_vm.navVisible),callback:function ($$v) {_vm.navVisible=$$v},expression:"navVisible"}},[_c('div',{staticClass:"aside-brand-wrap"},[_c('div',{staticClass:"aside-brand"},[_c('span',{staticClass:"aside-avatar elevation-2",attrs:{"href":""}},[(_vm.authUser.avatar_thumbnail)?_c('img',{attrs:{"src":_vm.authUser.avatar_thumbnail}}):_vm._e(),_vm._v(" "),(!_vm.authUser.avatar_thumbnail)?_c('img',{attrs:{"src":__webpack_require__(40)}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.authUser.full_name))])])]),_vm._v(" "),(_vm.isAdmin)?_c('admin-nav',{attrs:{"list":"","mini":_vm.miniNav}}):_vm._e(),_vm._v(" "),(_vm.isTrainer)?_c('trainer-nav',{attrs:{"list":""}}):_vm._e(),_vm._v(" "),(_vm.isRunner)?_c('runner-nav',{attrs:{"list":""}}):_vm._e()],1),_vm._v(" "),_c('v-toolbar',{attrs:{"color":"white","fixed":"","clipped-left":"","app":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.toggleNav($event)}}}),_vm._v(" "),_c('v-toolbar-title',[_c('v-img',{staticClass:"hidden-sm-and-down",attrs:{"width":"150","src":__webpack_require__(365)}}),_vm._v(" "),_c('v-img',{staticClass:"hidden-md-and-up",attrs:{"width":"30","src":__webpack_require__(366)}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.isAuthenticated && _vm.userLoaded)?_c('v-menu',{attrs:{"transition":"slide-y-transition","bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":""},slot:"activator"},[_c('em',[_vm._v(_vm._s(_vm.authUser.email))])]),_vm._v(" "),_c('v-list',[(_vm.isAdmin)?_c('v-list-tile',{attrs:{"to":{name: 'my-profile'}}},[_c('v-list-tile-title',[_vm._v("Zmień hasło")])],1):_vm._e(),_vm._v(" "),(!_vm.isAdmin)?_c('v-list-tile',{attrs:{"to":{name: 'my-profile'}}},[_c('v-list-tile-title',[_vm._v("Profil")])],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.logout}},[_c('v-list-tile-title',[_vm._v("Wyloguj")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-content',[_c('router-view')],1),_vm._v(" "),_c('v-footer',{attrs:{"absolute":"","inset":"","app":"","height":"auto"}},[_c('v-card',{staticClass:"flex",attrs:{"flat":"","tile":""}},[_c('v-card-actions',{staticClass:"justify-center flex-wrap-reverse"},[_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear())+" -  Inżynieria Biegania")]),_vm._v(" "),_c('span',[_c('a',{staticClass:"mx-3",attrs:{"target":"blank","href":"http://inzynieriabiegania.pl/regulamin/"}},[_vm._v("Regulamin")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-3",attrs:{"icon":"","href":"https://www.facebook.com/inzynieriabiegania/","target":"blank"}},[_c('v-icon',{attrs:{"size":"24px","color":"primary"}},[_vm._v("mdi-facebook-box")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-3",attrs:{"icon":"","href":"https://www.instagram.com/inzynieria.biegania/","target":"blank"}},[_c('v-icon',{attrs:{"size":"24px","color":"primary"}},[_vm._v("mdi-instagram")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-3",attrs:{"icon":"","href":"https://www.youtube.com/channel/UCveuB_K3xHQQAFkJXyj4mFw?view_as=subscriber","target":"blank"}},[_c('v-icon',{attrs:{"size":"24px","color":"primary"}},[_vm._v("mdi-youtube")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerPanelLayout_vue__ = __webpack_require__(371);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8051d8aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerPanelLayout_vue__ = __webpack_require__(774);
function injectStyle (ssrContext) {
  __webpack_require__(773)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainerPanelLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8051d8aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainerPanelLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"pa-0 ma-0 fluid",attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"column":""}},[(_vm.isAdmin)?_c('v-card',{staticClass:"tri-bg",attrs:{"dark":"","color":"light-blue darken-3"}},[_c('v-container',{staticClass:"pt-1 pb-0 px-4 fluid",attrs:{"color":"primary"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('v-flex',{staticClass:"d-inline-block runner-chooser"},[_c('span',{staticClass:"headline mr-4"},[_vm._v("TRENER:")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block"},[_c('v-btn',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('poprzedni'),expression:"'poprzedni'"}],staticClass:"upper",attrs:{"flat":"","small":"","icon":""},on:{"click":_vm.prevTrainer}},[_c('v-icon',[_vm._v("\n                      keyboard_arrow_left\n                    ")])],1),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.trainer.first_name)+" "+_vm._s(_vm.trainer.last_name))]),_vm._v(" "),_c('v-btn',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('następny'),expression:"'następny'"}],staticClass:"upper",attrs:{"flat":"","small":"","icon":""},on:{"click":_vm.nextTrainer}},[_c('v-icon',[_vm._v("\n                      keyboard_arrow_right\n                    ")])],1)],1)]),_vm._v(" "),_c('v-flex',{staticClass:"d-inline-block runner-mini-menu"},[_c('v-tabs',{attrs:{"fixed-tabs":"","dark":"","color":"transparent"}},[_c('v-tab',{attrs:{"to":{name: 'trainer-data', params: {id: _vm.$route.params.id}}}},[_vm._v("\n                  Dane\n                ")]),_vm._v(" "),_c('v-tab',{attrs:{"to":{name: 'trainer-runners', params: {id: _vm.$route.params.id}}}},[_vm._v("\n                  Zawodnicy\n                ")]),_vm._v(" "),_c('v-tab',{attrs:{"to":{name: 'trainer-videos', params: {id: _vm.$route.params.id}}}},[_vm._v("\n                  Filmy\n                ")])],1)],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',[_c('v-flex',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerPanelLayout_vue__ = __webpack_require__(372);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b82efed_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerPanelLayout_vue__ = __webpack_require__(777);
function injectStyle (ssrContext) {
  __webpack_require__(776)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunnerPanelLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b82efed_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunnerPanelLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"pa-0 ma-0 fluid runner-ribbon",attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"column":""}},[(_vm.isRunner && _vm.runnersTrainer)?_c('v-card',{staticClass:"pb-2 tri-bg",attrs:{"dark":"","color":"light-blue darken-3"}},[_c('v-container',{staticClass:"pt-1 pb-0 px-4 fluid",attrs:{"color":"primary"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('v-flex',{staticClass:"d-inline-block runner-chooser"},[_c('span',{staticClass:"headline mr-4"},[_vm._v("TRENER:")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block"},[_c('span',{staticClass:"title"},[_c('router-link',{attrs:{"to":{name: 'runner-trainer-data'}}},[_vm._v("\n                      "+_vm._s(_vm.runnersTrainer.first_name)+" "+_vm._s(_vm.runnersTrainer.last_name)+"\n                    ")])],1)])]),_vm._v(" "),(!_vm.runner.account_paid)?_c('v-flex',{staticClass:"d-inline-block runner-chooser"},[_c('span',{staticClass:"headline"},[_vm._v("konto nieopłacone!")])]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"text-md-right runner-package"},[_c('span',{staticClass:"headline mr-4"},[_vm._v("PAKIET:")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.runner.package_name))])])],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-container',{staticClass:"pa-0 ma-0 fluid",attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"column":""}},[(_vm.isTrainer || _vm.isAdmin)?_c('v-card',{staticClass:"tri-bg",attrs:{"dark":"","color":"light-blue darken-3"}},[_c('v-container',{staticClass:"pt-1 pb-0 px-4 fluid",attrs:{"color":"primary"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('v-flex',{staticClass:"d-inline-block runner-chooser"},[_c('span',{staticClass:"headline mr-4"},[_vm._v("ZAWODNIK:")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block"},[_c('v-btn',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('poprzedni'),expression:"'poprzedni'"}],staticClass:"upper",attrs:{"flat":"","small":"","icon":""},on:{"click":_vm.prevRunner}},[_c('v-icon',[_vm._v("\n                      keyboard_arrow_left\n                    ")])],1),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.runner.first_name)+" "+_vm._s(_vm.runner.last_name)+" "),(!_vm.runner.account_paid)?_c('span',[_vm._v("(nieopłacony)")]):_vm._e()]),_vm._v(" "),_c('v-btn',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('następny'),expression:"'następny'"}],staticClass:"upper",attrs:{"flat":"","small":"","icon":""},on:{"click":_vm.nextRunner}},[_c('v-icon',[_vm._v("\n                      keyboard_arrow_right\n                    ")])],1)],1)]),_vm._v(" "),_c('v-flex',{staticClass:"d-inline-block runner-mini-menu"},[_c('v-tabs',{attrs:{"fixed-tabs":"","dark":"","color":"transparent"}},[_c('v-tab',{attrs:{"to":{name: 'runner-data', params: {id: _vm.$route.params.id}}}},[_vm._v("\n                  Dane\n                ")]),_vm._v(" "),_c('v-tab',{attrs:{"to":{name: 'runner-plan', params: {id: _vm.$route.params.id}}}},[_vm._v("\n                  Plan treningowy\n                ")]),_vm._v(" "),_c('v-tab',{attrs:{"to":{name: 'runner-hrmax', params: {id: _vm.$route.params.id}}}},[_vm._v("\n                  Badania\n                ")]),_vm._v(" "),_c('v-tab',{attrs:{"to":{name: 'runner-progression', params: {id: _vm.$route.params.id}}}},[_vm._v("\n                  Rekordy\n                ")]),_vm._v(" "),_c('v-tab',{attrs:{"to":{name: 'runner-races', params: {id: _vm.$route.params.id}}}},[_vm._v("\n                  Zawody\n                ")]),_vm._v(" "),_c('v-tab',{attrs:{"to":{name: 'runner-payments', params: {id: _vm.$route.params.id}}}},[_vm._v("\n                  Płatności\n                ")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-md-right runner-package"},[_c('span',{staticClass:"headline mr-4"},[_vm._v("PAKIET:")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.runner.package_name))])])],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fill-height":"","fluid":_vm.fluid}},[_c('v-layout',[_c('v-flex',[_c('router-view',{on:{"runner-application-data-updated":_vm.rereadRunner}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22be32be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminPanelLayout_vue__ = __webpack_require__(779);
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22be32be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminPanelLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',[_c('v-flex',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forum_vue__ = __webpack_require__(373);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee12d440_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forum_vue__ = __webpack_require__(782);
function injectStyle (ssrContext) {
  __webpack_require__(781)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee12d440_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forum_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"iframeWrapper"},[_c('iframe',{attrs:{"src":"/forum"},on:{"load":_vm.setSize}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RpIcon_vue__ = __webpack_require__(374);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08e066c3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RpIcon_vue__ = __webpack_require__(788);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RpIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08e066c3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RpIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipContent),expression:"tooltipContent"}],attrs:{"icon":"","small":_vm.small},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"small":_vm.small,"color":_vm.dark ? 'white' : 'grey darken-1'}},[_vm._v("\n    "+_vm._s(_vm.type)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/trianglify-max.35a20e5.jpg";

/***/ })
],[377]);


// WEBPACK FOOTER //
// static/js/app.700cb9318b4ee86c9f1e.js